// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./_variables.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./_mixins.scss";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%231ab394%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23eb3349%27 viewBox=%27-2 -2 7 7%27%3e%3cpath stroke=%27%23eb3349%27 d=%27M0 0l3 3m0-3L0 3%27/%3e%3ccircle r=%27.5%27/%3e%3ccircle cx=%273%27 r=%27.5%27/%3e%3ccircle cy=%273%27 r=%27.5%27/%3e%3ccircle cx=%273%27 cy=%273%27 r=%27.5%27/%3e%3c/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Site color palette: #1f7c50 dark green, #07ffa9 mint, #101413 dark, #accbc3 sage */
  --color-dark-green: #1f7c50;
  --color-mint: #07ffa9;
  --color-dark: #101413;
  --color-sage: #accbc3;

  --blue: #007bff;
  --indigo: #6610f2;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #dc3545;
  --orange: #fd7e14;
  --yellow: #ffc107;
  --green: var(--color-dark-green);
  --teal: var(--color-mint);
  --cyan: #17a2b8;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: var(--color-dark);
  --primary: var(--color-dark-green);
  --secondary: var(--color-sage);
  --success: var(--color-dark-green);
  --info: #5d80f9;
  --warning: #f3c363;
  --danger: #eb3349;
  --light: var(--color-sage);
  --dark: var(--color-dark);
  --inverse: var(--color-dark);
  --gray: #ccc;
  --default: #f8f8f8;
  --accent: var(--color-mint);
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
  
}

input[type="text"], input[type="email"], input[type="password"],textarea {
  height: 45px !important;
  border-style: 1px solid #f5f4f4 !important;
  border-radius: 8px !important;
  
}

textarea{
  height: 100px !important;
}
input[type="text"]:focus, input[type="email"]:focus, input[type="password"]:focus,textarea:focus {
  border-color: #f7bc29f3 !important;
  box-shadow: none !important;
  outline: none !important;
  
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

article,
aside,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
  display: block;
}

body {
  font-family: 'Poppins', sans-serif;
  margin: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #f9f6f2;
}

[tabindex="-1"]:focus {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: .5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

a {
  color: #337ab7;
  text-decoration: none;
  background-color: transparent;
}

a:hover {
  color: #22527b;
  text-decoration: underline;
}

a:not([href]):not([tabindex]) {
  color: inherit;
  text-decoration: none;
}

a:not([href]):not([tabindex]):hover,
a:not([href]):not([tabindex]):focus {
  color: inherit;
  text-decoration: none;
}

a:not([href]):not([tabindex]):focus {
  outline: 0;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}


pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #cccbca;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}





input,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}





select {
  word-wrap: normal;
}


textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: .5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}



output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h1,
.h1 {
  font-size: 2.5rem;
}

h2,
.h2 {
  font-size: 2rem;
}

h3,
.h3 {
  font-size: 1.75rem;
}

h4,
.h4 {
  font-size: 1.5rem;
}

h5,
.h5 {
  font-size: 1.25rem;
}

h6,
.h6 {
  font-size: 1rem;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

small,
.small {
  font-size: 80%;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #6c757d;
}

.blockquote-footer::before {
  content: "\\2014\\00A0";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #f9f6f2;
  border: 1px solid #cccbca;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #6c757d;
}

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-break: break-word;
}

a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
}

kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

.container-fluid {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}

.no-gutters > .col,
.no-gutters > [class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}

.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12,
.col,
.col-auto,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm,
.col-sm-auto,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md,
.col-md-auto,
.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg,
.col-lg-auto,
.col-xl-1,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl,
.col-xl-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.33333%;
  max-width: 8.33333%;
}

.col-2 {
  flex: 0 0 16.66667%;
  max-width: 16.66667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.33333%;
  max-width: 33.33333%;
}

.col-5 {
  flex: 0 0 41.66667%;
  max-width: 41.66667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.33333%;
  max-width: 58.33333%;
}

.col-8 {
  flex: 0 0 66.66667%;
  max-width: 66.66667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.33333%;
  max-width: 83.33333%;
}

.col-11 {
  flex: 0 0 91.66667%;
  max-width: 91.66667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.33333%;
}

.offset-2 {
  margin-left: 16.66667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333%;
}

.offset-5 {
  margin-left: 41.66667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333%;
}

.offset-8 {
  margin-left: 66.66667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333%;
}

.offset-11 {
  margin-left: 91.66667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-sm-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .col-sm-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-sm-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .col-sm-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-sm-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .col-sm-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-sm-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .col-sm-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-sm-first {
    order: -1;
  }

  .order-sm-last {
    order: 13;
  }

  .order-sm-0 {
    order: 0;
  }

  .order-sm-1 {
    order: 1;
  }

  .order-sm-2 {
    order: 2;
  }

  .order-sm-3 {
    order: 3;
  }

  .order-sm-4 {
    order: 4;
  }

  .order-sm-5 {
    order: 5;
  }

  .order-sm-6 {
    order: 6;
  }

  .order-sm-7 {
    order: 7;
  }

  .order-sm-8 {
    order: 8;
  }

  .order-sm-9 {
    order: 9;
  }

  .order-sm-10 {
    order: 10;
  }

  .order-sm-11 {
    order: 11;
  }

  .order-sm-12 {
    order: 12;
  }

  .offset-sm-0 {
    margin-left: 0;
  }

  .offset-sm-1 {
    margin-left: 8.33333%;
  }

  .offset-sm-2 {
    margin-left: 16.66667%;
  }

  .offset-sm-3 {
    margin-left: 25%;
  }

  .offset-sm-4 {
    margin-left: 33.33333%;
  }

  .offset-sm-5 {
    margin-left: 41.66667%;
  }

  .offset-sm-6 {
    margin-left: 50%;
  }

  .offset-sm-7 {
    margin-left: 58.33333%;
  }

  .offset-sm-8 {
    margin-left: 66.66667%;
  }

  .offset-sm-9 {
    margin-left: 75%;
  }

  .offset-sm-10 {
    margin-left: 83.33333%;
  }

  .offset-sm-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-md-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .col-md-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-md-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .col-md-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-md-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .col-md-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-md-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .col-md-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-md-first {
    order: -1;
  }

  .order-md-last {
    order: 13;
  }

  .order-md-0 {
    order: 0;
  }

  .order-md-1 {
    order: 1;
  }

  .order-md-2 {
    order: 2;
  }

  .order-md-3 {
    order: 3;
  }

  .order-md-4 {
    order: 4;
  }

  .order-md-5 {
    order: 5;
  }

  .order-md-6 {
    order: 6;
  }

  .order-md-7 {
    order: 7;
  }

  .order-md-8 {
    order: 8;
  }

  .order-md-9 {
    order: 9;
  }

  .order-md-10 {
    order: 10;
  }

  .order-md-11 {
    order: 11;
  }

  .order-md-12 {
    order: 12;
  }

  .offset-md-0 {
    margin-left: 0;
  }

  .offset-md-1 {
    margin-left: 8.33333%;
  }

  .offset-md-2 {
    margin-left: 16.66667%;
  }

  .offset-md-3 {
    margin-left: 25%;
  }

  .offset-md-4 {
    margin-left: 33.33333%;
  }

  .offset-md-5 {
    margin-left: 41.66667%;
  }

  .offset-md-6 {
    margin-left: 50%;
  }

  .offset-md-7 {
    margin-left: 58.33333%;
  }

  .offset-md-8 {
    margin-left: 66.66667%;
  }

  .offset-md-9 {
    margin-left: 75%;
  }

  .offset-md-10 {
    margin-left: 83.33333%;
  }

  .offset-md-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-lg-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .col-lg-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-lg-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .col-lg-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-lg-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .col-lg-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-lg-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .col-lg-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-lg-first {
    order: -1;
  }

  .order-lg-last {
    order: 13;
  }

  .order-lg-0 {
    order: 0;
  }

  .order-lg-1 {
    order: 1;
  }

  .order-lg-2 {
    order: 2;
  }

  .order-lg-3 {
    order: 3;
  }

  .order-lg-4 {
    order: 4;
  }

  .order-lg-5 {
    order: 5;
  }

  .order-lg-6 {
    order: 6;
  }

  .order-lg-7 {
    order: 7;
  }

  .order-lg-8 {
    order: 8;
  }

  .order-lg-9 {
    order: 9;
  }

  .order-lg-10 {
    order: 10;
  }

  .order-lg-11 {
    order: 11;
  }

  .order-lg-12 {
    order: 12;
  }

  .offset-lg-0 {
    margin-left: 0;
  }

  .offset-lg-1 {
    margin-left: 8.33333%;
  }

  .offset-lg-2 {
    margin-left: 16.66667%;
  }

  .offset-lg-3 {
    margin-left: 25%;
  }

  .offset-lg-4 {
    margin-left: 33.33333%;
  }

  .offset-lg-5 {
    margin-left: 41.66667%;
  }

  .offset-lg-6 {
    margin-left: 50%;
  }

  .offset-lg-7 {
    margin-left: 58.33333%;
  }

  .offset-lg-8 {
    margin-left: 66.66667%;
  }

  .offset-lg-9 {
    margin-left: 75%;
  }

  .offset-lg-10 {
    margin-left: 83.33333%;
  }

  .offset-lg-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }

  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .col-xl-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }

  .col-xl-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }

  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }

  .col-xl-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }

  .col-xl-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }

  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .col-xl-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }

  .col-xl-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }

  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .col-xl-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }

  .col-xl-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }

  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .order-xl-first {
    order: -1;
  }

  .order-xl-last {
    order: 13;
  }

  .order-xl-0 {
    order: 0;
  }

  .order-xl-1 {
    order: 1;
  }

  .order-xl-2 {
    order: 2;
  }

  .order-xl-3 {
    order: 3;
  }

  .order-xl-4 {
    order: 4;
  }

  .order-xl-5 {
    order: 5;
  }

  .order-xl-6 {
    order: 6;
  }

  .order-xl-7 {
    order: 7;
  }

  .order-xl-8 {
    order: 8;
  }

  .order-xl-9 {
    order: 9;
  }

  .order-xl-10 {
    order: 10;
  }

  .order-xl-11 {
    order: 11;
  }

  .order-xl-12 {
    order: 12;
  }

  .offset-xl-0 {
    margin-left: 0;
  }

  .offset-xl-1 {
    margin-left: 8.33333%;
  }

  .offset-xl-2 {
    margin-left: 16.66667%;
  }

  .offset-xl-3 {
    margin-left: 25%;
  }

  .offset-xl-4 {
    margin-left: 33.33333%;
  }

  .offset-xl-5 {
    margin-left: 41.66667%;
  }

  .offset-xl-6 {
    margin-left: 50%;
  }

  .offset-xl-7 {
    margin-left: 58.33333%;
  }

  .offset-xl-8 {
    margin-left: 66.66667%;
  }

  .offset-xl-9 {
    margin-left: 75%;
  }

  .offset-xl-10 {
    margin-left: 83.33333%;
  }

  .offset-xl-11 {
    margin-left: 91.66667%;
  }
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #cccbca;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #cccbca;
}

.table tbody + tbody {
  border-top: 2px solid #cccbca;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #cccbca;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #cccbca;
}

.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

.table-hover tbody tr:hover {
  color: #212529;
  background-color: rgba(0, 0, 0, 0.075);
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #c7cfe6;
}

.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: #97a6d0;
}

.table-hover .table-primary:hover {
  background-color: #b5c0de;
}

.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: #b5c0de;
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #edf1fe;
}

.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: #dde4fe;
}

.border-Card {
  border: 1px solid #e0e0e0;       /* light gray border */
  border-radius: 8px;             /* rounded corners */
  padding: 16px;                   /* space inside the card */
  background-color: #fff;          /* white background */
  
  transition: box-shadow 0.2s ease;
}

.border-Cardcard:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* elevate on hover */
}

.table-hover .table-secondary:hover {
  background-color: #d5defd;
}

.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: #d5defd;
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: #bfeae1;
}

.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: #88d7c7;
}

.table-hover .table-success:hover {
  background-color: #ace4d8;
}

.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: #ace4d8;
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: #d2dbfd;
}

.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: #abbdfc;
}

.table-hover .table-info:hover {
  background-color: #bac7fc;
}

.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: #bac7fc;
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #fceed3;
}

.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: #f9e0ae;
}

.table-hover .table-warning:hover {
  background-color: #fae5bb;
}

.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: #fae5bb;
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #f9c6cc;
}

.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: #f595a0;
}

.table-hover .table-danger:hover {
  background-color: #f7afb7;
}

.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: #f7afb7;
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: #f1f0f0;
}

.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: #e4e4e3;
}

.table-hover .table-light:hover {
  background-color: #e5e3e3;
}

.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: #e5e3e3;
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #c6c8ca;
}

.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: #95999c;
}

.table-hover .table-dark:hover {
  background-color: #b9bbbe;
}

.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: #b9bbbe;
}

.table-inverse,
.table-inverse > th,
.table-inverse > td {
  background-color: #cdcdcd;
}

.table-inverse th,
.table-inverse td,
.table-inverse thead th,
.table-inverse tbody + tbody {
  border-color: #a2a2a2;
}

.table-hover .table-inverse:hover {
  background-color: silver;
}

.table-hover .table-inverse:hover > td,
.table-hover .table-inverse:hover > th {
  background-color: silver;
}

.table-gray,
.table-gray > th,
.table-gray > td {
  background-color: #f1f1f1;
}

.table-gray th,
.table-gray td,
.table-gray thead th,
.table-gray tbody + tbody {
  border-color: #e4e4e4;
}

.table-hover .table-gray:hover {
  background-color: #e4e4e4;
}

.table-hover .table-gray:hover > td,
.table-hover .table-gray:hover > th {
  background-color: #e4e4e4;
}

.table-default,
.table-default > th,
.table-default > td {
  background-color: #fdfdfd;
}

.table-default th,
.table-default td,
.table-default thead th,
.table-default tbody + tbody {
  border-color: #fbfbfb;
}

.table-hover .table-default:hover {
  background-color: #f0f0f0;
}

.table-hover .table-default:hover > td,
.table-hover .table-default:hover > th {
  background-color: #f0f0f0;
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075);
}

.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgba(0, 0, 0, 0.075);
}

.table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: #454d55;
}

.table .thead-light th {
  color: #4d4d4d;
  background-color: #efedea;
  border-color: #cccbca;
}

.table-dark {
  color: #fff;
  background-color: #343a40;
}

.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: #454d55;
}

.table-dark.table-bordered {
  border: 0;
}

.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}

.table-dark.table-hover tbody tr:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}

@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-md > .table-bordered {
    border: 0;
  }
}

@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #4d4d4d;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border-radius: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}

.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}

.form-control:focus {
  color: #4d4d4d;
  background-color: #fff;
  border-color: #859bd6;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.25);
}

.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #efedea;
  opacity: 1;
}

select.form-control:focus::-ms-value {
  color: #4d4d4d;
  background-color: #fff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.25rem;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  margin-bottom: 0;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}

.form-control-plaintext.form-control-sm,
.form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}

.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
}

select.form-control[size],
select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}

.form-row > .col,
.form-row > [class*="col-"] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}

.form-check-input:disabled ~ .form-check-label {
  color: #cccbca;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}

.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: var(--success);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(26, 179, 148, 0.9);
}

.was-validated .form-control:valid,
.form-control.is-valid {
  border-color: var(--success);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center right calc(0.375em + 0.1875rem);
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-control:valid:focus,
.form-control.is-valid:focus {
  border-color: var(--success);
  box-shadow: 0 0 0 0.2rem rgba(26, 179, 148, 0.25);
}

.was-validated .form-control:valid ~ .valid-feedback,
.was-validated .form-control:valid ~ .valid-tooltip,
.form-control.is-valid ~ .valid-feedback,
.form-control.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated textarea.form-control:valid,
textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .custom-select:valid,
.custom-select.is-valid {
  border-color: var(--success);
  padding-right: calc((1em + 0.75rem) * 3 / 4 + 1.75rem);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px, url(${___CSS_LOADER_URL_REPLACEMENT_0___}) #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .custom-select:valid:focus,
.custom-select.is-valid:focus {
  border-color: var(--success);
  box-shadow: 0 0 0 0.2rem rgba(26, 179, 148, 0.25);
}

.was-validated .custom-select:valid ~ .valid-feedback,
.was-validated .custom-select:valid ~ .valid-tooltip,
.custom-select.is-valid ~ .valid-feedback,
.custom-select.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control-file:valid ~ .valid-feedback,
.was-validated .form-control-file:valid ~ .valid-tooltip,
.form-control-file.is-valid ~ .valid-feedback,
.form-control-file.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-check-input:valid ~ .form-check-label,
.form-check-input.is-valid ~ .form-check-label {
  color: var(--success);
}

.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip,
.form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label,
.custom-control-input.is-valid ~ .custom-control-label {
  color: var(--success);
}

.was-validated .custom-control-input:valid ~ .custom-control-label::before,
.custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: var(--success);
}

.was-validated .custom-control-input:valid ~ .valid-feedback,
.was-validated .custom-control-input:valid ~ .valid-tooltip,
.custom-control-input.is-valid ~ .valid-feedback,
.custom-control-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before,
.custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: #21dfb8;
  background-color: #21dfb8;
}

.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before,
.custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(26, 179, 148, 0.25);
}

.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before,
.custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: var(--success);
}

.was-validated .custom-file-input:valid ~ .custom-file-label,
.custom-file-input.is-valid ~ .custom-file-label {
  border-color: var(--success);
}

.was-validated .custom-file-input:valid ~ .valid-feedback,
.was-validated .custom-file-input:valid ~ .valid-tooltip,
.custom-file-input.is-valid ~ .valid-feedback,
.custom-file-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-file-input:valid:focus ~ .custom-file-label,
.custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: var(--success);
  box-shadow: 0 0 0 0.2rem rgba(26, 179, 148, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #eb3349;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(235, 51, 73, 0.9);
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  border-color: #eb3349;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: center right calc(0.375em + 0.1875rem);
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus {
  border-color: #eb3349;
  box-shadow: 0 0 0 0.2rem rgba(235, 51, 73, 0.25);
}

.was-validated .form-control:invalid ~ .invalid-feedback,
.was-validated .form-control:invalid ~ .invalid-tooltip,
.form-control.is-invalid ~ .invalid-feedback,
.form-control.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated textarea.form-control:invalid,
textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .custom-select:invalid,
.custom-select.is-invalid {
  border-color: #eb3349;
  padding-right: calc((1em + 0.75rem) * 3 / 4 + 1.75rem);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px, url(${___CSS_LOADER_URL_REPLACEMENT_2___}) #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .custom-select:invalid:focus,
.custom-select.is-invalid:focus {
  border-color: #eb3349;
  box-shadow: 0 0 0 0.2rem rgba(235, 51, 73, 0.25);
}

.was-validated .custom-select:invalid ~ .invalid-feedback,
.was-validated .custom-select:invalid ~ .invalid-tooltip,
.custom-select.is-invalid ~ .invalid-feedback,
.custom-select.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control-file:invalid ~ .invalid-feedback,
.was-validated .form-control-file:invalid ~ .invalid-tooltip,
.form-control-file.is-invalid ~ .invalid-feedback,
.form-control-file.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-check-input:invalid ~ .form-check-label,
.form-check-input.is-invalid ~ .form-check-label {
  color: #eb3349;
}

.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip,
.form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label,
.custom-control-input.is-invalid ~ .custom-control-label {
  color: #eb3349;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label::before,
.custom-control-input.is-invalid ~ .custom-control-label::before {
  border-color: #eb3349;
}

.was-validated .custom-control-input:invalid ~ .invalid-feedback,
.was-validated .custom-control-input:invalid ~ .invalid-tooltip,
.custom-control-input.is-invalid ~ .invalid-feedback,
.custom-control-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before,
.custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: #f06172;
  background-color: #f06172;
}

.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before,
.custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(235, 51, 73, 0.25);
}

.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before,
.custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #eb3349;
}

.was-validated .custom-file-input:invalid ~ .custom-file-label,
.custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #eb3349;
}

.was-validated .custom-file-input:invalid ~ .invalid-feedback,
.was-validated .custom-file-input:invalid ~ .invalid-tooltip,
.custom-file-input.is-invalid ~ .invalid-feedback,
.custom-file-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-file-input:invalid:focus ~ .custom-file-label,
.custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #eb3349;
  box-shadow: 0 0 0 0.2rem rgba(235, 51, 73, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.form-inline .form-check {
  width: 100%;
}

@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }

  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }

  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }

  .form-inline .form-control-plaintext {
    display: inline-block;
  }

  .form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
  }

  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }

  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }

  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }

  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}



.btn:focus,
.btn.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.25);
}

.btn.disabled,
.btn:disabled {
  opacity: 0.65;
}

a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #fff;
  background-color: var(--primary);
  border-color: var(--primary);
}

.btn-primary:hover {
  color: #fff;
  background-color: #2d4588;
  border-color: #2a417f;
}

.btn-primary:focus,
.btn-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(85, 110, 179, 0.5);
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: #fff;
  background-color: var(--primary);
  border-color: var(--primary);
}

.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #2a417f;
  border-color: #273c75;
}

.btn-primary:not(:disabled):not(.disabled):active:focus,
.btn-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(85, 110, 179, 0.5);
}

.btn-secondary {
  color: #212529;
  background-color: var(--secondary);
  border-color: var(--secondary);
}

.btn-secondary:hover {
  color: #212529;
  background-color: #99affc;
  border-color: #8da5fb;
}

.btn-secondary:focus,
.btn-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(166, 179, 221, 0.5);
}

.btn-secondary.disabled,
.btn-secondary:disabled {
  color: #212529;
  background-color: var(--secondary);
  border-color: var(--secondary);
}

.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
  color: #212529;
  background-color: #8da5fb;
  border-color: #809bfb;
}

.btn-secondary:not(:disabled):not(.disabled):active:focus,
.btn-secondary:not(:disabled):not(.disabled).active:focus,
.show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(166, 179, 221, 0.5);
}

.btn-success {
  color: #fff;
  background-color: var(--success);
  border-color: var(--success);
}

.btn-success:hover {
  color: #fff;
  background-color: #159278;
  border-color: #14866f;
}

.btn-success:focus,
.btn-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(60, 190, 164, 0.5);
}

.btn-success.disabled,
.btn-success:disabled {
  color: #fff;
  background-color: var(--success);
  border-color: var(--success);
}

.btn-success:not(:disabled):not(.disabled):active,
.btn-success:not(:disabled):not(.disabled).active,
.show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: #14866f;
  border-color: #127b66;
}

.btn-success:not(:disabled):not(.disabled):active:focus,
.btn-success:not(:disabled):not(.disabled).active:focus,
.show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(60, 190, 164, 0.5);
}

.btn-info {
  color: #fff;
  background-color: #5d80f9;
  border-color: #5d80f9;
}

.btn-info:hover {
  color: #fff;
  background-color: #3863f8;
  border-color: #2c59f7;
}

.btn-info:focus,
.btn-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(117, 147, 250, 0.5);
}

.btn-info.disabled,
.btn-info:disabled {
  color: #fff;
  background-color: #5d80f9;
  border-color: #5d80f9;
}

.btn-info:not(:disabled):not(.disabled):active,
.btn-info:not(:disabled):not(.disabled).active,
.show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: #2c59f7;
  border-color: #2050f7;
}

.btn-info:not(:disabled):not(.disabled):active:focus,
.btn-info:not(:disabled):not(.disabled).active:focus,
.show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(117, 147, 250, 0.5);
}

.btn-warning {
  color: #212529;
  background-color: #f3c363;
  border-color: #f3c363;
}

.btn-warning:hover {
  color: #212529;
  background-color: #f0b53f;
  border-color: #efb134;
}

.btn-warning:focus,
.btn-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(212, 171, 90, 0.5);
}

.btn-warning.disabled,
.btn-warning:disabled {
  color: #212529;
  background-color: #f3c363;
  border-color: #f3c363;
}

.btn-warning:not(:disabled):not(.disabled):active,
.btn-warning:not(:disabled):not(.disabled).active,
.show > .btn-warning.dropdown-toggle {
  color: #212529;
  background-color: #efb134;
  border-color: #eeac28;
}

.btn-warning:not(:disabled):not(.disabled):active:focus,
.btn-warning:not(:disabled):not(.disabled).active:focus,
.show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(212, 171, 90, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #eb3349;
  border-color: #eb3349;
}

.btn-danger:hover {
  color: #fff;
  background-color: #e2162e;
  border-color: #d6152c;
}

.btn-danger:focus,
.btn-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(238, 82, 100, 0.5);
}

.btn-danger.disabled,
.btn-danger:disabled {
  color: #fff;
  background-color: #eb3349;
  border-color: #eb3349;
}

.btn-danger:not(:disabled):not(.disabled):active,
.btn-danger:not(:disabled):not(.disabled).active,
.show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #d6152c;
  border-color: #ca142a;
}

.btn-danger:not(:disabled):not(.disabled):active:focus,
.btn-danger:not(:disabled):not(.disabled).active:focus,
.show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(238, 82, 100, 0.5);
}

.btn-light {
  color: #212529;
  background-color: #cccbca;
  border-color: #cccbca;
}

.btn-light:hover {
  color: #212529;
  background-color: #b9b8b7;
  border-color: #b3b2b0;
}

.btn-light:focus,
.btn-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(178, 178, 178, 0.5);
}

.btn-light.disabled,
.btn-light:disabled {
  color: #212529;
  background-color: #cccbca;
  border-color: #cccbca;
}

.btn-light:not(:disabled):not(.disabled):active,
.btn-light:not(:disabled):not(.disabled).active,
.show > .btn-light.dropdown-toggle {
  color: #212529;
  background-color: #b3b2b0;
  border-color: #adabaa;
}

.btn-light:not(:disabled):not(.disabled):active:focus,
.btn-light:not(:disabled):not(.disabled).active:focus,
.show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(178, 178, 178, 0.5);
}

.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}

.btn-dark:hover {
  color: #fff;
  background-color: #23272b;
  border-color: #1d2124;
}

.btn-dark:focus,
.btn-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);
}

.btn-dark.disabled,
.btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}

.btn-dark:not(:disabled):not(.disabled):active,
.btn-dark:not(:disabled):not(.disabled).active,
.show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: #1d2124;
  border-color: #171a1d;
}

.btn-dark:not(:disabled):not(.disabled):active:focus,
.btn-dark:not(:disabled):not(.disabled).active:focus,
.show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);
}

.btn-inverse {
  color: #fff;
  background-color: #4d4d4d;
  border-color: #4d4d4d;
}

.btn-inverse:hover {
  color: #fff;
  background-color: #3a3a3a;
  border-color: #343434;
}

.btn-inverse:focus,
.btn-inverse.focus {
  box-shadow: 0 0 0 0.2rem rgba(104, 104, 104, 0.5);
}

.btn-inverse.disabled,
.btn-inverse:disabled {
  color: #fff;
  background-color: #4d4d4d;
  border-color: #4d4d4d;
}

.btn-inverse:not(:disabled):not(.disabled):active,
.btn-inverse:not(:disabled):not(.disabled).active,
.show > .btn-inverse.dropdown-toggle {
  color: #fff;
  background-color: #343434;
  border-color: #2d2d2d;
}

.btn-inverse:not(:disabled):not(.disabled):active:focus,
.btn-inverse:not(:disabled):not(.disabled).active:focus,
.show > .btn-inverse.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(104, 104, 104, 0.5);
}

.btn-gray {
  color: #212529;
  background-color: #ccc;
  border-color: #ccc;
}

.btn-gray:hover {
  color: #212529;
  background-color: #b9b9b9;
  border-color: #b3b3b3;
}

.btn-gray:focus,
.btn-gray.focus {
  box-shadow: 0 0 0 0.2rem rgba(178, 179, 180, 0.5);
}

.btn-gray.disabled,
.btn-gray:disabled {
  color: #212529;
  background-color: #ccc;
  border-color: #ccc;
}

.btn-gray:not(:disabled):not(.disabled):active,
.btn-gray:not(:disabled):not(.disabled).active,
.show > .btn-gray.dropdown-toggle {
  color: #212529;
  background-color: #b3b3b3;
  border-color: #acacac;
}

.btn-gray:not(:disabled):not(.disabled):active:focus,
.btn-gray:not(:disabled):not(.disabled).active:focus,
.show > .btn-gray.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(178, 179, 180, 0.5);
}

.btn-default {
  color: #f8fbfd;
  background-color: #d0c9c9;
  border-color: #9f9f9f;
}

.btn-default:hover {
  color: #e4e9ee;
  background-color: #a7a2a2;
  border-color: #dfdfdf;
}

.btn-default:focus,
.btn-default.focus {
  box-shadow: 0 0 0 0.2rem rgba(216, 216, 217, 0.5);
}

.btn-default.disabled,
.btn-default:disabled {
  color: #212529;
  background-color: #f8f8f8;
  border-color: #f8f8f8;
}

.btn-default:not(:disabled):not(.disabled):active,
.btn-default:not(:disabled):not(.disabled).active,
.show > .btn-default.dropdown-toggle {
  color: #212529;
  background-color: #dfdfdf;
  border-color: #d8d8d8;
}

.btn-default:not(:disabled):not(.disabled):active:focus,
.btn-default:not(:disabled):not(.disabled).active:focus,
.show > .btn-default.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(216, 216, 217, 0.5);
}

.btn-outline-primary {
  color: var(--primary);
  border-color: var(--primary);
}

.btn-outline-primary:hover {
  color: #fff;
  background-color: var(--primary);
  border-color: var(--primary);
}

.btn-outline-primary:focus,
.btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.5);
}

.btn-outline-primary.disabled,
.btn-outline-primary:disabled {
  color: var(--primary);
  background-color: transparent;
}

.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: var(--primary);
  border-color: var(--primary);
}

.btn-outline-primary:not(:disabled):not(.disabled):active:focus,
.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.5);
}

.btn-outline-secondary {
  color: var(--secondary);
  border-color: var(--secondary);
}

.btn-outline-secondary:hover {
  color: #212529;
  background-color: var(--secondary);
  border-color: var(--secondary);
}

.btn-outline-secondary:focus,
.btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(190, 204, 253, 0.5);
}

.btn-outline-secondary.disabled,
.btn-outline-secondary:disabled {
  color: var(--secondary);
  background-color: transparent;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
  color: #212529;
  background-color: var(--secondary);
  border-color: var(--secondary);
}

.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,
.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(190, 204, 253, 0.5);
}

.btn-outline-success {
  color: var(--success);
  border-color: var(--success);
}

.btn-outline-success:hover {
  color: #fff;
  background-color: var(--success);
  border-color: var(--success);
}

.btn-outline-success:focus,
.btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(26, 179, 148, 0.5);
}

.btn-outline-success.disabled,
.btn-outline-success:disabled {
  color: var(--success);
  background-color: transparent;
}

.btn-outline-success:not(:disabled):not(.disabled):active,
.btn-outline-success:not(:disabled):not(.disabled).active,
.show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: var(--success);
  border-color: var(--success);
}

.btn-outline-success:not(:disabled):not(.disabled):active:focus,
.btn-outline-success:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(26, 179, 148, 0.5);
}

.btn-outline-info {
  color: #5d80f9;
  border-color: #5d80f9;
}

.btn-outline-info:hover {
  color: #fff;
  background-color: #5d80f9;
  border-color: #5d80f9;
}

.btn-outline-info:focus,
.btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(93, 128, 249, 0.5);
}

.btn-outline-info.disabled,
.btn-outline-info:disabled {
  color: #5d80f9;
  background-color: transparent;
}

.btn-outline-info:not(:disabled):not(.disabled):active,
.btn-outline-info:not(:disabled):not(.disabled).active,
.show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #5d80f9;
  border-color: #5d80f9;
}

.btn-outline-info:not(:disabled):not(.disabled):active:focus,
.btn-outline-info:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(93, 128, 249, 0.5);
}

.btn-outline-warning {
  color: #f3c363;
  border-color: #f3c363;
}

.btn-outline-warning:hover {
  color: #212529;
  background-color: #f3c363;
  border-color: #f3c363;
}

.btn-outline-warning:focus,
.btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(243, 195, 99, 0.5);
}

.btn-outline-warning.disabled,
.btn-outline-warning:disabled {
  color: #f3c363;
  background-color: transparent;
}

.btn-outline-warning:not(:disabled):not(.disabled):active,
.btn-outline-warning:not(:disabled):not(.disabled).active,
.show > .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #f3c363;
  border-color: #f3c363;
}

.btn-outline-warning:not(:disabled):not(.disabled):active:focus,
.btn-outline-warning:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(243, 195, 99, 0.5);
}

.btn-outline-danger {
  color: #eb3349;
  border-color: #eb3349;
}

.btn-outline-danger:hover {
  color: #fff;
  background-color: #eb3349;
  border-color: #eb3349;
}

.btn-outline-danger:focus,
.btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(235, 51, 73, 0.5);
}

.btn-outline-danger.disabled,
.btn-outline-danger:disabled {
  color: #eb3349;
  background-color: transparent;
}

.btn-outline-danger:not(:disabled):not(.disabled):active,
.btn-outline-danger:not(:disabled):not(.disabled).active,
.show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #eb3349;
  border-color: #eb3349;
}

.btn-outline-danger:not(:disabled):not(.disabled):active:focus,
.btn-outline-danger:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(235, 51, 73, 0.5);
}

.btn-outline-light {
  color: #cccbca;
  border-color: #cccbca;
}

.btn-outline-light:hover {
  color: #212529;
  background-color: #cccbca;
  border-color: #cccbca;
}

.btn-outline-light:focus,
.btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(204, 203, 202, 0.5);
}

.btn-outline-light.disabled,
.btn-outline-light:disabled {
  color: #cccbca;
  background-color: transparent;
}

.btn-outline-light:not(:disabled):not(.disabled):active,
.btn-outline-light:not(:disabled):not(.disabled).active,
.show > .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #cccbca;
  border-color: #cccbca;
}

.btn-outline-light:not(:disabled):not(.disabled):active:focus,
.btn-outline-light:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(204, 203, 202, 0.5);
}

.btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}

.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}

.btn-outline-dark:focus,
.btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.btn-outline-dark.disabled,
.btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}

.btn-outline-dark:not(:disabled):not(.disabled):active,
.btn-outline-dark:not(:disabled):not(.disabled).active,
.show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}

.btn-outline-dark:not(:disabled):not(.disabled):active:focus,
.btn-outline-dark:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.btn-outline-inverse {
  color: #4d4d4d;
  border-color: #4d4d4d;
}

.btn-outline-inverse:hover {
  color: #fff;
  background-color: #4d4d4d;
  border-color: #4d4d4d;
}

.btn-outline-inverse:focus,
.btn-outline-inverse.focus {
  box-shadow: 0 0 0 0.2rem rgba(77, 77, 77, 0.5);
}

.btn-outline-inverse.disabled,
.btn-outline-inverse:disabled {
  color: #4d4d4d;
  background-color: transparent;
}

.btn-outline-inverse:not(:disabled):not(.disabled):active,
.btn-outline-inverse:not(:disabled):not(.disabled).active,
.show > .btn-outline-inverse.dropdown-toggle {
  color: #fff;
  background-color: #4d4d4d;
  border-color: #4d4d4d;
}

.btn-outline-inverse:not(:disabled):not(.disabled):active:focus,
.btn-outline-inverse:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-inverse.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(77, 77, 77, 0.5);
}

.btn-outline-gray {
  color: #ccc;
  border-color: #ccc;
}

.btn-outline-gray:hover {
  color: #212529;
  background-color: #ccc;
  border-color: #ccc;
}

.btn-outline-gray:focus,
.btn-outline-gray.focus {
  box-shadow: 0 0 0 0.2rem rgba(204, 204, 204, 0.5);
}

.btn-outline-gray.disabled,
.btn-outline-gray:disabled {
  color: #ccc;
  background-color: transparent;
}

.btn-outline-gray:not(:disabled):not(.disabled):active,
.btn-outline-gray:not(:disabled):not(.disabled).active,
.show > .btn-outline-gray.dropdown-toggle {
  color: #212529;
  background-color: #ccc;
  border-color: #ccc;
}

.btn-outline-gray:not(:disabled):not(.disabled):active:focus,
.btn-outline-gray:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-gray.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(204, 204, 204, 0.5);
}

.btn-outline-default {
  color: #f8f8f8;
  border-color: #f8f8f8;
}

.btn-outline-default:hover {
  color: #212529;
  background-color: #f8f8f8;
  border-color: #f8f8f8;
}

.btn-outline-default:focus,
.btn-outline-default.focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 248, 248, 0.5);
}

.btn-outline-default.disabled,
.btn-outline-default:disabled {
  color: #f8f8f8;
  background-color: transparent;
}

.btn-outline-default:not(:disabled):not(.disabled):active,
.btn-outline-default:not(:disabled):not(.disabled).active,
.show > .btn-outline-default.dropdown-toggle {
  color: #212529;
  background-color: #f8f8f8;
  border-color: #f8f8f8;
}

.btn-outline-default:not(:disabled):not(.disabled):active:focus,
.btn-outline-default:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-default.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(248, 248, 248, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #337ab7;
  text-decoration: none;
}

.btn-link:hover {
  color: #22527b;
  text-decoration: underline;
}

.btn-link:focus,
.btn-link.focus {
  text-decoration: underline;
  box-shadow: none;
}

.btn-link:disabled,
.btn-link.disabled {
  color: #6c757d;
  pointer-events: none;
}

.btn-lg,
.btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0;
}





.fade {
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}

.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}

.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}

.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}

.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}

.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}

.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  display: none;
}

.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}

.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^="top"],
.dropdown-menu[x-placement^="right"],
.dropdown-menu[x-placement^="bottom"],
.dropdown-menu[x-placement^="left"] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #efedea;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.dropdown-item:hover,
.dropdown-item:focus {
  color: #16181b;
  text-decoration: none;
  background-color: #f9f6f2;
}

.dropdown-item.active,
.dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: var(--primary);
}

.dropdown-item.disabled,
.dropdown-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #6c757d;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}

.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}

.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}

.dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after,
.dropright .dropdown-toggle-split::after {
  margin-left: 0;
}

.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split,
.btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split,
.btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}

.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}

.btn-group-toggle > .btn input[type="radio"],
.btn-group-toggle > .btn input[type="checkbox"],
.btn-group-toggle > .btn-group > .btn input[type="radio"],
.btn-group-toggle > .btn-group > .btn input[type="checkbox"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control,
.input-group > .form-control-plaintext,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}

.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .form-control-plaintext + .form-control,
.input-group > .form-control-plaintext + .custom-select,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}

.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}

.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}

.input-group > .custom-file {
  display: flex;
  align-items: center;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}

.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}

.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}

.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #4d4d4d;
  text-align: center;
  white-space: nowrap;
  background-color: #efedea;
  border: 1px solid #ccc;
}

.input-group-text input[type="radio"],
.input-group-text input[type="checkbox"] {
  margin-top: 0;
}

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.5em + 1rem + 2px);
}

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
}

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 0.5rem + 2px);
}

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 1.75rem;
}

.custom-control {
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: var(--primary);
  background-color: var(--primary);
}

.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.25);
}

.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #859bd6;
}

.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: #abbae3;
  border-color: #abbae3;
}

.custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
}

.custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #efedea;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}

.custom-control-label::before {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #666 solid 1px;
}

.custom-control-label::after {
  position: absolute;
  top: 0.25rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: no-repeat 50% / 50% 50%;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: var(--primary);
  background-color: var(--primary);
}

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(55, 84, 165, 0.5);
}

.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(55, 84, 165, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(55, 84, 165, 0.5);
}

.custom-switch {
  padding-left: 2.25rem;
}

.custom-switch .custom-control-label::before {
  left: -2.25rem;
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
}

.custom-switch .custom-control-label::after {
  top: calc(0.25rem + 2px);
  left: calc(-2.25rem + 2px);
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  background-color: #666;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}

.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(55, 84, 165, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #4d4d4d;
  vertical-align: middle;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 0;
  appearance: none;
}

.custom-select:focus {
  border-color: #859bd6;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.25);
}

.custom-select:focus::-ms-value {
  color: #4d4d4d;
  background-color: #fff;
}

.custom-select[multiple],
.custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}

.custom-select:disabled {
  color: #6c757d;
  background-color: #efedea;
}

.custom-select::-ms-expand {
  display: none;
}

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
}

.custom-select-lg {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin: 0;
  opacity: 0;
}

.custom-file-input:focus ~ .custom-file-label {
  border-color: #859bd6;
  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.25);
}

.custom-file-input:disabled ~ .custom-file-label {
  background-color: #efedea;
}

.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}

.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-weight: 400;
  line-height: 1.5;
  color: #4d4d4d;
  background-color: #fff;
  border: 1px solid #ccc;
}

.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 0.75rem);
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  color: #4d4d4d;
  content: "Browse";
  background-color: #efedea;
  border-left: inherit;
}

.custom-range {
  width: 100%;
  height: calc(1rem + 0.4rem);
  padding: 0;
  background-color: transparent;
  appearance: none;
}

.custom-range:focus {
  outline: none;
}

.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f9f6f2, 0 0 0 0.2rem rgba(55, 84, 165, 0.25);
}

.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f9f6f2, 0 0 0 0.2rem rgba(55, 84, 165, 0.25);
}

.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #f9f6f2, 0 0 0 0.2rem rgba(55, 84, 165, 0.25);
}

.custom-range::-moz-focus-outer {
  border: 0;
}

.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: var(--primary);
  border: 0;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}

.custom-range::-webkit-slider-thumb:active {
  background-color: #abbae3;
}

.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #cccbca;
  border-color: transparent;
}

.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: var(--primary);
  border: 0;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}

.custom-range::-moz-range-thumb:active {
  background-color: #abbae3;
}

.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #cccbca;
  border-color: transparent;
}

.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background-color: var(--primary);
  border: 0;
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
  }
}

.custom-range::-ms-thumb:active {
  background-color: #abbae3;
}

.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}

.custom-range::-ms-fill-lower {
  background-color: #cccbca;
}

.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #cccbca;
}

.custom-range:disabled::-webkit-slider-thumb {
  background-color: #666;
}

.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}

.custom-range:disabled::-moz-range-thumb {
  background-color: #666;
}

.custom-range:disabled::-moz-range-track {
  cursor: default;
}

.custom-range:disabled::-ms-thumb {
  background-color: #666;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}

.nav-link:hover,
.nav-link:focus {
  text-decoration: none;
}

.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #cccbca;
}

.nav-tabs .nav-item {
  margin-bottom: -1px;
}

.nav-tabs .nav-link {
  border: 1px solid transparent;
}

.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  border-color: #efedea #efedea #cccbca;
}

.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #4d4d4d;
  background-color: #f9f6f2;
  border-color: #cccbca #cccbca #f9f6f2;
}

.nav-tabs .dropdown-menu {
  margin-top: -1px;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: var(--primary);
}

.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}

.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}

.navbar > .container,
.navbar > .container-fluid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  display: inline-block;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}

.navbar-brand:hover,
.navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}

.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
}

.navbar-toggler:hover,
.navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: no-repeat center center;
  background-size: 100% 100%;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid {
    flex-wrap: nowrap;
  }

  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}

@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid {
    flex-wrap: nowrap;
  }

  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}

@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid {
    flex-wrap: nowrap;
  }

  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}

@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }

  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }

  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }

  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid {
    flex-wrap: nowrap;
  }

  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }

  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}

.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}

.navbar-expand > .container,
.navbar-expand > .container-fluid {
  padding-right: 0;
  padding-left: 0;
}

.navbar-expand .navbar-nav {
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.navbar-expand > .container,
.navbar-expand > .container-fluid {
  flex-wrap: nowrap;
}

.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-brand:hover,
.navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}

.navbar-light .navbar-nav .nav-link:hover,
.navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}

.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}

.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}

.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}

.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-text a:hover,
.navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: #fff;
}

.navbar-dark .navbar-brand:hover,
.navbar-dark .navbar-brand:focus {
  color: #fff;
}

.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}

.navbar-dark .navbar-nav .nav-link:hover,
.navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}

.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}

.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}

.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}

.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}

.navbar-dark .navbar-text a {
  color: #fff;
}

.navbar-dark .navbar-text a:hover,
.navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.card > hr {
  margin-right: 0;
  margin-left: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: 1.25rem;
}

.card-title {
  margin-bottom: 0.75rem;
}

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}

.card-link + .card-link {
  margin-left: 1.25rem;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.card-header + .list-group .list-group-item:first-child {
  border-top: 0;
}

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
}

.card-img {
  width: 100%;
}

.card-img-top {
  width: 100%;
}

.card-img-bottom {
  width: 100%;
}

.card-deck {
  display: flex;
  flex-direction: column;
}

.card-deck .card {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  .card-deck {
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }

  .card-deck .card {
    display: flex;
    flex: 1 0;
    flex-direction: column;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group {
  display: flex;
  flex-direction: column;
}

.card-group > .card {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  .card-group {
    flex-flow: row wrap;
  }

  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }

  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
}

.card-columns .card {
  margin-bottom: 0.75rem;
}

@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }

  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion > .card {
  overflow: hidden;
}

.accordion > .card:not(:first-of-type):not(:last-of-type) {
  border-bottom: 0;
}

.accordion > .card:first-of-type {
  border-bottom: 0;
}

.accordion > .card .card-header {
  margin-bottom: -1px;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0 0;
  margin-bottom: 1rem;
  list-style: none;
  background-color: transparent;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}

.breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5rem;
  color: #6c757d;
  content: ">";
}

.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
  text-decoration: none;
}

.breadcrumb-item.active {
  color: #6c757d;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #337ab7;
  background-color: #fff;
  border: 1px solid #cccbca;
}

.page-link:hover {
  z-index: 2;
  color: #22527b;
  text-decoration: none;
  background-color: #efedea;
  border-color: #cccbca;
}

.page-link:focus {
  z-index: 2;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.25);
}

.page-item:first-child .page-link {
  margin-left: 0;
}

.page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: var(--primary);
  border-color: var(--primary);
}

.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #cccbca;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}

a.badge:hover,
a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
}

.badge-primary {
  color: #fff;
  background-color: var(--primary);
}

a.badge-primary:hover,
a.badge-primary:focus {
  color: #fff;
  background-color: #2a417f;
}

a.badge-primary:focus,
a.badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.5);
}

.badge-secondary {
  color: #212529;
  background-color: var(--secondary);
}

a.badge-secondary:hover,
a.badge-secondary:focus {
  color: #212529;
  background-color: #8da5fb;
}

a.badge-secondary:focus,
a.badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(190, 204, 253, 0.5);
}

.badge-success {
  color: #fff;
  background-color: var(--success);
}

a.badge-success:hover,
a.badge-success:focus {
  color: #fff;
  background-color: #14866f;
}

a.badge-success:focus,
a.badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(26, 179, 148, 0.5);
}

.badge-info {
  color: #fff;
  background-color: #5d80f9;
}

a.badge-info:hover,
a.badge-info:focus {
  color: #fff;
  background-color: #2c59f7;
}

a.badge-info:focus,
a.badge-info.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(93, 128, 249, 0.5);
}

.badge-warning {
  color: #212529;
  background-color: #f3c363;
}

a.badge-warning:hover,
a.badge-warning:focus {
  color: #212529;
  background-color: #efb134;
}

a.badge-warning:focus,
a.badge-warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(243, 195, 99, 0.5);
}

.badge-danger {
  color: #fff;
  background-color: #eb3349;
}

a.badge-danger:hover,
a.badge-danger:focus {
  color: #fff;
  background-color: #d6152c;
}

a.badge-danger:focus,
a.badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(235, 51, 73, 0.5);
}

.badge-light {
  color: #212529;
  background-color: #cccbca;
}

a.badge-light:hover,
a.badge-light:focus {
  color: #212529;
  background-color: #b3b2b0;
}

a.badge-light:focus,
a.badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(204, 203, 202, 0.5);
}

.badge-dark {
  color: #fff;
  background-color: #343a40;
}

a.badge-dark:hover,
a.badge-dark:focus {
  color: #fff;
  background-color: #1d2124;
}

a.badge-dark:focus,
a.badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}

.badge-inverse {
  color: #fff;
  background-color: #4d4d4d;
}

a.badge-inverse:hover,
a.badge-inverse:focus {
  color: #fff;
  background-color: #343434;
}

a.badge-inverse:focus,
a.badge-inverse.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(77, 77, 77, 0.5);
}

.badge-gray {
  color: #212529;
  background-color: #ccc;
}

a.badge-gray:hover,
a.badge-gray:focus {
  color: #212529;
  background-color: #b3b3b3;
}

a.badge-gray:focus,
a.badge-gray.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(204, 204, 204, 0.5);
}

.badge-default {
  color: #212529;
  background-color: #f8f8f8;
}

a.badge-default:hover,
a.badge-default:focus {
  color: #212529;
  background-color: #dfdfdf;
}

a.badge-default:focus,
a.badge-default.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(248, 248, 248, 0.5);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #efedea;
}

@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 4rem;
}

.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.75rem 1.25rem;
  color: inherit;
}

.alert-primary {
  color: #1d2c56;
  background-color: #d7dded;
  border-color: #c7cfe6;
}

.alert-primary hr {
  border-top-color: #b5c0de;
}

.alert-primary .alert-link {
  color: #101830;
}

.alert-secondary {
  color: #636a84;
  background-color: #f2f5ff;
  border-color: #edf1fe;
}

.alert-secondary hr {
  border-top-color: #d5defd;
}

.alert-secondary .alert-link {
  color: #4d5367;
}

.alert-success {
  color: #0e5d4d;
  background-color: #d1f0ea;
  border-color: #bfeae1;
}

.alert-success hr {
  border-top-color: #ace4d8;
}

.alert-success .alert-link {
  color: #073128;
}

.alert-info {
  color: #304381;
  background-color: #dfe6fe;
  border-color: #d2dbfd;
}

.alert-info hr {
  border-top-color: #bac7fc;
}

.alert-info .alert-link {
  color: #22305c;
}

.alert-warning {
  color: #7e6533;
  background-color: #fdf3e0;
  border-color: #fceed3;
}

.alert-warning hr {
  border-top-color: #fae5bb;
}

.alert-warning .alert-link {
  color: #5a4824;
}

.alert-danger {
  color: #7a1b26;
  background-color: #fbd6db;
  border-color: #f9c6cc;
}

.alert-danger hr {
  border-top-color: #f7afb7;
}

.alert-danger .alert-link {
  color: #501219;
}

.alert-light {
  color: #6a6a69;
  background-color: #f5f5f4;
  border-color: #f1f0f0;
}

.alert-light hr {
  border-top-color: #e5e3e3;
}

.alert-light .alert-link {
  color: #505050;
}

.alert-dark {
  color: #1b1e21;
  background-color: #d6d8d9;
  border-color: #c6c8ca;
}

.alert-dark hr {
  border-top-color: #b9bbbe;
}

.alert-dark .alert-link {
  color: #040505;
}

.alert-inverse {
  color: #282828;
  background-color: #dbdbdb;
  border-color: #cdcdcd;
}

.alert-inverse hr {
  border-top-color: silver;
}

.alert-inverse .alert-link {
  color: #0f0f0f;
}

.alert-gray {
  color: #6a6a6a;
  background-color: whitesmoke;
  border-color: #f1f1f1;
}

.alert-gray hr {
  border-top-color: #e4e4e4;
}

.alert-gray .alert-link {
  color: #515151;
}

.alert-default {
  color: #818181;
  background-color: #fefefe;
  border-color: #fdfdfd;
}

.alert-default hr {
  border-top-color: #f0f0f0;
}

.alert-default .alert-link {
  color: #686868;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 1rem 0;
  }

  to {
    background-position: 0 0;
  }
}

.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  font-size: 0.75rem;
  background-color: #efedea;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: var(--primary);
  transition: width 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}

.list-group-item-action {
  width: 100%;
  color: #4d4d4d;
  text-align: inherit;
}

.list-group-item-action:hover,
.list-group-item-action:focus {
  z-index: 1;
  color: #4d4d4d;
  text-decoration: none;
  background-color: #f9f6f2;
}

.list-group-item-action:active {
  color: #212529;
  background-color: #efedea;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  margin-bottom: -1px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.list-group-item:last-child {
  margin-bottom: 0;
}

.list-group-item.disabled,
.list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
}

.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: var(--primary);
  border-color: var(--primary);
}

.list-group-horizontal {
  flex-direction: row;
}

.list-group-horizontal .list-group-item {
  margin-right: -1px;
  margin-bottom: 0;
}

.list-group-horizontal .list-group-item:last-child {
  margin-right: 0;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }

  .list-group-horizontal-sm .list-group-item {
    margin-right: -1px;
    margin-bottom: 0;
  }

  .list-group-horizontal-sm .list-group-item:last-child {
    margin-right: 0;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }

  .list-group-horizontal-md .list-group-item {
    margin-right: -1px;
    margin-bottom: 0;
  }

  .list-group-horizontal-md .list-group-item:last-child {
    margin-right: 0;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }

  .list-group-horizontal-lg .list-group-item {
    margin-right: -1px;
    margin-bottom: 0;
  }

  .list-group-horizontal-lg .list-group-item:last-child {
    margin-right: 0;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }

  .list-group-horizontal-xl .list-group-item {
    margin-right: -1px;
    margin-bottom: 0;
  }

  .list-group-horizontal-xl .list-group-item:last-child {
    margin-right: 0;
  }
}

.list-group-flush .list-group-item {
  border-right: 0;
  border-left: 0;
}

.list-group-flush .list-group-item:last-child {
  margin-bottom: -1px;
}

.list-group-flush:first-child .list-group-item:first-child {
  border-top: 0;
}

.list-group-flush:last-child .list-group-item:last-child {
  margin-bottom: 0;
  border-bottom: 0;
}

.list-group-item-primary {
  color: #1d2c56;
  background-color: #c7cfe6;
}

.list-group-item-primary.list-group-item-action:hover,
.list-group-item-primary.list-group-item-action:focus {
  color: #1d2c56;
  background-color: #b5c0de;
}

.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: #1d2c56;
  border-color: #1d2c56;
}

.list-group-item-secondary {
  color: #636a84;
  background-color: #edf1fe;
}

.list-group-item-secondary.list-group-item-action:hover,
.list-group-item-secondary.list-group-item-action:focus {
  color: #636a84;
  background-color: #d5defd;
}

.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: #636a84;
  border-color: #636a84;
}

.list-group-item-success {
  color: #0e5d4d;
  background-color: #bfeae1;
}

.list-group-item-success.list-group-item-action:hover,
.list-group-item-success.list-group-item-action:focus {
  color: #0e5d4d;
  background-color: #ace4d8;
}

.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: #0e5d4d;
  border-color: #0e5d4d;
}

.list-group-item-info {
  color: #304381;
  background-color: #d2dbfd;
}

.list-group-item-info.list-group-item-action:hover,
.list-group-item-info.list-group-item-action:focus {
  color: #304381;
  background-color: #bac7fc;
}

.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: #304381;
  border-color: #304381;
}

.list-group-item-warning {
  color: #7e6533;
  background-color: #fceed3;
}

.list-group-item-warning.list-group-item-action:hover,
.list-group-item-warning.list-group-item-action:focus {
  color: #7e6533;
  background-color: #fae5bb;
}

.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: #7e6533;
  border-color: #7e6533;
}

.list-group-item-danger {
  color: #7a1b26;
  background-color: #f9c6cc;
}

.list-group-item-danger.list-group-item-action:hover,
.list-group-item-danger.list-group-item-action:focus {
  color: #7a1b26;
  background-color: #f7afb7;
}

.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: #7a1b26;
  border-color: #7a1b26;
}

.list-group-item-light {
  color: #6a6a69;
  background-color: #f1f0f0;
}

.list-group-item-light.list-group-item-action:hover,
.list-group-item-light.list-group-item-action:focus {
  color: #6a6a69;
  background-color: #e5e3e3;
}

.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: #6a6a69;
  border-color: #6a6a69;
}

.list-group-item-dark {
  color: #1b1e21;
  background-color: #c6c8ca;
}

.list-group-item-dark.list-group-item-action:hover,
.list-group-item-dark.list-group-item-action:focus {
  color: #1b1e21;
  background-color: #b9bbbe;
}

.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: #1b1e21;
  border-color: #1b1e21;
}

.list-group-item-inverse {
  color: #282828;
  background-color: #cdcdcd;
}

.list-group-item-inverse.list-group-item-action:hover,
.list-group-item-inverse.list-group-item-action:focus {
  color: #282828;
  background-color: silver;
}

.list-group-item-inverse.list-group-item-action.active {
  color: #fff;
  background-color: #282828;
  border-color: #282828;
}

.list-group-item-gray {
  color: #6a6a6a;
  background-color: #f1f1f1;
}

.list-group-item-gray.list-group-item-action:hover,
.list-group-item-gray.list-group-item-action:focus {
  color: #6a6a6a;
  background-color: #e4e4e4;
}

.list-group-item-gray.list-group-item-action.active {
  color: #fff;
  background-color: #6a6a6a;
  border-color: #6a6a6a;
}

.list-group-item-default {
  color: #818181;
  background-color: #fdfdfd;
}

.list-group-item-default.list-group-item-action:hover,
.list-group-item-default.list-group-item-action:focus {
  color: #818181;
  background-color: #f0f0f0;
}

.list-group-item-default.list-group-item-action.active {
  color: #fff;
  background-color: #818181;
  border-color: #818181;
}

.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: .5;
}

.close:hover {
  color: #000;
  text-decoration: none;
}

.close:not(:disabled):not(.disabled):hover,
.close:not(:disabled):not(.disabled):focus {
  opacity: .75;
}




.toast {
  max-width: 350px;
  overflow: hidden;
  font-size: 0.875rem;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  opacity: 0;
}

.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}

.toast.showing {
  opacity: 1;
}

.toast.show {
  display: block;
  opacity: 1;
}

.toast.hide {
  display: none;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.toast-body {
  padding: 0.75rem;
}

.modal-open {
  overflow: hidden;
}

.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}

.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}

@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}

.modal.show .modal-dialog {
  transform: none;
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}

.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}

.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}

.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  content: "";
}

.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}

.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}

.modal-backdrop.fade {
  opacity: 0;
}

.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #cccbca;
}

.modal-header .close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 1rem;
  border-top: 1px solid #cccbca;
}

.modal-footer > :not(:first-child) {
  margin-left: .25rem;
}

.modal-footer > :not(:last-child) {
  margin-right: .25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }

  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }

  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }

  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }

  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
  }

  .modal-sm {
    max-width: 300px;
  }
}

@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}

@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}

.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: "Nunito", "HelveticaNeue-Light", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}

.tooltip.show {
  opacity: 0.9;
}

.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}

.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top,
.bs-tooltip-auto[x-placement^="top"] {
  padding: 0.4rem 0;
}

.bs-tooltip-top .arrow,
.bs-tooltip-auto[x-placement^="top"] .arrow {
  bottom: 0;
}

.bs-tooltip-top .arrow::before,
.bs-tooltip-auto[x-placement^="top"] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #000;
}

.bs-tooltip-right,
.bs-tooltip-auto[x-placement^="right"] {
  padding: 0 0.4rem;
}

.bs-tooltip-right .arrow,
.bs-tooltip-auto[x-placement^="right"] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-right .arrow::before,
.bs-tooltip-auto[x-placement^="right"] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #000;
}

.bs-tooltip-bottom,
.bs-tooltip-auto[x-placement^="bottom"] {
  padding: 0.4rem 0;
}

.bs-tooltip-bottom .arrow,
.bs-tooltip-auto[x-placement^="bottom"] .arrow {
  top: 0;
}

.bs-tooltip-bottom .arrow::before,
.bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #000;
}

.bs-tooltip-left,
.bs-tooltip-auto[x-placement^="left"] {
  padding: 0 0.4rem;
}

.bs-tooltip-left .arrow,
.bs-tooltip-auto[x-placement^="left"] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-left .arrow::before,
.bs-tooltip-auto[x-placement^="left"] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #000;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #000;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: "Nunito", "HelveticaNeue-Light", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.3rem;
}

.popover .arrow::before,
.popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top,
.bs-popover-auto[x-placement^="top"] {
  margin-bottom: 0.5rem;
}

.bs-popover-top > .arrow,
.bs-popover-auto[x-placement^="top"] > .arrow {
  bottom: calc((0.5rem + 1px) * -1);
}

.bs-popover-top > .arrow::before,
.bs-popover-auto[x-placement^="top"] > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-top > .arrow::after,
.bs-popover-auto[x-placement^="top"] > .arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-right,
.bs-popover-auto[x-placement^="right"] {
  margin-left: 0.5rem;
}

.bs-popover-right > .arrow,
.bs-popover-auto[x-placement^="right"] > .arrow {
  left: calc((0.5rem + 1px) * -1);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}

.bs-popover-right > .arrow::before,
.bs-popover-auto[x-placement^="right"] > .arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-right > .arrow::after,
.bs-popover-auto[x-placement^="right"] > .arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom,
.bs-popover-auto[x-placement^="bottom"] {
  margin-top: 0.5rem;
}

.bs-popover-bottom > .arrow,
.bs-popover-auto[x-placement^="bottom"] > .arrow {
  top: calc((0.5rem + 1px) * -1);
}

.bs-popover-bottom > .arrow::before,
.bs-popover-auto[x-placement^="bottom"] > .arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-bottom > .arrow::after,
.bs-popover-auto[x-placement^="bottom"] > .arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}

.bs-popover-bottom .popover-header::before,
.bs-popover-auto[x-placement^="bottom"] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid #f7f7f7;
}

.bs-popover-left,
.bs-popover-auto[x-placement^="left"] {
  margin-right: 0.5rem;
}

.bs-popover-left > .arrow,
.bs-popover-auto[x-placement^="left"] > .arrow {
  right: calc((0.5rem + 1px) * -1);
  width: 0.5rem;
  height: 1rem;
  margin: 0.3rem 0;
}

.bs-popover-left > .arrow::before,
.bs-popover-auto[x-placement^="left"] > .arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}

.bs-popover-left > .arrow::after,
.bs-popover-auto[x-placement^="left"] > .arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
}

.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #212529;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}

.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: 0s 0.6s opacity;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #fff;
  text-align: center;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}

.carousel-control-prev:hover,
.carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: no-repeat 50% / 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}

.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: .5;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}

.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border .75s linear infinite;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }

  50% {
    opacity: 1;
  }
}

.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  animation: spinner-grow .75s linear infinite;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: var(--primary) !important;
}

a.bg-primary:hover,
a.bg-primary:focus {
  background-color: #2a417f !important;
}



a.bg-secondary:hover,
a.bg-secondary:focus {
  background-color: #8da5fb !important;
}

.bg-success {
  background-color: var(--success) !important;
}

a.bg-success:hover,
a.bg-success:focus {
  background-color: #14866f !important;
}

.bg-info {
  background-color: #5d80f9 !important;
}

a.bg-info:hover,
a.bg-info:focus{
  background-color: #2c59f7 !important;
}

.bg-warning {
  background-color: #f3c363 !important;
}

a.bg-warning:hover,
a.bg-warning:focus {
  background-color: #efb134 !important;
}

.bg-danger {
  background-color: #eb3349 !important;
}

a.bg-danger:hover,
a.bg-danger:focus {
  background-color: #d6152c !important;
}

.bg-light {
  background-color: #cccbca !important;
}

a.bg-light:hover,
a.bg-light:focus {
  background-color: #b3b2b0 !important;
}

.bg-dark {
  background-color: #343a40 !important;
}

a.bg-dark:hover,
a.bg-dark:focus {
  background-color: #1d2124 !important;
}

.bg-inverse {
  background-color: #4d4d4d !important;
}

a.bg-inverse:hover,
a.bg-inverse:focus {
  background-color: #343434 !important;
}

.bg-gray {
  background-color: #ccc !important;
}



.bg-default {
  background-color: #f8f8f8 !important;
}

a.bg-default:hover,
a.bg-default:focus {
  background-color: #dfdfdf !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #cccbca !important;
}

.border-top {
  border-top: 1px solid #cccbca !important;
}

.border-right {
  border-right: 1px solid #cccbca !important;
}

.border-bottom {
  border-bottom: 1px solid #cccbca !important;
}

.border-left {
  border-left: 1px solid #cccbca !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: var(--primary) !important;
}

.border-secondary {
  border-color: var(--secondary) !important;
}

.border-success {
  border-color: var(--success) !important;
}

.border-info {
  border-color: #5d80f9 !important;
}

.border-warning {
  border-color: #f3c363 !important;
}

.border-danger {
  border-color: #eb3349 !important;
}

.border-light {
  border-color: #cccbca !important;
}

.border-dark {
  border-color: #343a40 !important;
}

.border-inverse {
  border-color: #4d4d4d !important;
}

.border-gray {
  border-color: #ccc !important;
}

.border-default {
  border-color: #f8f8f8 !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded-sm {
  border-radius: 0.2rem !important;
}

.rounded {
  border-radius: 0.25rem !important;
}

.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}

.rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}

.rounded-lg {
  border-radius: 0.3rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }

  .d-sm-inline {
    display: inline !important;
  }

  .d-sm-inline-block {
    display: inline-block !important;
  }

  .d-sm-block {
    display: block !important;
  }

  .d-sm-table {
    display: table !important;
  }

  .d-sm-table-row {
    display: table-row !important;
  }

  .d-sm-table-cell {
    display: table-cell !important;
  }

  .d-sm-flex {
    display: flex !important;
  }

  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }

  .d-md-inline {
    display: inline !important;
  }

  .d-md-inline-block {
    display: inline-block !important;
  }

  .d-md-block {
    display: block !important;
  }

  .d-md-table {
    display: table !important;
  }

  .d-md-table-row {
    display: table-row !important;
  }

  .d-md-table-cell {
    display: table-cell !important;
  }

  .d-md-flex {
    display: flex !important;
  }

  .d-md-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }

  .d-lg-inline {
    display: inline !important;
  }

  .d-lg-inline-block {
    display: inline-block !important;
  }

  .d-lg-block {
    display: block !important;
  }

  .d-lg-table {
    display: table !important;
  }

  .d-lg-table-row {
    display: table-row !important;
  }

  .d-lg-table-cell {
    display: table-cell !important;
  }

  .d-lg-flex {
    display: flex !important;
  }

  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }

  .d-xl-inline {
    display: inline !important;
  }

  .d-xl-inline-block {
    display: inline-block !important;
  }

  .d-xl-block {
    display: block !important;
  }

  .d-xl-table {
    display: table !important;
  }

  .d-xl-table-row {
    display: table-row !important;
  }

  .d-xl-table-cell {
    display: table-cell !important;
  }

  .d-xl-flex {
    display: flex !important;
  }

  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}

@media print {
  .d-print-none {
    display: none !important;
  }

  .d-print-inline {
    display: inline !important;
  }

  .d-print-inline-block {
    display: inline-block !important;
  }

  .d-print-block {
    display: block !important;
  }

  .d-print-table {
    display: table !important;
  }

  .d-print-table-row {
    display: table-row !important;
  }

  .d-print-table-cell {
    display: table-cell !important;
  }

  .d-print-flex {
    display: flex !important;
  }

  .d-print-inline-flex {
    display: inline-flex !important;
  }
}

.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}

.embed-responsive::before {
  display: block;
  content: "";
}

.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }

  .flex-sm-column {
    flex-direction: column !important;
  }

  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }

  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-sm-fill {
    flex: 1 1 auto !important;
  }

  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-sm-start {
    justify-content: flex-start !important;
  }

  .justify-content-sm-end {
    justify-content: flex-end !important;
  }

  .justify-content-sm-center {
    justify-content: center !important;
  }

  .justify-content-sm-between {
    justify-content: space-between !important;
  }

  .justify-content-sm-around {
    justify-content: space-around !important;
  }

  .align-items-sm-start {
    align-items: flex-start !important;
  }

  .align-items-sm-end {
    align-items: flex-end !important;
  }

  .align-items-sm-center {
    align-items: center !important;
  }

  .align-items-sm-baseline {
    align-items: baseline !important;
  }

  .align-items-sm-stretch {
    align-items: stretch !important;
  }

  .align-content-sm-start {
    align-content: flex-start !important;
  }

  .align-content-sm-end {
    align-content: flex-end !important;
  }

  .align-content-sm-center {
    align-content: center !important;
  }

  .align-content-sm-between {
    align-content: space-between !important;
  }

  .align-content-sm-around {
    align-content: space-around !important;
  }

  .align-content-sm-stretch {
    align-content: stretch !important;
  }

  .align-self-sm-auto {
    align-self: auto !important;
  }

  .align-self-sm-start {
    align-self: flex-start !important;
  }

  .align-self-sm-end {
    align-self: flex-end !important;
  }

  .align-self-sm-center {
    align-self: center !important;
  }

  .align-self-sm-baseline {
    align-self: baseline !important;
  }

  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }

  .flex-md-column {
    flex-direction: column !important;
  }

  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-md-wrap {
    flex-wrap: wrap !important;
  }

  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-md-fill {
    flex: 1 1 auto !important;
  }

  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-md-start {
    justify-content: flex-start !important;
  }

  .justify-content-md-end {
    justify-content: flex-end !important;
  }

  .justify-content-md-center {
    justify-content: center !important;
  }

  .justify-content-md-between {
    justify-content: space-between !important;
  }

  .justify-content-md-around {
    justify-content: space-around !important;
  }

  .align-items-md-start {
    align-items: flex-start !important;
  }

  .align-items-md-end {
    align-items: flex-end !important;
  }

  .align-items-md-center {
    align-items: center !important;
  }

  .align-items-md-baseline {
    align-items: baseline !important;
  }

  .align-items-md-stretch {
    align-items: stretch !important;
  }

  .align-content-md-start {
    align-content: flex-start !important;
  }

  .align-content-md-end {
    align-content: flex-end !important;
  }

  .align-content-md-center {
    align-content: center !important;
  }

  .align-content-md-between {
    align-content: space-between !important;
  }

  .align-content-md-around {
    align-content: space-around !important;
  }

  .align-content-md-stretch {
    align-content: stretch !important;
  }

  .align-self-md-auto {
    align-self: auto !important;
  }

  .align-self-md-start {
    align-self: flex-start !important;
  }

  .align-self-md-end {
    align-self: flex-end !important;
  }

  .align-self-md-center {
    align-self: center !important;
  }

  .align-self-md-baseline {
    align-self: baseline !important;
  }

  .align-self-md-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }

  .flex-lg-column {
    flex-direction: column !important;
  }

  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }

  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-lg-fill {
    flex: 1 1 auto !important;
  }

  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-lg-start {
    justify-content: flex-start !important;
  }

  .justify-content-lg-end {
    justify-content: flex-end !important;
  }

  .justify-content-lg-center {
    justify-content: center !important;
  }

  .justify-content-lg-between {
    justify-content: space-between !important;
  }

  .justify-content-lg-around {
    justify-content: space-around !important;
  }

  .align-items-lg-start {
    align-items: flex-start !important;
  }

  .align-items-lg-end {
    align-items: flex-end !important;
  }

  .align-items-lg-center {
    align-items: center !important;
  }

  .align-items-lg-baseline {
    align-items: baseline !important;
  }

  .align-items-lg-stretch {
    align-items: stretch !important;
  }

  .align-content-lg-start {
    align-content: flex-start !important;
  }

  .align-content-lg-end {
    align-content: flex-end !important;
  }

  .align-content-lg-center {
    align-content: center !important;
  }

  .align-content-lg-between {
    align-content: space-between !important;
  }

  .align-content-lg-around {
    align-content: space-around !important;
  }

  .align-content-lg-stretch {
    align-content: stretch !important;
  }

  .align-self-lg-auto {
    align-self: auto !important;
  }

  .align-self-lg-start {
    align-self: flex-start !important;
  }

  .align-self-lg-end {
    align-self: flex-end !important;
  }

  .align-self-lg-center {
    align-self: center !important;
  }

  .align-self-lg-baseline {
    align-self: baseline !important;
  }

  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }

  .flex-xl-column {
    flex-direction: column !important;
  }

  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .flex-xl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .justify-content-xl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xl-center {
    justify-content: center !important;
  }

  .justify-content-xl-between {
    justify-content: space-between !important;
  }

  .justify-content-xl-around {
    justify-content: space-around !important;
  }

  .align-items-xl-start {
    align-items: flex-start !important;
  }

  .align-items-xl-end {
    align-items: flex-end !important;
  }

  .align-items-xl-center {
    align-items: center !important;
  }

  .align-items-xl-baseline {
    align-items: baseline !important;
  }

  .align-items-xl-stretch {
    align-items: stretch !important;
  }

  .align-content-xl-start {
    align-content: flex-start !important;
  }

  .align-content-xl-end {
    align-content: flex-end !important;
  }

  .align-content-xl-center {
    align-content: center !important;
  }

  .align-content-xl-between {
    align-content: space-between !important;
  }

  .align-content-xl-around {
    align-content: space-around !important;
  }

  .align-content-xl-stretch {
    align-content: stretch !important;
  }

  .align-self-xl-auto {
    align-self: auto !important;
  }

  .align-self-xl-start {
    align-self: flex-start !important;
  }

  .align-self-xl-end {
    align-self: flex-end !important;
  }

  .align-self-xl-center {
    align-self: center !important;
  }

  .align-self-xl-baseline {
    align-self: baseline !important;
  }

  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}

.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }

  .float-sm-right {
    float: right !important;
  }

  .float-sm-none {
    float: none !important;
  }
}

@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }

  .float-md-right {
    float: right !important;
  }

  .float-md-none {
    float: none !important;
  }
}

@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }

  .float-lg-right {
    float: right !important;
  }

  .float-lg-none {
    float: none !important;
  }
}

@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }

  .float-xl-right {
    float: right !important;
  }

  .float-xl-none {
    float: none !important;
  }
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -3rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}



@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }

  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }

  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }

  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }

  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }

  .m-sm-1 {
    margin: 0.25rem !important;
  }

  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }

  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }

  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }

  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }

  .m-sm-2 {
    margin: 0.5rem !important;
  }

  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }

  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }

  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }

  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }

  .m-sm-3 {
    margin: 1rem !important;
  }

  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }

  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }

  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }

  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }

  .m-sm-4 {
    margin: 1.5rem !important;
  }

  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }

  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }

  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }

  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }

  .m-sm-5 {
    margin: 3rem !important;
  }

  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }

  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }

  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }

  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }

  .p-sm-0 {
    padding: 0 !important;
  }

  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }

  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }

  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }

  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }

  .p-sm-1 {
    padding: 0.25rem !important;
  }

  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }

  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }

  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }

  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }

  .p-sm-2 {
    padding: 0.5rem !important;
  }

  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }

  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }

  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }

  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }

  .p-sm-3 {
    padding: 1rem !important;
  }

  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }

  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }

  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }

  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }

  .p-sm-4 {
    padding: 1.5rem !important;
  }

  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }

  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }

  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }

  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }

  .p-sm-5 {
    padding: 3rem !important;
  }

  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }

  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }

  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }

  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }

  .m-sm-n1 {
    margin: -0.25rem !important;
  }

  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important;
  }

  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
  }

  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }

  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important;
  }

  .m-sm-n2 {
    margin: -0.5rem !important;
  }

  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important;
  }

  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
  }

  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }

  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important;
  }

  .m-sm-n3 {
    margin: -1rem !important;
  }

  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important;
  }

  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important;
  }

  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important;
  }

  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important;
  }

  .m-sm-n4 {
    margin: -1.5rem !important;
  }

  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important;
  }

  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }

  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }

  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }

  .m-sm-n5 {
    margin: -3rem !important;
  }

  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important;
  }

  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important;
  }

  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important;
  }

  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important;
  }

  .m-sm-auto {
    margin: auto !important;
  }

  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }

  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }

  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }

  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }

  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }

  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }

  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }

  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }

  .m-md-1 {
    margin: 0.25rem !important;
  }

  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }

  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }

  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }

  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }

  .m-md-2 {
    margin: 0.5rem !important;
  }

  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }

  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }

  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }

  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }

  .m-md-3 {
    margin: 1rem !important;
  }

  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }

  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }

  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }

  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }

  .m-md-4 {
    margin: 1.5rem !important;
  }

  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }

  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }

  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }

  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }

  .m-md-5 {
    margin: 3rem !important;
  }

  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }

  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }

  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }

  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }

  .p-md-0 {
    padding: 0 !important;
  }

  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }

  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }

  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }

  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }

  .p-md-1 {
    padding: 0.25rem !important;
  }

  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }

  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }

  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }

  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }

  .p-md-2 {
    padding: 0.5rem !important;
  }

  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }

  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }

  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }

  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }

  .p-md-3 {
    padding: 1rem !important;
  }

  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }

  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }

  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }

  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }

  .p-md-4 {
    padding: 1.5rem !important;
  }

  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }

  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }

  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }

  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }

  .p-md-5 {
    padding: 3rem !important;
  }

  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }

  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }

  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }

  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }

  .m-md-n1 {
    margin: -0.25rem !important;
  }

  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important;
  }

  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important;
  }

  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important;
  }

  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important;
  }

  .m-md-n2 {
    margin: -0.5rem !important;
  }

  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important;
  }

  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important;
  }

  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important;
  }

  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important;
  }

  .m-md-n3 {
    margin: -1rem !important;
  }

  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important;
  }

  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important;
  }

  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important;
  }

  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important;
  }

  .m-md-n4 {
    margin: -1.5rem !important;
  }

  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important;
  }

  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important;
  }

  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }

  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important;
  }

  .m-md-n5 {
    margin: -3rem !important;
  }

  .mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important;
  }

  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important;
  }

  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important;
  }

  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important;
  }

  .m-md-auto {
    margin: auto !important;
  }

  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }

  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }

  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }

  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }

  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }

  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }

  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }

  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }

  .m-lg-1 {
    margin: 0.25rem !important;
  }

  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }

  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }

  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }

  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }

  .m-lg-2 {
    margin: 0.5rem !important;
  }

  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }

  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }

  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }

  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }

  .m-lg-3 {
    margin: 1rem !important;
  }

  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }

  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }

  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }

  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }

  .m-lg-4 {
    margin: 1.5rem !important;
  }

  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }

  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }

  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }

  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }

  .m-lg-5 {
    margin: 3rem !important;
  }

  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }

  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }

  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }

  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }

  .p-lg-0 {
    padding: 0 !important;
  }

  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }

  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }

  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }

  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }

  .p-lg-1 {
    padding: 0.25rem !important;
  }

  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }

  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }

  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }

  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }

  .p-lg-2 {
    padding: 0.5rem !important;
  }

  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }

  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }

  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }

  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }

  .p-lg-3 {
    padding: 1rem !important;
  }

  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }

  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }

  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }

  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }

  .p-lg-4 {
    padding: 1.5rem !important;
  }

  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }

  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }

  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }

  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }

  .p-lg-5 {
    padding: 3rem !important;
  }

  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }

  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }

  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }

  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }

  .m-lg-n1 {
    margin: -0.25rem !important;
  }

  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important;
  }

  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
  }

  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }

  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important;
  }

  .m-lg-n2 {
    margin: -0.5rem !important;
  }

  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important;
  }

  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
  }

  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }

  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important;
  }

  .m-lg-n3 {
    margin: -1rem !important;
  }

  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important;
  }

  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important;
  }

  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important;
  }

  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important;
  }

  .m-lg-n4 {
    margin: -1.5rem !important;
  }

  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important;
  }

  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }

  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }

  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }

  .m-lg-n5 {
    margin: -3rem !important;
  }

  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important;
  }

  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important;
  }

  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important;
  }

  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important;
  }

  .m-lg-auto {
    margin: auto !important;
  }

  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }

  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }

  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }

  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }

  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }

  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }

  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }

  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }

  .m-xl-1 {
    margin: 0.25rem !important;
  }

  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }

  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }

  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }

  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }

  .m-xl-2 {
    margin: 0.5rem !important;
  }

  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }

  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }

  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }

  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }

  .m-xl-3 {
    margin: 1rem !important;
  }

  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }

  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }

  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }

  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }

  .m-xl-4 {
    margin: 1.5rem !important;
  }

  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }

  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }

  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }

  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }

  .m-xl-5 {
    margin: 3rem !important;
  }

  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }

  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }

  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }

  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }

  .p-xl-0 {
    padding: 0 !important;
  }

  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }

  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }

  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }

  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }

  .p-xl-1 {
    padding: 0.25rem !important;
  }

  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }

  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }

  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }

  .p-xl-2 {
    padding: 0.5rem !important;
  }

  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }

  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }

  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }

  .p-xl-3 {
    padding: 1rem !important;
  }

  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }

  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }

  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }

  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }

  .p-xl-4 {
    padding: 1.5rem !important;
  }

  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }

  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }

  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }

  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }

  .p-xl-5 {
    padding: 3rem !important;
  }

  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }

  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }

  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }

  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }

  .m-xl-n1 {
    margin: -0.25rem !important;
  }

  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important;
  }

  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
  }

  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }

  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important;
  }

  .m-xl-n2 {
    margin: -0.5rem !important;
  }

  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important;
  }

  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
  }

  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }

  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important;
  }

  .m-xl-n3 {
    margin: -1rem !important;
  }

  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important;
  }

  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important;
  }

  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important;
  }

  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important;
  }

  .m-xl-n4 {
    margin: -1.5rem !important;
  }

  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important;
  }

  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }

  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }

  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }

  .m-xl-n5 {
    margin: -3rem !important;
  }

  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important;
  }

  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important;
  }

  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important;
  }

  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important;
  }

  .m-xl-auto {
    margin: auto !important;
  }

  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }

  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }

  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }

  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }

  .text-sm-right {
    text-align: right !important;
  }

  .text-sm-center {
    text-align: center !important;
  }
}

@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }

  .text-md-right {
    text-align: right !important;
  }

  .text-md-center {
    text-align: center !important;
  }
}

@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }

  .text-lg-right {
    text-align: right !important;
  }

  .text-lg-center {
    text-align: center !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }

  .text-xl-right {
    text-align: right !important;
  }

  .text-xl-center {
    text-align: center !important;
  }
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: var(--primary) !important;
}

a.text-primary:hover,
a.text-primary:focus {
  color: #24376c !important;
}

.text-secondary {
  color: var(--secondary) !important;
}

a.text-secondary:hover,
a.text-secondary:focus {
  color: #7492fb !important;
}

.text-success {
  color: var(--success) !important;
}

a.text-success:hover,
a.text-success:focus {
  color: #10705d !important;
}

.text-info {
  color: #5d80f9 !important;
}

a.text-info:hover,
a.text-info:focus {
  color: #1346f6 !important;
}

.text-warning {
  color: #f3c363 !important;
}

a.text-warning:hover,
a.text-warning:focus {
  color: #eea81c !important;
}

.text-danger {
  color: #eb3349 !important;
}

a.text-danger:hover,
a.text-danger:focus {
  color: #bf1327 !important;
}

.text-light {
  color: #cccbca !important;
}

a.text-light:hover,
a.text-light:focus {
  color: #a6a5a3 !important;
}

.text-dark {
  color: #343a40 !important;
}

a.text-dark:hover,
a.text-dark:focus {
  color: #121416 !important;
}

.text-inverse {
  color: #4d4d4d !important;
}

a.text-inverse:hover,
a.text-inverse:focus {
  color: #272727 !important;
}

.text-gray {
  color: #ccc !important;
}

a.text-gray:hover,
a.text-gray:focus {
  color: #a6a6a6 !important;
}

.text-default {
  color: #f8f8f8 !important;
}

a.text-default:hover,
a.text-default:focus {
  color: #d2d2d2 !important;
}

.text-body {
  color: #212529 !important;
}

.text-muted {
  color: #cccbca !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }

  a:not(.btn) {
    text-decoration: underline;
  }

  abbr[title]::after {
    content: " (" attr(title) ")";
  }

  pre {
    white-space: pre-wrap !important;
  }

  pre,
  blockquote {
    border: 1px solid #666;
    page-break-inside: avoid;
  }

  thead {
    display: table-header-group;
  }

  tr,
  img {
    page-break-inside: avoid;
  }

  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }

  h2,
  h3 {
    page-break-after: avoid;
  }

@page {
    size: a3;
}

  body {
    min-width: 992px !important;
  }

  .container {
    min-width: 992px !important;
  }

  .navbar {
    display: none;
  }

  .badge {
    border: 1px solid #000;
  }

  .table {
    border-collapse: collapse !important;
  }

  .table td,
  .table th {
    background-color: #fff !important;
  }

  .table-bordered th,
  .table-bordered td {
    border: 1px solid #cccbca !important;
  }

  .table-dark {
    color: inherit;
  }

  .table-dark th,
  .table-dark td,
  .table-dark thead th,
  .table-dark tbody + tbody {
    border-color: #cccbca;
  }

  .table .thead-dark th {
    color: inherit;
    border-color: #cccbca;
  }
}

/*
 * Glyphicons Halflings
 */



.glyphicon {
  position: relative;
  top: 1px;
  display: inline-block;
  font-family: 'Glyphicons Halflings';
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  vertical-align: top;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.glyphicon.x05 {
  font-size: 7px;
}

.glyphicon.x2 {
  font-size: 28px;
}

.glyphicon.x3 {
  font-size: 42px;
}

.glyphicon.x4 {
  font-size: 56px;
}

.glyphicon.x5 {
  font-size: 70px;
}

.glyphicon.x6 {
  font-size: 84px;
}

.glyphicon.x7 {
  font-size: 98px;
}

.glyphicon.x8 {
  font-size: 112px;
}

.glyphicon.light:before {
  color: #f2f2f2;
}

.glyphicon.drop:before {
  text-shadow: -1px 1px 3px rgba(0, 0, 0, 0.3);
}

.glyphicon.flip {
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}

.glyphicon.flipv {
  transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV";
}

.glyphicon.rotate90 {
  transform: rotate(90deg);
}

.glyphicon.rotate180 {
  transform: rotate(180deg);
}

.glyphicon.rotate270 {
  transform: rotate(270deg);
}

.glyphicon-glass:before {
  content: "\\E001";
}

.glyphicon-music:before {
  content: "\\E002";
}

.glyphicon-search:before {
  content: "\\E003";
}

.glyphicon-envelope:before {
  content: "\\2709";
}

.glyphicon-heart:before {
  content: "\\E005";
}

.glyphicon-star:before {
  content: "\\E006";
}

.glyphicon-star-empty:before {
  content: "\\E007";
}

.glyphicon-user:before {
  content: "\\E008";
}

.glyphicon-film:before {
  content: "\\E009";
}

.glyphicon-th-large:before {
  content: "\\E010";
}

.glyphicon-th:before {
  content: "\\E011";
}

.glyphicon-th-list:before {
  content: "\\E012";
}

.glyphicon-ok:before {
  content: "\\E013";
}

.glyphicon-remove:before {
  content: "\\E014";
}

.glyphicon-zoom-in:before {
  content: "\\E015";
}

.glyphicon-zoom-out:before {
  content: "\\E016";
}

.glyphicon-off:before {
  content: "\\E017";
}

.glyphicon-signal:before {
  content: "\\E018";
}

.glyphicon-cog:before {
  content: "\\E019";
}

.glyphicon-trash:before {
  content: "\\E020";
}

.glyphicon-home:before {
  content: "\\E021";
}

.glyphicon-file:before {
  content: "\\E022";
}

.glyphicon-time:before {
  content: "\\E023";
}

.glyphicon-road:before {
  content: "\\E024";
}

.glyphicon-download-alt:before {
  content: "\\E025";
}

.glyphicon-download:before {
  content: "\\E026";
}

.glyphicon-upload:before {
  content: "\\E027";
}

.glyphicon-inbox:before {
  content: "\\E028";
}

.glyphicon-play-circle:before {
  content: "\\E029";
}

.glyphicon-repeat:before {
  content: "\\E030";
}

.glyphicon-refresh:before {
  content: "\\E031";
}

.glyphicon-list-alt:before {
  content: "\\E032";
}

.glyphicon-glyph-lock:before {
  content: "\\E033";
}

.glyphicon-flag:before {
  content: "\\E034";
}

.glyphicon-headphones:before {
  content: "\\E035";
}

.glyphicon-volume-off:before {
  content: "\\E036";
}

.glyphicon-volume-down:before {
  content: "\\E037";
}

.glyphicon-volume-up:before {
  content: "\\E038";
}

.glyphicon-qrcode:before {
  content: "\\E039";
}

.glyphicon-barcode:before {
  content: "\\E040";
}

.glyphicon-tag:before {
  content: "\\E041";
}

.glyphicon-tags:before {
  content: "\\E042";
}

.glyphicon-book:before {
  content: "\\E043";
}

.glyphicon-glyph-bookmark:before {
  content: "\\E044";
}

.glyphicon-print:before {
  content: "\\E045";
}

.glyphicon-glyph-camera:before {
  content: "\\E046";
}

.glyphicon-font:before {
  content: "\\E047";
}

.glyphicon-bold:before {
  content: "\\E048";
}

.glyphicon-italic:before {
  content: "\\E049";
}

.glyphicon-text-height:before {
  content: "\\E050";
}

.glyphicon-text-width:before {
  content: "\\E051";
}

.glyphicon-align-left:before {
  content: "\\E052";
}

.glyphicon-align-center:before {
  content: "\\E053";
}

.glyphicon-align-right:before {
  content: "\\E054";
}

.glyphicon-align-justify:before {
  content: "\\E055";
}

.glyphicon-list:before {
  content: "\\E056";
}

.glyphicon-indent-left:before {
  content: "\\E057";
}

.glyphicon-indent-right:before {
  content: "\\E058";
}

.glyphicon-facetime-video:before {
  content: "\\E059";
}

.glyphicon-picture:before {
  content: "\\E060";
}

.glyphicon-pencil:before {
  content: "\\270F";
}

.glyphicon-map-marker:before {
  content: "\\E062";
}

.glyphicon-adjust:before {
  content: "\\E063";
}

.glyphicon-tint:before {
  content: "\\E064";
}

.glyphicon-edit:before {
  content: "\\E065";
}

.glyphicon-share:before {
  content: "\\E066";
}

.glyphicon-check:before {
  content: "\\E067";
}

.glyphicon-move:before {
  content: "\\E068";
}

.glyphicon-step-backward:before {
  content: "\\E069";
}

.glyphicon-fast-backward:before {
  content: "\\E070";
}

.glyphicon-backward:before {
  content: "\\E071";
}

.glyphicon-play:before {
  content: "\\E072";
}

.glyphicon-pause:before {
  content: "\\E073";
}

.glyphicon-stop:before {
  content: "\\E074";
}

.glyphicon-forward:before {
  content: "\\E075";
}

.glyphicon-fast-forward:before {
  content: "\\E076";
}

.glyphicon-step-forward:before {
  content: "\\E077";
}

.glyphicon-eject:before {
  content: "\\E078";
}

.glyphicon-chevron-left:before {
  content: "\\E079";
}

.glyphicon-chevron-right:before {
  content: "\\E080";
}

.glyphicon-plus-sign:before {
  content: "\\E081";
}

.glyphicon-minus-sign:before {
  content: "\\E082";
}

.glyphicon-remove-sign:before {
  content: "\\E083";
}

.glyphicon-ok-sign:before {
  content: "\\E084";
}

.glyphicon-question-sign:before {
  content: "\\E085";
}

.glyphicon-info-sign:before {
  content: "\\E086";
}

.glyphicon-screenshot:before {
  content: "\\E087";
}

.glyphicon-remove-circle:before {
  content: "\\E088";
}

.glyphicon-ok-circle:before {
  content: "\\E089";
}

.glyphicon-ban-circle:before {
  content: "\\E090";
}

.glyphicon-arrow-left:before {
  content: "\\E091";
}

.glyphicon-arrow-right:before {
  content: "\\E092";
}

.glyphicon-arrow-up:before {
  content: "\\E093";
}

.glyphicon-arrow-down:before {
  content: "\\E094";
}

.glyphicon-share-alt:before {
  content: "\\E095";
}

.glyphicon-resize-full:before {
  content: "\\E096";
}

.glyphicon-resize-small:before {
  content: "\\E097";
}

.glyphicon-plus:before {
  content: "\\002B";
}

.glyphicon-minus:before {
  content: "\\2212";
}

.glyphicon-asterisk:before {
  content: "\\002A";
}

.glyphicon-exclamation-sign:before {
  content: "\\E101";
}

.glyphicon-gift:before {
  content: "\\E102";
}

.glyphicon-leaf:before {
  content: "\\E103";
}

.glyphicon-glyph-fire:before {
  content: "\\E104";
}

.glyphicon-eye-open:before {
  content: "\\E105";
}

.glyphicon-eye-close:before {
  content: "\\E106";
}

.glyphicon-warning-sign:before {
  content: "\\E107";
}

.glyphicon-plane:before {
  content: "\\E108";
}

.glyphicon-glyph-calendar:before {
  content: "\\E109";
}

.glyphicon-random:before {
  content: "\\E110";
}

.glyphicon-comments:before {
  content: "\\E111";
}

.glyphicon-magnet:before {
  content: "\\E112";
}

.glyphicon-chevron-up:before {
  content: "\\E113";
}

.glyphicon-chevron-down:before {
  content: "\\E114";
}

.glyphicon-retweet:before {
  content: "\\E115";
}

.glyphicon-shopping-cart:before {
  content: "\\E116";
}

.glyphicon-folder-close:before {
  content: "\\E117";
}

.glyphicon-folder-open:before {
  content: "\\E118";
}

.glyphicon-resize-vertical:before {
  content: "\\E119";
}

.glyphicon-resize-horizontal:before {
  content: "\\E120";
}

.glyphicon-hdd:before {
  content: "\\E121";
}

.glyphicon-bullhorn:before {
  content: "\\E122";
}

.glyphicon-glyph-bell:before {
  content: "\\E123";
}

.glyphicon-certificate:before {
  content: "\\E124";
}

.glyphicon-thumbs-up:before {
  content: "\\E125";
}

.glyphicon-thumbs-down:before {
  content: "\\E126";
}

.glyphicon-hand-right:before {
  content: "\\E127";
}

.glyphicon-hand-left:before {
  content: "\\E128";
}

.glyphicon-hand-top:before {
  content: "\\E129";
}

.glyphicon-hand-down:before {
  content: "\\E130";
}

.glyphicon-circle-arrow-right:before {
  content: "\\E131";
}

.glyphicon-circle-arrow-left:before {
  content: "\\E132";
}

.glyphicon-circle-arrow-top:before {
  content: "\\E133";
}

.glyphicon-circle-arrow-down:before {
  content: "\\E134";
}

.glyphicon-globe:before {
  content: "\\E135";
}

.glyphicon-glyph-wrench:before {
  content: "\\E136";
}

.glyphicon-tasks:before {
  content: "\\E137";
}

.glyphicon-filter:before {
  content: "\\E138";
}

.glyphicon-glyph-briefcase:before {
  content: "\\E139";
}

.glyphicon-fullscreen:before {
  content: "\\E140";
}

.glyphicon-dashboard:before {
  content: "\\E141";
}

.glyphicon-glyph-paperclip:before {
  content: "\\E142";
}

.glyphicon-heart-empty:before {
  content: "\\E143";
}

.glyphicon-link:before {
  content: "\\E144";
}

.glyphicon-phone:before {
  content: "\\E145";
}

.glyphicon-glyph-pushpin:before {
  content: "\\E146";
}

.glyphicon-euro:before {
  content: "\\20AC";
}

.glyphicon-usd:before {
  content: "\\E148";
}

.glyphicon-gbp:before {
  content: "\\E149";
}

.glyphicon-sort:before {
  content: "\\E150";
}

.glyphicon-sort-by-alphabet:before {
  content: "\\E151";
}

.glyphicon-sort-by-alphabet-alt:before {
  content: "\\E152";
}

.glyphicon-sort-by-order:before {
  content: "\\E153";
}

.glyphicon-sort-by-order-alt:before {
  content: "\\E154";
}

.glyphicon-sort-by-attributes:before {
  content: "\\E155";
}

.glyphicon-sort-by-attributes-alt:before {
  content: "\\E156";
}

.glyphicon-unchecked:before {
  content: "\\E157";
}

.glyphicon-expand:before {
  content: "\\E158";
}

.glyphicon-collapse:before {
  content: "\\E159";
}

.glyphicon-collapse-top:before {
  content: "\\E160";
}

.glyphicon-log-in:before {
  content: "\\E161";
}

.glyphicon-flash:before {
  content: "\\E162";
}

.glyphicon-log-out:before {
  content: "\\E163";
}

.glyphicon-new-window:before {
  content: "\\E164";
}

.glyphicon-record:before {
  content: "\\E165";
}

.glyphicon-save:before {
  content: "\\E166";
}

.glyphicon-open:before {
  content: "\\E167";
}

.glyphicon-saved:before {
  content: "\\E168";
}

.glyphicon-import:before {
  content: "\\E169";
}

.glyphicon-export:before {
  content: "\\E170";
}

.glyphicon-send:before {
  content: "\\E171";
}

.glyphicon-floppy-disk:before {
  content: "\\E172";
}

.glyphicon-floppy-saved:before {
  content: "\\E173";
}

.glyphicon-floppy-remove:before {
  content: "\\E174";
}

.glyphicon-floppy-save:before {
  content: "\\E175";
}

.glyphicon-floppy-open:before {
  content: "\\E176";
}

.glyphicon-credit-card:before {
  content: "\\E177";
}

.glyphicon-transfer:before {
  content: "\\E178";
}

.glyphicon-cutlery:before {
  content: "\\E179";
}

.glyphicon-header:before {
  content: "\\E180";
}

.glyphicon-compressed:before {
  content: "\\E181";
}

.glyphicon-earphone:before {
  content: "\\E182";
}

.glyphicon-phone-alt:before {
  content: "\\E183";
}

.glyphicon-tower:before {
  content: "\\E184";
}

.glyphicon-stats:before {
  content: "\\E185";
}

.glyphicon-sd-video:before {
  content: "\\E186";
}

.glyphicon-hd-video:before {
  content: "\\E187";
}

.glyphicon-subtitles:before {
  content: "\\E188";
}

.glyphicon-sound-stereo:before {
  content: "\\E189";
}

.glyphicon-sound-dolby:before {
  content: "\\E190";
}

.glyphicon-sound-5-1:before {
  content: "\\E191";
}

.glyphicon-sound-6-1:before {
  content: "\\E192";
}

.glyphicon-sound-7-1:before {
  content: "\\E193";
}

.glyphicon-copyright-mark:before {
  content: "\\E194";
}

.glyphicon-registration-mark:before {
  content: "\\E195";
}

.glyphicon-cloud:before {
  content: "\\2601";
}

.glyphicon-cloud-download:before {
  content: "\\E197";
}

.glyphicon-cloud-upload:before {
  content: "\\E198";
}

.glyphicon-tree-conifer:before {
  content: "\\E199";
}

.glyphicon-tree-deciduous:before {
  content: "\\E200";
}

.glyphicon-cd:before {
  content: "\\E201";
}

.glyphicon-save-file:before {
  content: "\\E202";
}

.glyphicon-open-file:before {
  content: "\\E203";
}

.glyphicon-level-up:before {
  content: "\\E204";
}

.glyphicon-copy:before {
  content: "\\E205";
}

.glyphicon-paste:before {
  content: "\\E206";
}

.glyphicon-door:before {
  content: "\\1F6AA";
}

.glyphicon-key:before {
  content: "\\1F511";
}

.glyphicon-alert:before {
  content: "\\E209";
}

.glyphicon-equalizer:before {
  content: "\\E210";
}

.glyphicon-king:before {
  content: "\\E211";
}

.glyphicon-queen:before {
  content: "\\E212";
}

.glyphicon-pawn:before {
  content: "\\E213";
}

.glyphicon-bishop:before {
  content: "\\E214";
}

.glyphicon-knight:before {
  content: "\\E215";
}

.glyphicon-baby-formula:before {
  content: "\\E216";
}

.glyphicon-tent:before {
  content: "\\26FA";
}

.glyphicon-blackboard:before {
  content: "\\E218";
}

.glyphicon-bed:before {
  content: "\\E219";
}

.glyphicon-apple:before {
  content: "\\F8FF";
}

.glyphicon-erase:before {
  content: "\\E221";
}

.glyphicon-hourglass:before {
  content: "\\231B";
}

.glyphicon-lamp:before {
  content: "\\E223";
}

.glyphicon-duplicate:before {
  content: "\\E224";
}

.glyphicon-piggy-bank:before {
  content: "\\E225";
}

.glyphicon-scissors:before {
  content: "\\E226";
}

.glyphicon-bitcoin:before {
  content: "\\E227";
}

.glyphicon-yen:before {
  content: "\\00A5";
}

.glyphicon-ruble:before {
  content: "\\20BD";
}

.glyphicon-scale:before {
  content: "\\E230";
}

.glyphicon-ice-lolly:before {
  content: "\\E231";
}

.glyphicon-ice-lolly-tasted:before {
  content: "\\E232";
}

.glyphicon-education:before {
  content: "\\E233";
}

.glyphicon-option-horizontal:before {
  content: "\\E234";
}

.glyphicon-option-vertical:before {
  content: "\\E235";
}

.glyphicon-menu-hamburger:before {
  content: "\\E236";
}

.glyphicon-modal-window:before {
  content: "\\E237";
}

.glyphicon-oil:before {
  content: "\\E238";
}

.glyphicon-grain:before {
  content: "\\E239";
}

.glyphicon-sunglasses:before {
  content: "\\E240";
}

.glyphicon-text-size:before {
  content: "\\E241";
}

.glyphicon-text-color:before {
  content: "\\E242";
}

.glyphicon-text-background:before {
  content: "\\E243";
}

.glyphicon-object-align-top:before {
  content: "\\E244";
}

.glyphicon-object-align-bottom:before {
  content: "\\E245";
}

.glyphicon-object-align-horizontal:before {
  content: "\\E246";
}

.glyphicon-object-align-left:before {
  content: "\\E247";
}

.glyphicon-object-align-vertical:before {
  content: "\\E248";
}

.glyphicon-object-align-right:before {
  content: "\\E249";
}

.glyphicon-triangle-right:before {
  content: "\\E250";
}

.glyphicon-triangle-left:before {
  content: "\\E251";
}

.glyphicon-triangle-bottom:before {
  content: "\\E252";
}

.glyphicon-triangle-top:before {
  content: "\\E253";
}

.glyphicon-terminal:before {
  content: "\\E254";
}

.glyphicon-superscript:before {
  content: "\\E255";
}

.glyphicon-subscript:before {
  content: "\\E256";
}

.glyphicon-menu-left:before {
  content: "\\E257";
}

.glyphicon-menu-right:before {
  content: "\\E258";
}

.glyphicon-menu-down:before {
  content: "\\E259";
}

.glyphicon-menu-up:before {
  content: "\\E260";
}

/* 
* 
* THIS IS A SMALL BONUS FOR ALL CURIOUS PEOPLE :) 
* Just add class .animated and .pulse, .rotateIn, .bounce, .swing or .tada to you HTML element with icons. You may find other great css animations here: http://coveloping.com/tools/css-animation-generator 
* 
*/

.abc-checkbox {
  cursor: default;
  padding-left: 4px;
}

.abc-checkbox label {
  cursor: pointer;
  display: inline;
  vertical-align: top;
  position: relative;
  padding-left: 5px;
}

.abc-checkbox label::before {
  cursor: pointer;
  content: "";
  display: inline-block;
  position: absolute;
  width: 17px;
  height: 17px;
  top: 2px;
  left: 0;
  margin-left: -1.25rem;
  border: 1px solid #ccc;
  border-radius: 3px;
  background-color: #fff;
  transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .abc-checkbox label::before {
    transition: none;
  }
}

.abc-checkbox label::after {
  cursor: pointer;
  display: inline-block;
  position: absolute;
  width: 16px;
  height: 16px;
  left: 0;
  top: 2px;
  margin-left: -1.25rem;
  padding-left: 3px;
  padding-top: 1px;
  font-size: 11px;
  color: #4d4d4d;
}

.abc-checkbox input[type="checkbox"],
.abc-checkbox input[type="radio"] {
  position: static;
  margin-left: 0;
  cursor: pointer;
  opacity: 0;
  z-index: 1;
}

.abc-checkbox input[type="checkbox"]:focus + label::before,
.abc-checkbox input[type="radio"]:focus + label::before {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

.abc-checkbox input[type="checkbox"]:checked + label::after,
.abc-checkbox input[type="radio"]:checked + label::after {
  font-family: "FontAwesome";
  content: "";
}

.abc-checkbox input[type="checkbox"]:indeterminate + label::after,
.abc-checkbox input[type="radio"]:indeterminate + label::after {
  display: block;
  content: "";
  width: 10px;
  height: 3px;
  background-color: #555555;
  border-radius: 2px;
  margin-left: -16.5px;
  margin-top: 7px;
}

.abc-checkbox input[type="checkbox"]:disabled + label,
.abc-checkbox input[type="radio"]:disabled + label {
  opacity: 0.65;
}

.abc-checkbox input[type="checkbox"]:disabled + label::before,
.abc-checkbox input[type="radio"]:disabled + label::before {
  background-color: #efedea;
  cursor: not-allowed;
}

.abc-checkbox input[type="checkbox"]:disabled + label::after,
.abc-checkbox input[type="radio"]:disabled + label::after {
  cursor: not-allowed;
}

.abc-checkbox.abc-checkbox-circle label::before {
  border-radius: 50%;
}

.abc-checkbox.checkbox-inline {
  margin-top: 0;
}

.abc-checkbox-primary input[type="checkbox"]:checked + label::before,
.abc-checkbox-primary input[type="radio"]:checked + label::before {
  background-color: var(--primary);
  border-color: var(--primary);
}

.abc-checkbox-primary input[type="checkbox"]:checked + label::after,
.abc-checkbox-primary input[type="radio"]:checked + label::after {
  color: #fff;
}

.abc-checkbox-danger input[type="checkbox"]:checked + label::before,
.abc-checkbox-danger input[type="radio"]:checked + label::before {
  background-color: #eb3349;
  border-color: #eb3349;
}

.abc-checkbox-danger input[type="checkbox"]:checked + label::after,
.abc-checkbox-danger input[type="radio"]:checked + label::after {
  color: #fff;
}

.abc-checkbox-info input[type="checkbox"]:checked + label::before,
.abc-checkbox-info input[type="radio"]:checked + label::before {
  background-color: #5d80f9;
  border-color: #5d80f9;
}

.abc-checkbox-info input[type="checkbox"]:checked + label::after,
.abc-checkbox-info input[type="radio"]:checked + label::after {
  color: #fff;
}

.abc-checkbox-warning input[type="checkbox"]:checked + label::before,
.abc-checkbox-warning input[type="radio"]:checked + label::before {
  background-color: #f3c363;
  border-color: #f3c363;
}

.abc-checkbox-warning input[type="checkbox"]:checked + label::after,
.abc-checkbox-warning input[type="radio"]:checked + label::after {
  color: #fff;
}

.abc-checkbox-success input[type="checkbox"]:checked + label::before,
.abc-checkbox-success input[type="radio"]:checked + label::before {
  background-color: var(--success);
  border-color: var(--success);
}

.abc-checkbox-success input[type="checkbox"]:checked + label::after,
.abc-checkbox-success input[type="radio"]:checked + label::after {
  color: #fff;
}

.abc-checkbox-primary input[type="checkbox"]:indeterminate + label::before,
.abc-checkbox-primary input[type="radio"]:indeterminate + label::before {
  background-color: var(--primary);
  border-color: var(--primary);
}

.abc-checkbox-primary input[type="checkbox"]:indeterminate + label::after,
.abc-checkbox-primary input[type="radio"]:indeterminate + label::after {
  background-color: #fff;
}

.abc-checkbox-danger input[type="checkbox"]:indeterminate + label::before,
.abc-checkbox-danger input[type="radio"]:indeterminate + label::before {
  background-color: #eb3349;
  border-color: #eb3349;
}

.abc-checkbox-danger input[type="checkbox"]:indeterminate + label::after,
.abc-checkbox-danger input[type="radio"]:indeterminate + label::after {
  background-color: #fff;
}

.abc-checkbox-info input[type="checkbox"]:indeterminate + label::before,
.abc-checkbox-info input[type="radio"]:indeterminate + label::before {
  background-color: #5d80f9;
  border-color: #5d80f9;
}

.abc-checkbox-info input[type="checkbox"]:indeterminate + label::after,
.abc-checkbox-info input[type="radio"]:indeterminate + label::after {
  background-color: #fff;
}

.abc-checkbox-warning input[type="checkbox"]:indeterminate + label::before,
.abc-checkbox-warning input[type="radio"]:indeterminate + label::before {
  background-color: #f3c363;
  border-color: #f3c363;
}

.abc-checkbox-warning input[type="checkbox"]:indeterminate + label::after,
.abc-checkbox-warning input[type="radio"]:indeterminate + label::after {
  background-color: #fff;
}

.abc-checkbox-success input[type="checkbox"]:indeterminate + label::before,
.abc-checkbox-success input[type="radio"]:indeterminate + label::before {
  background-color: var(--success);
  border-color: var(--success);
}

.abc-checkbox-success input[type="checkbox"]:indeterminate + label::after,
.abc-checkbox-success input[type="radio"]:indeterminate + label::after {
  background-color: #fff;
}

.abc-radio {
  cursor: default;
  padding-left: 4px;
}

.abc-radio label {
  cursor: pointer;
  display: inline;
  vertical-align: top;
  position: relative;
  padding-left: 5px;
}

.abc-radio label::before {
  cursor: pointer;
  content: "";
  display: inline-block;
  position: absolute;
  width: 17px;
  height: 17px;
  top: 2px;
  left: 0;
  margin-left: -20px;
  border: 1px solid #ccc;
  border-radius: 50%;
  background-color: #fff;
  transition: border 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .abc-radio label::before {
    transition: none;
  }
}

.abc-radio label::after {
  cursor: pointer;
  display: inline-block;
  position: absolute;
  content: " ";
  width: 11px;
  height: 11px;
  left: 3px;
  top: 5px;
  margin-left: -20px;
  border-radius: 50%;
  background-color: #4d4d4d;
  transform: scale(0, 0);
  transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
}

.abc-radio input[type="radio"] {
  position: static;
  margin-left: 0;
  cursor: pointer;
  opacity: 0;
  z-index: 1;
}

.abc-radio input[type="radio"]:focus + label::before {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

.abc-radio input[type="radio"]:checked + label::after {
  transform: scale(1, 1);
}

.abc-radio input[type="radio"]:disabled + label {
  opacity: 0.65;
}

.abc-radio input[type="radio"]:disabled + label::before {
  cursor: not-allowed;
}

.abc-radio input[type="radio"]:disabled + label::after {
  cursor: not-allowed;
}

.abc-radio.radio-inline {
  margin-top: 0;
}

.abc-radio-primary input[type="radio"] + label::after {
  background-color: var(--primary);
}

.abc-radio-primary input[type="radio"]:checked + label::before {
  border-color: var(--primary);
}

.abc-radio-primary input[type="radio"]:checked + label::after {
  background-color: var(--primary);
}

.abc-radio-danger input[type="radio"] + label::after {
  background-color: #eb3349;
}

.abc-radio-danger input[type="radio"]:checked + label::before {
  border-color: #eb3349;
}

.abc-radio-danger input[type="radio"]:checked + label::after {
  background-color: #eb3349;
}

.abc-radio-info input[type="radio"] + label::after {
  background-color: #5d80f9;
}

.abc-radio-info input[type="radio"]:checked + label::before {
  border-color: #5d80f9;
}

.abc-radio-info input[type="radio"]:checked + label::after {
  background-color: #5d80f9;
}

.abc-radio-warning input[type="radio"] + label::after {
  background-color: #f3c363;
}

.abc-radio-warning input[type="radio"]:checked + label::before {
  border-color: #f3c363;
}

.abc-radio-warning input[type="radio"]:checked + label::after {
  background-color: #f3c363;
}

.abc-radio-success input[type="radio"] + label::after {
  background-color: var(--success);
}

.abc-radio-success input[type="radio"]:checked + label::before {
  border-color: var(--success);
}

.abc-radio-success input[type="radio"]:checked + label::after {
  background-color: var(--success);
}

label .was-validated .form-check-input:invalid .abc-checkbox:before,
label
.was-validated .form-check-input:invalid .abc-radio:before,
label .form-check-input.is-invalid .abc-checkbox:before,
label
.form-check-input.is-invalid .abc-radio:before {
  border-color: #eb3349;
}

/**
 * Custom application mixins available through out the app
 */

.container-fluid {
  padding-left: 30px;
  padding-right: 30px;
}

.navbar {
  border: none;
  height: 75px;
  border-radius: 0;
  margin-bottom: -75px;
  padding: 0.5rem 2.25rem;
}

@media (min-width: 0) {
  .navbar-right .dropdown-menu {
    left: 0;
  }
}

.nav.nav-tabs .nav-item a {
  color: #4d4d4d;
}

.nav.nav-tabs .nav-item a.active {
  background-color: #eb3349;
  border-color: #eb3349;
  color: white;
}

.progress-sm {
  height: 1rem;
  margin-bottom: 1rem;
}

.progress-xs {
  height: 5px;
  margin-bottom: 0.5rem;
}

.breadcrumb {
  margin-top: -15px;
  font-size: 0.9rem;
}

.breadcrumb > .active {
  font-weight: 600;
}

.breadcrumb > li + li::before {
  color: #f9f6f2;
}

.form-control {
  font-size: 1rem;
  transition: border-color ease-in-out 0.15s, background-color ease-in-out 0.15s;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}

.form-control.no-border {
  border: none;
  background-color: #f2f2f2;
}

.form-control.no-border:focus {
  background-color: #ededed;
}

.input-sm {
  font-size: 13px;
}

.btn-inverse {
  color: #212529;
  background-color: #fff;
  border-color: #4d4d4d;
}

.btn-inverse:hover {
  color: #fff;
  background-color: #414749;
  border-color: #343434;
}

.btn-inverse:focus,
.btn-inverse.focus {
  box-shadow: 0 0 0 0.2rem rgba(70, 71, 72, 0.5);
}

.btn-inverse.disabled,
.btn-inverse:disabled {
  color: #212529;
  background-color: #fff;
  border-color: #4d4d4d;
}

.btn-inverse:not(:disabled):not(.disabled):active,
.btn-inverse:not(:disabled):not(.disabled).active,
.show > .btn-inverse.dropdown-toggle {
  color: #212529;
  background-color: #e6e6e6;
  border-color: #2d2d2d;
}

.btn-inverse:not(:disabled):not(.disabled):active:focus,
.btn-inverse:not(:disabled):not(.disabled).active:focus,
.show > .btn-inverse.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(70, 71, 72, 0.5);
}

.alert {
  font-size: 0.9rem;
}

.alert .close {
  color: rgba(0, 0, 0, 0.4);
}

.alert-sm {
  padding: 10px 15px;
}

.alert-sm .close {
  font-size: 20px;
  top: 0;
  right: -8px;
}

.badge {
  font-size: 12px;
}

.list-group-item > .badge {
  margin-top: 2px;
}

.table-no-border {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}

.table-no-border > thead > tr > th,
.table-no-border > thead > tr > td,
.table-no-border > tbody > tr > th,
.table-no-border > tbody > tr > td,
.table-no-border > tfoot > tr > th,
.table-no-border > tfoot > tr > td {
  border-top: 0;
}

.table-sm {
  font-size: 0.9rem;
}

.table-sm > thead > tr > th,
.table-sm > thead > tr > td,
.table-sm > tbody > tr > th,
.table-sm > tbody > tr > td,
.table-sm > tfoot > tr > th,
.table-sm > tfoot > tr > td {
  padding: 4px;
}

.table-sm.table-no-border {
  margin-left: -4px;
  margin-right: -4px;
}

pre {
  display: block;
  padding: 6.5px;
  margin: 0 0 0.5rem;
  font-size: 13px;
  line-height: 1rem;
  word-break: break-all;
  word-wrap: break-word;
  color: #212529;
  background-color: #f9f6f2;
  border: 1px solid #ccc;
  border-radius: 0.25rem;
}

pre code {
  padding: 0;
  font-size: inherit;
  color: inherit;
  white-space: pre-wrap;
  background-color: transparent;
  border-radius: 0;
}

.list-group {
  padding: 0 1.25rem;
  background: #fff;
}

.list-group .list-group-item {
  border: none;
  padding: 1.25rem 0;
  color: #5d80f9;
  border-top: 1px solid #efedea;
}

.list-group .list-group-item:hover {
  z-index: 0;
}

.list-group .list-group-item:first-child {
  border-top: none;
}

html {
  font-weight: 100;
  font-size: 14px;
}

body {
  overflow-x: hidden;
}

html,
body,
.app {
  height: 100%;
}

a {
  cursor: pointer;
  transition: color 0.1s ease-in-out, background-color 0.1s ease-in-out;
}

th {
  font-weight: 600;
}

label {
  font-weight: 600;
}

.mt-xlg {
  margin-top: 40px;
}

.mt-n-xlg {
  margin-top: -40px;
}

.mt-lg {
  margin-top: 2.25rem;
}

.mt-n-lg {
  margin-top: -2.25rem;
}

.mt {
  margin-top: 1.5rem;
}

.mt-n {
  margin-top: 1.5rem;
}

.mt-md {
  margin-top: 1.5rem;
}

.mt-n-md {
  margin-top: -1.5rem;
}

.mt-sm {
  margin-top: 0.75rem;
}

.mt-n-sm {
  margin-top: -0.75rem;
}

.mt-xs {
  margin-top: 0.375rem;
}

.mt-n-xs {
  margin-top: -0.375rem;
}

.mt-0 {
  margin-top: 0;
}

.mt-n-0 {
  margin-top: 0;
}

.mb-xlg {
  margin-bottom: 40px;
}

.mb-n-xlg {
  margin-bottom: -40px;
}

.mb-lg {
  margin-bottom: 2.25rem;
}

.mb-n-lg {
  margin-bottom: -2.25rem;
}

.mb {
  margin-bottom: 1.5rem;
}

.mb-n {
  margin-bottom: 1.5rem;
}

.mb-md {
  margin-bottom: 1.5rem;
}

.mb-n-md {
  margin-bottom: -1.5rem;
}

.mb-sm {
  margin-bottom: 0.75rem;
}

.mb-n-sm {
  margin-bottom: -0.75rem;
}

.mb-xs {
  margin-bottom: 0.375rem;
}

.mb-n-xs {
  margin-bottom: -0.375rem;
}

.mb-0 {
  margin-bottom: 0;
}

.mb-n-0 {
  margin-bottom: 0;
}

.ml-lg {
  margin-left: 20px;
}

.ml-n-lg {
  margin-left: -20px;
}

.ml {
  margin-left: 15px;
}

.ml-n {
  margin-left: 15px;
}

.ml-md {
  margin-left: 15px;
}

.ml-n-md {
  margin-left: -15px;
}

.ml-sm {
  margin-left: 10px;
}

.ml-n-sm {
  margin-left: -10px;
}

.ml-xs {
  margin-left: 5px;
}

.ml-n-xs {
  margin-left: -5px;
}

.ml-0 {
  margin-left: 0;
}

.ml-n-0 {
  margin-left: 0;
}

.mr-lg {
  margin-right: 20px;
}

.mr-n-lg {
  margin-right: -20px;
}

.mr {
  margin-right: 15px;
}

.mr-n {
  margin-right: 15px;
}

.mr-md {
  margin-right: 15px;
}

.mr-n-md {
  margin-right: -15px;
}

.mr-sm {
  margin-right: 10px;
}

.mr-n-sm {
  margin-right: -10px;
}

.mr-xs {
  margin-right: 5px;
}

.mr-n-xs {
  margin-right: -5px;
}

.mr-0 {
  margin-right: 0;
}

.mr-n-0 {
  margin-right: 0;
}

.opacity-10 {
  opacity: 0.1;
}

.opacity-n-10 {
  opacity: -0.1;
}

.opacity-20 {
  opacity: 0.2;
}

.opacity-n-20 {
  opacity: -0.2;
}

.opacity-30 {
  opacity: 0.3;
}

.opacity-n-30 {
  opacity: -0.3;
}

.opacity-40 {
  opacity: 0.4;
}

.opacity-n-40 {
  opacity: -0.4;
}

.opacity-50 {
  opacity: 0.5;
}

.opacity-n-50 {
  opacity: -0.5;
}

.opacity-60 {
  opacity: 0.6;
}

.opacity-n-60 {
  opacity: -0.6;
}

.opacity-70 {
  opacity: 0.7;
}

.opacity-n-70 {
  opacity: -0.7;
}

.opacity-80 {
  opacity: 0.8;
}

.opacity-n-80 {
  opacity: -0.8;
}

.opacity-90 {
  opacity: 0.9;
}

.opacity-n-90 {
  opacity: -0.9;
}

.fw-thin {
  font-weight: 300;
}

.fw-normal {
  font-weight: 400;
}

.fw-semi-bold {
  font-weight: 600;
}

.fw-bold {
  font-weight: 700;
}

.fs-sm {
  font-size: 0.9rem;
}

.text-default {
  color: #4d4d4d;
}

.bg-dark {
  background-color: #4d4d4d !important;
}

a.bg-dark:hover,
a.bg-dark:focus {
  background-color: #343434 !important;
}

.td-underline {
  text-decoration: underline;
}

.widget-table-overflow {
  margin: 0 -20px -15px;
}

.text-orange{
    color: #fd7e14 !important;
}

.text-dark{
    color: #4d4d4d !important;
}

.a_login {
    text-decoration: none;
    color:#14b1d7 !important;
    
}

.a_login:hover {
    color:#1479d7;
    text-shadow: 0 0 10px #1479d7;
}

.text-gray-600{
    color: #959798 !important
}
.btn-cancle{
  padding: 10px 20px;
    size: 16px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  background-color: #b9bbbe;
}
.btn-cancle:hover{

  background-color:#acacac;
}



.bg-purple-500 {
    background-color: #8A5BD7
}

.text-purple-500 {
    color: #8A5BD7
}
.border-purple-500 {
    border-color: #8A5BD7;
}


  
 
  
   .main-title {
    font-size: 24px;
    text-align: center;
    margin-bottom: 20px;
    color: #333;
  } 
 



  html[dir="rtl"] {
    direction: rtl;
    text-align: right;
  }
  
  html[dir="ltr"] {
    direction: ltr;
    text-align: left;
  }



  
  .btnSubmit {
    padding: 10px 20px;
    size: 16px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    background-color: #1f7c50;
    color: white;
    opacity: 0.9;
  }

  .btnSubmit:hover {
    background-color: #196b43;
    color: white;
    opacity: 1;
  }

  .styled-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    background-color: white;
  }
  
  .styled-table th,
  .styled-table td {
    padding: 12px;
   
    border-bottom: 1px solid #ddd;
  }
  
  .styled-table th {
    background-color: #f2f2f2;
    cursor: pointer;
  }
  
  .styled-table th.sortable-header:hover {
    background-color: #eaeef2;
  }
`, "",{"version":3,"sources":["webpack://./src/styles/app.css"],"names":[],"mappings":"AASA;EACE,qFAAqF;EACrF,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;;EAErB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,kCAAkC;EAClC,8BAA8B;EAC9B,kCAAkC;EAClC,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,+MAA+M;EAC/M,6GAA6G;AAC/G;;AAEA;;;EAGE,sBAAsB;;AAExB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,6BAA6B;;AAE/B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,wBAAwB;;AAE1B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;;;;;;;;;;EAUE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;;;;EAME,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;EAC1B,yCAAiC;UAAjC,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;;;;EAIE,iGAAiG;EACjG,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;;;;;AAMA;;;;EAIE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;;;;;AAMA;EACE,iBAAiB;AACnB;;;AAGA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;;;AAIA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;EAYE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,wCAAwC;AAC1C;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAsEE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,QAAQ,sBAAsB;EACvD,kBAAkB,cAAc,oBAAoB;EACpD,aAAa,oBAAoB,0BAA0B;EAC3D,sBAAsB,WAAW,qBAAqB;;EAEtD,gCAAgC;AAClC;;AAEA;EACE,yCAAyC,EAAE,qBAAqB;AAClE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mCAAmC;EACnC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;EAChB,wEAAwE;AAC1E;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;;EAEE,4BAA4B;EAC5B,oCAAoC;EACpC,yDAA4P;EAC5P,4BAA4B;EAC5B,2DAA2D;EAC3D,gEAAgE;AAClE;;AAEA;;EAEE,4BAA4B;EAC5B,iDAAiD;AACnD;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,kFAAkF;AACpF;;AAEA;;EAEE,4BAA4B;EAC5B,sDAAsD;EACtD,wNAA6gB;AAC/gB;;AAEA;;EAEE,4BAA4B;EAC5B,iDAAiD;AACnD;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,4BAA4B;EAC5B,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;;EAEE,qBAAqB;EACrB,oCAAoC;EACpC,yDAAsS;EACtS,4BAA4B;EAC5B,2DAA2D;EAC3D,gEAAgE;AAClE;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,kFAAkF;AACpF;;AAEA;;EAEE,qBAAqB;EACrB,sDAAsD;EACtD,wNAAujB;AACzjB;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;UACjB,iBAAiB;EACzB,6BAA6B;EAC7B,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qIAAqI;AACvI;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;;;AAIA;;EAEE,UAAU;EACV,gDAAgD;AAClD;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,WAAW;EACX,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,cAAc;EACd,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,WAAW;EACX,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;;EAEE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;;;EAGE,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;;;EAGE,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;;EAGE,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;;EAEE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;;;;;AAMA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,qCAAqC;EACrC,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,mCAAmC;EACnC,eAAe;EACf,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EAIX,aAAa;AAHf;;AAMA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,WAAW;EACX,mCAAmC;EACnC,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;EACd,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;;;;EAME,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;EAIE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA;;;;EAIE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;EAYE,iBAAiB;AACnB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;;;;;;EAQE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;;;;;EAME,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;;;;;EAME,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,yDAA6M;AAC/M;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,yDAA0J;AAC5J;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yDAAuJ;AACzJ;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,yIAAyI;AAC3I;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,mCAAmC;EACnC,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,2FAA6M;EAC7M,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAGR,gBAAgB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,UAAU;EACV,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,UAAU;EACV,6BAA6B;EAGrB,gBAAgB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gCAAgC;EAChC,SAAS;EAET,oHAA4G;EAA5G,4GAA4G;EAEpG,gBAAgB;AAC1B;;AAEA;EACE;IAEE,wBAAgB;IAAhB,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,SAAS;EAET,iHAA4G;EAA5G,4GAA4G;EAEvG,gBAAgB;AACvB;;AAEA;EACE;IAEE,qBAAgB;IAAhB,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,SAAS;EAET,gHAA4G;EAA5G,4GAA4G;EAC5G,gBAAgB;AAClB;;AAEA;EACE;IAEE,oBAAgB;IAAhB,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,4GAA4G;AAC9G;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yDAAwP;AAC1P;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,yDAA8P;AAChQ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,qBAAqB;IACrB,WAAW;EACb;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,0BAA0B;EAI1B,qBAAqB;AAHvB;;AAMA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,qIAAqI;AACvI;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,qMAAqM;EACrM,0BAA0B;AAC5B;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;;EAEE,YAAY;AACd;;;;;AAKA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,4BAA4B;EAC5B,oCAAoC;EACpC,gDAAgD;EAExC,2BAA2B;EACnC,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;EACd,2CAA2C;EAC3C,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,SAAS;EACT,wDAAwD;EACxD,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,MAAM;EACN,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,OAAO;EACP,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,QAAQ;EACR,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,MAAM;AACR;;AAEA;;EAEE,SAAS;EACT,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,QAAQ;EACR,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,OAAO;EACP,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,wDAAwD;EACxD,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,SAAS;EACT,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;;EAEE,WAAW;EACX,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,+BAA+B;EAC/B,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,OAAO;EACP,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;;EAEE,SAAS;EACT,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,MAAM;EACN,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;;EAEE,QAAQ;EACR,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,gCAAgC;AAClC;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,gCAAgC;EAChC,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,QAAQ;EACR,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;;EAEE,UAAU;EACV,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EAEX,2BAA2B;EACnC,sCAAsC;AACxC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;;;EAGE,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;;;;EAIE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,yDAAmM;AACrM;;AAEA;EACE,yDAAmM;AACrM;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;EAClC,qCAAqC;EACrC,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,oCAAoC;AACtC;;;;AAIA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;;;AAIA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;;;;;EAKE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;AACf;;AAEA;EACE;IAEE,gBAAgB;IAChB,MAAM;IACN,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;;;AAIA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,kCAAkC;EACpC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,kCAAkC;EACpC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,kCAAkC;EACpC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,kCAAkC;EACpC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,kCAAkC;EACpC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,kCAAkC;EACpC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,kCAAkC;EACpC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,kCAAkC;EACpC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,gCAAgC;EAClC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2BAA2B;EAC7B;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;;IAEE,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE,4GAA4G;AAC9G;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;;;IAGE,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;;IAEE,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;;;IAGE,UAAU;IACV,SAAS;EACX;;EAEA;;IAEE,uBAAuB;EACzB;;AAEF;IACI,QAAQ;AACZ;;EAEE;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;;IAEE,iCAAiC;EACnC;;EAEA;;IAEE,oCAAoC;EACtC;;EAEA;IACE,cAAc;EAChB;;EAEA;;;;IAIE,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;AACF;;AAEA;;EAEE;;;;AAIF;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;;CAKC;;AAED;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,OAAO;EACP,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,6DAA6D;AAC/D;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;EACpB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;;EAEE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,OAAO;EACP,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,8DAA8D;AAChE;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;;;EAME,qBAAqB;AACvB;;AAEA;;EAEE;;AAEF;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE;IACE,OAAO;EACT;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;EAME,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,qEAAqE;AACvE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;;AAE5B;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI;AACJ;AACA;EACE,kBAAkB;IAChB,UAAU;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;AACA;;EAEE,wBAAwB;AAC1B;;;;AAIA;IACI;AACJ;;AAEA;IACI;AACJ;AACA;IACI,qBAAqB;AACzB;;;;;;GAMG;IACC,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;EACb;;;;;EAKA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;;;;EAKA;IACE,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;;IAEE,aAAa;;IAEb,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B","sourcesContent":["@import url('../../node_modules/bootstrap/dist/css/bootstrap.min.css');\r\n@import url('_variables.css');\r\n@import url('_mixins.scss');\r\n\r\n\r\n\r\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap');\r\n\r\n\r\n:root {\r\n  /* Site color palette: #1f7c50 dark green, #07ffa9 mint, #101413 dark, #accbc3 sage */\r\n  --color-dark-green: #1f7c50;\r\n  --color-mint: #07ffa9;\r\n  --color-dark: #101413;\r\n  --color-sage: #accbc3;\r\n\r\n  --blue: #007bff;\r\n  --indigo: #6610f2;\r\n  --purple: #6f42c1;\r\n  --pink: #e83e8c;\r\n  --red: #dc3545;\r\n  --orange: #fd7e14;\r\n  --yellow: #ffc107;\r\n  --green: var(--color-dark-green);\r\n  --teal: var(--color-mint);\r\n  --cyan: #17a2b8;\r\n  --white: #fff;\r\n  --gray: #6c757d;\r\n  --gray-dark: var(--color-dark);\r\n  --primary: var(--color-dark-green);\r\n  --secondary: var(--color-sage);\r\n  --success: var(--color-dark-green);\r\n  --info: #5d80f9;\r\n  --warning: #f3c363;\r\n  --danger: #eb3349;\r\n  --light: var(--color-sage);\r\n  --dark: var(--color-dark);\r\n  --inverse: var(--color-dark);\r\n  --gray: #ccc;\r\n  --default: #f8f8f8;\r\n  --accent: var(--color-mint);\r\n  --breakpoint-xs: 0;\r\n  --breakpoint-sm: 576px;\r\n  --breakpoint-md: 768px;\r\n  --breakpoint-lg: 992px;\r\n  --breakpoint-xl: 1200px;\r\n  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\r\n  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\r\n}\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n  \r\n}\r\n\r\ninput[type=\"text\"], input[type=\"email\"], input[type=\"password\"],textarea {\r\n  height: 45px !important;\r\n  border-style: 1px solid #f5f4f4 !important;\r\n  border-radius: 8px !important;\r\n  \r\n}\r\n\r\ntextarea{\r\n  height: 100px !important;\r\n}\r\ninput[type=\"text\"]:focus, input[type=\"email\"]:focus, input[type=\"password\"]:focus,textarea:focus {\r\n  border-color: #f7bc29f3 !important;\r\n  box-shadow: none !important;\r\n  outline: none !important;\r\n  \r\n}\r\n\r\nhtml {\r\n  font-family: sans-serif;\r\n  line-height: 1.15;\r\n  -webkit-text-size-adjust: 100%;\r\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\narticle,\r\naside,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nhgroup,\r\nmain,\r\nnav,\r\nsection {\r\n  display: block;\r\n}\r\n\r\nbody {\r\n  font-family: 'Poppins', sans-serif;\r\n  margin: 0;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #212529;\r\n  background-color: #f9f6f2;\r\n}\r\n\r\n[tabindex=\"-1\"]:focus {\r\n  outline: 0 !important;\r\n}\r\n\r\nhr {\r\n  box-sizing: content-box;\r\n  height: 0;\r\n  overflow: visible;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  margin-top: 0;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\np {\r\n  margin-top: 0;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\nabbr[title],\r\nabbr[data-original-title] {\r\n  text-decoration: underline;\r\n  text-decoration: underline dotted;\r\n  cursor: help;\r\n  border-bottom: 0;\r\n  text-decoration-skip-ink: none;\r\n}\r\n\r\naddress {\r\n  margin-bottom: 1rem;\r\n  font-style: normal;\r\n  line-height: inherit;\r\n}\r\n\r\nol,\r\nul,\r\ndl {\r\n  margin-top: 0;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\nol ol,\r\nul ul,\r\nol ul,\r\nul ol {\r\n  margin-bottom: 0;\r\n}\r\n\r\ndt {\r\n  font-weight: 700;\r\n}\r\n\r\ndd {\r\n  margin-bottom: .5rem;\r\n  margin-left: 0;\r\n}\r\n\r\nblockquote {\r\n  margin: 0 0 1rem;\r\n}\r\n\r\nb,\r\nstrong {\r\n  font-weight: bolder;\r\n}\r\n\r\nsmall {\r\n  font-size: 80%;\r\n}\r\n\r\nsub,\r\nsup {\r\n  position: relative;\r\n  font-size: 75%;\r\n  line-height: 0;\r\n  vertical-align: baseline;\r\n}\r\n\r\nsub {\r\n  bottom: -.25em;\r\n}\r\n\r\nsup {\r\n  top: -.5em;\r\n}\r\n\r\na {\r\n  color: #337ab7;\r\n  text-decoration: none;\r\n  background-color: transparent;\r\n}\r\n\r\na:hover {\r\n  color: #22527b;\r\n  text-decoration: underline;\r\n}\r\n\r\na:not([href]):not([tabindex]) {\r\n  color: inherit;\r\n  text-decoration: none;\r\n}\r\n\r\na:not([href]):not([tabindex]):hover,\r\na:not([href]):not([tabindex]):focus {\r\n  color: inherit;\r\n  text-decoration: none;\r\n}\r\n\r\na:not([href]):not([tabindex]):focus {\r\n  outline: 0;\r\n}\r\n\r\npre,\r\ncode,\r\nkbd,\r\nsamp {\r\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\r\n  font-size: 1em;\r\n}\r\n\r\n\r\npre {\r\n  margin-top: 0;\r\n  margin-bottom: 1rem;\r\n  overflow: auto;\r\n}\r\n\r\nfigure {\r\n  margin: 0 0 1rem;\r\n}\r\n\r\nimg {\r\n  vertical-align: middle;\r\n  border-style: none;\r\n}\r\n\r\nsvg {\r\n  overflow: hidden;\r\n  vertical-align: middle;\r\n}\r\n\r\ntable {\r\n  border-collapse: collapse;\r\n}\r\n\r\ncaption {\r\n  padding-top: 0.75rem;\r\n  padding-bottom: 0.75rem;\r\n  color: #cccbca;\r\n  text-align: left;\r\n  caption-side: bottom;\r\n}\r\n\r\nth {\r\n  text-align: inherit;\r\n}\r\n\r\nlabel {\r\n  display: inline-block;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n\r\n\r\n\r\n\r\ninput,\r\nselect,\r\noptgroup,\r\ntextarea {\r\n  margin: 0;\r\n  font-family: inherit;\r\n  font-size: inherit;\r\n  line-height: inherit;\r\n}\r\n\r\n\r\n\r\n\r\n\r\nselect {\r\n  word-wrap: normal;\r\n}\r\n\r\n\r\ntextarea {\r\n  overflow: auto;\r\n  resize: vertical;\r\n}\r\n\r\nfieldset {\r\n  min-width: 0;\r\n  padding: 0;\r\n  margin: 0;\r\n  border: 0;\r\n}\r\n\r\nlegend {\r\n  display: block;\r\n  width: 100%;\r\n  max-width: 100%;\r\n  padding: 0;\r\n  margin-bottom: .5rem;\r\n  font-size: 1.5rem;\r\n  line-height: inherit;\r\n  color: inherit;\r\n  white-space: normal;\r\n}\r\n\r\nprogress {\r\n  vertical-align: baseline;\r\n}\r\n\r\n\r\n\r\noutput {\r\n  display: inline-block;\r\n}\r\n\r\nsummary {\r\n  display: list-item;\r\n  cursor: pointer;\r\n}\r\n\r\ntemplate {\r\n  display: none;\r\n}\r\n\r\n[hidden] {\r\n  display: none !important;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\n.h1,\r\n.h2,\r\n.h3,\r\n.h4,\r\n.h5,\r\n.h6 {\r\n  margin-bottom: 0.5rem;\r\n  font-weight: 500;\r\n  line-height: 1.2;\r\n}\r\n\r\nh1,\r\n.h1 {\r\n  font-size: 2.5rem;\r\n}\r\n\r\nh2,\r\n.h2 {\r\n  font-size: 2rem;\r\n}\r\n\r\nh3,\r\n.h3 {\r\n  font-size: 1.75rem;\r\n}\r\n\r\nh4,\r\n.h4 {\r\n  font-size: 1.5rem;\r\n}\r\n\r\nh5,\r\n.h5 {\r\n  font-size: 1.25rem;\r\n}\r\n\r\nh6,\r\n.h6 {\r\n  font-size: 1rem;\r\n}\r\n\r\n.lead {\r\n  font-size: 1.25rem;\r\n  font-weight: 300;\r\n}\r\n\r\n.display-1 {\r\n  font-size: 6rem;\r\n  font-weight: 300;\r\n  line-height: 1.2;\r\n}\r\n\r\n.display-2 {\r\n  font-size: 5.5rem;\r\n  font-weight: 300;\r\n  line-height: 1.2;\r\n}\r\n\r\n.display-3 {\r\n  font-size: 4.5rem;\r\n  font-weight: 300;\r\n  line-height: 1.2;\r\n}\r\n\r\n.display-4 {\r\n  font-size: 3.5rem;\r\n  font-weight: 300;\r\n  line-height: 1.2;\r\n}\r\n\r\nhr {\r\n  margin-top: 1rem;\r\n  margin-bottom: 1rem;\r\n  border: 0;\r\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n\r\nsmall,\r\n.small {\r\n  font-size: 80%;\r\n  font-weight: 400;\r\n}\r\n\r\nmark,\r\n.mark {\r\n  padding: 0.2em;\r\n  background-color: #fcf8e3;\r\n}\r\n\r\n.list-unstyled {\r\n  padding-left: 0;\r\n  list-style: none;\r\n}\r\n\r\n.list-inline {\r\n  padding-left: 0;\r\n  list-style: none;\r\n}\r\n\r\n.list-inline-item {\r\n  display: inline-block;\r\n}\r\n\r\n.list-inline-item:not(:last-child) {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.initialism {\r\n  font-size: 90%;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.blockquote {\r\n  margin-bottom: 1rem;\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.blockquote-footer {\r\n  display: block;\r\n  font-size: 80%;\r\n  color: #6c757d;\r\n}\r\n\r\n.blockquote-footer::before {\r\n  content: \"\\2014\\00A0\";\r\n}\r\n\r\n.img-fluid {\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.img-thumbnail {\r\n  padding: 0.25rem;\r\n  background-color: #f9f6f2;\r\n  border: 1px solid #cccbca;\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.figure {\r\n  display: inline-block;\r\n}\r\n\r\n.figure-img {\r\n  margin-bottom: 0.5rem;\r\n  line-height: 1;\r\n}\r\n\r\n.figure-caption {\r\n  font-size: 90%;\r\n  color: #6c757d;\r\n}\r\n\r\ncode {\r\n  font-size: 87.5%;\r\n  color: #e83e8c;\r\n  word-break: break-word;\r\n}\r\n\r\na > code {\r\n  color: inherit;\r\n}\r\n\r\nkbd {\r\n  padding: 0.2rem 0.4rem;\r\n  font-size: 87.5%;\r\n  color: #fff;\r\n  background-color: #212529;\r\n}\r\n\r\nkbd kbd {\r\n  padding: 0;\r\n  font-size: 100%;\r\n  font-weight: 700;\r\n}\r\n\r\npre {\r\n  display: block;\r\n  font-size: 87.5%;\r\n  color: #212529;\r\n}\r\n\r\npre code {\r\n  font-size: inherit;\r\n  color: inherit;\r\n  word-break: normal;\r\n}\r\n\r\n.pre-scrollable {\r\n  max-height: 340px;\r\n  overflow-y: scroll;\r\n}\r\n\r\n.container {\r\n  width: 100%;\r\n  padding-right: 15px;\r\n  padding-left: 15px;\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .container {\r\n    max-width: 540px;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .container {\r\n    max-width: 720px;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .container {\r\n    max-width: 960px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .container {\r\n    max-width: 1140px;\r\n  }\r\n}\r\n\r\n.container-fluid {\r\n  width: 100%;\r\n  padding-right: 15px;\r\n  padding-left: 15px;\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n}\r\n\r\n.row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin-right: -15px;\r\n  margin-left: -15px;\r\n}\r\n\r\n.no-gutters {\r\n  margin-right: 0;\r\n  margin-left: 0;\r\n}\r\n\r\n.no-gutters > .col,\r\n.no-gutters > [class*=\"col-\"] {\r\n  padding-right: 0;\r\n  padding-left: 0;\r\n}\r\n\r\n.col-1,\r\n.col-2,\r\n.col-3,\r\n.col-4,\r\n.col-5,\r\n.col-6,\r\n.col-7,\r\n.col-8,\r\n.col-9,\r\n.col-10,\r\n.col-11,\r\n.col-12,\r\n.col,\r\n.col-auto,\r\n.col-sm-1,\r\n.col-sm-2,\r\n.col-sm-3,\r\n.col-sm-4,\r\n.col-sm-5,\r\n.col-sm-6,\r\n.col-sm-7,\r\n.col-sm-8,\r\n.col-sm-9,\r\n.col-sm-10,\r\n.col-sm-11,\r\n.col-sm-12,\r\n.col-sm,\r\n.col-sm-auto,\r\n.col-md-1,\r\n.col-md-2,\r\n.col-md-3,\r\n.col-md-4,\r\n.col-md-5,\r\n.col-md-6,\r\n.col-md-7,\r\n.col-md-8,\r\n.col-md-9,\r\n.col-md-10,\r\n.col-md-11,\r\n.col-md-12,\r\n.col-md,\r\n.col-md-auto,\r\n.col-lg-1,\r\n.col-lg-2,\r\n.col-lg-3,\r\n.col-lg-4,\r\n.col-lg-5,\r\n.col-lg-6,\r\n.col-lg-7,\r\n.col-lg-8,\r\n.col-lg-9,\r\n.col-lg-10,\r\n.col-lg-11,\r\n.col-lg-12,\r\n.col-lg,\r\n.col-lg-auto,\r\n.col-xl-1,\r\n.col-xl-2,\r\n.col-xl-3,\r\n.col-xl-4,\r\n.col-xl-5,\r\n.col-xl-6,\r\n.col-xl-7,\r\n.col-xl-8,\r\n.col-xl-9,\r\n.col-xl-10,\r\n.col-xl-11,\r\n.col-xl-12,\r\n.col-xl,\r\n.col-xl-auto {\r\n  position: relative;\r\n  width: 100%;\r\n  padding-right: 15px;\r\n  padding-left: 15px;\r\n}\r\n\r\n.col {\r\n  flex-basis: 0;\r\n  flex-grow: 1;\r\n  max-width: 100%;\r\n}\r\n\r\n.col-auto {\r\n  flex: 0 0 auto;\r\n  width: auto;\r\n  max-width: 100%;\r\n}\r\n\r\n.col-1 {\r\n  flex: 0 0 8.33333%;\r\n  max-width: 8.33333%;\r\n}\r\n\r\n.col-2 {\r\n  flex: 0 0 16.66667%;\r\n  max-width: 16.66667%;\r\n}\r\n\r\n.col-3 {\r\n  flex: 0 0 25%;\r\n  max-width: 25%;\r\n}\r\n\r\n.col-4 {\r\n  flex: 0 0 33.33333%;\r\n  max-width: 33.33333%;\r\n}\r\n\r\n.col-5 {\r\n  flex: 0 0 41.66667%;\r\n  max-width: 41.66667%;\r\n}\r\n\r\n.col-6 {\r\n  flex: 0 0 50%;\r\n  max-width: 50%;\r\n}\r\n\r\n.col-7 {\r\n  flex: 0 0 58.33333%;\r\n  max-width: 58.33333%;\r\n}\r\n\r\n.col-8 {\r\n  flex: 0 0 66.66667%;\r\n  max-width: 66.66667%;\r\n}\r\n\r\n.col-9 {\r\n  flex: 0 0 75%;\r\n  max-width: 75%;\r\n}\r\n\r\n.col-10 {\r\n  flex: 0 0 83.33333%;\r\n  max-width: 83.33333%;\r\n}\r\n\r\n.col-11 {\r\n  flex: 0 0 91.66667%;\r\n  max-width: 91.66667%;\r\n}\r\n\r\n.col-12 {\r\n  flex: 0 0 100%;\r\n  max-width: 100%;\r\n}\r\n\r\n.order-first {\r\n  order: -1;\r\n}\r\n\r\n.order-last {\r\n  order: 13;\r\n}\r\n\r\n.order-0 {\r\n  order: 0;\r\n}\r\n\r\n.order-1 {\r\n  order: 1;\r\n}\r\n\r\n.order-2 {\r\n  order: 2;\r\n}\r\n\r\n.order-3 {\r\n  order: 3;\r\n}\r\n\r\n.order-4 {\r\n  order: 4;\r\n}\r\n\r\n.order-5 {\r\n  order: 5;\r\n}\r\n\r\n.order-6 {\r\n  order: 6;\r\n}\r\n\r\n.order-7 {\r\n  order: 7;\r\n}\r\n\r\n.order-8 {\r\n  order: 8;\r\n}\r\n\r\n.order-9 {\r\n  order: 9;\r\n}\r\n\r\n.order-10 {\r\n  order: 10;\r\n}\r\n\r\n.order-11 {\r\n  order: 11;\r\n}\r\n\r\n.order-12 {\r\n  order: 12;\r\n}\r\n\r\n.offset-1 {\r\n  margin-left: 8.33333%;\r\n}\r\n\r\n.offset-2 {\r\n  margin-left: 16.66667%;\r\n}\r\n\r\n.offset-3 {\r\n  margin-left: 25%;\r\n}\r\n\r\n.offset-4 {\r\n  margin-left: 33.33333%;\r\n}\r\n\r\n.offset-5 {\r\n  margin-left: 41.66667%;\r\n}\r\n\r\n.offset-6 {\r\n  margin-left: 50%;\r\n}\r\n\r\n.offset-7 {\r\n  margin-left: 58.33333%;\r\n}\r\n\r\n.offset-8 {\r\n  margin-left: 66.66667%;\r\n}\r\n\r\n.offset-9 {\r\n  margin-left: 75%;\r\n}\r\n\r\n.offset-10 {\r\n  margin-left: 83.33333%;\r\n}\r\n\r\n.offset-11 {\r\n  margin-left: 91.66667%;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .col-sm {\r\n    flex-basis: 0;\r\n    flex-grow: 1;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .col-sm-auto {\r\n    flex: 0 0 auto;\r\n    width: auto;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .col-sm-1 {\r\n    flex: 0 0 8.33333%;\r\n    max-width: 8.33333%;\r\n  }\r\n\r\n  .col-sm-2 {\r\n    flex: 0 0 16.66667%;\r\n    max-width: 16.66667%;\r\n  }\r\n\r\n  .col-sm-3 {\r\n    flex: 0 0 25%;\r\n    max-width: 25%;\r\n  }\r\n\r\n  .col-sm-4 {\r\n    flex: 0 0 33.33333%;\r\n    max-width: 33.33333%;\r\n  }\r\n\r\n  .col-sm-5 {\r\n    flex: 0 0 41.66667%;\r\n    max-width: 41.66667%;\r\n  }\r\n\r\n  .col-sm-6 {\r\n    flex: 0 0 50%;\r\n    max-width: 50%;\r\n  }\r\n\r\n  .col-sm-7 {\r\n    flex: 0 0 58.33333%;\r\n    max-width: 58.33333%;\r\n  }\r\n\r\n  .col-sm-8 {\r\n    flex: 0 0 66.66667%;\r\n    max-width: 66.66667%;\r\n  }\r\n\r\n  .col-sm-9 {\r\n    flex: 0 0 75%;\r\n    max-width: 75%;\r\n  }\r\n\r\n  .col-sm-10 {\r\n    flex: 0 0 83.33333%;\r\n    max-width: 83.33333%;\r\n  }\r\n\r\n  .col-sm-11 {\r\n    flex: 0 0 91.66667%;\r\n    max-width: 91.66667%;\r\n  }\r\n\r\n  .col-sm-12 {\r\n    flex: 0 0 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .order-sm-first {\r\n    order: -1;\r\n  }\r\n\r\n  .order-sm-last {\r\n    order: 13;\r\n  }\r\n\r\n  .order-sm-0 {\r\n    order: 0;\r\n  }\r\n\r\n  .order-sm-1 {\r\n    order: 1;\r\n  }\r\n\r\n  .order-sm-2 {\r\n    order: 2;\r\n  }\r\n\r\n  .order-sm-3 {\r\n    order: 3;\r\n  }\r\n\r\n  .order-sm-4 {\r\n    order: 4;\r\n  }\r\n\r\n  .order-sm-5 {\r\n    order: 5;\r\n  }\r\n\r\n  .order-sm-6 {\r\n    order: 6;\r\n  }\r\n\r\n  .order-sm-7 {\r\n    order: 7;\r\n  }\r\n\r\n  .order-sm-8 {\r\n    order: 8;\r\n  }\r\n\r\n  .order-sm-9 {\r\n    order: 9;\r\n  }\r\n\r\n  .order-sm-10 {\r\n    order: 10;\r\n  }\r\n\r\n  .order-sm-11 {\r\n    order: 11;\r\n  }\r\n\r\n  .order-sm-12 {\r\n    order: 12;\r\n  }\r\n\r\n  .offset-sm-0 {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .offset-sm-1 {\r\n    margin-left: 8.33333%;\r\n  }\r\n\r\n  .offset-sm-2 {\r\n    margin-left: 16.66667%;\r\n  }\r\n\r\n  .offset-sm-3 {\r\n    margin-left: 25%;\r\n  }\r\n\r\n  .offset-sm-4 {\r\n    margin-left: 33.33333%;\r\n  }\r\n\r\n  .offset-sm-5 {\r\n    margin-left: 41.66667%;\r\n  }\r\n\r\n  .offset-sm-6 {\r\n    margin-left: 50%;\r\n  }\r\n\r\n  .offset-sm-7 {\r\n    margin-left: 58.33333%;\r\n  }\r\n\r\n  .offset-sm-8 {\r\n    margin-left: 66.66667%;\r\n  }\r\n\r\n  .offset-sm-9 {\r\n    margin-left: 75%;\r\n  }\r\n\r\n  .offset-sm-10 {\r\n    margin-left: 83.33333%;\r\n  }\r\n\r\n  .offset-sm-11 {\r\n    margin-left: 91.66667%;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .col-md {\r\n    flex-basis: 0;\r\n    flex-grow: 1;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .col-md-auto {\r\n    flex: 0 0 auto;\r\n    width: auto;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .col-md-1 {\r\n    flex: 0 0 8.33333%;\r\n    max-width: 8.33333%;\r\n  }\r\n\r\n  .col-md-2 {\r\n    flex: 0 0 16.66667%;\r\n    max-width: 16.66667%;\r\n  }\r\n\r\n  .col-md-3 {\r\n    flex: 0 0 25%;\r\n    max-width: 25%;\r\n  }\r\n\r\n  .col-md-4 {\r\n    flex: 0 0 33.33333%;\r\n    max-width: 33.33333%;\r\n  }\r\n\r\n  .col-md-5 {\r\n    flex: 0 0 41.66667%;\r\n    max-width: 41.66667%;\r\n  }\r\n\r\n  .col-md-6 {\r\n    flex: 0 0 50%;\r\n    max-width: 50%;\r\n  }\r\n\r\n  .col-md-7 {\r\n    flex: 0 0 58.33333%;\r\n    max-width: 58.33333%;\r\n  }\r\n\r\n  .col-md-8 {\r\n    flex: 0 0 66.66667%;\r\n    max-width: 66.66667%;\r\n  }\r\n\r\n  .col-md-9 {\r\n    flex: 0 0 75%;\r\n    max-width: 75%;\r\n  }\r\n\r\n  .col-md-10 {\r\n    flex: 0 0 83.33333%;\r\n    max-width: 83.33333%;\r\n  }\r\n\r\n  .col-md-11 {\r\n    flex: 0 0 91.66667%;\r\n    max-width: 91.66667%;\r\n  }\r\n\r\n  .col-md-12 {\r\n    flex: 0 0 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .order-md-first {\r\n    order: -1;\r\n  }\r\n\r\n  .order-md-last {\r\n    order: 13;\r\n  }\r\n\r\n  .order-md-0 {\r\n    order: 0;\r\n  }\r\n\r\n  .order-md-1 {\r\n    order: 1;\r\n  }\r\n\r\n  .order-md-2 {\r\n    order: 2;\r\n  }\r\n\r\n  .order-md-3 {\r\n    order: 3;\r\n  }\r\n\r\n  .order-md-4 {\r\n    order: 4;\r\n  }\r\n\r\n  .order-md-5 {\r\n    order: 5;\r\n  }\r\n\r\n  .order-md-6 {\r\n    order: 6;\r\n  }\r\n\r\n  .order-md-7 {\r\n    order: 7;\r\n  }\r\n\r\n  .order-md-8 {\r\n    order: 8;\r\n  }\r\n\r\n  .order-md-9 {\r\n    order: 9;\r\n  }\r\n\r\n  .order-md-10 {\r\n    order: 10;\r\n  }\r\n\r\n  .order-md-11 {\r\n    order: 11;\r\n  }\r\n\r\n  .order-md-12 {\r\n    order: 12;\r\n  }\r\n\r\n  .offset-md-0 {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .offset-md-1 {\r\n    margin-left: 8.33333%;\r\n  }\r\n\r\n  .offset-md-2 {\r\n    margin-left: 16.66667%;\r\n  }\r\n\r\n  .offset-md-3 {\r\n    margin-left: 25%;\r\n  }\r\n\r\n  .offset-md-4 {\r\n    margin-left: 33.33333%;\r\n  }\r\n\r\n  .offset-md-5 {\r\n    margin-left: 41.66667%;\r\n  }\r\n\r\n  .offset-md-6 {\r\n    margin-left: 50%;\r\n  }\r\n\r\n  .offset-md-7 {\r\n    margin-left: 58.33333%;\r\n  }\r\n\r\n  .offset-md-8 {\r\n    margin-left: 66.66667%;\r\n  }\r\n\r\n  .offset-md-9 {\r\n    margin-left: 75%;\r\n  }\r\n\r\n  .offset-md-10 {\r\n    margin-left: 83.33333%;\r\n  }\r\n\r\n  .offset-md-11 {\r\n    margin-left: 91.66667%;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .col-lg {\r\n    flex-basis: 0;\r\n    flex-grow: 1;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .col-lg-auto {\r\n    flex: 0 0 auto;\r\n    width: auto;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .col-lg-1 {\r\n    flex: 0 0 8.33333%;\r\n    max-width: 8.33333%;\r\n  }\r\n\r\n  .col-lg-2 {\r\n    flex: 0 0 16.66667%;\r\n    max-width: 16.66667%;\r\n  }\r\n\r\n  .col-lg-3 {\r\n    flex: 0 0 25%;\r\n    max-width: 25%;\r\n  }\r\n\r\n  .col-lg-4 {\r\n    flex: 0 0 33.33333%;\r\n    max-width: 33.33333%;\r\n  }\r\n\r\n  .col-lg-5 {\r\n    flex: 0 0 41.66667%;\r\n    max-width: 41.66667%;\r\n  }\r\n\r\n  .col-lg-6 {\r\n    flex: 0 0 50%;\r\n    max-width: 50%;\r\n  }\r\n\r\n  .col-lg-7 {\r\n    flex: 0 0 58.33333%;\r\n    max-width: 58.33333%;\r\n  }\r\n\r\n  .col-lg-8 {\r\n    flex: 0 0 66.66667%;\r\n    max-width: 66.66667%;\r\n  }\r\n\r\n  .col-lg-9 {\r\n    flex: 0 0 75%;\r\n    max-width: 75%;\r\n  }\r\n\r\n  .col-lg-10 {\r\n    flex: 0 0 83.33333%;\r\n    max-width: 83.33333%;\r\n  }\r\n\r\n  .col-lg-11 {\r\n    flex: 0 0 91.66667%;\r\n    max-width: 91.66667%;\r\n  }\r\n\r\n  .col-lg-12 {\r\n    flex: 0 0 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .order-lg-first {\r\n    order: -1;\r\n  }\r\n\r\n  .order-lg-last {\r\n    order: 13;\r\n  }\r\n\r\n  .order-lg-0 {\r\n    order: 0;\r\n  }\r\n\r\n  .order-lg-1 {\r\n    order: 1;\r\n  }\r\n\r\n  .order-lg-2 {\r\n    order: 2;\r\n  }\r\n\r\n  .order-lg-3 {\r\n    order: 3;\r\n  }\r\n\r\n  .order-lg-4 {\r\n    order: 4;\r\n  }\r\n\r\n  .order-lg-5 {\r\n    order: 5;\r\n  }\r\n\r\n  .order-lg-6 {\r\n    order: 6;\r\n  }\r\n\r\n  .order-lg-7 {\r\n    order: 7;\r\n  }\r\n\r\n  .order-lg-8 {\r\n    order: 8;\r\n  }\r\n\r\n  .order-lg-9 {\r\n    order: 9;\r\n  }\r\n\r\n  .order-lg-10 {\r\n    order: 10;\r\n  }\r\n\r\n  .order-lg-11 {\r\n    order: 11;\r\n  }\r\n\r\n  .order-lg-12 {\r\n    order: 12;\r\n  }\r\n\r\n  .offset-lg-0 {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .offset-lg-1 {\r\n    margin-left: 8.33333%;\r\n  }\r\n\r\n  .offset-lg-2 {\r\n    margin-left: 16.66667%;\r\n  }\r\n\r\n  .offset-lg-3 {\r\n    margin-left: 25%;\r\n  }\r\n\r\n  .offset-lg-4 {\r\n    margin-left: 33.33333%;\r\n  }\r\n\r\n  .offset-lg-5 {\r\n    margin-left: 41.66667%;\r\n  }\r\n\r\n  .offset-lg-6 {\r\n    margin-left: 50%;\r\n  }\r\n\r\n  .offset-lg-7 {\r\n    margin-left: 58.33333%;\r\n  }\r\n\r\n  .offset-lg-8 {\r\n    margin-left: 66.66667%;\r\n  }\r\n\r\n  .offset-lg-9 {\r\n    margin-left: 75%;\r\n  }\r\n\r\n  .offset-lg-10 {\r\n    margin-left: 83.33333%;\r\n  }\r\n\r\n  .offset-lg-11 {\r\n    margin-left: 91.66667%;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .col-xl {\r\n    flex-basis: 0;\r\n    flex-grow: 1;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .col-xl-auto {\r\n    flex: 0 0 auto;\r\n    width: auto;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .col-xl-1 {\r\n    flex: 0 0 8.33333%;\r\n    max-width: 8.33333%;\r\n  }\r\n\r\n  .col-xl-2 {\r\n    flex: 0 0 16.66667%;\r\n    max-width: 16.66667%;\r\n  }\r\n\r\n  .col-xl-3 {\r\n    flex: 0 0 25%;\r\n    max-width: 25%;\r\n  }\r\n\r\n  .col-xl-4 {\r\n    flex: 0 0 33.33333%;\r\n    max-width: 33.33333%;\r\n  }\r\n\r\n  .col-xl-5 {\r\n    flex: 0 0 41.66667%;\r\n    max-width: 41.66667%;\r\n  }\r\n\r\n  .col-xl-6 {\r\n    flex: 0 0 50%;\r\n    max-width: 50%;\r\n  }\r\n\r\n  .col-xl-7 {\r\n    flex: 0 0 58.33333%;\r\n    max-width: 58.33333%;\r\n  }\r\n\r\n  .col-xl-8 {\r\n    flex: 0 0 66.66667%;\r\n    max-width: 66.66667%;\r\n  }\r\n\r\n  .col-xl-9 {\r\n    flex: 0 0 75%;\r\n    max-width: 75%;\r\n  }\r\n\r\n  .col-xl-10 {\r\n    flex: 0 0 83.33333%;\r\n    max-width: 83.33333%;\r\n  }\r\n\r\n  .col-xl-11 {\r\n    flex: 0 0 91.66667%;\r\n    max-width: 91.66667%;\r\n  }\r\n\r\n  .col-xl-12 {\r\n    flex: 0 0 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .order-xl-first {\r\n    order: -1;\r\n  }\r\n\r\n  .order-xl-last {\r\n    order: 13;\r\n  }\r\n\r\n  .order-xl-0 {\r\n    order: 0;\r\n  }\r\n\r\n  .order-xl-1 {\r\n    order: 1;\r\n  }\r\n\r\n  .order-xl-2 {\r\n    order: 2;\r\n  }\r\n\r\n  .order-xl-3 {\r\n    order: 3;\r\n  }\r\n\r\n  .order-xl-4 {\r\n    order: 4;\r\n  }\r\n\r\n  .order-xl-5 {\r\n    order: 5;\r\n  }\r\n\r\n  .order-xl-6 {\r\n    order: 6;\r\n  }\r\n\r\n  .order-xl-7 {\r\n    order: 7;\r\n  }\r\n\r\n  .order-xl-8 {\r\n    order: 8;\r\n  }\r\n\r\n  .order-xl-9 {\r\n    order: 9;\r\n  }\r\n\r\n  .order-xl-10 {\r\n    order: 10;\r\n  }\r\n\r\n  .order-xl-11 {\r\n    order: 11;\r\n  }\r\n\r\n  .order-xl-12 {\r\n    order: 12;\r\n  }\r\n\r\n  .offset-xl-0 {\r\n    margin-left: 0;\r\n  }\r\n\r\n  .offset-xl-1 {\r\n    margin-left: 8.33333%;\r\n  }\r\n\r\n  .offset-xl-2 {\r\n    margin-left: 16.66667%;\r\n  }\r\n\r\n  .offset-xl-3 {\r\n    margin-left: 25%;\r\n  }\r\n\r\n  .offset-xl-4 {\r\n    margin-left: 33.33333%;\r\n  }\r\n\r\n  .offset-xl-5 {\r\n    margin-left: 41.66667%;\r\n  }\r\n\r\n  .offset-xl-6 {\r\n    margin-left: 50%;\r\n  }\r\n\r\n  .offset-xl-7 {\r\n    margin-left: 58.33333%;\r\n  }\r\n\r\n  .offset-xl-8 {\r\n    margin-left: 66.66667%;\r\n  }\r\n\r\n  .offset-xl-9 {\r\n    margin-left: 75%;\r\n  }\r\n\r\n  .offset-xl-10 {\r\n    margin-left: 83.33333%;\r\n  }\r\n\r\n  .offset-xl-11 {\r\n    margin-left: 91.66667%;\r\n  }\r\n}\r\n\r\n.table {\r\n  width: 100%;\r\n  margin-bottom: 1rem;\r\n  color: #212529;\r\n}\r\n\r\n.table th,\r\n.table td {\r\n  padding: 0.75rem;\r\n  vertical-align: top;\r\n  border-top: 1px solid #cccbca;\r\n}\r\n\r\n.table thead th {\r\n  vertical-align: bottom;\r\n  border-bottom: 2px solid #cccbca;\r\n}\r\n\r\n.table tbody + tbody {\r\n  border-top: 2px solid #cccbca;\r\n}\r\n\r\n.table-sm th,\r\n.table-sm td {\r\n  padding: 0.3rem;\r\n}\r\n\r\n.table-bordered {\r\n  border: 1px solid #cccbca;\r\n}\r\n\r\n.table-bordered th,\r\n.table-bordered td {\r\n  border: 1px solid #cccbca;\r\n}\r\n\r\n.table-bordered thead th,\r\n.table-bordered thead td {\r\n  border-bottom-width: 2px;\r\n}\r\n\r\n.table-borderless th,\r\n.table-borderless td,\r\n.table-borderless thead th,\r\n.table-borderless tbody + tbody {\r\n  border: 0;\r\n}\r\n\r\n.table-striped tbody tr:nth-of-type(odd) {\r\n  background-color: rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.table-hover tbody tr:hover {\r\n  color: #212529;\r\n  background-color: rgba(0, 0, 0, 0.075);\r\n}\r\n\r\n.table-primary,\r\n.table-primary > th,\r\n.table-primary > td {\r\n  background-color: #c7cfe6;\r\n}\r\n\r\n.table-primary th,\r\n.table-primary td,\r\n.table-primary thead th,\r\n.table-primary tbody + tbody {\r\n  border-color: #97a6d0;\r\n}\r\n\r\n.table-hover .table-primary:hover {\r\n  background-color: #b5c0de;\r\n}\r\n\r\n.table-hover .table-primary:hover > td,\r\n.table-hover .table-primary:hover > th {\r\n  background-color: #b5c0de;\r\n}\r\n\r\n.table-secondary,\r\n.table-secondary > th,\r\n.table-secondary > td {\r\n  background-color: #edf1fe;\r\n}\r\n\r\n.table-secondary th,\r\n.table-secondary td,\r\n.table-secondary thead th,\r\n.table-secondary tbody + tbody {\r\n  border-color: #dde4fe;\r\n}\r\n\r\n.border-Card {\r\n  border: 1px solid #e0e0e0;       /* light gray border */\r\n  border-radius: 8px;             /* rounded corners */\r\n  padding: 16px;                   /* space inside the card */\r\n  background-color: #fff;          /* white background */\r\n  \r\n  transition: box-shadow 0.2s ease;\r\n}\r\n\r\n.border-Cardcard:hover {\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* elevate on hover */\r\n}\r\n\r\n.table-hover .table-secondary:hover {\r\n  background-color: #d5defd;\r\n}\r\n\r\n.table-hover .table-secondary:hover > td,\r\n.table-hover .table-secondary:hover > th {\r\n  background-color: #d5defd;\r\n}\r\n\r\n.table-success,\r\n.table-success > th,\r\n.table-success > td {\r\n  background-color: #bfeae1;\r\n}\r\n\r\n.table-success th,\r\n.table-success td,\r\n.table-success thead th,\r\n.table-success tbody + tbody {\r\n  border-color: #88d7c7;\r\n}\r\n\r\n.table-hover .table-success:hover {\r\n  background-color: #ace4d8;\r\n}\r\n\r\n.table-hover .table-success:hover > td,\r\n.table-hover .table-success:hover > th {\r\n  background-color: #ace4d8;\r\n}\r\n\r\n.table-info,\r\n.table-info > th,\r\n.table-info > td {\r\n  background-color: #d2dbfd;\r\n}\r\n\r\n.table-info th,\r\n.table-info td,\r\n.table-info thead th,\r\n.table-info tbody + tbody {\r\n  border-color: #abbdfc;\r\n}\r\n\r\n.table-hover .table-info:hover {\r\n  background-color: #bac7fc;\r\n}\r\n\r\n.table-hover .table-info:hover > td,\r\n.table-hover .table-info:hover > th {\r\n  background-color: #bac7fc;\r\n}\r\n\r\n.table-warning,\r\n.table-warning > th,\r\n.table-warning > td {\r\n  background-color: #fceed3;\r\n}\r\n\r\n.table-warning th,\r\n.table-warning td,\r\n.table-warning thead th,\r\n.table-warning tbody + tbody {\r\n  border-color: #f9e0ae;\r\n}\r\n\r\n.table-hover .table-warning:hover {\r\n  background-color: #fae5bb;\r\n}\r\n\r\n.table-hover .table-warning:hover > td,\r\n.table-hover .table-warning:hover > th {\r\n  background-color: #fae5bb;\r\n}\r\n\r\n.table-danger,\r\n.table-danger > th,\r\n.table-danger > td {\r\n  background-color: #f9c6cc;\r\n}\r\n\r\n.table-danger th,\r\n.table-danger td,\r\n.table-danger thead th,\r\n.table-danger tbody + tbody {\r\n  border-color: #f595a0;\r\n}\r\n\r\n.table-hover .table-danger:hover {\r\n  background-color: #f7afb7;\r\n}\r\n\r\n.table-hover .table-danger:hover > td,\r\n.table-hover .table-danger:hover > th {\r\n  background-color: #f7afb7;\r\n}\r\n\r\n.table-light,\r\n.table-light > th,\r\n.table-light > td {\r\n  background-color: #f1f0f0;\r\n}\r\n\r\n.table-light th,\r\n.table-light td,\r\n.table-light thead th,\r\n.table-light tbody + tbody {\r\n  border-color: #e4e4e3;\r\n}\r\n\r\n.table-hover .table-light:hover {\r\n  background-color: #e5e3e3;\r\n}\r\n\r\n.table-hover .table-light:hover > td,\r\n.table-hover .table-light:hover > th {\r\n  background-color: #e5e3e3;\r\n}\r\n\r\n.table-dark,\r\n.table-dark > th,\r\n.table-dark > td {\r\n  background-color: #c6c8ca;\r\n}\r\n\r\n.table-dark th,\r\n.table-dark td,\r\n.table-dark thead th,\r\n.table-dark tbody + tbody {\r\n  border-color: #95999c;\r\n}\r\n\r\n.table-hover .table-dark:hover {\r\n  background-color: #b9bbbe;\r\n}\r\n\r\n.table-hover .table-dark:hover > td,\r\n.table-hover .table-dark:hover > th {\r\n  background-color: #b9bbbe;\r\n}\r\n\r\n.table-inverse,\r\n.table-inverse > th,\r\n.table-inverse > td {\r\n  background-color: #cdcdcd;\r\n}\r\n\r\n.table-inverse th,\r\n.table-inverse td,\r\n.table-inverse thead th,\r\n.table-inverse tbody + tbody {\r\n  border-color: #a2a2a2;\r\n}\r\n\r\n.table-hover .table-inverse:hover {\r\n  background-color: silver;\r\n}\r\n\r\n.table-hover .table-inverse:hover > td,\r\n.table-hover .table-inverse:hover > th {\r\n  background-color: silver;\r\n}\r\n\r\n.table-gray,\r\n.table-gray > th,\r\n.table-gray > td {\r\n  background-color: #f1f1f1;\r\n}\r\n\r\n.table-gray th,\r\n.table-gray td,\r\n.table-gray thead th,\r\n.table-gray tbody + tbody {\r\n  border-color: #e4e4e4;\r\n}\r\n\r\n.table-hover .table-gray:hover {\r\n  background-color: #e4e4e4;\r\n}\r\n\r\n.table-hover .table-gray:hover > td,\r\n.table-hover .table-gray:hover > th {\r\n  background-color: #e4e4e4;\r\n}\r\n\r\n.table-default,\r\n.table-default > th,\r\n.table-default > td {\r\n  background-color: #fdfdfd;\r\n}\r\n\r\n.table-default th,\r\n.table-default td,\r\n.table-default thead th,\r\n.table-default tbody + tbody {\r\n  border-color: #fbfbfb;\r\n}\r\n\r\n.table-hover .table-default:hover {\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.table-hover .table-default:hover > td,\r\n.table-hover .table-default:hover > th {\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.table-active,\r\n.table-active > th,\r\n.table-active > td {\r\n  background-color: rgba(0, 0, 0, 0.075);\r\n}\r\n\r\n.table-hover .table-active:hover {\r\n  background-color: rgba(0, 0, 0, 0.075);\r\n}\r\n\r\n.table-hover .table-active:hover > td,\r\n.table-hover .table-active:hover > th {\r\n  background-color: rgba(0, 0, 0, 0.075);\r\n}\r\n\r\n.table .thead-dark th {\r\n  color: #fff;\r\n  background-color: #343a40;\r\n  border-color: #454d55;\r\n}\r\n\r\n.table .thead-light th {\r\n  color: #4d4d4d;\r\n  background-color: #efedea;\r\n  border-color: #cccbca;\r\n}\r\n\r\n.table-dark {\r\n  color: #fff;\r\n  background-color: #343a40;\r\n}\r\n\r\n.table-dark th,\r\n.table-dark td,\r\n.table-dark thead th {\r\n  border-color: #454d55;\r\n}\r\n\r\n.table-dark.table-bordered {\r\n  border: 0;\r\n}\r\n\r\n.table-dark.table-striped tbody tr:nth-of-type(odd) {\r\n  background-color: rgba(255, 255, 255, 0.05);\r\n}\r\n\r\n.table-dark.table-hover tbody tr:hover {\r\n  color: #fff;\r\n  background-color: rgba(255, 255, 255, 0.075);\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .table-responsive-sm {\r\n    display: block;\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .table-responsive-sm > .table-bordered {\r\n    border: 0;\r\n  }\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n  .table-responsive-md {\r\n    display: block;\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .table-responsive-md > .table-bordered {\r\n    border: 0;\r\n  }\r\n}\r\n\r\n@media (max-width: 991.98px) {\r\n  .table-responsive-lg {\r\n    display: block;\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .table-responsive-lg > .table-bordered {\r\n    border: 0;\r\n  }\r\n}\r\n\r\n@media (max-width: 1199.98px) {\r\n  .table-responsive-xl {\r\n    display: block;\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n  }\r\n\r\n  .table-responsive-xl > .table-bordered {\r\n    border: 0;\r\n  }\r\n}\r\n\r\n.table-responsive {\r\n  display: block;\r\n  width: 100%;\r\n  overflow-x: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.table-responsive > .table-bordered {\r\n  border: 0;\r\n}\r\n\r\n.form-control {\r\n  display: block;\r\n  width: 100%;\r\n  height: calc(1.5em + 0.75rem + 2px);\r\n  padding: 0.375rem 0.75rem;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #4d4d4d;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid #ccc;\r\n  border-radius: 0;\r\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .form-control {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.form-control::-ms-expand {\r\n  background-color: transparent;\r\n  border: 0;\r\n}\r\n\r\n.form-control:focus {\r\n  color: #4d4d4d;\r\n  background-color: #fff;\r\n  border-color: #859bd6;\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.25);\r\n}\r\n\r\n.form-control::placeholder {\r\n  color: #6c757d;\r\n  opacity: 1;\r\n}\r\n\r\n.form-control:disabled,\r\n.form-control[readonly] {\r\n  background-color: #efedea;\r\n  opacity: 1;\r\n}\r\n\r\nselect.form-control:focus::-ms-value {\r\n  color: #4d4d4d;\r\n  background-color: #fff;\r\n}\r\n\r\n.form-control-file,\r\n.form-control-range {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.col-form-label {\r\n  padding-top: calc(0.375rem + 1px);\r\n  padding-bottom: calc(0.375rem + 1px);\r\n  margin-bottom: 0;\r\n  font-size: inherit;\r\n  line-height: 1.5;\r\n}\r\n\r\n.col-form-label-lg {\r\n  padding-top: calc(0.5rem + 1px);\r\n  padding-bottom: calc(0.5rem + 1px);\r\n  font-size: 1.25rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.col-form-label-sm {\r\n  padding-top: calc(0.25rem + 1px);\r\n  padding-bottom: calc(0.25rem + 1px);\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.form-control-plaintext {\r\n  display: block;\r\n  width: 100%;\r\n  padding-top: 0.375rem;\r\n  padding-bottom: 0.375rem;\r\n  margin-bottom: 0;\r\n  line-height: 1.5;\r\n  color: #212529;\r\n  background-color: transparent;\r\n  border: solid transparent;\r\n  border-width: 1px 0;\r\n}\r\n\r\n.form-control-plaintext.form-control-sm,\r\n.form-control-plaintext.form-control-lg {\r\n  padding-right: 0;\r\n  padding-left: 0;\r\n}\r\n\r\n.form-control-sm {\r\n  height: calc(1.5em + 0.5rem + 2px);\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.form-control-lg {\r\n  height: calc(1.5em + 1rem + 2px);\r\n  padding: 0.5rem 1rem;\r\n  font-size: 1.25rem;\r\n  line-height: 1.5;\r\n}\r\n\r\nselect.form-control[size],\r\nselect.form-control[multiple] {\r\n  height: auto;\r\n}\r\n\r\ntextarea.form-control {\r\n  height: auto;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.form-text {\r\n  display: block;\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n.form-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin-right: -5px;\r\n  margin-left: -5px;\r\n}\r\n\r\n.form-row > .col,\r\n.form-row > [class*=\"col-\"] {\r\n  padding-right: 5px;\r\n  padding-left: 5px;\r\n}\r\n\r\n.form-check {\r\n  position: relative;\r\n  display: block;\r\n  padding-left: 1.25rem;\r\n}\r\n\r\n.form-check-input {\r\n  position: absolute;\r\n  margin-top: 0.3rem;\r\n  margin-left: -1.25rem;\r\n}\r\n\r\n.form-check-input:disabled ~ .form-check-label {\r\n  color: #cccbca;\r\n}\r\n\r\n.form-check-label {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.form-check-inline {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding-left: 0;\r\n  margin-right: 0.75rem;\r\n}\r\n\r\n.form-check-inline .form-check-input {\r\n  position: static;\r\n  margin-top: 0;\r\n  margin-right: 0.3125rem;\r\n  margin-left: 0;\r\n}\r\n\r\n.valid-feedback {\r\n  display: none;\r\n  width: 100%;\r\n  margin-top: 0.25rem;\r\n  font-size: 80%;\r\n  color: var(--success);\r\n}\r\n\r\n.valid-tooltip {\r\n  position: absolute;\r\n  top: 100%;\r\n  z-index: 5;\r\n  display: none;\r\n  max-width: 100%;\r\n  padding: 0.25rem 0.5rem;\r\n  margin-top: .1rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n  color: #fff;\r\n  background-color: rgba(26, 179, 148, 0.9);\r\n}\r\n\r\n.was-validated .form-control:valid,\r\n.form-control.is-valid {\r\n  border-color: var(--success);\r\n  padding-right: calc(1.5em + 0.75rem);\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%231ab394' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\r\n  background-repeat: no-repeat;\r\n  background-position: center right calc(0.375em + 0.1875rem);\r\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\r\n}\r\n\r\n.was-validated .form-control:valid:focus,\r\n.form-control.is-valid:focus {\r\n  border-color: var(--success);\r\n  box-shadow: 0 0 0 0.2rem rgba(26, 179, 148, 0.25);\r\n}\r\n\r\n.was-validated .form-control:valid ~ .valid-feedback,\r\n.was-validated .form-control:valid ~ .valid-tooltip,\r\n.form-control.is-valid ~ .valid-feedback,\r\n.form-control.is-valid ~ .valid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated textarea.form-control:valid,\r\ntextarea.form-control.is-valid {\r\n  padding-right: calc(1.5em + 0.75rem);\r\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\r\n}\r\n\r\n.was-validated .custom-select:valid,\r\n.custom-select.is-valid {\r\n  border-color: var(--success);\r\n  padding-right: calc((1em + 0.75rem) * 3 / 4 + 1.75rem);\r\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 0.75rem center/8px 10px, url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%231ab394' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\r\n}\r\n\r\n.was-validated .custom-select:valid:focus,\r\n.custom-select.is-valid:focus {\r\n  border-color: var(--success);\r\n  box-shadow: 0 0 0 0.2rem rgba(26, 179, 148, 0.25);\r\n}\r\n\r\n.was-validated .custom-select:valid ~ .valid-feedback,\r\n.was-validated .custom-select:valid ~ .valid-tooltip,\r\n.custom-select.is-valid ~ .valid-feedback,\r\n.custom-select.is-valid ~ .valid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .form-control-file:valid ~ .valid-feedback,\r\n.was-validated .form-control-file:valid ~ .valid-tooltip,\r\n.form-control-file.is-valid ~ .valid-feedback,\r\n.form-control-file.is-valid ~ .valid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .form-check-input:valid ~ .form-check-label,\r\n.form-check-input.is-valid ~ .form-check-label {\r\n  color: var(--success);\r\n}\r\n\r\n.was-validated .form-check-input:valid ~ .valid-feedback,\r\n.was-validated .form-check-input:valid ~ .valid-tooltip,\r\n.form-check-input.is-valid ~ .valid-feedback,\r\n.form-check-input.is-valid ~ .valid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .custom-control-input:valid ~ .custom-control-label,\r\n.custom-control-input.is-valid ~ .custom-control-label {\r\n  color: var(--success);\r\n}\r\n\r\n.was-validated .custom-control-input:valid ~ .custom-control-label::before,\r\n.custom-control-input.is-valid ~ .custom-control-label::before {\r\n  border-color: var(--success);\r\n}\r\n\r\n.was-validated .custom-control-input:valid ~ .valid-feedback,\r\n.was-validated .custom-control-input:valid ~ .valid-tooltip,\r\n.custom-control-input.is-valid ~ .valid-feedback,\r\n.custom-control-input.is-valid ~ .valid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before,\r\n.custom-control-input.is-valid:checked ~ .custom-control-label::before {\r\n  border-color: #21dfb8;\r\n  background-color: #21dfb8;\r\n}\r\n\r\n.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before,\r\n.custom-control-input.is-valid:focus ~ .custom-control-label::before {\r\n  box-shadow: 0 0 0 0.2rem rgba(26, 179, 148, 0.25);\r\n}\r\n\r\n.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before,\r\n.custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {\r\n  border-color: var(--success);\r\n}\r\n\r\n.was-validated .custom-file-input:valid ~ .custom-file-label,\r\n.custom-file-input.is-valid ~ .custom-file-label {\r\n  border-color: var(--success);\r\n}\r\n\r\n.was-validated .custom-file-input:valid ~ .valid-feedback,\r\n.was-validated .custom-file-input:valid ~ .valid-tooltip,\r\n.custom-file-input.is-valid ~ .valid-feedback,\r\n.custom-file-input.is-valid ~ .valid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .custom-file-input:valid:focus ~ .custom-file-label,\r\n.custom-file-input.is-valid:focus ~ .custom-file-label {\r\n  border-color: var(--success);\r\n  box-shadow: 0 0 0 0.2rem rgba(26, 179, 148, 0.25);\r\n}\r\n\r\n.invalid-feedback {\r\n  display: none;\r\n  width: 100%;\r\n  margin-top: 0.25rem;\r\n  font-size: 80%;\r\n  color: #eb3349;\r\n}\r\n\r\n.invalid-tooltip {\r\n  position: absolute;\r\n  top: 100%;\r\n  z-index: 5;\r\n  display: none;\r\n  max-width: 100%;\r\n  padding: 0.25rem 0.5rem;\r\n  margin-top: .1rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n  color: #fff;\r\n  background-color: rgba(235, 51, 73, 0.9);\r\n}\r\n\r\n.was-validated .form-control:invalid,\r\n.form-control.is-invalid {\r\n  border-color: #eb3349;\r\n  padding-right: calc(1.5em + 0.75rem);\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23eb3349' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23eb3349' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E\");\r\n  background-repeat: no-repeat;\r\n  background-position: center right calc(0.375em + 0.1875rem);\r\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\r\n}\r\n\r\n.was-validated .form-control:invalid:focus,\r\n.form-control.is-invalid:focus {\r\n  border-color: #eb3349;\r\n  box-shadow: 0 0 0 0.2rem rgba(235, 51, 73, 0.25);\r\n}\r\n\r\n.was-validated .form-control:invalid ~ .invalid-feedback,\r\n.was-validated .form-control:invalid ~ .invalid-tooltip,\r\n.form-control.is-invalid ~ .invalid-feedback,\r\n.form-control.is-invalid ~ .invalid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated textarea.form-control:invalid,\r\ntextarea.form-control.is-invalid {\r\n  padding-right: calc(1.5em + 0.75rem);\r\n  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);\r\n}\r\n\r\n.was-validated .custom-select:invalid,\r\n.custom-select.is-invalid {\r\n  border-color: #eb3349;\r\n  padding-right: calc((1em + 0.75rem) * 3 / 4 + 1.75rem);\r\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 0.75rem center/8px 10px, url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23eb3349' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23eb3349' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E\") #fff no-repeat center right 1.75rem/calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\r\n}\r\n\r\n.was-validated .custom-select:invalid:focus,\r\n.custom-select.is-invalid:focus {\r\n  border-color: #eb3349;\r\n  box-shadow: 0 0 0 0.2rem rgba(235, 51, 73, 0.25);\r\n}\r\n\r\n.was-validated .custom-select:invalid ~ .invalid-feedback,\r\n.was-validated .custom-select:invalid ~ .invalid-tooltip,\r\n.custom-select.is-invalid ~ .invalid-feedback,\r\n.custom-select.is-invalid ~ .invalid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .form-control-file:invalid ~ .invalid-feedback,\r\n.was-validated .form-control-file:invalid ~ .invalid-tooltip,\r\n.form-control-file.is-invalid ~ .invalid-feedback,\r\n.form-control-file.is-invalid ~ .invalid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .form-check-input:invalid ~ .form-check-label,\r\n.form-check-input.is-invalid ~ .form-check-label {\r\n  color: #eb3349;\r\n}\r\n\r\n.was-validated .form-check-input:invalid ~ .invalid-feedback,\r\n.was-validated .form-check-input:invalid ~ .invalid-tooltip,\r\n.form-check-input.is-invalid ~ .invalid-feedback,\r\n.form-check-input.is-invalid ~ .invalid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .custom-control-input:invalid ~ .custom-control-label,\r\n.custom-control-input.is-invalid ~ .custom-control-label {\r\n  color: #eb3349;\r\n}\r\n\r\n.was-validated .custom-control-input:invalid ~ .custom-control-label::before,\r\n.custom-control-input.is-invalid ~ .custom-control-label::before {\r\n  border-color: #eb3349;\r\n}\r\n\r\n.was-validated .custom-control-input:invalid ~ .invalid-feedback,\r\n.was-validated .custom-control-input:invalid ~ .invalid-tooltip,\r\n.custom-control-input.is-invalid ~ .invalid-feedback,\r\n.custom-control-input.is-invalid ~ .invalid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before,\r\n.custom-control-input.is-invalid:checked ~ .custom-control-label::before {\r\n  border-color: #f06172;\r\n  background-color: #f06172;\r\n}\r\n\r\n.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before,\r\n.custom-control-input.is-invalid:focus ~ .custom-control-label::before {\r\n  box-shadow: 0 0 0 0.2rem rgba(235, 51, 73, 0.25);\r\n}\r\n\r\n.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before,\r\n.custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {\r\n  border-color: #eb3349;\r\n}\r\n\r\n.was-validated .custom-file-input:invalid ~ .custom-file-label,\r\n.custom-file-input.is-invalid ~ .custom-file-label {\r\n  border-color: #eb3349;\r\n}\r\n\r\n.was-validated .custom-file-input:invalid ~ .invalid-feedback,\r\n.was-validated .custom-file-input:invalid ~ .invalid-tooltip,\r\n.custom-file-input.is-invalid ~ .invalid-feedback,\r\n.custom-file-input.is-invalid ~ .invalid-tooltip {\r\n  display: block;\r\n}\r\n\r\n.was-validated .custom-file-input:invalid:focus ~ .custom-file-label,\r\n.custom-file-input.is-invalid:focus ~ .custom-file-label {\r\n  border-color: #eb3349;\r\n  box-shadow: 0 0 0 0.2rem rgba(235, 51, 73, 0.25);\r\n}\r\n\r\n.form-inline {\r\n  display: flex;\r\n  flex-flow: row wrap;\r\n  align-items: center;\r\n}\r\n\r\n.form-inline .form-check {\r\n  width: 100%;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .form-inline label {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .form-inline .form-group {\r\n    display: flex;\r\n    flex: 0 0 auto;\r\n    flex-flow: row wrap;\r\n    align-items: center;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .form-inline .form-control {\r\n    display: inline-block;\r\n    width: auto;\r\n    vertical-align: middle;\r\n  }\r\n\r\n  .form-inline .form-control-plaintext {\r\n    display: inline-block;\r\n  }\r\n\r\n  .form-inline .input-group,\r\n  .form-inline .custom-select {\r\n    width: auto;\r\n  }\r\n\r\n  .form-inline .form-check {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: auto;\r\n    padding-left: 0;\r\n  }\r\n\r\n  .form-inline .form-check-input {\r\n    position: relative;\r\n    flex-shrink: 0;\r\n    margin-top: 0;\r\n    margin-right: 0.25rem;\r\n    margin-left: 0;\r\n  }\r\n\r\n  .form-inline .custom-control {\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .form-inline .custom-control-label {\r\n    margin-bottom: 0;\r\n  }\r\n}\r\n\r\n.btn {\r\n  display: inline-block;\r\n  font-weight: 400;\r\n  color: #212529;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  -webkit-user-select: none;\r\n          user-select: none;\r\n  background-color: transparent;\r\n  border: 1px solid transparent;\r\n  padding: 0.375rem 0.75rem;\r\n  font-size: 1rem;\r\n  line-height: 1.5;\r\n  border-radius: 0;\r\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .btn {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n\r\n\r\n.btn:focus,\r\n.btn.focus {\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.25);\r\n}\r\n\r\n.btn.disabled,\r\n.btn:disabled {\r\n  opacity: 0.65;\r\n}\r\n\r\na.btn.disabled,\r\nfieldset:disabled a.btn {\r\n  pointer-events: none;\r\n}\r\n\r\n.btn-primary {\r\n  color: #fff;\r\n  background-color: var(--primary);\r\n  border-color: var(--primary);\r\n}\r\n\r\n.btn-primary:hover {\r\n  color: #fff;\r\n  background-color: #2d4588;\r\n  border-color: #2a417f;\r\n}\r\n\r\n.btn-primary:focus,\r\n.btn-primary.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(85, 110, 179, 0.5);\r\n}\r\n\r\n.btn-primary.disabled,\r\n.btn-primary:disabled {\r\n  color: #fff;\r\n  background-color: var(--primary);\r\n  border-color: var(--primary);\r\n}\r\n\r\n.btn-primary:not(:disabled):not(.disabled):active,\r\n.btn-primary:not(:disabled):not(.disabled).active,\r\n.show > .btn-primary.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #2a417f;\r\n  border-color: #273c75;\r\n}\r\n\r\n.btn-primary:not(:disabled):not(.disabled):active:focus,\r\n.btn-primary:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-primary.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(85, 110, 179, 0.5);\r\n}\r\n\r\n.btn-secondary {\r\n  color: #212529;\r\n  background-color: var(--secondary);\r\n  border-color: var(--secondary);\r\n}\r\n\r\n.btn-secondary:hover {\r\n  color: #212529;\r\n  background-color: #99affc;\r\n  border-color: #8da5fb;\r\n}\r\n\r\n.btn-secondary:focus,\r\n.btn-secondary.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(166, 179, 221, 0.5);\r\n}\r\n\r\n.btn-secondary.disabled,\r\n.btn-secondary:disabled {\r\n  color: #212529;\r\n  background-color: var(--secondary);\r\n  border-color: var(--secondary);\r\n}\r\n\r\n.btn-secondary:not(:disabled):not(.disabled):active,\r\n.btn-secondary:not(:disabled):not(.disabled).active,\r\n.show > .btn-secondary.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #8da5fb;\r\n  border-color: #809bfb;\r\n}\r\n\r\n.btn-secondary:not(:disabled):not(.disabled):active:focus,\r\n.btn-secondary:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-secondary.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(166, 179, 221, 0.5);\r\n}\r\n\r\n.btn-success {\r\n  color: #fff;\r\n  background-color: var(--success);\r\n  border-color: var(--success);\r\n}\r\n\r\n.btn-success:hover {\r\n  color: #fff;\r\n  background-color: #159278;\r\n  border-color: #14866f;\r\n}\r\n\r\n.btn-success:focus,\r\n.btn-success.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(60, 190, 164, 0.5);\r\n}\r\n\r\n.btn-success.disabled,\r\n.btn-success:disabled {\r\n  color: #fff;\r\n  background-color: var(--success);\r\n  border-color: var(--success);\r\n}\r\n\r\n.btn-success:not(:disabled):not(.disabled):active,\r\n.btn-success:not(:disabled):not(.disabled).active,\r\n.show > .btn-success.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #14866f;\r\n  border-color: #127b66;\r\n}\r\n\r\n.btn-success:not(:disabled):not(.disabled):active:focus,\r\n.btn-success:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-success.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(60, 190, 164, 0.5);\r\n}\r\n\r\n.btn-info {\r\n  color: #fff;\r\n  background-color: #5d80f9;\r\n  border-color: #5d80f9;\r\n}\r\n\r\n.btn-info:hover {\r\n  color: #fff;\r\n  background-color: #3863f8;\r\n  border-color: #2c59f7;\r\n}\r\n\r\n.btn-info:focus,\r\n.btn-info.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(117, 147, 250, 0.5);\r\n}\r\n\r\n.btn-info.disabled,\r\n.btn-info:disabled {\r\n  color: #fff;\r\n  background-color: #5d80f9;\r\n  border-color: #5d80f9;\r\n}\r\n\r\n.btn-info:not(:disabled):not(.disabled):active,\r\n.btn-info:not(:disabled):not(.disabled).active,\r\n.show > .btn-info.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #2c59f7;\r\n  border-color: #2050f7;\r\n}\r\n\r\n.btn-info:not(:disabled):not(.disabled):active:focus,\r\n.btn-info:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-info.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(117, 147, 250, 0.5);\r\n}\r\n\r\n.btn-warning {\r\n  color: #212529;\r\n  background-color: #f3c363;\r\n  border-color: #f3c363;\r\n}\r\n\r\n.btn-warning:hover {\r\n  color: #212529;\r\n  background-color: #f0b53f;\r\n  border-color: #efb134;\r\n}\r\n\r\n.btn-warning:focus,\r\n.btn-warning.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(212, 171, 90, 0.5);\r\n}\r\n\r\n.btn-warning.disabled,\r\n.btn-warning:disabled {\r\n  color: #212529;\r\n  background-color: #f3c363;\r\n  border-color: #f3c363;\r\n}\r\n\r\n.btn-warning:not(:disabled):not(.disabled):active,\r\n.btn-warning:not(:disabled):not(.disabled).active,\r\n.show > .btn-warning.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #efb134;\r\n  border-color: #eeac28;\r\n}\r\n\r\n.btn-warning:not(:disabled):not(.disabled):active:focus,\r\n.btn-warning:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-warning.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(212, 171, 90, 0.5);\r\n}\r\n\r\n.btn-danger {\r\n  color: #fff;\r\n  background-color: #eb3349;\r\n  border-color: #eb3349;\r\n}\r\n\r\n.btn-danger:hover {\r\n  color: #fff;\r\n  background-color: #e2162e;\r\n  border-color: #d6152c;\r\n}\r\n\r\n.btn-danger:focus,\r\n.btn-danger.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(238, 82, 100, 0.5);\r\n}\r\n\r\n.btn-danger.disabled,\r\n.btn-danger:disabled {\r\n  color: #fff;\r\n  background-color: #eb3349;\r\n  border-color: #eb3349;\r\n}\r\n\r\n.btn-danger:not(:disabled):not(.disabled):active,\r\n.btn-danger:not(:disabled):not(.disabled).active,\r\n.show > .btn-danger.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #d6152c;\r\n  border-color: #ca142a;\r\n}\r\n\r\n.btn-danger:not(:disabled):not(.disabled):active:focus,\r\n.btn-danger:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-danger.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(238, 82, 100, 0.5);\r\n}\r\n\r\n.btn-light {\r\n  color: #212529;\r\n  background-color: #cccbca;\r\n  border-color: #cccbca;\r\n}\r\n\r\n.btn-light:hover {\r\n  color: #212529;\r\n  background-color: #b9b8b7;\r\n  border-color: #b3b2b0;\r\n}\r\n\r\n.btn-light:focus,\r\n.btn-light.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(178, 178, 178, 0.5);\r\n}\r\n\r\n.btn-light.disabled,\r\n.btn-light:disabled {\r\n  color: #212529;\r\n  background-color: #cccbca;\r\n  border-color: #cccbca;\r\n}\r\n\r\n.btn-light:not(:disabled):not(.disabled):active,\r\n.btn-light:not(:disabled):not(.disabled).active,\r\n.show > .btn-light.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #b3b2b0;\r\n  border-color: #adabaa;\r\n}\r\n\r\n.btn-light:not(:disabled):not(.disabled):active:focus,\r\n.btn-light:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-light.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(178, 178, 178, 0.5);\r\n}\r\n\r\n.btn-dark {\r\n  color: #fff;\r\n  background-color: #343a40;\r\n  border-color: #343a40;\r\n}\r\n\r\n.btn-dark:hover {\r\n  color: #fff;\r\n  background-color: #23272b;\r\n  border-color: #1d2124;\r\n}\r\n\r\n.btn-dark:focus,\r\n.btn-dark.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);\r\n}\r\n\r\n.btn-dark.disabled,\r\n.btn-dark:disabled {\r\n  color: #fff;\r\n  background-color: #343a40;\r\n  border-color: #343a40;\r\n}\r\n\r\n.btn-dark:not(:disabled):not(.disabled):active,\r\n.btn-dark:not(:disabled):not(.disabled).active,\r\n.show > .btn-dark.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #1d2124;\r\n  border-color: #171a1d;\r\n}\r\n\r\n.btn-dark:not(:disabled):not(.disabled):active:focus,\r\n.btn-dark:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-dark.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(82, 88, 93, 0.5);\r\n}\r\n\r\n.btn-inverse {\r\n  color: #fff;\r\n  background-color: #4d4d4d;\r\n  border-color: #4d4d4d;\r\n}\r\n\r\n.btn-inverse:hover {\r\n  color: #fff;\r\n  background-color: #3a3a3a;\r\n  border-color: #343434;\r\n}\r\n\r\n.btn-inverse:focus,\r\n.btn-inverse.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(104, 104, 104, 0.5);\r\n}\r\n\r\n.btn-inverse.disabled,\r\n.btn-inverse:disabled {\r\n  color: #fff;\r\n  background-color: #4d4d4d;\r\n  border-color: #4d4d4d;\r\n}\r\n\r\n.btn-inverse:not(:disabled):not(.disabled):active,\r\n.btn-inverse:not(:disabled):not(.disabled).active,\r\n.show > .btn-inverse.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #343434;\r\n  border-color: #2d2d2d;\r\n}\r\n\r\n.btn-inverse:not(:disabled):not(.disabled):active:focus,\r\n.btn-inverse:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-inverse.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(104, 104, 104, 0.5);\r\n}\r\n\r\n.btn-gray {\r\n  color: #212529;\r\n  background-color: #ccc;\r\n  border-color: #ccc;\r\n}\r\n\r\n.btn-gray:hover {\r\n  color: #212529;\r\n  background-color: #b9b9b9;\r\n  border-color: #b3b3b3;\r\n}\r\n\r\n.btn-gray:focus,\r\n.btn-gray.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(178, 179, 180, 0.5);\r\n}\r\n\r\n.btn-gray.disabled,\r\n.btn-gray:disabled {\r\n  color: #212529;\r\n  background-color: #ccc;\r\n  border-color: #ccc;\r\n}\r\n\r\n.btn-gray:not(:disabled):not(.disabled):active,\r\n.btn-gray:not(:disabled):not(.disabled).active,\r\n.show > .btn-gray.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #b3b3b3;\r\n  border-color: #acacac;\r\n}\r\n\r\n.btn-gray:not(:disabled):not(.disabled):active:focus,\r\n.btn-gray:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-gray.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(178, 179, 180, 0.5);\r\n}\r\n\r\n.btn-default {\r\n  color: #f8fbfd;\r\n  background-color: #d0c9c9;\r\n  border-color: #9f9f9f;\r\n}\r\n\r\n.btn-default:hover {\r\n  color: #e4e9ee;\r\n  background-color: #a7a2a2;\r\n  border-color: #dfdfdf;\r\n}\r\n\r\n.btn-default:focus,\r\n.btn-default.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(216, 216, 217, 0.5);\r\n}\r\n\r\n.btn-default.disabled,\r\n.btn-default:disabled {\r\n  color: #212529;\r\n  background-color: #f8f8f8;\r\n  border-color: #f8f8f8;\r\n}\r\n\r\n.btn-default:not(:disabled):not(.disabled):active,\r\n.btn-default:not(:disabled):not(.disabled).active,\r\n.show > .btn-default.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #dfdfdf;\r\n  border-color: #d8d8d8;\r\n}\r\n\r\n.btn-default:not(:disabled):not(.disabled):active:focus,\r\n.btn-default:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-default.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(216, 216, 217, 0.5);\r\n}\r\n\r\n.btn-outline-primary {\r\n  color: var(--primary);\r\n  border-color: var(--primary);\r\n}\r\n\r\n.btn-outline-primary:hover {\r\n  color: #fff;\r\n  background-color: var(--primary);\r\n  border-color: var(--primary);\r\n}\r\n\r\n.btn-outline-primary:focus,\r\n.btn-outline-primary.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.5);\r\n}\r\n\r\n.btn-outline-primary.disabled,\r\n.btn-outline-primary:disabled {\r\n  color: var(--primary);\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-primary:not(:disabled):not(.disabled):active,\r\n.btn-outline-primary:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-primary.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: var(--primary);\r\n  border-color: var(--primary);\r\n}\r\n\r\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-primary:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-primary.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.5);\r\n}\r\n\r\n.btn-outline-secondary {\r\n  color: var(--secondary);\r\n  border-color: var(--secondary);\r\n}\r\n\r\n.btn-outline-secondary:hover {\r\n  color: #212529;\r\n  background-color: var(--secondary);\r\n  border-color: var(--secondary);\r\n}\r\n\r\n.btn-outline-secondary:focus,\r\n.btn-outline-secondary.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(190, 204, 253, 0.5);\r\n}\r\n\r\n.btn-outline-secondary.disabled,\r\n.btn-outline-secondary:disabled {\r\n  color: var(--secondary);\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-secondary:not(:disabled):not(.disabled):active,\r\n.btn-outline-secondary:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-secondary.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: var(--secondary);\r\n  border-color: var(--secondary);\r\n}\r\n\r\n.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-secondary:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-secondary.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(190, 204, 253, 0.5);\r\n}\r\n\r\n.btn-outline-success {\r\n  color: var(--success);\r\n  border-color: var(--success);\r\n}\r\n\r\n.btn-outline-success:hover {\r\n  color: #fff;\r\n  background-color: var(--success);\r\n  border-color: var(--success);\r\n}\r\n\r\n.btn-outline-success:focus,\r\n.btn-outline-success.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(26, 179, 148, 0.5);\r\n}\r\n\r\n.btn-outline-success.disabled,\r\n.btn-outline-success:disabled {\r\n  color: var(--success);\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-success:not(:disabled):not(.disabled):active,\r\n.btn-outline-success:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-success.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: var(--success);\r\n  border-color: var(--success);\r\n}\r\n\r\n.btn-outline-success:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-success:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-success.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(26, 179, 148, 0.5);\r\n}\r\n\r\n.btn-outline-info {\r\n  color: #5d80f9;\r\n  border-color: #5d80f9;\r\n}\r\n\r\n.btn-outline-info:hover {\r\n  color: #fff;\r\n  background-color: #5d80f9;\r\n  border-color: #5d80f9;\r\n}\r\n\r\n.btn-outline-info:focus,\r\n.btn-outline-info.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(93, 128, 249, 0.5);\r\n}\r\n\r\n.btn-outline-info.disabled,\r\n.btn-outline-info:disabled {\r\n  color: #5d80f9;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-info:not(:disabled):not(.disabled):active,\r\n.btn-outline-info:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-info.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #5d80f9;\r\n  border-color: #5d80f9;\r\n}\r\n\r\n.btn-outline-info:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-info:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-info.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(93, 128, 249, 0.5);\r\n}\r\n\r\n.btn-outline-warning {\r\n  color: #f3c363;\r\n  border-color: #f3c363;\r\n}\r\n\r\n.btn-outline-warning:hover {\r\n  color: #212529;\r\n  background-color: #f3c363;\r\n  border-color: #f3c363;\r\n}\r\n\r\n.btn-outline-warning:focus,\r\n.btn-outline-warning.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(243, 195, 99, 0.5);\r\n}\r\n\r\n.btn-outline-warning.disabled,\r\n.btn-outline-warning:disabled {\r\n  color: #f3c363;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-warning:not(:disabled):not(.disabled):active,\r\n.btn-outline-warning:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-warning.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #f3c363;\r\n  border-color: #f3c363;\r\n}\r\n\r\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-warning:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-warning.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(243, 195, 99, 0.5);\r\n}\r\n\r\n.btn-outline-danger {\r\n  color: #eb3349;\r\n  border-color: #eb3349;\r\n}\r\n\r\n.btn-outline-danger:hover {\r\n  color: #fff;\r\n  background-color: #eb3349;\r\n  border-color: #eb3349;\r\n}\r\n\r\n.btn-outline-danger:focus,\r\n.btn-outline-danger.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(235, 51, 73, 0.5);\r\n}\r\n\r\n.btn-outline-danger.disabled,\r\n.btn-outline-danger:disabled {\r\n  color: #eb3349;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-danger:not(:disabled):not(.disabled):active,\r\n.btn-outline-danger:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-danger.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #eb3349;\r\n  border-color: #eb3349;\r\n}\r\n\r\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-danger:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-danger.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(235, 51, 73, 0.5);\r\n}\r\n\r\n.btn-outline-light {\r\n  color: #cccbca;\r\n  border-color: #cccbca;\r\n}\r\n\r\n.btn-outline-light:hover {\r\n  color: #212529;\r\n  background-color: #cccbca;\r\n  border-color: #cccbca;\r\n}\r\n\r\n.btn-outline-light:focus,\r\n.btn-outline-light.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(204, 203, 202, 0.5);\r\n}\r\n\r\n.btn-outline-light.disabled,\r\n.btn-outline-light:disabled {\r\n  color: #cccbca;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-light:not(:disabled):not(.disabled):active,\r\n.btn-outline-light:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-light.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #cccbca;\r\n  border-color: #cccbca;\r\n}\r\n\r\n.btn-outline-light:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-light:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-light.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(204, 203, 202, 0.5);\r\n}\r\n\r\n.btn-outline-dark {\r\n  color: #343a40;\r\n  border-color: #343a40;\r\n}\r\n\r\n.btn-outline-dark:hover {\r\n  color: #fff;\r\n  background-color: #343a40;\r\n  border-color: #343a40;\r\n}\r\n\r\n.btn-outline-dark:focus,\r\n.btn-outline-dark.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\r\n}\r\n\r\n.btn-outline-dark.disabled,\r\n.btn-outline-dark:disabled {\r\n  color: #343a40;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-dark:not(:disabled):not(.disabled):active,\r\n.btn-outline-dark:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-dark.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #343a40;\r\n  border-color: #343a40;\r\n}\r\n\r\n.btn-outline-dark:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-dark:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-dark.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\r\n}\r\n\r\n.btn-outline-inverse {\r\n  color: #4d4d4d;\r\n  border-color: #4d4d4d;\r\n}\r\n\r\n.btn-outline-inverse:hover {\r\n  color: #fff;\r\n  background-color: #4d4d4d;\r\n  border-color: #4d4d4d;\r\n}\r\n\r\n.btn-outline-inverse:focus,\r\n.btn-outline-inverse.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(77, 77, 77, 0.5);\r\n}\r\n\r\n.btn-outline-inverse.disabled,\r\n.btn-outline-inverse:disabled {\r\n  color: #4d4d4d;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-inverse:not(:disabled):not(.disabled):active,\r\n.btn-outline-inverse:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-inverse.dropdown-toggle {\r\n  color: #fff;\r\n  background-color: #4d4d4d;\r\n  border-color: #4d4d4d;\r\n}\r\n\r\n.btn-outline-inverse:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-inverse:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-inverse.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(77, 77, 77, 0.5);\r\n}\r\n\r\n.btn-outline-gray {\r\n  color: #ccc;\r\n  border-color: #ccc;\r\n}\r\n\r\n.btn-outline-gray:hover {\r\n  color: #212529;\r\n  background-color: #ccc;\r\n  border-color: #ccc;\r\n}\r\n\r\n.btn-outline-gray:focus,\r\n.btn-outline-gray.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(204, 204, 204, 0.5);\r\n}\r\n\r\n.btn-outline-gray.disabled,\r\n.btn-outline-gray:disabled {\r\n  color: #ccc;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-gray:not(:disabled):not(.disabled):active,\r\n.btn-outline-gray:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-gray.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #ccc;\r\n  border-color: #ccc;\r\n}\r\n\r\n.btn-outline-gray:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-gray:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-gray.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(204, 204, 204, 0.5);\r\n}\r\n\r\n.btn-outline-default {\r\n  color: #f8f8f8;\r\n  border-color: #f8f8f8;\r\n}\r\n\r\n.btn-outline-default:hover {\r\n  color: #212529;\r\n  background-color: #f8f8f8;\r\n  border-color: #f8f8f8;\r\n}\r\n\r\n.btn-outline-default:focus,\r\n.btn-outline-default.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(248, 248, 248, 0.5);\r\n}\r\n\r\n.btn-outline-default.disabled,\r\n.btn-outline-default:disabled {\r\n  color: #f8f8f8;\r\n  background-color: transparent;\r\n}\r\n\r\n.btn-outline-default:not(:disabled):not(.disabled):active,\r\n.btn-outline-default:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-default.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #f8f8f8;\r\n  border-color: #f8f8f8;\r\n}\r\n\r\n.btn-outline-default:not(:disabled):not(.disabled):active:focus,\r\n.btn-outline-default:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-default.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(248, 248, 248, 0.5);\r\n}\r\n\r\n.btn-link {\r\n  font-weight: 400;\r\n  color: #337ab7;\r\n  text-decoration: none;\r\n}\r\n\r\n.btn-link:hover {\r\n  color: #22527b;\r\n  text-decoration: underline;\r\n}\r\n\r\n.btn-link:focus,\r\n.btn-link.focus {\r\n  text-decoration: underline;\r\n  box-shadow: none;\r\n}\r\n\r\n.btn-link:disabled,\r\n.btn-link.disabled {\r\n  color: #6c757d;\r\n  pointer-events: none;\r\n}\r\n\r\n.btn-lg,\r\n.btn-group-lg > .btn {\r\n  padding: 0.5rem 1rem;\r\n  font-size: 1.25rem;\r\n  line-height: 1.5;\r\n  border-radius: 0;\r\n}\r\n\r\n.btn-sm,\r\n.btn-group-sm > .btn {\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n  border-radius: 0;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.fade {\r\n  transition: opacity 0.15s linear;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .fade {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.fade:not(.show) {\r\n  opacity: 0;\r\n}\r\n\r\n.collapse:not(.show) {\r\n  display: none;\r\n}\r\n\r\n.collapsing {\r\n  position: relative;\r\n  height: 0;\r\n  overflow: hidden;\r\n  transition: height 0.35s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .collapsing {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.dropup,\r\n.dropright,\r\n.dropdown,\r\n.dropleft {\r\n  position: relative;\r\n}\r\n\r\n.dropdown-toggle {\r\n  white-space: nowrap;\r\n}\r\n\r\n.dropdown-toggle::after {\r\n  display: inline-block;\r\n  margin-left: 0.255em;\r\n  vertical-align: 0.255em;\r\n  content: \"\";\r\n  border-top: 0.3em solid;\r\n  border-right: 0.3em solid transparent;\r\n  border-bottom: 0;\r\n  border-left: 0.3em solid transparent;\r\n}\r\n\r\n.dropdown-toggle:empty::after {\r\n  margin-left: 0;\r\n}\r\n\r\n.dropdown-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  z-index: 1000;\r\n  display: none;\r\n  float: left;\r\n  min-width: 10rem;\r\n  padding: 0.5rem 0;\r\n  margin: 0.125rem 0 0;\r\n  font-size: 1rem;\r\n  color: #212529;\r\n  text-align: left;\r\n  list-style: none;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.dropdown-menu-left {\r\n  right: auto;\r\n  left: 0;\r\n}\r\n\r\n.dropdown-menu-right {\r\n  right: 0;\r\n  left: auto;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .dropdown-menu-sm-left {\r\n    right: auto;\r\n    left: 0;\r\n  }\r\n\r\n  .dropdown-menu-sm-right {\r\n    right: 0;\r\n    left: auto;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .dropdown-menu-md-left {\r\n    right: auto;\r\n    left: 0;\r\n  }\r\n\r\n  .dropdown-menu-md-right {\r\n    right: 0;\r\n    left: auto;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .dropdown-menu-lg-left {\r\n    right: auto;\r\n    left: 0;\r\n  }\r\n\r\n  .dropdown-menu-lg-right {\r\n    right: 0;\r\n    left: auto;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .dropdown-menu-xl-left {\r\n    right: auto;\r\n    left: 0;\r\n  }\r\n\r\n  .dropdown-menu-xl-right {\r\n    right: 0;\r\n    left: auto;\r\n  }\r\n}\r\n\r\n.dropup .dropdown-menu {\r\n  top: auto;\r\n  bottom: 100%;\r\n  margin-top: 0;\r\n  margin-bottom: 0.125rem;\r\n}\r\n\r\n.dropup .dropdown-toggle::after {\r\n  display: inline-block;\r\n  margin-left: 0.255em;\r\n  vertical-align: 0.255em;\r\n  content: \"\";\r\n  border-top: 0;\r\n  border-right: 0.3em solid transparent;\r\n  border-bottom: 0.3em solid;\r\n  border-left: 0.3em solid transparent;\r\n}\r\n\r\n.dropup .dropdown-toggle:empty::after {\r\n  margin-left: 0;\r\n}\r\n\r\n.dropright .dropdown-menu {\r\n  top: 0;\r\n  right: auto;\r\n  left: 100%;\r\n  margin-top: 0;\r\n  margin-left: 0.125rem;\r\n}\r\n\r\n.dropright .dropdown-toggle::after {\r\n  display: inline-block;\r\n  margin-left: 0.255em;\r\n  vertical-align: 0.255em;\r\n  content: \"\";\r\n  border-top: 0.3em solid transparent;\r\n  border-right: 0;\r\n  border-bottom: 0.3em solid transparent;\r\n  border-left: 0.3em solid;\r\n}\r\n\r\n.dropright .dropdown-toggle:empty::after {\r\n  margin-left: 0;\r\n}\r\n\r\n.dropright .dropdown-toggle::after {\r\n  vertical-align: 0;\r\n}\r\n\r\n.dropleft .dropdown-menu {\r\n  top: 0;\r\n  right: 100%;\r\n  left: auto;\r\n  margin-top: 0;\r\n  margin-right: 0.125rem;\r\n}\r\n\r\n.dropleft .dropdown-toggle::after {\r\n  display: inline-block;\r\n  margin-left: 0.255em;\r\n  vertical-align: 0.255em;\r\n  content: \"\";\r\n}\r\n\r\n.dropleft .dropdown-toggle::after {\r\n  display: none;\r\n}\r\n\r\n.dropleft .dropdown-toggle::before {\r\n  display: inline-block;\r\n  margin-right: 0.255em;\r\n  vertical-align: 0.255em;\r\n  content: \"\";\r\n  border-top: 0.3em solid transparent;\r\n  border-right: 0.3em solid;\r\n  border-bottom: 0.3em solid transparent;\r\n}\r\n\r\n.dropleft .dropdown-toggle:empty::after {\r\n  margin-left: 0;\r\n}\r\n\r\n.dropleft .dropdown-toggle::before {\r\n  vertical-align: 0;\r\n}\r\n\r\n.dropdown-menu[x-placement^=\"top\"],\r\n.dropdown-menu[x-placement^=\"right\"],\r\n.dropdown-menu[x-placement^=\"bottom\"],\r\n.dropdown-menu[x-placement^=\"left\"] {\r\n  right: auto;\r\n  bottom: auto;\r\n}\r\n\r\n.dropdown-divider {\r\n  height: 0;\r\n  margin: 0.5rem 0;\r\n  overflow: hidden;\r\n  border-top: 1px solid #efedea;\r\n}\r\n\r\n.dropdown-item {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 0.25rem 1.5rem;\r\n  clear: both;\r\n  font-weight: 400;\r\n  color: #212529;\r\n  text-align: inherit;\r\n  white-space: nowrap;\r\n  background-color: transparent;\r\n  border: 0;\r\n}\r\n\r\n.dropdown-item:hover,\r\n.dropdown-item:focus {\r\n  color: #16181b;\r\n  text-decoration: none;\r\n  background-color: #f9f6f2;\r\n}\r\n\r\n.dropdown-item.active,\r\n.dropdown-item:active {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  background-color: var(--primary);\r\n}\r\n\r\n.dropdown-item.disabled,\r\n.dropdown-item:disabled {\r\n  color: #6c757d;\r\n  pointer-events: none;\r\n  background-color: transparent;\r\n}\r\n\r\n.dropdown-menu.show {\r\n  display: block;\r\n}\r\n\r\n.dropdown-header {\r\n  display: block;\r\n  padding: 0.5rem 1.5rem;\r\n  margin-bottom: 0;\r\n  font-size: 0.875rem;\r\n  color: #6c757d;\r\n  white-space: nowrap;\r\n}\r\n\r\n.dropdown-item-text {\r\n  display: block;\r\n  padding: 0.25rem 1.5rem;\r\n  color: #212529;\r\n}\r\n\r\n.btn-group,\r\n.btn-group-vertical {\r\n  position: relative;\r\n  display: inline-flex;\r\n  vertical-align: middle;\r\n}\r\n\r\n.btn-group > .btn,\r\n.btn-group-vertical > .btn {\r\n  position: relative;\r\n  flex: 1 1 auto;\r\n}\r\n\r\n.btn-group > .btn:hover,\r\n.btn-group-vertical > .btn:hover {\r\n  z-index: 1;\r\n}\r\n\r\n.btn-group > .btn:focus,\r\n.btn-group > .btn:active,\r\n.btn-group > .btn.active,\r\n.btn-group-vertical > .btn:focus,\r\n.btn-group-vertical > .btn:active,\r\n.btn-group-vertical > .btn.active {\r\n  z-index: 1;\r\n}\r\n\r\n.btn-toolbar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.btn-toolbar .input-group {\r\n  width: auto;\r\n}\r\n\r\n.btn-group > .btn:not(:first-child),\r\n.btn-group > .btn-group:not(:first-child) {\r\n  margin-left: -1px;\r\n}\r\n\r\n.dropdown-toggle-split {\r\n  padding-right: 0.5625rem;\r\n  padding-left: 0.5625rem;\r\n}\r\n\r\n.dropdown-toggle-split::after,\r\n.dropup .dropdown-toggle-split::after,\r\n.dropright .dropdown-toggle-split::after {\r\n  margin-left: 0;\r\n}\r\n\r\n.dropleft .dropdown-toggle-split::before {\r\n  margin-right: 0;\r\n}\r\n\r\n.btn-sm + .dropdown-toggle-split,\r\n.btn-group-sm > .btn + .dropdown-toggle-split {\r\n  padding-right: 0.375rem;\r\n  padding-left: 0.375rem;\r\n}\r\n\r\n.btn-lg + .dropdown-toggle-split,\r\n.btn-group-lg > .btn + .dropdown-toggle-split {\r\n  padding-right: 0.75rem;\r\n  padding-left: 0.75rem;\r\n}\r\n\r\n.btn-group-vertical {\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n}\r\n\r\n.btn-group-vertical > .btn,\r\n.btn-group-vertical > .btn-group {\r\n  width: 100%;\r\n}\r\n\r\n.btn-group-vertical > .btn:not(:first-child),\r\n.btn-group-vertical > .btn-group:not(:first-child) {\r\n  margin-top: -1px;\r\n}\r\n\r\n.btn-group-toggle > .btn,\r\n.btn-group-toggle > .btn-group > .btn {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.btn-group-toggle > .btn input[type=\"radio\"],\r\n.btn-group-toggle > .btn input[type=\"checkbox\"],\r\n.btn-group-toggle > .btn-group > .btn input[type=\"radio\"],\r\n.btn-group-toggle > .btn-group > .btn input[type=\"checkbox\"] {\r\n  position: absolute;\r\n  clip: rect(0, 0, 0, 0);\r\n  pointer-events: none;\r\n}\r\n\r\n.input-group {\r\n  position: relative;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: stretch;\r\n  width: 100%;\r\n}\r\n\r\n.input-group > .form-control,\r\n.input-group > .form-control-plaintext,\r\n.input-group > .custom-select,\r\n.input-group > .custom-file {\r\n  position: relative;\r\n  flex: 1 1 auto;\r\n  width: 1%;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.input-group > .form-control + .form-control,\r\n.input-group > .form-control + .custom-select,\r\n.input-group > .form-control + .custom-file,\r\n.input-group > .form-control-plaintext + .form-control,\r\n.input-group > .form-control-plaintext + .custom-select,\r\n.input-group > .form-control-plaintext + .custom-file,\r\n.input-group > .custom-select + .form-control,\r\n.input-group > .custom-select + .custom-select,\r\n.input-group > .custom-select + .custom-file,\r\n.input-group > .custom-file + .form-control,\r\n.input-group > .custom-file + .custom-select,\r\n.input-group > .custom-file + .custom-file {\r\n  margin-left: -1px;\r\n}\r\n\r\n.input-group > .form-control:focus,\r\n.input-group > .custom-select:focus,\r\n.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {\r\n  z-index: 3;\r\n}\r\n\r\n.input-group > .custom-file .custom-file-input:focus {\r\n  z-index: 4;\r\n}\r\n\r\n.input-group > .custom-file {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.input-group-prepend,\r\n.input-group-append {\r\n  display: flex;\r\n}\r\n\r\n.input-group-prepend .btn,\r\n.input-group-append .btn {\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.input-group-prepend .btn:focus,\r\n.input-group-append .btn:focus {\r\n  z-index: 3;\r\n}\r\n\r\n.input-group-prepend .btn + .btn,\r\n.input-group-prepend .btn + .input-group-text,\r\n.input-group-prepend .input-group-text + .input-group-text,\r\n.input-group-prepend .input-group-text + .btn,\r\n.input-group-append .btn + .btn,\r\n.input-group-append .btn + .input-group-text,\r\n.input-group-append .input-group-text + .input-group-text,\r\n.input-group-append .input-group-text + .btn {\r\n  margin-left: -1px;\r\n}\r\n\r\n.input-group-prepend {\r\n  margin-right: -1px;\r\n}\r\n\r\n.input-group-append {\r\n  margin-left: -1px;\r\n}\r\n\r\n.input-group-text {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0.375rem 0.75rem;\r\n  margin-bottom: 0;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #4d4d4d;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  background-color: #efedea;\r\n  border: 1px solid #ccc;\r\n}\r\n\r\n.input-group-text input[type=\"radio\"],\r\n.input-group-text input[type=\"checkbox\"] {\r\n  margin-top: 0;\r\n}\r\n\r\n.input-group-lg > .form-control:not(textarea),\r\n.input-group-lg > .custom-select {\r\n  height: calc(1.5em + 1rem + 2px);\r\n}\r\n\r\n.input-group-lg > .form-control,\r\n.input-group-lg > .custom-select,\r\n.input-group-lg > .input-group-prepend > .input-group-text,\r\n.input-group-lg > .input-group-append > .input-group-text,\r\n.input-group-lg > .input-group-prepend > .btn,\r\n.input-group-lg > .input-group-append > .btn {\r\n  padding: 0.5rem 1rem;\r\n  font-size: 1.25rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.input-group-sm > .form-control:not(textarea),\r\n.input-group-sm > .custom-select {\r\n  height: calc(1.5em + 0.5rem + 2px);\r\n}\r\n\r\n.input-group-sm > .form-control,\r\n.input-group-sm > .custom-select,\r\n.input-group-sm > .input-group-prepend > .input-group-text,\r\n.input-group-sm > .input-group-append > .input-group-text,\r\n.input-group-sm > .input-group-prepend > .btn,\r\n.input-group-sm > .input-group-append > .btn {\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.input-group-lg > .custom-select,\r\n.input-group-sm > .custom-select {\r\n  padding-right: 1.75rem;\r\n}\r\n\r\n.custom-control {\r\n  position: relative;\r\n  display: block;\r\n  min-height: 1.5rem;\r\n  padding-left: 1.5rem;\r\n}\r\n\r\n.custom-control-inline {\r\n  display: inline-flex;\r\n  margin-right: 1rem;\r\n}\r\n\r\n.custom-control-input {\r\n  position: absolute;\r\n  z-index: -1;\r\n  opacity: 0;\r\n}\r\n\r\n.custom-control-input:checked ~ .custom-control-label::before {\r\n  color: #fff;\r\n  border-color: var(--primary);\r\n  background-color: var(--primary);\r\n}\r\n\r\n.custom-control-input:focus ~ .custom-control-label::before {\r\n  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.25);\r\n}\r\n\r\n.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {\r\n  border-color: #859bd6;\r\n}\r\n\r\n.custom-control-input:not(:disabled):active ~ .custom-control-label::before {\r\n  color: #fff;\r\n  background-color: #abbae3;\r\n  border-color: #abbae3;\r\n}\r\n\r\n.custom-control-input:disabled ~ .custom-control-label {\r\n  color: #6c757d;\r\n}\r\n\r\n.custom-control-input:disabled ~ .custom-control-label::before {\r\n  background-color: #efedea;\r\n}\r\n\r\n.custom-control-label {\r\n  position: relative;\r\n  margin-bottom: 0;\r\n  vertical-align: top;\r\n}\r\n\r\n.custom-control-label::before {\r\n  position: absolute;\r\n  top: 0.25rem;\r\n  left: -1.5rem;\r\n  display: block;\r\n  width: 1rem;\r\n  height: 1rem;\r\n  pointer-events: none;\r\n  content: \"\";\r\n  background-color: #fff;\r\n  border: #666 solid 1px;\r\n}\r\n\r\n.custom-control-label::after {\r\n  position: absolute;\r\n  top: 0.25rem;\r\n  left: -1.5rem;\r\n  display: block;\r\n  width: 1rem;\r\n  height: 1rem;\r\n  content: \"\";\r\n  background: no-repeat 50% / 50% 50%;\r\n}\r\n\r\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {\r\n  border-color: var(--primary);\r\n  background-color: var(--primary);\r\n}\r\n\r\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {\r\n  background-color: rgba(55, 84, 165, 0.5);\r\n}\r\n\r\n.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {\r\n  background-color: rgba(55, 84, 165, 0.5);\r\n}\r\n\r\n.custom-radio .custom-control-label::before {\r\n  border-radius: 50%;\r\n}\r\n\r\n.custom-radio .custom-control-input:checked ~ .custom-control-label::after {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {\r\n  background-color: rgba(55, 84, 165, 0.5);\r\n}\r\n\r\n.custom-switch {\r\n  padding-left: 2.25rem;\r\n}\r\n\r\n.custom-switch .custom-control-label::before {\r\n  left: -2.25rem;\r\n  width: 1.75rem;\r\n  pointer-events: all;\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.custom-switch .custom-control-label::after {\r\n  top: calc(0.25rem + 2px);\r\n  left: calc(-2.25rem + 2px);\r\n  width: calc(1rem - 4px);\r\n  height: calc(1rem - 4px);\r\n  background-color: #666;\r\n  border-radius: 0.5rem;\r\n  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .custom-switch .custom-control-label::after {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.custom-switch .custom-control-input:checked ~ .custom-control-label::after {\r\n  background-color: #fff;\r\n  transform: translateX(0.75rem);\r\n}\r\n\r\n.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {\r\n  background-color: rgba(55, 84, 165, 0.5);\r\n}\r\n\r\n.custom-select {\r\n  display: inline-block;\r\n  width: 100%;\r\n  height: calc(1.5em + 0.75rem + 2px);\r\n  padding: 0.375rem 1.75rem 0.375rem 0.75rem;\r\n  font-size: 1rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #4d4d4d;\r\n  vertical-align: middle;\r\n  background: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\") no-repeat right 0.75rem center/8px 10px;\r\n  background-color: #fff;\r\n  border: 1px solid #ccc;\r\n  border-radius: 0;\r\n  -webkit-appearance: none;\r\n     -moz-appearance: none;\r\n          appearance: none;\r\n}\r\n\r\n.custom-select:focus {\r\n  border-color: #859bd6;\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.25);\r\n}\r\n\r\n.custom-select:focus::-ms-value {\r\n  color: #4d4d4d;\r\n  background-color: #fff;\r\n}\r\n\r\n.custom-select[multiple],\r\n.custom-select[size]:not([size=\"1\"]) {\r\n  height: auto;\r\n  padding-right: 0.75rem;\r\n  background-image: none;\r\n}\r\n\r\n.custom-select:disabled {\r\n  color: #6c757d;\r\n  background-color: #efedea;\r\n}\r\n\r\n.custom-select::-ms-expand {\r\n  display: none;\r\n}\r\n\r\n.custom-select-sm {\r\n  height: calc(1.5em + 0.5rem + 2px);\r\n  padding-top: 0.25rem;\r\n  padding-bottom: 0.25rem;\r\n  padding-left: 0.5rem;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.custom-select-lg {\r\n  height: calc(1.5em + 1rem + 2px);\r\n  padding-top: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n  padding-left: 1rem;\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.custom-file {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 100%;\r\n  height: calc(1.5em + 0.75rem + 2px);\r\n  margin-bottom: 0;\r\n}\r\n\r\n.custom-file-input {\r\n  position: relative;\r\n  z-index: 2;\r\n  width: 100%;\r\n  height: calc(1.5em + 0.75rem + 2px);\r\n  margin: 0;\r\n  opacity: 0;\r\n}\r\n\r\n.custom-file-input:focus ~ .custom-file-label {\r\n  border-color: #859bd6;\r\n  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.25);\r\n}\r\n\r\n.custom-file-input:disabled ~ .custom-file-label {\r\n  background-color: #efedea;\r\n}\r\n\r\n.custom-file-input:lang(en) ~ .custom-file-label::after {\r\n  content: \"Browse\";\r\n}\r\n\r\n.custom-file-input ~ .custom-file-label[data-browse]::after {\r\n  content: attr(data-browse);\r\n}\r\n\r\n.custom-file-label {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  z-index: 1;\r\n  height: calc(1.5em + 0.75rem + 2px);\r\n  padding: 0.375rem 0.75rem;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  color: #4d4d4d;\r\n  background-color: #fff;\r\n  border: 1px solid #ccc;\r\n}\r\n\r\n.custom-file-label::after {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 3;\r\n  display: block;\r\n  height: calc(1.5em + 0.75rem);\r\n  padding: 0.375rem 0.75rem;\r\n  line-height: 1.5;\r\n  color: #4d4d4d;\r\n  content: \"Browse\";\r\n  background-color: #efedea;\r\n  border-left: inherit;\r\n}\r\n\r\n.custom-range {\r\n  width: 100%;\r\n  height: calc(1rem + 0.4rem);\r\n  padding: 0;\r\n  background-color: transparent;\r\n  -webkit-appearance: none;\r\n     -moz-appearance: none;\r\n          appearance: none;\r\n}\r\n\r\n.custom-range:focus {\r\n  outline: none;\r\n}\r\n\r\n.custom-range:focus::-webkit-slider-thumb {\r\n  box-shadow: 0 0 0 1px #f9f6f2, 0 0 0 0.2rem rgba(55, 84, 165, 0.25);\r\n}\r\n\r\n.custom-range:focus::-moz-range-thumb {\r\n  box-shadow: 0 0 0 1px #f9f6f2, 0 0 0 0.2rem rgba(55, 84, 165, 0.25);\r\n}\r\n\r\n.custom-range:focus::-ms-thumb {\r\n  box-shadow: 0 0 0 1px #f9f6f2, 0 0 0 0.2rem rgba(55, 84, 165, 0.25);\r\n}\r\n\r\n.custom-range::-moz-focus-outer {\r\n  border: 0;\r\n}\r\n\r\n.custom-range::-webkit-slider-thumb {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  margin-top: -0.25rem;\r\n  background-color: var(--primary);\r\n  border: 0;\r\n  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n  -webkit-appearance: none;\r\n          appearance: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .custom-range::-webkit-slider-thumb {\r\n    -webkit-transition: none;\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.custom-range::-webkit-slider-thumb:active {\r\n  background-color: #abbae3;\r\n}\r\n\r\n.custom-range::-webkit-slider-runnable-track {\r\n  width: 100%;\r\n  height: 0.5rem;\r\n  color: transparent;\r\n  cursor: pointer;\r\n  background-color: #cccbca;\r\n  border-color: transparent;\r\n}\r\n\r\n.custom-range::-moz-range-thumb {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  background-color: var(--primary);\r\n  border: 0;\r\n  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n  -moz-appearance: none;\r\n       appearance: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .custom-range::-moz-range-thumb {\r\n    -moz-transition: none;\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.custom-range::-moz-range-thumb:active {\r\n  background-color: #abbae3;\r\n}\r\n\r\n.custom-range::-moz-range-track {\r\n  width: 100%;\r\n  height: 0.5rem;\r\n  color: transparent;\r\n  cursor: pointer;\r\n  background-color: #cccbca;\r\n  border-color: transparent;\r\n}\r\n\r\n.custom-range::-ms-thumb {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  margin-top: 0;\r\n  margin-right: 0.2rem;\r\n  margin-left: 0.2rem;\r\n  background-color: var(--primary);\r\n  border: 0;\r\n  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n  appearance: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .custom-range::-ms-thumb {\r\n    -ms-transition: none;\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.custom-range::-ms-thumb:active {\r\n  background-color: #abbae3;\r\n}\r\n\r\n.custom-range::-ms-track {\r\n  width: 100%;\r\n  height: 0.5rem;\r\n  color: transparent;\r\n  cursor: pointer;\r\n  background-color: transparent;\r\n  border-color: transparent;\r\n  border-width: 0.5rem;\r\n}\r\n\r\n.custom-range::-ms-fill-lower {\r\n  background-color: #cccbca;\r\n}\r\n\r\n.custom-range::-ms-fill-upper {\r\n  margin-right: 15px;\r\n  background-color: #cccbca;\r\n}\r\n\r\n.custom-range:disabled::-webkit-slider-thumb {\r\n  background-color: #666;\r\n}\r\n\r\n.custom-range:disabled::-webkit-slider-runnable-track {\r\n  cursor: default;\r\n}\r\n\r\n.custom-range:disabled::-moz-range-thumb {\r\n  background-color: #666;\r\n}\r\n\r\n.custom-range:disabled::-moz-range-track {\r\n  cursor: default;\r\n}\r\n\r\n.custom-range:disabled::-ms-thumb {\r\n  background-color: #666;\r\n}\r\n\r\n.custom-control-label::before,\r\n.custom-file-label,\r\n.custom-select {\r\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .custom-control-label::before,\r\n  .custom-file-label,\r\n  .custom-select {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.nav {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  list-style: none;\r\n}\r\n\r\n.nav-link {\r\n  display: block;\r\n  padding: 0.5rem 1rem;\r\n}\r\n\r\n.nav-link:hover,\r\n.nav-link:focus {\r\n  text-decoration: none;\r\n}\r\n\r\n.nav-link.disabled {\r\n  color: #6c757d;\r\n  pointer-events: none;\r\n  cursor: default;\r\n}\r\n\r\n.nav-tabs {\r\n  border-bottom: 1px solid #cccbca;\r\n}\r\n\r\n.nav-tabs .nav-item {\r\n  margin-bottom: -1px;\r\n}\r\n\r\n.nav-tabs .nav-link {\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.nav-tabs .nav-link:hover,\r\n.nav-tabs .nav-link:focus {\r\n  border-color: #efedea #efedea #cccbca;\r\n}\r\n\r\n.nav-tabs .nav-link.disabled {\r\n  color: #6c757d;\r\n  background-color: transparent;\r\n  border-color: transparent;\r\n}\r\n\r\n.nav-tabs .nav-link.active,\r\n.nav-tabs .nav-item.show .nav-link {\r\n  color: #4d4d4d;\r\n  background-color: #f9f6f2;\r\n  border-color: #cccbca #cccbca #f9f6f2;\r\n}\r\n\r\n.nav-tabs .dropdown-menu {\r\n  margin-top: -1px;\r\n}\r\n\r\n.nav-pills .nav-link.active,\r\n.nav-pills .show > .nav-link {\r\n  color: #fff;\r\n  background-color: var(--primary);\r\n}\r\n\r\n.nav-fill .nav-item {\r\n  flex: 1 1 auto;\r\n  text-align: center;\r\n}\r\n\r\n.nav-justified .nav-item {\r\n  flex-basis: 0;\r\n  flex-grow: 1;\r\n  text-align: center;\r\n}\r\n\r\n.tab-content > .tab-pane {\r\n  display: none;\r\n}\r\n\r\n.tab-content > .active {\r\n  display: block;\r\n}\r\n\r\n.navbar {\r\n  position: relative;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0.5rem 1rem;\r\n}\r\n\r\n.navbar > .container,\r\n.navbar > .container-fluid {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.navbar-brand {\r\n  display: inline-block;\r\n  padding-top: 0.3125rem;\r\n  padding-bottom: 0.3125rem;\r\n  margin-right: 1rem;\r\n  font-size: 1.25rem;\r\n  line-height: inherit;\r\n  white-space: nowrap;\r\n}\r\n\r\n.navbar-brand:hover,\r\n.navbar-brand:focus {\r\n  text-decoration: none;\r\n}\r\n\r\n.navbar-nav {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n  list-style: none;\r\n}\r\n\r\n.navbar-nav .nav-link {\r\n  padding-right: 0;\r\n  padding-left: 0;\r\n}\r\n\r\n.navbar-nav .dropdown-menu {\r\n  position: static;\r\n  float: none;\r\n}\r\n\r\n.navbar-text {\r\n  display: inline-block;\r\n  padding-top: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n}\r\n\r\n.navbar-collapse {\r\n  flex-basis: 100%;\r\n  flex-grow: 1;\r\n  align-items: center;\r\n}\r\n\r\n.navbar-toggler {\r\n  padding: 0.25rem 0.75rem;\r\n  font-size: 1.25rem;\r\n  line-height: 1;\r\n  background-color: transparent;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.navbar-toggler:hover,\r\n.navbar-toggler:focus {\r\n  text-decoration: none;\r\n}\r\n\r\n.navbar-toggler-icon {\r\n  display: inline-block;\r\n  width: 1.5em;\r\n  height: 1.5em;\r\n  vertical-align: middle;\r\n  content: \"\";\r\n  background: no-repeat center center;\r\n  background-size: 100% 100%;\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .navbar-expand-sm > .container,\r\n  .navbar-expand-sm > .container-fluid {\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .navbar-expand-sm {\r\n    flex-flow: row nowrap;\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .navbar-expand-sm .navbar-nav {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\r\n    position: absolute;\r\n  }\r\n\r\n  .navbar-expand-sm .navbar-nav .nav-link {\r\n    padding-right: 0.5rem;\r\n    padding-left: 0.5rem;\r\n  }\r\n\r\n  .navbar-expand-sm > .container,\r\n  .navbar-expand-sm > .container-fluid {\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .navbar-expand-sm .navbar-collapse {\r\n    display: flex !important;\r\n    flex-basis: auto;\r\n  }\r\n\r\n  .navbar-expand-sm .navbar-toggler {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n  .navbar-expand-md > .container,\r\n  .navbar-expand-md > .container-fluid {\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .navbar-expand-md {\r\n    flex-flow: row nowrap;\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .navbar-expand-md .navbar-nav {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .navbar-expand-md .navbar-nav .dropdown-menu {\r\n    position: absolute;\r\n  }\r\n\r\n  .navbar-expand-md .navbar-nav .nav-link {\r\n    padding-right: 0.5rem;\r\n    padding-left: 0.5rem;\r\n  }\r\n\r\n  .navbar-expand-md > .container,\r\n  .navbar-expand-md > .container-fluid {\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .navbar-expand-md .navbar-collapse {\r\n    display: flex !important;\r\n    flex-basis: auto;\r\n  }\r\n\r\n  .navbar-expand-md .navbar-toggler {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 991.98px) {\r\n  .navbar-expand-lg > .container,\r\n  .navbar-expand-lg > .container-fluid {\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .navbar-expand-lg {\r\n    flex-flow: row nowrap;\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .navbar-expand-lg .navbar-nav {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\r\n    position: absolute;\r\n  }\r\n\r\n  .navbar-expand-lg .navbar-nav .nav-link {\r\n    padding-right: 0.5rem;\r\n    padding-left: 0.5rem;\r\n  }\r\n\r\n  .navbar-expand-lg > .container,\r\n  .navbar-expand-lg > .container-fluid {\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .navbar-expand-lg .navbar-collapse {\r\n    display: flex !important;\r\n    flex-basis: auto;\r\n  }\r\n\r\n  .navbar-expand-lg .navbar-toggler {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 1199.98px) {\r\n  .navbar-expand-xl > .container,\r\n  .navbar-expand-xl > .container-fluid {\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .navbar-expand-xl {\r\n    flex-flow: row nowrap;\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .navbar-expand-xl .navbar-nav {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\r\n    position: absolute;\r\n  }\r\n\r\n  .navbar-expand-xl .navbar-nav .nav-link {\r\n    padding-right: 0.5rem;\r\n    padding-left: 0.5rem;\r\n  }\r\n\r\n  .navbar-expand-xl > .container,\r\n  .navbar-expand-xl > .container-fluid {\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .navbar-expand-xl .navbar-collapse {\r\n    display: flex !important;\r\n    flex-basis: auto;\r\n  }\r\n\r\n  .navbar-expand-xl .navbar-toggler {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.navbar-expand {\r\n  flex-flow: row nowrap;\r\n  justify-content: flex-start;\r\n}\r\n\r\n.navbar-expand > .container,\r\n.navbar-expand > .container-fluid {\r\n  padding-right: 0;\r\n  padding-left: 0;\r\n}\r\n\r\n.navbar-expand .navbar-nav {\r\n  flex-direction: row;\r\n}\r\n\r\n.navbar-expand .navbar-nav .dropdown-menu {\r\n  position: absolute;\r\n}\r\n\r\n.navbar-expand .navbar-nav .nav-link {\r\n  padding-right: 0.5rem;\r\n  padding-left: 0.5rem;\r\n}\r\n\r\n.navbar-expand > .container,\r\n.navbar-expand > .container-fluid {\r\n  flex-wrap: nowrap;\r\n}\r\n\r\n.navbar-expand .navbar-collapse {\r\n  display: flex !important;\r\n  flex-basis: auto;\r\n}\r\n\r\n.navbar-expand .navbar-toggler {\r\n  display: none;\r\n}\r\n\r\n.navbar-light .navbar-brand {\r\n  color: rgba(0, 0, 0, 0.9);\r\n}\r\n\r\n.navbar-light .navbar-brand:hover,\r\n.navbar-light .navbar-brand:focus {\r\n  color: rgba(0, 0, 0, 0.9);\r\n}\r\n\r\n.navbar-light .navbar-nav .nav-link {\r\n  color: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.navbar-light .navbar-nav .nav-link:hover,\r\n.navbar-light .navbar-nav .nav-link:focus {\r\n  color: rgba(0, 0, 0, 0.7);\r\n}\r\n\r\n.navbar-light .navbar-nav .nav-link.disabled {\r\n  color: rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.navbar-light .navbar-nav .show > .nav-link,\r\n.navbar-light .navbar-nav .active > .nav-link,\r\n.navbar-light .navbar-nav .nav-link.show,\r\n.navbar-light .navbar-nav .nav-link.active {\r\n  color: rgba(0, 0, 0, 0.9);\r\n}\r\n\r\n.navbar-light .navbar-toggler {\r\n  color: rgba(0, 0, 0, 0.5);\r\n  border-color: rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.navbar-light .navbar-toggler-icon {\r\n  background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.navbar-light .navbar-text {\r\n  color: rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.navbar-light .navbar-text a {\r\n  color: rgba(0, 0, 0, 0.9);\r\n}\r\n\r\n.navbar-light .navbar-text a:hover,\r\n.navbar-light .navbar-text a:focus {\r\n  color: rgba(0, 0, 0, 0.9);\r\n}\r\n\r\n.navbar-dark .navbar-brand {\r\n  color: #fff;\r\n}\r\n\r\n.navbar-dark .navbar-brand:hover,\r\n.navbar-dark .navbar-brand:focus {\r\n  color: #fff;\r\n}\r\n\r\n.navbar-dark .navbar-nav .nav-link {\r\n  color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.navbar-dark .navbar-nav .nav-link:hover,\r\n.navbar-dark .navbar-nav .nav-link:focus {\r\n  color: rgba(255, 255, 255, 0.75);\r\n}\r\n\r\n.navbar-dark .navbar-nav .nav-link.disabled {\r\n  color: rgba(255, 255, 255, 0.25);\r\n}\r\n\r\n.navbar-dark .navbar-nav .show > .nav-link,\r\n.navbar-dark .navbar-nav .active > .nav-link,\r\n.navbar-dark .navbar-nav .nav-link.show,\r\n.navbar-dark .navbar-nav .nav-link.active {\r\n  color: #fff;\r\n}\r\n\r\n.navbar-dark .navbar-toggler {\r\n  color: rgba(255, 255, 255, 0.5);\r\n  border-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.navbar-dark .navbar-toggler-icon {\r\n  background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='rgba(255, 255, 255, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.navbar-dark .navbar-text {\r\n  color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.navbar-dark .navbar-text a {\r\n  color: #fff;\r\n}\r\n\r\n.navbar-dark .navbar-text a:hover,\r\n.navbar-dark .navbar-text a:focus {\r\n  color: #fff;\r\n}\r\n\r\n.card {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n  word-wrap: break-word;\r\n  background-color: #fff;\r\n  background-clip: border-box;\r\n  border: 1px solid rgba(0, 0, 0, 0.125);\r\n}\r\n\r\n.card > hr {\r\n  margin-right: 0;\r\n  margin-left: 0;\r\n}\r\n\r\n.card-body {\r\n  flex: 1 1 auto;\r\n  padding: 1.25rem;\r\n}\r\n\r\n.card-title {\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.card-subtitle {\r\n  margin-top: -0.375rem;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.card-text:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.card-link:hover {\r\n  text-decoration: none;\r\n}\r\n\r\n.card-link + .card-link {\r\n  margin-left: 1.25rem;\r\n}\r\n\r\n.card-header {\r\n  padding: 0.75rem 1.25rem;\r\n  margin-bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.03);\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125);\r\n}\r\n\r\n.card-header + .list-group .list-group-item:first-child {\r\n  border-top: 0;\r\n}\r\n\r\n.card-footer {\r\n  padding: 0.75rem 1.25rem;\r\n  background-color: rgba(0, 0, 0, 0.03);\r\n  border-top: 1px solid rgba(0, 0, 0, 0.125);\r\n}\r\n\r\n.card-header-tabs {\r\n  margin-right: -0.625rem;\r\n  margin-bottom: -0.75rem;\r\n  margin-left: -0.625rem;\r\n  border-bottom: 0;\r\n}\r\n\r\n.card-header-pills {\r\n  margin-right: -0.625rem;\r\n  margin-left: -0.625rem;\r\n}\r\n\r\n.card-img-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  padding: 1.25rem;\r\n}\r\n\r\n.card-img {\r\n  width: 100%;\r\n}\r\n\r\n.card-img-top {\r\n  width: 100%;\r\n}\r\n\r\n.card-img-bottom {\r\n  width: 100%;\r\n}\r\n\r\n.card-deck {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.card-deck .card {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .card-deck {\r\n    flex-flow: row wrap;\r\n    margin-right: -15px;\r\n    margin-left: -15px;\r\n  }\r\n\r\n  .card-deck .card {\r\n    display: flex;\r\n    flex: 1 0;\r\n    flex-direction: column;\r\n    margin-right: 15px;\r\n    margin-bottom: 0;\r\n    margin-left: 15px;\r\n  }\r\n}\r\n\r\n.card-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.card-group > .card {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .card-group {\r\n    flex-flow: row wrap;\r\n  }\r\n\r\n  .card-group > .card {\r\n    flex: 1 0;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .card-group > .card + .card {\r\n    margin-left: 0;\r\n    border-left: 0;\r\n  }\r\n}\r\n\r\n.card-columns .card {\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .card-columns {\r\n    column-count: 3;\r\n    grid-column-gap: 1.25rem;\r\n    column-gap: 1.25rem;\r\n    orphans: 1;\r\n    widows: 1;\r\n  }\r\n\r\n  .card-columns .card {\r\n    display: inline-block;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.accordion > .card {\r\n  overflow: hidden;\r\n}\r\n\r\n.accordion > .card:not(:first-of-type):not(:last-of-type) {\r\n  border-bottom: 0;\r\n}\r\n\r\n.accordion > .card:first-of-type {\r\n  border-bottom: 0;\r\n}\r\n\r\n.accordion > .card .card-header {\r\n  margin-bottom: -1px;\r\n}\r\n\r\n.breadcrumb {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding: 0 0;\r\n  margin-bottom: 1rem;\r\n  list-style: none;\r\n  background-color: transparent;\r\n}\r\n\r\n.breadcrumb-item + .breadcrumb-item {\r\n  padding-left: 0.5rem;\r\n}\r\n\r\n.breadcrumb-item + .breadcrumb-item::before {\r\n  display: inline-block;\r\n  padding-right: 0.5rem;\r\n  color: #6c757d;\r\n  content: \">\";\r\n}\r\n\r\n.breadcrumb-item + .breadcrumb-item:hover::before {\r\n  text-decoration: underline;\r\n}\r\n\r\n.breadcrumb-item + .breadcrumb-item:hover::before {\r\n  text-decoration: none;\r\n}\r\n\r\n.breadcrumb-item.active {\r\n  color: #6c757d;\r\n}\r\n\r\n.pagination {\r\n  display: flex;\r\n  padding-left: 0;\r\n  list-style: none;\r\n}\r\n\r\n.page-link {\r\n  position: relative;\r\n  display: block;\r\n  padding: 0.5rem 0.75rem;\r\n  margin-left: -1px;\r\n  line-height: 1.25;\r\n  color: #337ab7;\r\n  background-color: #fff;\r\n  border: 1px solid #cccbca;\r\n}\r\n\r\n.page-link:hover {\r\n  z-index: 2;\r\n  color: #22527b;\r\n  text-decoration: none;\r\n  background-color: #efedea;\r\n  border-color: #cccbca;\r\n}\r\n\r\n.page-link:focus {\r\n  z-index: 2;\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.25);\r\n}\r\n\r\n.page-item:first-child .page-link {\r\n  margin-left: 0;\r\n}\r\n\r\n.page-item.active .page-link {\r\n  z-index: 1;\r\n  color: #fff;\r\n  background-color: var(--primary);\r\n  border-color: var(--primary);\r\n}\r\n\r\n.page-item.disabled .page-link {\r\n  color: #6c757d;\r\n  pointer-events: none;\r\n  cursor: auto;\r\n  background-color: #fff;\r\n  border-color: #cccbca;\r\n}\r\n\r\n.pagination-lg .page-link {\r\n  padding: 0.75rem 1.5rem;\r\n  font-size: 1.25rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.pagination-sm .page-link {\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: 0.875rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.badge {\r\n  display: inline-block;\r\n  padding: 0.25em 0.4em;\r\n  font-size: 75%;\r\n  font-weight: 600;\r\n  line-height: 1;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  vertical-align: baseline;\r\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .badge {\r\n    transition: none;\r\n  }\r\n}\r\n\r\na.badge:hover,\r\na.badge:focus {\r\n  text-decoration: none;\r\n}\r\n\r\n.badge:empty {\r\n  display: none;\r\n}\r\n\r\n.btn .badge {\r\n  position: relative;\r\n  top: -1px;\r\n}\r\n\r\n.badge-pill {\r\n  padding-right: 0.6em;\r\n  padding-left: 0.6em;\r\n}\r\n\r\n.badge-primary {\r\n  color: #fff;\r\n  background-color: var(--primary);\r\n}\r\n\r\na.badge-primary:hover,\r\na.badge-primary:focus {\r\n  color: #fff;\r\n  background-color: #2a417f;\r\n}\r\n\r\na.badge-primary:focus,\r\na.badge-primary.focus {\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.2rem rgba(55, 84, 165, 0.5);\r\n}\r\n\r\n.badge-secondary {\r\n  color: #212529;\r\n  background-color: var(--secondary);\r\n}\r\n\r\na.badge-secondary:hover,\r\na.badge-secondary:focus {\r\n  color: #212529;\r\n  background-color: #8da5fb;\r\n}\r\n\r\na.badge-secondary:focus,\r\na.badge-secondary.focus {\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.2rem rgba(190, 204, 253, 0.5);\r\n}\r\n\r\n.badge-success {\r\n  color: #fff;\r\n  background-color: var(--success);\r\n}\r\n\r\na.badge-success:hover,\r\na.badge-success:focus {\r\n  color: #fff;\r\n  background-color: #14866f;\r\n}\r\n\r\na.badge-success:focus,\r\na.badge-success.focus {\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.2rem rgba(26, 179, 148, 0.5);\r\n}\r\n\r\n.badge-info {\r\n  color: #fff;\r\n  background-color: #5d80f9;\r\n}\r\n\r\na.badge-info:hover,\r\na.badge-info:focus {\r\n  color: #fff;\r\n  background-color: #2c59f7;\r\n}\r\n\r\na.badge-info:focus,\r\na.badge-info.focus {\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.2rem rgba(93, 128, 249, 0.5);\r\n}\r\n\r\n.badge-warning {\r\n  color: #212529;\r\n  background-color: #f3c363;\r\n}\r\n\r\na.badge-warning:hover,\r\na.badge-warning:focus {\r\n  color: #212529;\r\n  background-color: #efb134;\r\n}\r\n\r\na.badge-warning:focus,\r\na.badge-warning.focus {\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.2rem rgba(243, 195, 99, 0.5);\r\n}\r\n\r\n.badge-danger {\r\n  color: #fff;\r\n  background-color: #eb3349;\r\n}\r\n\r\na.badge-danger:hover,\r\na.badge-danger:focus {\r\n  color: #fff;\r\n  background-color: #d6152c;\r\n}\r\n\r\na.badge-danger:focus,\r\na.badge-danger.focus {\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.2rem rgba(235, 51, 73, 0.5);\r\n}\r\n\r\n.badge-light {\r\n  color: #212529;\r\n  background-color: #cccbca;\r\n}\r\n\r\na.badge-light:hover,\r\na.badge-light:focus {\r\n  color: #212529;\r\n  background-color: #b3b2b0;\r\n}\r\n\r\na.badge-light:focus,\r\na.badge-light.focus {\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.2rem rgba(204, 203, 202, 0.5);\r\n}\r\n\r\n.badge-dark {\r\n  color: #fff;\r\n  background-color: #343a40;\r\n}\r\n\r\na.badge-dark:hover,\r\na.badge-dark:focus {\r\n  color: #fff;\r\n  background-color: #1d2124;\r\n}\r\n\r\na.badge-dark:focus,\r\na.badge-dark.focus {\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);\r\n}\r\n\r\n.badge-inverse {\r\n  color: #fff;\r\n  background-color: #4d4d4d;\r\n}\r\n\r\na.badge-inverse:hover,\r\na.badge-inverse:focus {\r\n  color: #fff;\r\n  background-color: #343434;\r\n}\r\n\r\na.badge-inverse:focus,\r\na.badge-inverse.focus {\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.2rem rgba(77, 77, 77, 0.5);\r\n}\r\n\r\n.badge-gray {\r\n  color: #212529;\r\n  background-color: #ccc;\r\n}\r\n\r\na.badge-gray:hover,\r\na.badge-gray:focus {\r\n  color: #212529;\r\n  background-color: #b3b3b3;\r\n}\r\n\r\na.badge-gray:focus,\r\na.badge-gray.focus {\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.2rem rgba(204, 204, 204, 0.5);\r\n}\r\n\r\n.badge-default {\r\n  color: #212529;\r\n  background-color: #f8f8f8;\r\n}\r\n\r\na.badge-default:hover,\r\na.badge-default:focus {\r\n  color: #212529;\r\n  background-color: #dfdfdf;\r\n}\r\n\r\na.badge-default:focus,\r\na.badge-default.focus {\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.2rem rgba(248, 248, 248, 0.5);\r\n}\r\n\r\n.jumbotron {\r\n  padding: 2rem 1rem;\r\n  margin-bottom: 2rem;\r\n  background-color: #efedea;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .jumbotron {\r\n    padding: 4rem 2rem;\r\n  }\r\n}\r\n\r\n.jumbotron-fluid {\r\n  padding-right: 0;\r\n  padding-left: 0;\r\n}\r\n\r\n.alert {\r\n  position: relative;\r\n  padding: 0.75rem 1.25rem;\r\n  margin-bottom: 1rem;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.alert-heading {\r\n  color: inherit;\r\n}\r\n\r\n.alert-link {\r\n  font-weight: 700;\r\n}\r\n\r\n.alert-dismissible {\r\n  padding-right: 4rem;\r\n}\r\n\r\n.alert-dismissible .close {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  padding: 0.75rem 1.25rem;\r\n  color: inherit;\r\n}\r\n\r\n.alert-primary {\r\n  color: #1d2c56;\r\n  background-color: #d7dded;\r\n  border-color: #c7cfe6;\r\n}\r\n\r\n.alert-primary hr {\r\n  border-top-color: #b5c0de;\r\n}\r\n\r\n.alert-primary .alert-link {\r\n  color: #101830;\r\n}\r\n\r\n.alert-secondary {\r\n  color: #636a84;\r\n  background-color: #f2f5ff;\r\n  border-color: #edf1fe;\r\n}\r\n\r\n.alert-secondary hr {\r\n  border-top-color: #d5defd;\r\n}\r\n\r\n.alert-secondary .alert-link {\r\n  color: #4d5367;\r\n}\r\n\r\n.alert-success {\r\n  color: #0e5d4d;\r\n  background-color: #d1f0ea;\r\n  border-color: #bfeae1;\r\n}\r\n\r\n.alert-success hr {\r\n  border-top-color: #ace4d8;\r\n}\r\n\r\n.alert-success .alert-link {\r\n  color: #073128;\r\n}\r\n\r\n.alert-info {\r\n  color: #304381;\r\n  background-color: #dfe6fe;\r\n  border-color: #d2dbfd;\r\n}\r\n\r\n.alert-info hr {\r\n  border-top-color: #bac7fc;\r\n}\r\n\r\n.alert-info .alert-link {\r\n  color: #22305c;\r\n}\r\n\r\n.alert-warning {\r\n  color: #7e6533;\r\n  background-color: #fdf3e0;\r\n  border-color: #fceed3;\r\n}\r\n\r\n.alert-warning hr {\r\n  border-top-color: #fae5bb;\r\n}\r\n\r\n.alert-warning .alert-link {\r\n  color: #5a4824;\r\n}\r\n\r\n.alert-danger {\r\n  color: #7a1b26;\r\n  background-color: #fbd6db;\r\n  border-color: #f9c6cc;\r\n}\r\n\r\n.alert-danger hr {\r\n  border-top-color: #f7afb7;\r\n}\r\n\r\n.alert-danger .alert-link {\r\n  color: #501219;\r\n}\r\n\r\n.alert-light {\r\n  color: #6a6a69;\r\n  background-color: #f5f5f4;\r\n  border-color: #f1f0f0;\r\n}\r\n\r\n.alert-light hr {\r\n  border-top-color: #e5e3e3;\r\n}\r\n\r\n.alert-light .alert-link {\r\n  color: #505050;\r\n}\r\n\r\n.alert-dark {\r\n  color: #1b1e21;\r\n  background-color: #d6d8d9;\r\n  border-color: #c6c8ca;\r\n}\r\n\r\n.alert-dark hr {\r\n  border-top-color: #b9bbbe;\r\n}\r\n\r\n.alert-dark .alert-link {\r\n  color: #040505;\r\n}\r\n\r\n.alert-inverse {\r\n  color: #282828;\r\n  background-color: #dbdbdb;\r\n  border-color: #cdcdcd;\r\n}\r\n\r\n.alert-inverse hr {\r\n  border-top-color: silver;\r\n}\r\n\r\n.alert-inverse .alert-link {\r\n  color: #0f0f0f;\r\n}\r\n\r\n.alert-gray {\r\n  color: #6a6a6a;\r\n  background-color: whitesmoke;\r\n  border-color: #f1f1f1;\r\n}\r\n\r\n.alert-gray hr {\r\n  border-top-color: #e4e4e4;\r\n}\r\n\r\n.alert-gray .alert-link {\r\n  color: #515151;\r\n}\r\n\r\n.alert-default {\r\n  color: #818181;\r\n  background-color: #fefefe;\r\n  border-color: #fdfdfd;\r\n}\r\n\r\n.alert-default hr {\r\n  border-top-color: #f0f0f0;\r\n}\r\n\r\n.alert-default .alert-link {\r\n  color: #686868;\r\n}\r\n\r\n@keyframes progress-bar-stripes {\r\n  from {\r\n    background-position: 1rem 0;\r\n  }\r\n\r\n  to {\r\n    background-position: 0 0;\r\n  }\r\n}\r\n\r\n.progress {\r\n  display: flex;\r\n  height: 1rem;\r\n  overflow: hidden;\r\n  font-size: 0.75rem;\r\n  background-color: #efedea;\r\n}\r\n\r\n.progress-bar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  color: #fff;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  background-color: var(--primary);\r\n  transition: width 0.6s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .progress-bar {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.progress-bar-striped {\r\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\r\n  background-size: 1rem 1rem;\r\n}\r\n\r\n.progress-bar-animated {\r\n  animation: progress-bar-stripes 1s linear infinite;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .progress-bar-animated {\r\n    animation: none;\r\n  }\r\n}\r\n\r\n.media {\r\n  display: flex;\r\n  align-items: flex-start;\r\n}\r\n\r\n.media-body {\r\n  flex: 1 1;\r\n}\r\n\r\n.list-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-left: 0;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.list-group-item-action {\r\n  width: 100%;\r\n  color: #4d4d4d;\r\n  text-align: inherit;\r\n}\r\n\r\n.list-group-item-action:hover,\r\n.list-group-item-action:focus {\r\n  z-index: 1;\r\n  color: #4d4d4d;\r\n  text-decoration: none;\r\n  background-color: #f9f6f2;\r\n}\r\n\r\n.list-group-item-action:active {\r\n  color: #212529;\r\n  background-color: #efedea;\r\n}\r\n\r\n.list-group-item {\r\n  position: relative;\r\n  display: block;\r\n  padding: 0.75rem 1.25rem;\r\n  margin-bottom: -1px;\r\n  background-color: #fff;\r\n  border: 1px solid rgba(0, 0, 0, 0.125);\r\n}\r\n\r\n.list-group-item:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.list-group-item.disabled,\r\n.list-group-item:disabled {\r\n  color: #6c757d;\r\n  pointer-events: none;\r\n  background-color: #fff;\r\n}\r\n\r\n.list-group-item.active {\r\n  z-index: 2;\r\n  color: #fff;\r\n  background-color: var(--primary);\r\n  border-color: var(--primary);\r\n}\r\n\r\n.list-group-horizontal {\r\n  flex-direction: row;\r\n}\r\n\r\n.list-group-horizontal .list-group-item {\r\n  margin-right: -1px;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.list-group-horizontal .list-group-item:last-child {\r\n  margin-right: 0;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .list-group-horizontal-sm {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .list-group-horizontal-sm .list-group-item {\r\n    margin-right: -1px;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .list-group-horizontal-sm .list-group-item:last-child {\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .list-group-horizontal-md {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .list-group-horizontal-md .list-group-item {\r\n    margin-right: -1px;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .list-group-horizontal-md .list-group-item:last-child {\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .list-group-horizontal-lg {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .list-group-horizontal-lg .list-group-item {\r\n    margin-right: -1px;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .list-group-horizontal-lg .list-group-item:last-child {\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .list-group-horizontal-xl {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .list-group-horizontal-xl .list-group-item {\r\n    margin-right: -1px;\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .list-group-horizontal-xl .list-group-item:last-child {\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n.list-group-flush .list-group-item {\r\n  border-right: 0;\r\n  border-left: 0;\r\n}\r\n\r\n.list-group-flush .list-group-item:last-child {\r\n  margin-bottom: -1px;\r\n}\r\n\r\n.list-group-flush:first-child .list-group-item:first-child {\r\n  border-top: 0;\r\n}\r\n\r\n.list-group-flush:last-child .list-group-item:last-child {\r\n  margin-bottom: 0;\r\n  border-bottom: 0;\r\n}\r\n\r\n.list-group-item-primary {\r\n  color: #1d2c56;\r\n  background-color: #c7cfe6;\r\n}\r\n\r\n.list-group-item-primary.list-group-item-action:hover,\r\n.list-group-item-primary.list-group-item-action:focus {\r\n  color: #1d2c56;\r\n  background-color: #b5c0de;\r\n}\r\n\r\n.list-group-item-primary.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #1d2c56;\r\n  border-color: #1d2c56;\r\n}\r\n\r\n.list-group-item-secondary {\r\n  color: #636a84;\r\n  background-color: #edf1fe;\r\n}\r\n\r\n.list-group-item-secondary.list-group-item-action:hover,\r\n.list-group-item-secondary.list-group-item-action:focus {\r\n  color: #636a84;\r\n  background-color: #d5defd;\r\n}\r\n\r\n.list-group-item-secondary.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #636a84;\r\n  border-color: #636a84;\r\n}\r\n\r\n.list-group-item-success {\r\n  color: #0e5d4d;\r\n  background-color: #bfeae1;\r\n}\r\n\r\n.list-group-item-success.list-group-item-action:hover,\r\n.list-group-item-success.list-group-item-action:focus {\r\n  color: #0e5d4d;\r\n  background-color: #ace4d8;\r\n}\r\n\r\n.list-group-item-success.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #0e5d4d;\r\n  border-color: #0e5d4d;\r\n}\r\n\r\n.list-group-item-info {\r\n  color: #304381;\r\n  background-color: #d2dbfd;\r\n}\r\n\r\n.list-group-item-info.list-group-item-action:hover,\r\n.list-group-item-info.list-group-item-action:focus {\r\n  color: #304381;\r\n  background-color: #bac7fc;\r\n}\r\n\r\n.list-group-item-info.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #304381;\r\n  border-color: #304381;\r\n}\r\n\r\n.list-group-item-warning {\r\n  color: #7e6533;\r\n  background-color: #fceed3;\r\n}\r\n\r\n.list-group-item-warning.list-group-item-action:hover,\r\n.list-group-item-warning.list-group-item-action:focus {\r\n  color: #7e6533;\r\n  background-color: #fae5bb;\r\n}\r\n\r\n.list-group-item-warning.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #7e6533;\r\n  border-color: #7e6533;\r\n}\r\n\r\n.list-group-item-danger {\r\n  color: #7a1b26;\r\n  background-color: #f9c6cc;\r\n}\r\n\r\n.list-group-item-danger.list-group-item-action:hover,\r\n.list-group-item-danger.list-group-item-action:focus {\r\n  color: #7a1b26;\r\n  background-color: #f7afb7;\r\n}\r\n\r\n.list-group-item-danger.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #7a1b26;\r\n  border-color: #7a1b26;\r\n}\r\n\r\n.list-group-item-light {\r\n  color: #6a6a69;\r\n  background-color: #f1f0f0;\r\n}\r\n\r\n.list-group-item-light.list-group-item-action:hover,\r\n.list-group-item-light.list-group-item-action:focus {\r\n  color: #6a6a69;\r\n  background-color: #e5e3e3;\r\n}\r\n\r\n.list-group-item-light.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #6a6a69;\r\n  border-color: #6a6a69;\r\n}\r\n\r\n.list-group-item-dark {\r\n  color: #1b1e21;\r\n  background-color: #c6c8ca;\r\n}\r\n\r\n.list-group-item-dark.list-group-item-action:hover,\r\n.list-group-item-dark.list-group-item-action:focus {\r\n  color: #1b1e21;\r\n  background-color: #b9bbbe;\r\n}\r\n\r\n.list-group-item-dark.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #1b1e21;\r\n  border-color: #1b1e21;\r\n}\r\n\r\n.list-group-item-inverse {\r\n  color: #282828;\r\n  background-color: #cdcdcd;\r\n}\r\n\r\n.list-group-item-inverse.list-group-item-action:hover,\r\n.list-group-item-inverse.list-group-item-action:focus {\r\n  color: #282828;\r\n  background-color: silver;\r\n}\r\n\r\n.list-group-item-inverse.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #282828;\r\n  border-color: #282828;\r\n}\r\n\r\n.list-group-item-gray {\r\n  color: #6a6a6a;\r\n  background-color: #f1f1f1;\r\n}\r\n\r\n.list-group-item-gray.list-group-item-action:hover,\r\n.list-group-item-gray.list-group-item-action:focus {\r\n  color: #6a6a6a;\r\n  background-color: #e4e4e4;\r\n}\r\n\r\n.list-group-item-gray.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #6a6a6a;\r\n  border-color: #6a6a6a;\r\n}\r\n\r\n.list-group-item-default {\r\n  color: #818181;\r\n  background-color: #fdfdfd;\r\n}\r\n\r\n.list-group-item-default.list-group-item-action:hover,\r\n.list-group-item-default.list-group-item-action:focus {\r\n  color: #818181;\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.list-group-item-default.list-group-item-action.active {\r\n  color: #fff;\r\n  background-color: #818181;\r\n  border-color: #818181;\r\n}\r\n\r\n.close {\r\n  float: right;\r\n  font-size: 1.5rem;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n  color: #000;\r\n  text-shadow: 0 1px 0 #fff;\r\n  opacity: .5;\r\n}\r\n\r\n.close:hover {\r\n  color: #000;\r\n  text-decoration: none;\r\n}\r\n\r\n.close:not(:disabled):not(.disabled):hover,\r\n.close:not(:disabled):not(.disabled):focus {\r\n  opacity: .75;\r\n}\r\n\r\n\r\n\r\n\r\n.toast {\r\n  max-width: 350px;\r\n  overflow: hidden;\r\n  font-size: 0.875rem;\r\n  background-color: rgba(255, 255, 255, 0.85);\r\n  background-clip: padding-box;\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);\r\n  -webkit-backdrop-filter: blur(10px);\r\n          backdrop-filter: blur(10px);\r\n  opacity: 0;\r\n}\r\n\r\n.toast:not(:last-child) {\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.toast.showing {\r\n  opacity: 1;\r\n}\r\n\r\n.toast.show {\r\n  display: block;\r\n  opacity: 1;\r\n}\r\n\r\n.toast.hide {\r\n  display: none;\r\n}\r\n\r\n.toast-header {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0.25rem 0.75rem;\r\n  color: #6c757d;\r\n  background-color: rgba(255, 255, 255, 0.85);\r\n  background-clip: padding-box;\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.toast-body {\r\n  padding: 0.75rem;\r\n}\r\n\r\n.modal-open {\r\n  overflow: hidden;\r\n}\r\n\r\n.modal-open .modal {\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n}\r\n\r\n.modal {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 1050;\r\n  display: none;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  outline: 0;\r\n}\r\n\r\n.modal-dialog {\r\n  position: relative;\r\n  width: auto;\r\n  margin: 0.5rem;\r\n  pointer-events: none;\r\n}\r\n\r\n.modal.fade .modal-dialog {\r\n  transition: transform 0.3s ease-out;\r\n  transform: translate(0, -50px);\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .modal.fade .modal-dialog {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.modal.show .modal-dialog {\r\n  transform: none;\r\n}\r\n\r\n.modal-dialog-scrollable {\r\n  display: flex;\r\n  max-height: calc(100% - 1rem);\r\n}\r\n\r\n.modal-dialog-scrollable .modal-content {\r\n  max-height: calc(100vh - 1rem);\r\n  overflow: hidden;\r\n}\r\n\r\n.modal-dialog-scrollable .modal-header,\r\n.modal-dialog-scrollable .modal-footer {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.modal-dialog-scrollable .modal-body {\r\n  overflow-y: auto;\r\n}\r\n\r\n.modal-dialog-centered {\r\n  display: flex;\r\n  align-items: center;\r\n  min-height: calc(100% - 1rem);\r\n}\r\n\r\n.modal-dialog-centered::before {\r\n  display: block;\r\n  height: calc(100vh - 1rem);\r\n  content: \"\";\r\n}\r\n\r\n.modal-dialog-centered.modal-dialog-scrollable {\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  height: 100%;\r\n}\r\n\r\n.modal-dialog-centered.modal-dialog-scrollable .modal-content {\r\n  max-height: none;\r\n}\r\n\r\n.modal-dialog-centered.modal-dialog-scrollable::before {\r\n  content: none;\r\n}\r\n\r\n.modal-content {\r\n  position: relative;\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  pointer-events: auto;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid rgba(0, 0, 0, 0.2);\r\n  outline: 0;\r\n}\r\n\r\n.modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 1040;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-color: #000;\r\n}\r\n\r\n.modal-backdrop.fade {\r\n  opacity: 0;\r\n}\r\n\r\n.modal-backdrop.show {\r\n  opacity: 0.5;\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  padding: 1rem 1rem;\r\n  border-bottom: 1px solid #cccbca;\r\n}\r\n\r\n.modal-header .close {\r\n  padding: 1rem 1rem;\r\n  margin: -1rem -1rem -1rem auto;\r\n}\r\n\r\n.modal-title {\r\n  margin-bottom: 0;\r\n  line-height: 1.5;\r\n}\r\n\r\n.modal-body {\r\n  position: relative;\r\n  flex: 1 1 auto;\r\n  padding: 1rem;\r\n}\r\n\r\n.modal-footer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  padding: 1rem;\r\n  border-top: 1px solid #cccbca;\r\n}\r\n\r\n.modal-footer > :not(:first-child) {\r\n  margin-left: .25rem;\r\n}\r\n\r\n.modal-footer > :not(:last-child) {\r\n  margin-right: .25rem;\r\n}\r\n\r\n.modal-scrollbar-measure {\r\n  position: absolute;\r\n  top: -9999px;\r\n  width: 50px;\r\n  height: 50px;\r\n  overflow: scroll;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .modal-dialog {\r\n    max-width: 500px;\r\n    margin: 1.75rem auto;\r\n  }\r\n\r\n  .modal-dialog-scrollable {\r\n    max-height: calc(100% - 3.5rem);\r\n  }\r\n\r\n  .modal-dialog-scrollable .modal-content {\r\n    max-height: calc(100vh - 3.5rem);\r\n  }\r\n\r\n  .modal-dialog-centered {\r\n    min-height: calc(100% - 3.5rem);\r\n  }\r\n\r\n  .modal-dialog-centered::before {\r\n    height: calc(100vh - 3.5rem);\r\n  }\r\n\r\n  .modal-sm {\r\n    max-width: 300px;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .modal-lg,\r\n  .modal-xl {\r\n    max-width: 800px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .modal-xl {\r\n    max-width: 1140px;\r\n  }\r\n}\r\n\r\n.tooltip {\r\n  position: absolute;\r\n  z-index: 1070;\r\n  display: block;\r\n  margin: 0;\r\n  font-family: \"Nunito\", \"HelveticaNeue-Light\", sans-serif;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  text-align: left;\r\n  text-align: start;\r\n  text-decoration: none;\r\n  text-shadow: none;\r\n  text-transform: none;\r\n  letter-spacing: normal;\r\n  word-break: normal;\r\n  word-spacing: normal;\r\n  white-space: normal;\r\n  line-break: auto;\r\n  font-size: 0.875rem;\r\n  word-wrap: break-word;\r\n  opacity: 0;\r\n}\r\n\r\n.tooltip.show {\r\n  opacity: 0.9;\r\n}\r\n\r\n.tooltip .arrow {\r\n  position: absolute;\r\n  display: block;\r\n  width: 0.8rem;\r\n  height: 0.4rem;\r\n}\r\n\r\n.tooltip .arrow::before {\r\n  position: absolute;\r\n  content: \"\";\r\n  border-color: transparent;\r\n  border-style: solid;\r\n}\r\n\r\n.bs-tooltip-top,\r\n.bs-tooltip-auto[x-placement^=\"top\"] {\r\n  padding: 0.4rem 0;\r\n}\r\n\r\n.bs-tooltip-top .arrow,\r\n.bs-tooltip-auto[x-placement^=\"top\"] .arrow {\r\n  bottom: 0;\r\n}\r\n\r\n.bs-tooltip-top .arrow::before,\r\n.bs-tooltip-auto[x-placement^=\"top\"] .arrow::before {\r\n  top: 0;\r\n  border-width: 0.4rem 0.4rem 0;\r\n  border-top-color: #000;\r\n}\r\n\r\n.bs-tooltip-right,\r\n.bs-tooltip-auto[x-placement^=\"right\"] {\r\n  padding: 0 0.4rem;\r\n}\r\n\r\n.bs-tooltip-right .arrow,\r\n.bs-tooltip-auto[x-placement^=\"right\"] .arrow {\r\n  left: 0;\r\n  width: 0.4rem;\r\n  height: 0.8rem;\r\n}\r\n\r\n.bs-tooltip-right .arrow::before,\r\n.bs-tooltip-auto[x-placement^=\"right\"] .arrow::before {\r\n  right: 0;\r\n  border-width: 0.4rem 0.4rem 0.4rem 0;\r\n  border-right-color: #000;\r\n}\r\n\r\n.bs-tooltip-bottom,\r\n.bs-tooltip-auto[x-placement^=\"bottom\"] {\r\n  padding: 0.4rem 0;\r\n}\r\n\r\n.bs-tooltip-bottom .arrow,\r\n.bs-tooltip-auto[x-placement^=\"bottom\"] .arrow {\r\n  top: 0;\r\n}\r\n\r\n.bs-tooltip-bottom .arrow::before,\r\n.bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before {\r\n  bottom: 0;\r\n  border-width: 0 0.4rem 0.4rem;\r\n  border-bottom-color: #000;\r\n}\r\n\r\n.bs-tooltip-left,\r\n.bs-tooltip-auto[x-placement^=\"left\"] {\r\n  padding: 0 0.4rem;\r\n}\r\n\r\n.bs-tooltip-left .arrow,\r\n.bs-tooltip-auto[x-placement^=\"left\"] .arrow {\r\n  right: 0;\r\n  width: 0.4rem;\r\n  height: 0.8rem;\r\n}\r\n\r\n.bs-tooltip-left .arrow::before,\r\n.bs-tooltip-auto[x-placement^=\"left\"] .arrow::before {\r\n  left: 0;\r\n  border-width: 0.4rem 0 0.4rem 0.4rem;\r\n  border-left-color: #000;\r\n}\r\n\r\n.tooltip-inner {\r\n  max-width: 200px;\r\n  padding: 0.25rem 0.5rem;\r\n  color: #fff;\r\n  text-align: center;\r\n  background-color: #000;\r\n}\r\n\r\n.popover {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 1060;\r\n  display: block;\r\n  max-width: 276px;\r\n  font-family: \"Nunito\", \"HelveticaNeue-Light\", sans-serif;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 1.5;\r\n  text-align: left;\r\n  text-align: start;\r\n  text-decoration: none;\r\n  text-shadow: none;\r\n  text-transform: none;\r\n  letter-spacing: normal;\r\n  word-break: normal;\r\n  word-spacing: normal;\r\n  white-space: normal;\r\n  line-break: auto;\r\n  font-size: 0.875rem;\r\n  word-wrap: break-word;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border: 1px solid rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.popover .arrow {\r\n  position: absolute;\r\n  display: block;\r\n  width: 1rem;\r\n  height: 0.5rem;\r\n  margin: 0 0.3rem;\r\n}\r\n\r\n.popover .arrow::before,\r\n.popover .arrow::after {\r\n  position: absolute;\r\n  display: block;\r\n  content: \"\";\r\n  border-color: transparent;\r\n  border-style: solid;\r\n}\r\n\r\n.bs-popover-top,\r\n.bs-popover-auto[x-placement^=\"top\"] {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.bs-popover-top > .arrow,\r\n.bs-popover-auto[x-placement^=\"top\"] > .arrow {\r\n  bottom: calc((0.5rem + 1px) * -1);\r\n}\r\n\r\n.bs-popover-top > .arrow::before,\r\n.bs-popover-auto[x-placement^=\"top\"] > .arrow::before {\r\n  bottom: 0;\r\n  border-width: 0.5rem 0.5rem 0;\r\n  border-top-color: rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.bs-popover-top > .arrow::after,\r\n.bs-popover-auto[x-placement^=\"top\"] > .arrow::after {\r\n  bottom: 1px;\r\n  border-width: 0.5rem 0.5rem 0;\r\n  border-top-color: #fff;\r\n}\r\n\r\n.bs-popover-right,\r\n.bs-popover-auto[x-placement^=\"right\"] {\r\n  margin-left: 0.5rem;\r\n}\r\n\r\n.bs-popover-right > .arrow,\r\n.bs-popover-auto[x-placement^=\"right\"] > .arrow {\r\n  left: calc((0.5rem + 1px) * -1);\r\n  width: 0.5rem;\r\n  height: 1rem;\r\n  margin: 0.3rem 0;\r\n}\r\n\r\n.bs-popover-right > .arrow::before,\r\n.bs-popover-auto[x-placement^=\"right\"] > .arrow::before {\r\n  left: 0;\r\n  border-width: 0.5rem 0.5rem 0.5rem 0;\r\n  border-right-color: rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.bs-popover-right > .arrow::after,\r\n.bs-popover-auto[x-placement^=\"right\"] > .arrow::after {\r\n  left: 1px;\r\n  border-width: 0.5rem 0.5rem 0.5rem 0;\r\n  border-right-color: #fff;\r\n}\r\n\r\n.bs-popover-bottom,\r\n.bs-popover-auto[x-placement^=\"bottom\"] {\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.bs-popover-bottom > .arrow,\r\n.bs-popover-auto[x-placement^=\"bottom\"] > .arrow {\r\n  top: calc((0.5rem + 1px) * -1);\r\n}\r\n\r\n.bs-popover-bottom > .arrow::before,\r\n.bs-popover-auto[x-placement^=\"bottom\"] > .arrow::before {\r\n  top: 0;\r\n  border-width: 0 0.5rem 0.5rem 0.5rem;\r\n  border-bottom-color: rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.bs-popover-bottom > .arrow::after,\r\n.bs-popover-auto[x-placement^=\"bottom\"] > .arrow::after {\r\n  top: 1px;\r\n  border-width: 0 0.5rem 0.5rem 0.5rem;\r\n  border-bottom-color: #fff;\r\n}\r\n\r\n.bs-popover-bottom .popover-header::before,\r\n.bs-popover-auto[x-placement^=\"bottom\"] .popover-header::before {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 50%;\r\n  display: block;\r\n  width: 1rem;\r\n  margin-left: -0.5rem;\r\n  content: \"\";\r\n  border-bottom: 1px solid #f7f7f7;\r\n}\r\n\r\n.bs-popover-left,\r\n.bs-popover-auto[x-placement^=\"left\"] {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.bs-popover-left > .arrow,\r\n.bs-popover-auto[x-placement^=\"left\"] > .arrow {\r\n  right: calc((0.5rem + 1px) * -1);\r\n  width: 0.5rem;\r\n  height: 1rem;\r\n  margin: 0.3rem 0;\r\n}\r\n\r\n.bs-popover-left > .arrow::before,\r\n.bs-popover-auto[x-placement^=\"left\"] > .arrow::before {\r\n  right: 0;\r\n  border-width: 0.5rem 0 0.5rem 0.5rem;\r\n  border-left-color: rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.bs-popover-left > .arrow::after,\r\n.bs-popover-auto[x-placement^=\"left\"] > .arrow::after {\r\n  right: 1px;\r\n  border-width: 0.5rem 0 0.5rem 0.5rem;\r\n  border-left-color: #fff;\r\n}\r\n\r\n.popover-header {\r\n  padding: 0.5rem 0.75rem;\r\n  margin-bottom: 0;\r\n  font-size: 1rem;\r\n  background-color: #f7f7f7;\r\n  border-bottom: 1px solid #ebebeb;\r\n}\r\n\r\n.popover-header:empty {\r\n  display: none;\r\n}\r\n\r\n.popover-body {\r\n  padding: 0.5rem 0.75rem;\r\n  color: #212529;\r\n}\r\n\r\n.carousel {\r\n  position: relative;\r\n}\r\n\r\n.carousel.pointer-event {\r\n  touch-action: pan-y;\r\n}\r\n\r\n.carousel-inner {\r\n  position: relative;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.carousel-inner::after {\r\n  display: block;\r\n  clear: both;\r\n  content: \"\";\r\n}\r\n\r\n.carousel-item {\r\n  position: relative;\r\n  display: none;\r\n  float: left;\r\n  width: 100%;\r\n  margin-right: -100%;\r\n  -webkit-backface-visibility: hidden;\r\n          backface-visibility: hidden;\r\n  transition: transform 0.6s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .carousel-item {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.carousel-item.active,\r\n.carousel-item-next,\r\n.carousel-item-prev {\r\n  display: block;\r\n}\r\n\r\n.carousel-item-next:not(.carousel-item-left),\r\n.active.carousel-item-right {\r\n  transform: translateX(100%);\r\n}\r\n\r\n.carousel-item-prev:not(.carousel-item-right),\r\n.active.carousel-item-left {\r\n  transform: translateX(-100%);\r\n}\r\n\r\n.carousel-fade .carousel-item {\r\n  opacity: 0;\r\n  transition-property: opacity;\r\n  transform: none;\r\n}\r\n\r\n.carousel-fade .carousel-item.active,\r\n.carousel-fade .carousel-item-next.carousel-item-left,\r\n.carousel-fade .carousel-item-prev.carousel-item-right {\r\n  z-index: 1;\r\n  opacity: 1;\r\n}\r\n\r\n.carousel-fade .active.carousel-item-left,\r\n.carousel-fade .active.carousel-item-right {\r\n  z-index: 0;\r\n  opacity: 0;\r\n  transition: 0s 0.6s opacity;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .carousel-fade .active.carousel-item-left,\r\n  .carousel-fade .active.carousel-item-right {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.carousel-control-prev,\r\n.carousel-control-next {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  z-index: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 15%;\r\n  color: #fff;\r\n  text-align: center;\r\n  opacity: 0.5;\r\n  transition: opacity 0.15s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .carousel-control-prev,\r\n  .carousel-control-next {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.carousel-control-prev:hover,\r\n.carousel-control-prev:focus,\r\n.carousel-control-next:hover,\r\n.carousel-control-next:focus {\r\n  color: #fff;\r\n  text-decoration: none;\r\n  outline: 0;\r\n  opacity: 0.9;\r\n}\r\n\r\n.carousel-control-prev {\r\n  left: 0;\r\n}\r\n\r\n.carousel-control-next {\r\n  right: 0;\r\n}\r\n\r\n.carousel-control-prev-icon,\r\n.carousel-control-next-icon {\r\n  display: inline-block;\r\n  width: 20px;\r\n  height: 20px;\r\n  background: no-repeat 50% / 100% 100%;\r\n}\r\n\r\n.carousel-control-prev-icon {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.carousel-control-next-icon {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n.carousel-indicators {\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: 15;\r\n  display: flex;\r\n  justify-content: center;\r\n  padding-left: 0;\r\n  margin-right: 15%;\r\n  margin-left: 15%;\r\n  list-style: none;\r\n}\r\n\r\n.carousel-indicators li {\r\n  box-sizing: content-box;\r\n  flex: 0 1 auto;\r\n  width: 30px;\r\n  height: 3px;\r\n  margin-right: 3px;\r\n  margin-left: 3px;\r\n  text-indent: -999px;\r\n  cursor: pointer;\r\n  background-color: #fff;\r\n  background-clip: padding-box;\r\n  border-top: 10px solid transparent;\r\n  border-bottom: 10px solid transparent;\r\n  opacity: .5;\r\n  transition: opacity 0.6s ease;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .carousel-indicators li {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.carousel-indicators .active {\r\n  opacity: 1;\r\n}\r\n\r\n.carousel-caption {\r\n  position: absolute;\r\n  right: 15%;\r\n  bottom: 20px;\r\n  left: 15%;\r\n  z-index: 10;\r\n  padding-top: 20px;\r\n  padding-bottom: 20px;\r\n  color: #fff;\r\n  text-align: center;\r\n}\r\n\r\n@keyframes spinner-border {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.spinner-border {\r\n  display: inline-block;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  vertical-align: text-bottom;\r\n  border: 0.25em solid currentColor;\r\n  border-right-color: transparent;\r\n  border-radius: 50%;\r\n  animation: spinner-border .75s linear infinite;\r\n}\r\n\r\n.spinner-border-sm {\r\n  width: 1rem;\r\n  height: 1rem;\r\n  border-width: 0.2em;\r\n}\r\n\r\n@keyframes spinner-grow {\r\n  0% {\r\n    transform: scale(0);\r\n  }\r\n\r\n  50% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.spinner-grow {\r\n  display: inline-block;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  vertical-align: text-bottom;\r\n  background-color: currentColor;\r\n  border-radius: 50%;\r\n  opacity: 0;\r\n  animation: spinner-grow .75s linear infinite;\r\n}\r\n\r\n.spinner-grow-sm {\r\n  width: 1rem;\r\n  height: 1rem;\r\n}\r\n\r\n.align-baseline {\r\n  vertical-align: baseline !important;\r\n}\r\n\r\n.align-top {\r\n  vertical-align: top !important;\r\n}\r\n\r\n.align-middle {\r\n  vertical-align: middle !important;\r\n}\r\n\r\n.align-bottom {\r\n  vertical-align: bottom !important;\r\n}\r\n\r\n.align-text-bottom {\r\n  vertical-align: text-bottom !important;\r\n}\r\n\r\n.align-text-top {\r\n  vertical-align: text-top !important;\r\n}\r\n\r\n.bg-primary {\r\n  background-color: var(--primary) !important;\r\n}\r\n\r\na.bg-primary:hover,\r\na.bg-primary:focus {\r\n  background-color: #2a417f !important;\r\n}\r\n\r\n\r\n\r\na.bg-secondary:hover,\r\na.bg-secondary:focus {\r\n  background-color: #8da5fb !important;\r\n}\r\n\r\n.bg-success {\r\n  background-color: var(--success) !important;\r\n}\r\n\r\na.bg-success:hover,\r\na.bg-success:focus {\r\n  background-color: #14866f !important;\r\n}\r\n\r\n.bg-info {\r\n  background-color: #5d80f9 !important;\r\n}\r\n\r\na.bg-info:hover,\r\na.bg-info:focus{\r\n  background-color: #2c59f7 !important;\r\n}\r\n\r\n.bg-warning {\r\n  background-color: #f3c363 !important;\r\n}\r\n\r\na.bg-warning:hover,\r\na.bg-warning:focus {\r\n  background-color: #efb134 !important;\r\n}\r\n\r\n.bg-danger {\r\n  background-color: #eb3349 !important;\r\n}\r\n\r\na.bg-danger:hover,\r\na.bg-danger:focus {\r\n  background-color: #d6152c !important;\r\n}\r\n\r\n.bg-light {\r\n  background-color: #cccbca !important;\r\n}\r\n\r\na.bg-light:hover,\r\na.bg-light:focus {\r\n  background-color: #b3b2b0 !important;\r\n}\r\n\r\n.bg-dark {\r\n  background-color: #343a40 !important;\r\n}\r\n\r\na.bg-dark:hover,\r\na.bg-dark:focus {\r\n  background-color: #1d2124 !important;\r\n}\r\n\r\n.bg-inverse {\r\n  background-color: #4d4d4d !important;\r\n}\r\n\r\na.bg-inverse:hover,\r\na.bg-inverse:focus {\r\n  background-color: #343434 !important;\r\n}\r\n\r\n.bg-gray {\r\n  background-color: #ccc !important;\r\n}\r\n\r\n\r\n\r\n.bg-default {\r\n  background-color: #f8f8f8 !important;\r\n}\r\n\r\na.bg-default:hover,\r\na.bg-default:focus {\r\n  background-color: #dfdfdf !important;\r\n}\r\n\r\n.bg-white {\r\n  background-color: #fff !important;\r\n}\r\n\r\n.bg-transparent {\r\n  background-color: transparent !important;\r\n}\r\n\r\n.border {\r\n  border: 1px solid #cccbca !important;\r\n}\r\n\r\n.border-top {\r\n  border-top: 1px solid #cccbca !important;\r\n}\r\n\r\n.border-right {\r\n  border-right: 1px solid #cccbca !important;\r\n}\r\n\r\n.border-bottom {\r\n  border-bottom: 1px solid #cccbca !important;\r\n}\r\n\r\n.border-left {\r\n  border-left: 1px solid #cccbca !important;\r\n}\r\n\r\n.border-0 {\r\n  border: 0 !important;\r\n}\r\n\r\n.border-top-0 {\r\n  border-top: 0 !important;\r\n}\r\n\r\n.border-right-0 {\r\n  border-right: 0 !important;\r\n}\r\n\r\n.border-bottom-0 {\r\n  border-bottom: 0 !important;\r\n}\r\n\r\n.border-left-0 {\r\n  border-left: 0 !important;\r\n}\r\n\r\n.border-primary {\r\n  border-color: var(--primary) !important;\r\n}\r\n\r\n.border-secondary {\r\n  border-color: var(--secondary) !important;\r\n}\r\n\r\n.border-success {\r\n  border-color: var(--success) !important;\r\n}\r\n\r\n.border-info {\r\n  border-color: #5d80f9 !important;\r\n}\r\n\r\n.border-warning {\r\n  border-color: #f3c363 !important;\r\n}\r\n\r\n.border-danger {\r\n  border-color: #eb3349 !important;\r\n}\r\n\r\n.border-light {\r\n  border-color: #cccbca !important;\r\n}\r\n\r\n.border-dark {\r\n  border-color: #343a40 !important;\r\n}\r\n\r\n.border-inverse {\r\n  border-color: #4d4d4d !important;\r\n}\r\n\r\n.border-gray {\r\n  border-color: #ccc !important;\r\n}\r\n\r\n.border-default {\r\n  border-color: #f8f8f8 !important;\r\n}\r\n\r\n.border-white {\r\n  border-color: #fff !important;\r\n}\r\n\r\n.rounded-sm {\r\n  border-radius: 0.2rem !important;\r\n}\r\n\r\n.rounded {\r\n  border-radius: 0.25rem !important;\r\n}\r\n\r\n.rounded-top {\r\n  border-top-left-radius: 0.25rem !important;\r\n  border-top-right-radius: 0.25rem !important;\r\n}\r\n\r\n.rounded-right {\r\n  border-top-right-radius: 0.25rem !important;\r\n  border-bottom-right-radius: 0.25rem !important;\r\n}\r\n\r\n.rounded-bottom {\r\n  border-bottom-right-radius: 0.25rem !important;\r\n  border-bottom-left-radius: 0.25rem !important;\r\n}\r\n\r\n.rounded-left {\r\n  border-top-left-radius: 0.25rem !important;\r\n  border-bottom-left-radius: 0.25rem !important;\r\n}\r\n\r\n.rounded-lg {\r\n  border-radius: 0.3rem !important;\r\n}\r\n\r\n.rounded-circle {\r\n  border-radius: 50% !important;\r\n}\r\n\r\n.rounded-pill {\r\n  border-radius: 50rem !important;\r\n}\r\n\r\n.rounded-0 {\r\n  border-radius: 0 !important;\r\n}\r\n\r\n.clearfix::after {\r\n  display: block;\r\n  clear: both;\r\n  content: \"\";\r\n}\r\n\r\n.d-none {\r\n  display: none !important;\r\n}\r\n\r\n.d-inline {\r\n  display: inline !important;\r\n}\r\n\r\n.d-inline-block {\r\n  display: inline-block !important;\r\n}\r\n\r\n.d-block {\r\n  display: block !important;\r\n}\r\n\r\n.d-table {\r\n  display: table !important;\r\n}\r\n\r\n.d-table-row {\r\n  display: table-row !important;\r\n}\r\n\r\n.d-table-cell {\r\n  display: table-cell !important;\r\n}\r\n\r\n.d-flex {\r\n  display: flex !important;\r\n}\r\n\r\n.d-inline-flex {\r\n  display: inline-flex !important;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .d-sm-none {\r\n    display: none !important;\r\n  }\r\n\r\n  .d-sm-inline {\r\n    display: inline !important;\r\n  }\r\n\r\n  .d-sm-inline-block {\r\n    display: inline-block !important;\r\n  }\r\n\r\n  .d-sm-block {\r\n    display: block !important;\r\n  }\r\n\r\n  .d-sm-table {\r\n    display: table !important;\r\n  }\r\n\r\n  .d-sm-table-row {\r\n    display: table-row !important;\r\n  }\r\n\r\n  .d-sm-table-cell {\r\n    display: table-cell !important;\r\n  }\r\n\r\n  .d-sm-flex {\r\n    display: flex !important;\r\n  }\r\n\r\n  .d-sm-inline-flex {\r\n    display: inline-flex !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .d-md-none {\r\n    display: none !important;\r\n  }\r\n\r\n  .d-md-inline {\r\n    display: inline !important;\r\n  }\r\n\r\n  .d-md-inline-block {\r\n    display: inline-block !important;\r\n  }\r\n\r\n  .d-md-block {\r\n    display: block !important;\r\n  }\r\n\r\n  .d-md-table {\r\n    display: table !important;\r\n  }\r\n\r\n  .d-md-table-row {\r\n    display: table-row !important;\r\n  }\r\n\r\n  .d-md-table-cell {\r\n    display: table-cell !important;\r\n  }\r\n\r\n  .d-md-flex {\r\n    display: flex !important;\r\n  }\r\n\r\n  .d-md-inline-flex {\r\n    display: inline-flex !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .d-lg-none {\r\n    display: none !important;\r\n  }\r\n\r\n  .d-lg-inline {\r\n    display: inline !important;\r\n  }\r\n\r\n  .d-lg-inline-block {\r\n    display: inline-block !important;\r\n  }\r\n\r\n  .d-lg-block {\r\n    display: block !important;\r\n  }\r\n\r\n  .d-lg-table {\r\n    display: table !important;\r\n  }\r\n\r\n  .d-lg-table-row {\r\n    display: table-row !important;\r\n  }\r\n\r\n  .d-lg-table-cell {\r\n    display: table-cell !important;\r\n  }\r\n\r\n  .d-lg-flex {\r\n    display: flex !important;\r\n  }\r\n\r\n  .d-lg-inline-flex {\r\n    display: inline-flex !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .d-xl-none {\r\n    display: none !important;\r\n  }\r\n\r\n  .d-xl-inline {\r\n    display: inline !important;\r\n  }\r\n\r\n  .d-xl-inline-block {\r\n    display: inline-block !important;\r\n  }\r\n\r\n  .d-xl-block {\r\n    display: block !important;\r\n  }\r\n\r\n  .d-xl-table {\r\n    display: table !important;\r\n  }\r\n\r\n  .d-xl-table-row {\r\n    display: table-row !important;\r\n  }\r\n\r\n  .d-xl-table-cell {\r\n    display: table-cell !important;\r\n  }\r\n\r\n  .d-xl-flex {\r\n    display: flex !important;\r\n  }\r\n\r\n  .d-xl-inline-flex {\r\n    display: inline-flex !important;\r\n  }\r\n}\r\n\r\n@media print {\r\n  .d-print-none {\r\n    display: none !important;\r\n  }\r\n\r\n  .d-print-inline {\r\n    display: inline !important;\r\n  }\r\n\r\n  .d-print-inline-block {\r\n    display: inline-block !important;\r\n  }\r\n\r\n  .d-print-block {\r\n    display: block !important;\r\n  }\r\n\r\n  .d-print-table {\r\n    display: table !important;\r\n  }\r\n\r\n  .d-print-table-row {\r\n    display: table-row !important;\r\n  }\r\n\r\n  .d-print-table-cell {\r\n    display: table-cell !important;\r\n  }\r\n\r\n  .d-print-flex {\r\n    display: flex !important;\r\n  }\r\n\r\n  .d-print-inline-flex {\r\n    display: inline-flex !important;\r\n  }\r\n}\r\n\r\n.embed-responsive {\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n  padding: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.embed-responsive::before {\r\n  display: block;\r\n  content: \"\";\r\n}\r\n\r\n.embed-responsive .embed-responsive-item,\r\n.embed-responsive iframe,\r\n.embed-responsive embed,\r\n.embed-responsive object,\r\n.embed-responsive video {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 0;\r\n}\r\n\r\n.embed-responsive-21by9::before {\r\n  padding-top: 42.85714%;\r\n}\r\n\r\n.embed-responsive-16by9::before {\r\n  padding-top: 56.25%;\r\n}\r\n\r\n.embed-responsive-4by3::before {\r\n  padding-top: 75%;\r\n}\r\n\r\n.embed-responsive-1by1::before {\r\n  padding-top: 100%;\r\n}\r\n\r\n.flex-row {\r\n  flex-direction: row !important;\r\n}\r\n\r\n.flex-column {\r\n  flex-direction: column !important;\r\n}\r\n\r\n.flex-row-reverse {\r\n  flex-direction: row-reverse !important;\r\n}\r\n\r\n.flex-column-reverse {\r\n  flex-direction: column-reverse !important;\r\n}\r\n\r\n.flex-wrap {\r\n  flex-wrap: wrap !important;\r\n}\r\n\r\n.flex-nowrap {\r\n  flex-wrap: nowrap !important;\r\n}\r\n\r\n.flex-wrap-reverse {\r\n  flex-wrap: wrap-reverse !important;\r\n}\r\n\r\n.flex-fill {\r\n  flex: 1 1 auto !important;\r\n}\r\n\r\n.flex-grow-0 {\r\n  flex-grow: 0 !important;\r\n}\r\n\r\n.flex-grow-1 {\r\n  flex-grow: 1 !important;\r\n}\r\n\r\n.flex-shrink-0 {\r\n  flex-shrink: 0 !important;\r\n}\r\n\r\n.flex-shrink-1 {\r\n  flex-shrink: 1 !important;\r\n}\r\n\r\n.justify-content-start {\r\n  justify-content: flex-start !important;\r\n}\r\n\r\n.justify-content-end {\r\n  justify-content: flex-end !important;\r\n}\r\n\r\n.justify-content-center {\r\n  justify-content: center !important;\r\n}\r\n\r\n.justify-content-between {\r\n  justify-content: space-between !important;\r\n}\r\n\r\n.justify-content-around {\r\n  justify-content: space-around !important;\r\n}\r\n\r\n.align-items-start {\r\n  align-items: flex-start !important;\r\n}\r\n\r\n.align-items-end {\r\n  align-items: flex-end !important;\r\n}\r\n\r\n.align-items-center {\r\n  align-items: center !important;\r\n}\r\n\r\n.align-items-baseline {\r\n  align-items: baseline !important;\r\n}\r\n\r\n.align-items-stretch {\r\n  align-items: stretch !important;\r\n}\r\n\r\n.align-content-start {\r\n  align-content: flex-start !important;\r\n}\r\n\r\n.align-content-end {\r\n  align-content: flex-end !important;\r\n}\r\n\r\n.align-content-center {\r\n  align-content: center !important;\r\n}\r\n\r\n.align-content-between {\r\n  align-content: space-between !important;\r\n}\r\n\r\n.align-content-around {\r\n  align-content: space-around !important;\r\n}\r\n\r\n.align-content-stretch {\r\n  align-content: stretch !important;\r\n}\r\n\r\n.align-self-auto {\r\n  align-self: auto !important;\r\n}\r\n\r\n.align-self-start {\r\n  align-self: flex-start !important;\r\n}\r\n\r\n.align-self-end {\r\n  align-self: flex-end !important;\r\n}\r\n\r\n.align-self-center {\r\n  align-self: center !important;\r\n}\r\n\r\n.align-self-baseline {\r\n  align-self: baseline !important;\r\n}\r\n\r\n.align-self-stretch {\r\n  align-self: stretch !important;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .flex-sm-row {\r\n    flex-direction: row !important;\r\n  }\r\n\r\n  .flex-sm-column {\r\n    flex-direction: column !important;\r\n  }\r\n\r\n  .flex-sm-row-reverse {\r\n    flex-direction: row-reverse !important;\r\n  }\r\n\r\n  .flex-sm-column-reverse {\r\n    flex-direction: column-reverse !important;\r\n  }\r\n\r\n  .flex-sm-wrap {\r\n    flex-wrap: wrap !important;\r\n  }\r\n\r\n  .flex-sm-nowrap {\r\n    flex-wrap: nowrap !important;\r\n  }\r\n\r\n  .flex-sm-wrap-reverse {\r\n    flex-wrap: wrap-reverse !important;\r\n  }\r\n\r\n  .flex-sm-fill {\r\n    flex: 1 1 auto !important;\r\n  }\r\n\r\n  .flex-sm-grow-0 {\r\n    flex-grow: 0 !important;\r\n  }\r\n\r\n  .flex-sm-grow-1 {\r\n    flex-grow: 1 !important;\r\n  }\r\n\r\n  .flex-sm-shrink-0 {\r\n    flex-shrink: 0 !important;\r\n  }\r\n\r\n  .flex-sm-shrink-1 {\r\n    flex-shrink: 1 !important;\r\n  }\r\n\r\n  .justify-content-sm-start {\r\n    justify-content: flex-start !important;\r\n  }\r\n\r\n  .justify-content-sm-end {\r\n    justify-content: flex-end !important;\r\n  }\r\n\r\n  .justify-content-sm-center {\r\n    justify-content: center !important;\r\n  }\r\n\r\n  .justify-content-sm-between {\r\n    justify-content: space-between !important;\r\n  }\r\n\r\n  .justify-content-sm-around {\r\n    justify-content: space-around !important;\r\n  }\r\n\r\n  .align-items-sm-start {\r\n    align-items: flex-start !important;\r\n  }\r\n\r\n  .align-items-sm-end {\r\n    align-items: flex-end !important;\r\n  }\r\n\r\n  .align-items-sm-center {\r\n    align-items: center !important;\r\n  }\r\n\r\n  .align-items-sm-baseline {\r\n    align-items: baseline !important;\r\n  }\r\n\r\n  .align-items-sm-stretch {\r\n    align-items: stretch !important;\r\n  }\r\n\r\n  .align-content-sm-start {\r\n    align-content: flex-start !important;\r\n  }\r\n\r\n  .align-content-sm-end {\r\n    align-content: flex-end !important;\r\n  }\r\n\r\n  .align-content-sm-center {\r\n    align-content: center !important;\r\n  }\r\n\r\n  .align-content-sm-between {\r\n    align-content: space-between !important;\r\n  }\r\n\r\n  .align-content-sm-around {\r\n    align-content: space-around !important;\r\n  }\r\n\r\n  .align-content-sm-stretch {\r\n    align-content: stretch !important;\r\n  }\r\n\r\n  .align-self-sm-auto {\r\n    align-self: auto !important;\r\n  }\r\n\r\n  .align-self-sm-start {\r\n    align-self: flex-start !important;\r\n  }\r\n\r\n  .align-self-sm-end {\r\n    align-self: flex-end !important;\r\n  }\r\n\r\n  .align-self-sm-center {\r\n    align-self: center !important;\r\n  }\r\n\r\n  .align-self-sm-baseline {\r\n    align-self: baseline !important;\r\n  }\r\n\r\n  .align-self-sm-stretch {\r\n    align-self: stretch !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .flex-md-row {\r\n    flex-direction: row !important;\r\n  }\r\n\r\n  .flex-md-column {\r\n    flex-direction: column !important;\r\n  }\r\n\r\n  .flex-md-row-reverse {\r\n    flex-direction: row-reverse !important;\r\n  }\r\n\r\n  .flex-md-column-reverse {\r\n    flex-direction: column-reverse !important;\r\n  }\r\n\r\n  .flex-md-wrap {\r\n    flex-wrap: wrap !important;\r\n  }\r\n\r\n  .flex-md-nowrap {\r\n    flex-wrap: nowrap !important;\r\n  }\r\n\r\n  .flex-md-wrap-reverse {\r\n    flex-wrap: wrap-reverse !important;\r\n  }\r\n\r\n  .flex-md-fill {\r\n    flex: 1 1 auto !important;\r\n  }\r\n\r\n  .flex-md-grow-0 {\r\n    flex-grow: 0 !important;\r\n  }\r\n\r\n  .flex-md-grow-1 {\r\n    flex-grow: 1 !important;\r\n  }\r\n\r\n  .flex-md-shrink-0 {\r\n    flex-shrink: 0 !important;\r\n  }\r\n\r\n  .flex-md-shrink-1 {\r\n    flex-shrink: 1 !important;\r\n  }\r\n\r\n  .justify-content-md-start {\r\n    justify-content: flex-start !important;\r\n  }\r\n\r\n  .justify-content-md-end {\r\n    justify-content: flex-end !important;\r\n  }\r\n\r\n  .justify-content-md-center {\r\n    justify-content: center !important;\r\n  }\r\n\r\n  .justify-content-md-between {\r\n    justify-content: space-between !important;\r\n  }\r\n\r\n  .justify-content-md-around {\r\n    justify-content: space-around !important;\r\n  }\r\n\r\n  .align-items-md-start {\r\n    align-items: flex-start !important;\r\n  }\r\n\r\n  .align-items-md-end {\r\n    align-items: flex-end !important;\r\n  }\r\n\r\n  .align-items-md-center {\r\n    align-items: center !important;\r\n  }\r\n\r\n  .align-items-md-baseline {\r\n    align-items: baseline !important;\r\n  }\r\n\r\n  .align-items-md-stretch {\r\n    align-items: stretch !important;\r\n  }\r\n\r\n  .align-content-md-start {\r\n    align-content: flex-start !important;\r\n  }\r\n\r\n  .align-content-md-end {\r\n    align-content: flex-end !important;\r\n  }\r\n\r\n  .align-content-md-center {\r\n    align-content: center !important;\r\n  }\r\n\r\n  .align-content-md-between {\r\n    align-content: space-between !important;\r\n  }\r\n\r\n  .align-content-md-around {\r\n    align-content: space-around !important;\r\n  }\r\n\r\n  .align-content-md-stretch {\r\n    align-content: stretch !important;\r\n  }\r\n\r\n  .align-self-md-auto {\r\n    align-self: auto !important;\r\n  }\r\n\r\n  .align-self-md-start {\r\n    align-self: flex-start !important;\r\n  }\r\n\r\n  .align-self-md-end {\r\n    align-self: flex-end !important;\r\n  }\r\n\r\n  .align-self-md-center {\r\n    align-self: center !important;\r\n  }\r\n\r\n  .align-self-md-baseline {\r\n    align-self: baseline !important;\r\n  }\r\n\r\n  .align-self-md-stretch {\r\n    align-self: stretch !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .flex-lg-row {\r\n    flex-direction: row !important;\r\n  }\r\n\r\n  .flex-lg-column {\r\n    flex-direction: column !important;\r\n  }\r\n\r\n  .flex-lg-row-reverse {\r\n    flex-direction: row-reverse !important;\r\n  }\r\n\r\n  .flex-lg-column-reverse {\r\n    flex-direction: column-reverse !important;\r\n  }\r\n\r\n  .flex-lg-wrap {\r\n    flex-wrap: wrap !important;\r\n  }\r\n\r\n  .flex-lg-nowrap {\r\n    flex-wrap: nowrap !important;\r\n  }\r\n\r\n  .flex-lg-wrap-reverse {\r\n    flex-wrap: wrap-reverse !important;\r\n  }\r\n\r\n  .flex-lg-fill {\r\n    flex: 1 1 auto !important;\r\n  }\r\n\r\n  .flex-lg-grow-0 {\r\n    flex-grow: 0 !important;\r\n  }\r\n\r\n  .flex-lg-grow-1 {\r\n    flex-grow: 1 !important;\r\n  }\r\n\r\n  .flex-lg-shrink-0 {\r\n    flex-shrink: 0 !important;\r\n  }\r\n\r\n  .flex-lg-shrink-1 {\r\n    flex-shrink: 1 !important;\r\n  }\r\n\r\n  .justify-content-lg-start {\r\n    justify-content: flex-start !important;\r\n  }\r\n\r\n  .justify-content-lg-end {\r\n    justify-content: flex-end !important;\r\n  }\r\n\r\n  .justify-content-lg-center {\r\n    justify-content: center !important;\r\n  }\r\n\r\n  .justify-content-lg-between {\r\n    justify-content: space-between !important;\r\n  }\r\n\r\n  .justify-content-lg-around {\r\n    justify-content: space-around !important;\r\n  }\r\n\r\n  .align-items-lg-start {\r\n    align-items: flex-start !important;\r\n  }\r\n\r\n  .align-items-lg-end {\r\n    align-items: flex-end !important;\r\n  }\r\n\r\n  .align-items-lg-center {\r\n    align-items: center !important;\r\n  }\r\n\r\n  .align-items-lg-baseline {\r\n    align-items: baseline !important;\r\n  }\r\n\r\n  .align-items-lg-stretch {\r\n    align-items: stretch !important;\r\n  }\r\n\r\n  .align-content-lg-start {\r\n    align-content: flex-start !important;\r\n  }\r\n\r\n  .align-content-lg-end {\r\n    align-content: flex-end !important;\r\n  }\r\n\r\n  .align-content-lg-center {\r\n    align-content: center !important;\r\n  }\r\n\r\n  .align-content-lg-between {\r\n    align-content: space-between !important;\r\n  }\r\n\r\n  .align-content-lg-around {\r\n    align-content: space-around !important;\r\n  }\r\n\r\n  .align-content-lg-stretch {\r\n    align-content: stretch !important;\r\n  }\r\n\r\n  .align-self-lg-auto {\r\n    align-self: auto !important;\r\n  }\r\n\r\n  .align-self-lg-start {\r\n    align-self: flex-start !important;\r\n  }\r\n\r\n  .align-self-lg-end {\r\n    align-self: flex-end !important;\r\n  }\r\n\r\n  .align-self-lg-center {\r\n    align-self: center !important;\r\n  }\r\n\r\n  .align-self-lg-baseline {\r\n    align-self: baseline !important;\r\n  }\r\n\r\n  .align-self-lg-stretch {\r\n    align-self: stretch !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .flex-xl-row {\r\n    flex-direction: row !important;\r\n  }\r\n\r\n  .flex-xl-column {\r\n    flex-direction: column !important;\r\n  }\r\n\r\n  .flex-xl-row-reverse {\r\n    flex-direction: row-reverse !important;\r\n  }\r\n\r\n  .flex-xl-column-reverse {\r\n    flex-direction: column-reverse !important;\r\n  }\r\n\r\n  .flex-xl-wrap {\r\n    flex-wrap: wrap !important;\r\n  }\r\n\r\n  .flex-xl-nowrap {\r\n    flex-wrap: nowrap !important;\r\n  }\r\n\r\n  .flex-xl-wrap-reverse {\r\n    flex-wrap: wrap-reverse !important;\r\n  }\r\n\r\n  .flex-xl-fill {\r\n    flex: 1 1 auto !important;\r\n  }\r\n\r\n  .flex-xl-grow-0 {\r\n    flex-grow: 0 !important;\r\n  }\r\n\r\n  .flex-xl-grow-1 {\r\n    flex-grow: 1 !important;\r\n  }\r\n\r\n  .flex-xl-shrink-0 {\r\n    flex-shrink: 0 !important;\r\n  }\r\n\r\n  .flex-xl-shrink-1 {\r\n    flex-shrink: 1 !important;\r\n  }\r\n\r\n  .justify-content-xl-start {\r\n    justify-content: flex-start !important;\r\n  }\r\n\r\n  .justify-content-xl-end {\r\n    justify-content: flex-end !important;\r\n  }\r\n\r\n  .justify-content-xl-center {\r\n    justify-content: center !important;\r\n  }\r\n\r\n  .justify-content-xl-between {\r\n    justify-content: space-between !important;\r\n  }\r\n\r\n  .justify-content-xl-around {\r\n    justify-content: space-around !important;\r\n  }\r\n\r\n  .align-items-xl-start {\r\n    align-items: flex-start !important;\r\n  }\r\n\r\n  .align-items-xl-end {\r\n    align-items: flex-end !important;\r\n  }\r\n\r\n  .align-items-xl-center {\r\n    align-items: center !important;\r\n  }\r\n\r\n  .align-items-xl-baseline {\r\n    align-items: baseline !important;\r\n  }\r\n\r\n  .align-items-xl-stretch {\r\n    align-items: stretch !important;\r\n  }\r\n\r\n  .align-content-xl-start {\r\n    align-content: flex-start !important;\r\n  }\r\n\r\n  .align-content-xl-end {\r\n    align-content: flex-end !important;\r\n  }\r\n\r\n  .align-content-xl-center {\r\n    align-content: center !important;\r\n  }\r\n\r\n  .align-content-xl-between {\r\n    align-content: space-between !important;\r\n  }\r\n\r\n  .align-content-xl-around {\r\n    align-content: space-around !important;\r\n  }\r\n\r\n  .align-content-xl-stretch {\r\n    align-content: stretch !important;\r\n  }\r\n\r\n  .align-self-xl-auto {\r\n    align-self: auto !important;\r\n  }\r\n\r\n  .align-self-xl-start {\r\n    align-self: flex-start !important;\r\n  }\r\n\r\n  .align-self-xl-end {\r\n    align-self: flex-end !important;\r\n  }\r\n\r\n  .align-self-xl-center {\r\n    align-self: center !important;\r\n  }\r\n\r\n  .align-self-xl-baseline {\r\n    align-self: baseline !important;\r\n  }\r\n\r\n  .align-self-xl-stretch {\r\n    align-self: stretch !important;\r\n  }\r\n}\r\n\r\n.float-left {\r\n  float: left !important;\r\n}\r\n\r\n.float-right {\r\n  float: right !important;\r\n}\r\n\r\n.float-none {\r\n  float: none !important;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .float-sm-left {\r\n    float: left !important;\r\n  }\r\n\r\n  .float-sm-right {\r\n    float: right !important;\r\n  }\r\n\r\n  .float-sm-none {\r\n    float: none !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .float-md-left {\r\n    float: left !important;\r\n  }\r\n\r\n  .float-md-right {\r\n    float: right !important;\r\n  }\r\n\r\n  .float-md-none {\r\n    float: none !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .float-lg-left {\r\n    float: left !important;\r\n  }\r\n\r\n  .float-lg-right {\r\n    float: right !important;\r\n  }\r\n\r\n  .float-lg-none {\r\n    float: none !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .float-xl-left {\r\n    float: left !important;\r\n  }\r\n\r\n  .float-xl-right {\r\n    float: right !important;\r\n  }\r\n\r\n  .float-xl-none {\r\n    float: none !important;\r\n  }\r\n}\r\n\r\n.overflow-auto {\r\n  overflow: auto !important;\r\n}\r\n\r\n.overflow-hidden {\r\n  overflow: hidden !important;\r\n}\r\n\r\n.position-static {\r\n  position: static !important;\r\n}\r\n\r\n.position-relative {\r\n  position: relative !important;\r\n}\r\n\r\n.position-absolute {\r\n  position: absolute !important;\r\n}\r\n\r\n.position-fixed {\r\n  position: fixed !important;\r\n}\r\n\r\n.position-sticky {\r\n  position: -webkit-sticky !important;\r\n  position: sticky !important;\r\n}\r\n\r\n.fixed-top {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  left: 0;\r\n  z-index: 1030;\r\n}\r\n\r\n.fixed-bottom {\r\n  position: fixed;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: 1030;\r\n}\r\n\r\n@supports ((position: -webkit-sticky) or (position: sticky)) {\r\n  .sticky-top {\r\n    position: -webkit-sticky;\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 1020;\r\n  }\r\n}\r\n\r\n.sr-only {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  white-space: nowrap;\r\n  border: 0;\r\n}\r\n\r\n.sr-only-focusable:active,\r\n.sr-only-focusable:focus {\r\n  position: static;\r\n  width: auto;\r\n  height: auto;\r\n  overflow: visible;\r\n  clip: auto;\r\n  white-space: normal;\r\n}\r\n\r\n.shadow-sm {\r\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\r\n}\r\n\r\n.shadow {\r\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\r\n}\r\n\r\n.shadow-lg {\r\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;\r\n}\r\n\r\n.shadow-none {\r\n  box-shadow: none !important;\r\n}\r\n\r\n.w-25 {\r\n  width: 25% !important;\r\n}\r\n\r\n.w-50 {\r\n  width: 50% !important;\r\n}\r\n\r\n.w-75 {\r\n  width: 75% !important;\r\n}\r\n\r\n.w-100 {\r\n  width: 100% !important;\r\n}\r\n\r\n.w-auto {\r\n  width: auto !important;\r\n}\r\n\r\n.h-25 {\r\n  height: 25% !important;\r\n}\r\n\r\n.h-50 {\r\n  height: 50% !important;\r\n}\r\n\r\n.h-75 {\r\n  height: 75% !important;\r\n}\r\n\r\n.h-100 {\r\n  height: 100% !important;\r\n}\r\n\r\n.h-auto {\r\n  height: auto !important;\r\n}\r\n\r\n.mw-100 {\r\n  max-width: 100% !important;\r\n}\r\n\r\n.mh-100 {\r\n  max-height: 100% !important;\r\n}\r\n\r\n.min-vw-100 {\r\n  min-width: 100vw !important;\r\n}\r\n\r\n.min-vh-100 {\r\n  min-height: 100vh !important;\r\n}\r\n\r\n.vw-100 {\r\n  width: 100vw !important;\r\n}\r\n\r\n.vh-100 {\r\n  height: 100vh !important;\r\n}\r\n\r\n.stretched-link::after {\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: 1;\r\n  pointer-events: auto;\r\n  content: \"\";\r\n  background-color: rgba(0, 0, 0, 0);\r\n}\r\n\r\n.m-0 {\r\n  margin: 0 !important;\r\n}\r\n\r\n.mt-0,\r\n.my-0 {\r\n  margin-top: 0 !important;\r\n}\r\n\r\n.mr-0,\r\n.mx-0 {\r\n  margin-right: 0 !important;\r\n}\r\n\r\n.mb-0,\r\n.my-0 {\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n.ml-0,\r\n.mx-0 {\r\n  margin-left: 0 !important;\r\n}\r\n\r\n.m-1 {\r\n  margin: 0.25rem !important;\r\n}\r\n\r\n.mt-1,\r\n.my-1 {\r\n  margin-top: 0.25rem !important;\r\n}\r\n\r\n.mr-1,\r\n.mx-1 {\r\n  margin-right: 0.25rem !important;\r\n}\r\n\r\n.mb-1,\r\n.my-1 {\r\n  margin-bottom: 0.25rem !important;\r\n}\r\n\r\n.ml-1,\r\n.mx-1 {\r\n  margin-left: 0.25rem !important;\r\n}\r\n\r\n.m-2 {\r\n  margin: 0.5rem !important;\r\n}\r\n\r\n.mt-2,\r\n.my-2 {\r\n  margin-top: 0.5rem !important;\r\n}\r\n\r\n.mr-2,\r\n.mx-2 {\r\n  margin-right: 0.5rem !important;\r\n}\r\n\r\n.mb-2,\r\n.my-2 {\r\n  margin-bottom: 0.5rem !important;\r\n}\r\n\r\n.ml-2,\r\n.mx-2 {\r\n  margin-left: 0.5rem !important;\r\n}\r\n\r\n.m-3 {\r\n  margin: 1rem !important;\r\n}\r\n\r\n.mt-3,\r\n.my-3 {\r\n  margin-top: 1rem !important;\r\n}\r\n\r\n.mr-3,\r\n.mx-3 {\r\n  margin-right: 1rem !important;\r\n}\r\n\r\n.mb-3,\r\n.my-3 {\r\n  margin-bottom: 1rem !important;\r\n}\r\n\r\n.ml-3,\r\n.mx-3 {\r\n  margin-left: 1rem !important;\r\n}\r\n\r\n.m-4 {\r\n  margin: 1.5rem !important;\r\n}\r\n\r\n.mt-4,\r\n.my-4 {\r\n  margin-top: 1.5rem !important;\r\n}\r\n\r\n.mr-4,\r\n.mx-4 {\r\n  margin-right: 1.5rem !important;\r\n}\r\n\r\n.mb-4,\r\n.my-4 {\r\n  margin-bottom: 1.5rem !important;\r\n}\r\n\r\n.ml-4,\r\n.mx-4 {\r\n  margin-left: 1.5rem !important;\r\n}\r\n\r\n.m-5 {\r\n  margin: 3rem !important;\r\n}\r\n\r\n.mt-5,\r\n.my-5 {\r\n  margin-top: 3rem !important;\r\n}\r\n\r\n.mr-5,\r\n.mx-5 {\r\n  margin-right: 3rem !important;\r\n}\r\n\r\n.mb-5,\r\n.my-5 {\r\n  margin-bottom: 3rem !important;\r\n}\r\n\r\n.ml-5,\r\n.mx-5 {\r\n  margin-left: 3rem !important;\r\n}\r\n\r\n.p-0 {\r\n  padding: 0 !important;\r\n}\r\n\r\n.pt-0,\r\n.py-0 {\r\n  padding-top: 0 !important;\r\n}\r\n\r\n.pr-0,\r\n.px-0 {\r\n  padding-right: 0 !important;\r\n}\r\n\r\n.pb-0,\r\n.py-0 {\r\n  padding-bottom: 0 !important;\r\n}\r\n\r\n.pl-0,\r\n.px-0 {\r\n  padding-left: 0 !important;\r\n}\r\n\r\n.p-1 {\r\n  padding: 0.25rem !important;\r\n}\r\n\r\n.pt-1,\r\n.py-1 {\r\n  padding-top: 0.25rem !important;\r\n}\r\n\r\n.pr-1,\r\n.px-1 {\r\n  padding-right: 0.25rem !important;\r\n}\r\n\r\n.pb-1,\r\n.py-1 {\r\n  padding-bottom: 0.25rem !important;\r\n}\r\n\r\n.pl-1,\r\n.px-1 {\r\n  padding-left: 0.25rem !important;\r\n}\r\n\r\n.p-2 {\r\n  padding: 0.5rem !important;\r\n}\r\n\r\n.pt-2,\r\n.py-2 {\r\n  padding-top: 0.5rem !important;\r\n}\r\n\r\n.pr-2,\r\n.px-2 {\r\n  padding-right: 0.5rem !important;\r\n}\r\n\r\n.pb-2,\r\n.py-2 {\r\n  padding-bottom: 0.5rem !important;\r\n}\r\n\r\n.pl-2,\r\n.px-2 {\r\n  padding-left: 0.5rem !important;\r\n}\r\n\r\n.p-3 {\r\n  padding: 1rem !important;\r\n}\r\n\r\n.pt-3,\r\n.py-3 {\r\n  padding-top: 1rem !important;\r\n}\r\n\r\n.pr-3,\r\n.px-3 {\r\n  padding-right: 1rem !important;\r\n}\r\n\r\n.pb-3,\r\n.py-3 {\r\n  padding-bottom: 1rem !important;\r\n}\r\n\r\n.pl-3,\r\n.px-3 {\r\n  padding-left: 1rem !important;\r\n}\r\n\r\n.p-4 {\r\n  padding: 1.5rem !important;\r\n}\r\n\r\n.pt-4,\r\n.py-4 {\r\n  padding-top: 1.5rem !important;\r\n}\r\n\r\n.pr-4,\r\n.px-4 {\r\n  padding-right: 1.5rem !important;\r\n}\r\n\r\n.pb-4,\r\n.py-4 {\r\n  padding-bottom: 1.5rem !important;\r\n}\r\n\r\n.pl-4,\r\n.px-4 {\r\n  padding-left: 1.5rem !important;\r\n}\r\n\r\n.p-5 {\r\n  padding: 3rem !important;\r\n}\r\n\r\n.pt-5,\r\n.py-5 {\r\n  padding-top: 3rem !important;\r\n}\r\n\r\n.pr-5,\r\n.px-5 {\r\n  padding-right: 3rem !important;\r\n}\r\n\r\n.pb-5,\r\n.py-5 {\r\n  padding-bottom: 3rem !important;\r\n}\r\n\r\n.pl-5,\r\n.px-5 {\r\n  padding-left: 3rem !important;\r\n}\r\n\r\n.m-n1 {\r\n  margin: -0.25rem !important;\r\n}\r\n\r\n.mt-n1,\r\n.my-n1 {\r\n  margin-top: -0.25rem !important;\r\n}\r\n\r\n.mr-n1,\r\n.mx-n1 {\r\n  margin-right: -0.25rem !important;\r\n}\r\n\r\n.mb-n1,\r\n.my-n1 {\r\n  margin-bottom: -0.25rem !important;\r\n}\r\n\r\n.ml-n1,\r\n.mx-n1 {\r\n  margin-left: -0.25rem !important;\r\n}\r\n\r\n.m-n2 {\r\n  margin: -0.5rem !important;\r\n}\r\n\r\n.mt-n2,\r\n.my-n2 {\r\n  margin-top: -0.5rem !important;\r\n}\r\n\r\n.mr-n2,\r\n.mx-n2 {\r\n  margin-right: -0.5rem !important;\r\n}\r\n\r\n.mb-n2,\r\n.my-n2 {\r\n  margin-bottom: -0.5rem !important;\r\n}\r\n\r\n.ml-n2,\r\n.mx-n2 {\r\n  margin-left: -0.5rem !important;\r\n}\r\n\r\n.m-n3 {\r\n  margin: -1rem !important;\r\n}\r\n\r\n.mt-n3,\r\n.my-n3 {\r\n  margin-top: -1rem !important;\r\n}\r\n\r\n.mr-n3,\r\n.mx-n3 {\r\n  margin-right: -1rem !important;\r\n}\r\n\r\n.mb-n3,\r\n.my-n3 {\r\n  margin-bottom: -1rem !important;\r\n}\r\n\r\n.ml-n3,\r\n.mx-n3 {\r\n  margin-left: -1rem !important;\r\n}\r\n\r\n.m-n4 {\r\n  margin: -1.5rem !important;\r\n}\r\n\r\n.mt-n4,\r\n.my-n4 {\r\n  margin-top: -1.5rem !important;\r\n}\r\n\r\n.mr-n4,\r\n.mx-n4 {\r\n  margin-right: -1.5rem !important;\r\n}\r\n\r\n.mb-n4,\r\n.my-n4 {\r\n  margin-bottom: -1.5rem !important;\r\n}\r\n\r\n.ml-n4,\r\n.mx-n4 {\r\n  margin-left: -1.5rem !important;\r\n}\r\n\r\n.m-n5 {\r\n  margin: -3rem !important;\r\n}\r\n\r\n.mt-n5,\r\n.my-n5 {\r\n  margin-top: -3rem !important;\r\n}\r\n\r\n.mr-n5,\r\n.mx-n5 {\r\n  margin-right: -3rem !important;\r\n}\r\n\r\n.mb-n5,\r\n.my-n5 {\r\n  margin-bottom: -3rem !important;\r\n}\r\n\r\n.ml-n5,\r\n.mx-n5 {\r\n  margin-left: -3rem !important;\r\n}\r\n\r\n.m-auto {\r\n  margin: auto !important;\r\n}\r\n\r\n.mt-auto,\r\n.my-auto {\r\n  margin-top: auto !important;\r\n}\r\n\r\n.mr-auto,\r\n.mx-auto {\r\n  margin-right: auto !important;\r\n}\r\n\r\n.mb-auto,\r\n.my-auto {\r\n  margin-bottom: auto !important;\r\n}\r\n\r\n\r\n\r\n@media (min-width: 576px) {\r\n  .m-sm-0 {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  .mt-sm-0,\r\n  .my-sm-0 {\r\n    margin-top: 0 !important;\r\n  }\r\n\r\n  .mr-sm-0,\r\n  .mx-sm-0 {\r\n    margin-right: 0 !important;\r\n  }\r\n\r\n  .mb-sm-0,\r\n  .my-sm-0 {\r\n    margin-bottom: 0 !important;\r\n  }\r\n\r\n  .ml-sm-0,\r\n  .mx-sm-0 {\r\n    margin-left: 0 !important;\r\n  }\r\n\r\n  .m-sm-1 {\r\n    margin: 0.25rem !important;\r\n  }\r\n\r\n  .mt-sm-1,\r\n  .my-sm-1 {\r\n    margin-top: 0.25rem !important;\r\n  }\r\n\r\n  .mr-sm-1,\r\n  .mx-sm-1 {\r\n    margin-right: 0.25rem !important;\r\n  }\r\n\r\n  .mb-sm-1,\r\n  .my-sm-1 {\r\n    margin-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .ml-sm-1,\r\n  .mx-sm-1 {\r\n    margin-left: 0.25rem !important;\r\n  }\r\n\r\n  .m-sm-2 {\r\n    margin: 0.5rem !important;\r\n  }\r\n\r\n  .mt-sm-2,\r\n  .my-sm-2 {\r\n    margin-top: 0.5rem !important;\r\n  }\r\n\r\n  .mr-sm-2,\r\n  .mx-sm-2 {\r\n    margin-right: 0.5rem !important;\r\n  }\r\n\r\n  .mb-sm-2,\r\n  .my-sm-2 {\r\n    margin-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .ml-sm-2,\r\n  .mx-sm-2 {\r\n    margin-left: 0.5rem !important;\r\n  }\r\n\r\n  .m-sm-3 {\r\n    margin: 1rem !important;\r\n  }\r\n\r\n  .mt-sm-3,\r\n  .my-sm-3 {\r\n    margin-top: 1rem !important;\r\n  }\r\n\r\n  .mr-sm-3,\r\n  .mx-sm-3 {\r\n    margin-right: 1rem !important;\r\n  }\r\n\r\n  .mb-sm-3,\r\n  .my-sm-3 {\r\n    margin-bottom: 1rem !important;\r\n  }\r\n\r\n  .ml-sm-3,\r\n  .mx-sm-3 {\r\n    margin-left: 1rem !important;\r\n  }\r\n\r\n  .m-sm-4 {\r\n    margin: 1.5rem !important;\r\n  }\r\n\r\n  .mt-sm-4,\r\n  .my-sm-4 {\r\n    margin-top: 1.5rem !important;\r\n  }\r\n\r\n  .mr-sm-4,\r\n  .mx-sm-4 {\r\n    margin-right: 1.5rem !important;\r\n  }\r\n\r\n  .mb-sm-4,\r\n  .my-sm-4 {\r\n    margin-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .ml-sm-4,\r\n  .mx-sm-4 {\r\n    margin-left: 1.5rem !important;\r\n  }\r\n\r\n  .m-sm-5 {\r\n    margin: 3rem !important;\r\n  }\r\n\r\n  .mt-sm-5,\r\n  .my-sm-5 {\r\n    margin-top: 3rem !important;\r\n  }\r\n\r\n  .mr-sm-5,\r\n  .mx-sm-5 {\r\n    margin-right: 3rem !important;\r\n  }\r\n\r\n  .mb-sm-5,\r\n  .my-sm-5 {\r\n    margin-bottom: 3rem !important;\r\n  }\r\n\r\n  .ml-sm-5,\r\n  .mx-sm-5 {\r\n    margin-left: 3rem !important;\r\n  }\r\n\r\n  .p-sm-0 {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .pt-sm-0,\r\n  .py-sm-0 {\r\n    padding-top: 0 !important;\r\n  }\r\n\r\n  .pr-sm-0,\r\n  .px-sm-0 {\r\n    padding-right: 0 !important;\r\n  }\r\n\r\n  .pb-sm-0,\r\n  .py-sm-0 {\r\n    padding-bottom: 0 !important;\r\n  }\r\n\r\n  .pl-sm-0,\r\n  .px-sm-0 {\r\n    padding-left: 0 !important;\r\n  }\r\n\r\n  .p-sm-1 {\r\n    padding: 0.25rem !important;\r\n  }\r\n\r\n  .pt-sm-1,\r\n  .py-sm-1 {\r\n    padding-top: 0.25rem !important;\r\n  }\r\n\r\n  .pr-sm-1,\r\n  .px-sm-1 {\r\n    padding-right: 0.25rem !important;\r\n  }\r\n\r\n  .pb-sm-1,\r\n  .py-sm-1 {\r\n    padding-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .pl-sm-1,\r\n  .px-sm-1 {\r\n    padding-left: 0.25rem !important;\r\n  }\r\n\r\n  .p-sm-2 {\r\n    padding: 0.5rem !important;\r\n  }\r\n\r\n  .pt-sm-2,\r\n  .py-sm-2 {\r\n    padding-top: 0.5rem !important;\r\n  }\r\n\r\n  .pr-sm-2,\r\n  .px-sm-2 {\r\n    padding-right: 0.5rem !important;\r\n  }\r\n\r\n  .pb-sm-2,\r\n  .py-sm-2 {\r\n    padding-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .pl-sm-2,\r\n  .px-sm-2 {\r\n    padding-left: 0.5rem !important;\r\n  }\r\n\r\n  .p-sm-3 {\r\n    padding: 1rem !important;\r\n  }\r\n\r\n  .pt-sm-3,\r\n  .py-sm-3 {\r\n    padding-top: 1rem !important;\r\n  }\r\n\r\n  .pr-sm-3,\r\n  .px-sm-3 {\r\n    padding-right: 1rem !important;\r\n  }\r\n\r\n  .pb-sm-3,\r\n  .py-sm-3 {\r\n    padding-bottom: 1rem !important;\r\n  }\r\n\r\n  .pl-sm-3,\r\n  .px-sm-3 {\r\n    padding-left: 1rem !important;\r\n  }\r\n\r\n  .p-sm-4 {\r\n    padding: 1.5rem !important;\r\n  }\r\n\r\n  .pt-sm-4,\r\n  .py-sm-4 {\r\n    padding-top: 1.5rem !important;\r\n  }\r\n\r\n  .pr-sm-4,\r\n  .px-sm-4 {\r\n    padding-right: 1.5rem !important;\r\n  }\r\n\r\n  .pb-sm-4,\r\n  .py-sm-4 {\r\n    padding-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .pl-sm-4,\r\n  .px-sm-4 {\r\n    padding-left: 1.5rem !important;\r\n  }\r\n\r\n  .p-sm-5 {\r\n    padding: 3rem !important;\r\n  }\r\n\r\n  .pt-sm-5,\r\n  .py-sm-5 {\r\n    padding-top: 3rem !important;\r\n  }\r\n\r\n  .pr-sm-5,\r\n  .px-sm-5 {\r\n    padding-right: 3rem !important;\r\n  }\r\n\r\n  .pb-sm-5,\r\n  .py-sm-5 {\r\n    padding-bottom: 3rem !important;\r\n  }\r\n\r\n  .pl-sm-5,\r\n  .px-sm-5 {\r\n    padding-left: 3rem !important;\r\n  }\r\n\r\n  .m-sm-n1 {\r\n    margin: -0.25rem !important;\r\n  }\r\n\r\n  .mt-sm-n1,\r\n  .my-sm-n1 {\r\n    margin-top: -0.25rem !important;\r\n  }\r\n\r\n  .mr-sm-n1,\r\n  .mx-sm-n1 {\r\n    margin-right: -0.25rem !important;\r\n  }\r\n\r\n  .mb-sm-n1,\r\n  .my-sm-n1 {\r\n    margin-bottom: -0.25rem !important;\r\n  }\r\n\r\n  .ml-sm-n1,\r\n  .mx-sm-n1 {\r\n    margin-left: -0.25rem !important;\r\n  }\r\n\r\n  .m-sm-n2 {\r\n    margin: -0.5rem !important;\r\n  }\r\n\r\n  .mt-sm-n2,\r\n  .my-sm-n2 {\r\n    margin-top: -0.5rem !important;\r\n  }\r\n\r\n  .mr-sm-n2,\r\n  .mx-sm-n2 {\r\n    margin-right: -0.5rem !important;\r\n  }\r\n\r\n  .mb-sm-n2,\r\n  .my-sm-n2 {\r\n    margin-bottom: -0.5rem !important;\r\n  }\r\n\r\n  .ml-sm-n2,\r\n  .mx-sm-n2 {\r\n    margin-left: -0.5rem !important;\r\n  }\r\n\r\n  .m-sm-n3 {\r\n    margin: -1rem !important;\r\n  }\r\n\r\n  .mt-sm-n3,\r\n  .my-sm-n3 {\r\n    margin-top: -1rem !important;\r\n  }\r\n\r\n  .mr-sm-n3,\r\n  .mx-sm-n3 {\r\n    margin-right: -1rem !important;\r\n  }\r\n\r\n  .mb-sm-n3,\r\n  .my-sm-n3 {\r\n    margin-bottom: -1rem !important;\r\n  }\r\n\r\n  .ml-sm-n3,\r\n  .mx-sm-n3 {\r\n    margin-left: -1rem !important;\r\n  }\r\n\r\n  .m-sm-n4 {\r\n    margin: -1.5rem !important;\r\n  }\r\n\r\n  .mt-sm-n4,\r\n  .my-sm-n4 {\r\n    margin-top: -1.5rem !important;\r\n  }\r\n\r\n  .mr-sm-n4,\r\n  .mx-sm-n4 {\r\n    margin-right: -1.5rem !important;\r\n  }\r\n\r\n  .mb-sm-n4,\r\n  .my-sm-n4 {\r\n    margin-bottom: -1.5rem !important;\r\n  }\r\n\r\n  .ml-sm-n4,\r\n  .mx-sm-n4 {\r\n    margin-left: -1.5rem !important;\r\n  }\r\n\r\n  .m-sm-n5 {\r\n    margin: -3rem !important;\r\n  }\r\n\r\n  .mt-sm-n5,\r\n  .my-sm-n5 {\r\n    margin-top: -3rem !important;\r\n  }\r\n\r\n  .mr-sm-n5,\r\n  .mx-sm-n5 {\r\n    margin-right: -3rem !important;\r\n  }\r\n\r\n  .mb-sm-n5,\r\n  .my-sm-n5 {\r\n    margin-bottom: -3rem !important;\r\n  }\r\n\r\n  .ml-sm-n5,\r\n  .mx-sm-n5 {\r\n    margin-left: -3rem !important;\r\n  }\r\n\r\n  .m-sm-auto {\r\n    margin: auto !important;\r\n  }\r\n\r\n  .mt-sm-auto,\r\n  .my-sm-auto {\r\n    margin-top: auto !important;\r\n  }\r\n\r\n  .mr-sm-auto,\r\n  .mx-sm-auto {\r\n    margin-right: auto !important;\r\n  }\r\n\r\n  .mb-sm-auto,\r\n  .my-sm-auto {\r\n    margin-bottom: auto !important;\r\n  }\r\n\r\n  .ml-sm-auto,\r\n  .mx-sm-auto {\r\n    margin-left: auto !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .m-md-0 {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  .mt-md-0,\r\n  .my-md-0 {\r\n    margin-top: 0 !important;\r\n  }\r\n\r\n  .mr-md-0,\r\n  .mx-md-0 {\r\n    margin-right: 0 !important;\r\n  }\r\n\r\n  .mb-md-0,\r\n  .my-md-0 {\r\n    margin-bottom: 0 !important;\r\n  }\r\n\r\n  .ml-md-0,\r\n  .mx-md-0 {\r\n    margin-left: 0 !important;\r\n  }\r\n\r\n  .m-md-1 {\r\n    margin: 0.25rem !important;\r\n  }\r\n\r\n  .mt-md-1,\r\n  .my-md-1 {\r\n    margin-top: 0.25rem !important;\r\n  }\r\n\r\n  .mr-md-1,\r\n  .mx-md-1 {\r\n    margin-right: 0.25rem !important;\r\n  }\r\n\r\n  .mb-md-1,\r\n  .my-md-1 {\r\n    margin-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .ml-md-1,\r\n  .mx-md-1 {\r\n    margin-left: 0.25rem !important;\r\n  }\r\n\r\n  .m-md-2 {\r\n    margin: 0.5rem !important;\r\n  }\r\n\r\n  .mt-md-2,\r\n  .my-md-2 {\r\n    margin-top: 0.5rem !important;\r\n  }\r\n\r\n  .mr-md-2,\r\n  .mx-md-2 {\r\n    margin-right: 0.5rem !important;\r\n  }\r\n\r\n  .mb-md-2,\r\n  .my-md-2 {\r\n    margin-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .ml-md-2,\r\n  .mx-md-2 {\r\n    margin-left: 0.5rem !important;\r\n  }\r\n\r\n  .m-md-3 {\r\n    margin: 1rem !important;\r\n  }\r\n\r\n  .mt-md-3,\r\n  .my-md-3 {\r\n    margin-top: 1rem !important;\r\n  }\r\n\r\n  .mr-md-3,\r\n  .mx-md-3 {\r\n    margin-right: 1rem !important;\r\n  }\r\n\r\n  .mb-md-3,\r\n  .my-md-3 {\r\n    margin-bottom: 1rem !important;\r\n  }\r\n\r\n  .ml-md-3,\r\n  .mx-md-3 {\r\n    margin-left: 1rem !important;\r\n  }\r\n\r\n  .m-md-4 {\r\n    margin: 1.5rem !important;\r\n  }\r\n\r\n  .mt-md-4,\r\n  .my-md-4 {\r\n    margin-top: 1.5rem !important;\r\n  }\r\n\r\n  .mr-md-4,\r\n  .mx-md-4 {\r\n    margin-right: 1.5rem !important;\r\n  }\r\n\r\n  .mb-md-4,\r\n  .my-md-4 {\r\n    margin-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .ml-md-4,\r\n  .mx-md-4 {\r\n    margin-left: 1.5rem !important;\r\n  }\r\n\r\n  .m-md-5 {\r\n    margin: 3rem !important;\r\n  }\r\n\r\n  .mt-md-5,\r\n  .my-md-5 {\r\n    margin-top: 3rem !important;\r\n  }\r\n\r\n  .mr-md-5,\r\n  .mx-md-5 {\r\n    margin-right: 3rem !important;\r\n  }\r\n\r\n  .mb-md-5,\r\n  .my-md-5 {\r\n    margin-bottom: 3rem !important;\r\n  }\r\n\r\n  .ml-md-5,\r\n  .mx-md-5 {\r\n    margin-left: 3rem !important;\r\n  }\r\n\r\n  .p-md-0 {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .pt-md-0,\r\n  .py-md-0 {\r\n    padding-top: 0 !important;\r\n  }\r\n\r\n  .pr-md-0,\r\n  .px-md-0 {\r\n    padding-right: 0 !important;\r\n  }\r\n\r\n  .pb-md-0,\r\n  .py-md-0 {\r\n    padding-bottom: 0 !important;\r\n  }\r\n\r\n  .pl-md-0,\r\n  .px-md-0 {\r\n    padding-left: 0 !important;\r\n  }\r\n\r\n  .p-md-1 {\r\n    padding: 0.25rem !important;\r\n  }\r\n\r\n  .pt-md-1,\r\n  .py-md-1 {\r\n    padding-top: 0.25rem !important;\r\n  }\r\n\r\n  .pr-md-1,\r\n  .px-md-1 {\r\n    padding-right: 0.25rem !important;\r\n  }\r\n\r\n  .pb-md-1,\r\n  .py-md-1 {\r\n    padding-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .pl-md-1,\r\n  .px-md-1 {\r\n    padding-left: 0.25rem !important;\r\n  }\r\n\r\n  .p-md-2 {\r\n    padding: 0.5rem !important;\r\n  }\r\n\r\n  .pt-md-2,\r\n  .py-md-2 {\r\n    padding-top: 0.5rem !important;\r\n  }\r\n\r\n  .pr-md-2,\r\n  .px-md-2 {\r\n    padding-right: 0.5rem !important;\r\n  }\r\n\r\n  .pb-md-2,\r\n  .py-md-2 {\r\n    padding-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .pl-md-2,\r\n  .px-md-2 {\r\n    padding-left: 0.5rem !important;\r\n  }\r\n\r\n  .p-md-3 {\r\n    padding: 1rem !important;\r\n  }\r\n\r\n  .pt-md-3,\r\n  .py-md-3 {\r\n    padding-top: 1rem !important;\r\n  }\r\n\r\n  .pr-md-3,\r\n  .px-md-3 {\r\n    padding-right: 1rem !important;\r\n  }\r\n\r\n  .pb-md-3,\r\n  .py-md-3 {\r\n    padding-bottom: 1rem !important;\r\n  }\r\n\r\n  .pl-md-3,\r\n  .px-md-3 {\r\n    padding-left: 1rem !important;\r\n  }\r\n\r\n  .p-md-4 {\r\n    padding: 1.5rem !important;\r\n  }\r\n\r\n  .pt-md-4,\r\n  .py-md-4 {\r\n    padding-top: 1.5rem !important;\r\n  }\r\n\r\n  .pr-md-4,\r\n  .px-md-4 {\r\n    padding-right: 1.5rem !important;\r\n  }\r\n\r\n  .pb-md-4,\r\n  .py-md-4 {\r\n    padding-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .pl-md-4,\r\n  .px-md-4 {\r\n    padding-left: 1.5rem !important;\r\n  }\r\n\r\n  .p-md-5 {\r\n    padding: 3rem !important;\r\n  }\r\n\r\n  .pt-md-5,\r\n  .py-md-5 {\r\n    padding-top: 3rem !important;\r\n  }\r\n\r\n  .pr-md-5,\r\n  .px-md-5 {\r\n    padding-right: 3rem !important;\r\n  }\r\n\r\n  .pb-md-5,\r\n  .py-md-5 {\r\n    padding-bottom: 3rem !important;\r\n  }\r\n\r\n  .pl-md-5,\r\n  .px-md-5 {\r\n    padding-left: 3rem !important;\r\n  }\r\n\r\n  .m-md-n1 {\r\n    margin: -0.25rem !important;\r\n  }\r\n\r\n  .mt-md-n1,\r\n  .my-md-n1 {\r\n    margin-top: -0.25rem !important;\r\n  }\r\n\r\n  .mr-md-n1,\r\n  .mx-md-n1 {\r\n    margin-right: -0.25rem !important;\r\n  }\r\n\r\n  .mb-md-n1,\r\n  .my-md-n1 {\r\n    margin-bottom: -0.25rem !important;\r\n  }\r\n\r\n  .ml-md-n1,\r\n  .mx-md-n1 {\r\n    margin-left: -0.25rem !important;\r\n  }\r\n\r\n  .m-md-n2 {\r\n    margin: -0.5rem !important;\r\n  }\r\n\r\n  .mt-md-n2,\r\n  .my-md-n2 {\r\n    margin-top: -0.5rem !important;\r\n  }\r\n\r\n  .mr-md-n2,\r\n  .mx-md-n2 {\r\n    margin-right: -0.5rem !important;\r\n  }\r\n\r\n  .mb-md-n2,\r\n  .my-md-n2 {\r\n    margin-bottom: -0.5rem !important;\r\n  }\r\n\r\n  .ml-md-n2,\r\n  .mx-md-n2 {\r\n    margin-left: -0.5rem !important;\r\n  }\r\n\r\n  .m-md-n3 {\r\n    margin: -1rem !important;\r\n  }\r\n\r\n  .mt-md-n3,\r\n  .my-md-n3 {\r\n    margin-top: -1rem !important;\r\n  }\r\n\r\n  .mr-md-n3,\r\n  .mx-md-n3 {\r\n    margin-right: -1rem !important;\r\n  }\r\n\r\n  .mb-md-n3,\r\n  .my-md-n3 {\r\n    margin-bottom: -1rem !important;\r\n  }\r\n\r\n  .ml-md-n3,\r\n  .mx-md-n3 {\r\n    margin-left: -1rem !important;\r\n  }\r\n\r\n  .m-md-n4 {\r\n    margin: -1.5rem !important;\r\n  }\r\n\r\n  .mt-md-n4,\r\n  .my-md-n4 {\r\n    margin-top: -1.5rem !important;\r\n  }\r\n\r\n  .mr-md-n4,\r\n  .mx-md-n4 {\r\n    margin-right: -1.5rem !important;\r\n  }\r\n\r\n  .mb-md-n4,\r\n  .my-md-n4 {\r\n    margin-bottom: -1.5rem !important;\r\n  }\r\n\r\n  .ml-md-n4,\r\n  .mx-md-n4 {\r\n    margin-left: -1.5rem !important;\r\n  }\r\n\r\n  .m-md-n5 {\r\n    margin: -3rem !important;\r\n  }\r\n\r\n  .mt-md-n5,\r\n  .my-md-n5 {\r\n    margin-top: -3rem !important;\r\n  }\r\n\r\n  .mr-md-n5,\r\n  .mx-md-n5 {\r\n    margin-right: -3rem !important;\r\n  }\r\n\r\n  .mb-md-n5,\r\n  .my-md-n5 {\r\n    margin-bottom: -3rem !important;\r\n  }\r\n\r\n  .ml-md-n5,\r\n  .mx-md-n5 {\r\n    margin-left: -3rem !important;\r\n  }\r\n\r\n  .m-md-auto {\r\n    margin: auto !important;\r\n  }\r\n\r\n  .mt-md-auto,\r\n  .my-md-auto {\r\n    margin-top: auto !important;\r\n  }\r\n\r\n  .mr-md-auto,\r\n  .mx-md-auto {\r\n    margin-right: auto !important;\r\n  }\r\n\r\n  .mb-md-auto,\r\n  .my-md-auto {\r\n    margin-bottom: auto !important;\r\n  }\r\n\r\n  .ml-md-auto,\r\n  .mx-md-auto {\r\n    margin-left: auto !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .m-lg-0 {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  .mt-lg-0,\r\n  .my-lg-0 {\r\n    margin-top: 0 !important;\r\n  }\r\n\r\n  .mr-lg-0,\r\n  .mx-lg-0 {\r\n    margin-right: 0 !important;\r\n  }\r\n\r\n  .mb-lg-0,\r\n  .my-lg-0 {\r\n    margin-bottom: 0 !important;\r\n  }\r\n\r\n  .ml-lg-0,\r\n  .mx-lg-0 {\r\n    margin-left: 0 !important;\r\n  }\r\n\r\n  .m-lg-1 {\r\n    margin: 0.25rem !important;\r\n  }\r\n\r\n  .mt-lg-1,\r\n  .my-lg-1 {\r\n    margin-top: 0.25rem !important;\r\n  }\r\n\r\n  .mr-lg-1,\r\n  .mx-lg-1 {\r\n    margin-right: 0.25rem !important;\r\n  }\r\n\r\n  .mb-lg-1,\r\n  .my-lg-1 {\r\n    margin-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .ml-lg-1,\r\n  .mx-lg-1 {\r\n    margin-left: 0.25rem !important;\r\n  }\r\n\r\n  .m-lg-2 {\r\n    margin: 0.5rem !important;\r\n  }\r\n\r\n  .mt-lg-2,\r\n  .my-lg-2 {\r\n    margin-top: 0.5rem !important;\r\n  }\r\n\r\n  .mr-lg-2,\r\n  .mx-lg-2 {\r\n    margin-right: 0.5rem !important;\r\n  }\r\n\r\n  .mb-lg-2,\r\n  .my-lg-2 {\r\n    margin-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .ml-lg-2,\r\n  .mx-lg-2 {\r\n    margin-left: 0.5rem !important;\r\n  }\r\n\r\n  .m-lg-3 {\r\n    margin: 1rem !important;\r\n  }\r\n\r\n  .mt-lg-3,\r\n  .my-lg-3 {\r\n    margin-top: 1rem !important;\r\n  }\r\n\r\n  .mr-lg-3,\r\n  .mx-lg-3 {\r\n    margin-right: 1rem !important;\r\n  }\r\n\r\n  .mb-lg-3,\r\n  .my-lg-3 {\r\n    margin-bottom: 1rem !important;\r\n  }\r\n\r\n  .ml-lg-3,\r\n  .mx-lg-3 {\r\n    margin-left: 1rem !important;\r\n  }\r\n\r\n  .m-lg-4 {\r\n    margin: 1.5rem !important;\r\n  }\r\n\r\n  .mt-lg-4,\r\n  .my-lg-4 {\r\n    margin-top: 1.5rem !important;\r\n  }\r\n\r\n  .mr-lg-4,\r\n  .mx-lg-4 {\r\n    margin-right: 1.5rem !important;\r\n  }\r\n\r\n  .mb-lg-4,\r\n  .my-lg-4 {\r\n    margin-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .ml-lg-4,\r\n  .mx-lg-4 {\r\n    margin-left: 1.5rem !important;\r\n  }\r\n\r\n  .m-lg-5 {\r\n    margin: 3rem !important;\r\n  }\r\n\r\n  .mt-lg-5,\r\n  .my-lg-5 {\r\n    margin-top: 3rem !important;\r\n  }\r\n\r\n  .mr-lg-5,\r\n  .mx-lg-5 {\r\n    margin-right: 3rem !important;\r\n  }\r\n\r\n  .mb-lg-5,\r\n  .my-lg-5 {\r\n    margin-bottom: 3rem !important;\r\n  }\r\n\r\n  .ml-lg-5,\r\n  .mx-lg-5 {\r\n    margin-left: 3rem !important;\r\n  }\r\n\r\n  .p-lg-0 {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .pt-lg-0,\r\n  .py-lg-0 {\r\n    padding-top: 0 !important;\r\n  }\r\n\r\n  .pr-lg-0,\r\n  .px-lg-0 {\r\n    padding-right: 0 !important;\r\n  }\r\n\r\n  .pb-lg-0,\r\n  .py-lg-0 {\r\n    padding-bottom: 0 !important;\r\n  }\r\n\r\n  .pl-lg-0,\r\n  .px-lg-0 {\r\n    padding-left: 0 !important;\r\n  }\r\n\r\n  .p-lg-1 {\r\n    padding: 0.25rem !important;\r\n  }\r\n\r\n  .pt-lg-1,\r\n  .py-lg-1 {\r\n    padding-top: 0.25rem !important;\r\n  }\r\n\r\n  .pr-lg-1,\r\n  .px-lg-1 {\r\n    padding-right: 0.25rem !important;\r\n  }\r\n\r\n  .pb-lg-1,\r\n  .py-lg-1 {\r\n    padding-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .pl-lg-1,\r\n  .px-lg-1 {\r\n    padding-left: 0.25rem !important;\r\n  }\r\n\r\n  .p-lg-2 {\r\n    padding: 0.5rem !important;\r\n  }\r\n\r\n  .pt-lg-2,\r\n  .py-lg-2 {\r\n    padding-top: 0.5rem !important;\r\n  }\r\n\r\n  .pr-lg-2,\r\n  .px-lg-2 {\r\n    padding-right: 0.5rem !important;\r\n  }\r\n\r\n  .pb-lg-2,\r\n  .py-lg-2 {\r\n    padding-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .pl-lg-2,\r\n  .px-lg-2 {\r\n    padding-left: 0.5rem !important;\r\n  }\r\n\r\n  .p-lg-3 {\r\n    padding: 1rem !important;\r\n  }\r\n\r\n  .pt-lg-3,\r\n  .py-lg-3 {\r\n    padding-top: 1rem !important;\r\n  }\r\n\r\n  .pr-lg-3,\r\n  .px-lg-3 {\r\n    padding-right: 1rem !important;\r\n  }\r\n\r\n  .pb-lg-3,\r\n  .py-lg-3 {\r\n    padding-bottom: 1rem !important;\r\n  }\r\n\r\n  .pl-lg-3,\r\n  .px-lg-3 {\r\n    padding-left: 1rem !important;\r\n  }\r\n\r\n  .p-lg-4 {\r\n    padding: 1.5rem !important;\r\n  }\r\n\r\n  .pt-lg-4,\r\n  .py-lg-4 {\r\n    padding-top: 1.5rem !important;\r\n  }\r\n\r\n  .pr-lg-4,\r\n  .px-lg-4 {\r\n    padding-right: 1.5rem !important;\r\n  }\r\n\r\n  .pb-lg-4,\r\n  .py-lg-4 {\r\n    padding-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .pl-lg-4,\r\n  .px-lg-4 {\r\n    padding-left: 1.5rem !important;\r\n  }\r\n\r\n  .p-lg-5 {\r\n    padding: 3rem !important;\r\n  }\r\n\r\n  .pt-lg-5,\r\n  .py-lg-5 {\r\n    padding-top: 3rem !important;\r\n  }\r\n\r\n  .pr-lg-5,\r\n  .px-lg-5 {\r\n    padding-right: 3rem !important;\r\n  }\r\n\r\n  .pb-lg-5,\r\n  .py-lg-5 {\r\n    padding-bottom: 3rem !important;\r\n  }\r\n\r\n  .pl-lg-5,\r\n  .px-lg-5 {\r\n    padding-left: 3rem !important;\r\n  }\r\n\r\n  .m-lg-n1 {\r\n    margin: -0.25rem !important;\r\n  }\r\n\r\n  .mt-lg-n1,\r\n  .my-lg-n1 {\r\n    margin-top: -0.25rem !important;\r\n  }\r\n\r\n  .mr-lg-n1,\r\n  .mx-lg-n1 {\r\n    margin-right: -0.25rem !important;\r\n  }\r\n\r\n  .mb-lg-n1,\r\n  .my-lg-n1 {\r\n    margin-bottom: -0.25rem !important;\r\n  }\r\n\r\n  .ml-lg-n1,\r\n  .mx-lg-n1 {\r\n    margin-left: -0.25rem !important;\r\n  }\r\n\r\n  .m-lg-n2 {\r\n    margin: -0.5rem !important;\r\n  }\r\n\r\n  .mt-lg-n2,\r\n  .my-lg-n2 {\r\n    margin-top: -0.5rem !important;\r\n  }\r\n\r\n  .mr-lg-n2,\r\n  .mx-lg-n2 {\r\n    margin-right: -0.5rem !important;\r\n  }\r\n\r\n  .mb-lg-n2,\r\n  .my-lg-n2 {\r\n    margin-bottom: -0.5rem !important;\r\n  }\r\n\r\n  .ml-lg-n2,\r\n  .mx-lg-n2 {\r\n    margin-left: -0.5rem !important;\r\n  }\r\n\r\n  .m-lg-n3 {\r\n    margin: -1rem !important;\r\n  }\r\n\r\n  .mt-lg-n3,\r\n  .my-lg-n3 {\r\n    margin-top: -1rem !important;\r\n  }\r\n\r\n  .mr-lg-n3,\r\n  .mx-lg-n3 {\r\n    margin-right: -1rem !important;\r\n  }\r\n\r\n  .mb-lg-n3,\r\n  .my-lg-n3 {\r\n    margin-bottom: -1rem !important;\r\n  }\r\n\r\n  .ml-lg-n3,\r\n  .mx-lg-n3 {\r\n    margin-left: -1rem !important;\r\n  }\r\n\r\n  .m-lg-n4 {\r\n    margin: -1.5rem !important;\r\n  }\r\n\r\n  .mt-lg-n4,\r\n  .my-lg-n4 {\r\n    margin-top: -1.5rem !important;\r\n  }\r\n\r\n  .mr-lg-n4,\r\n  .mx-lg-n4 {\r\n    margin-right: -1.5rem !important;\r\n  }\r\n\r\n  .mb-lg-n4,\r\n  .my-lg-n4 {\r\n    margin-bottom: -1.5rem !important;\r\n  }\r\n\r\n  .ml-lg-n4,\r\n  .mx-lg-n4 {\r\n    margin-left: -1.5rem !important;\r\n  }\r\n\r\n  .m-lg-n5 {\r\n    margin: -3rem !important;\r\n  }\r\n\r\n  .mt-lg-n5,\r\n  .my-lg-n5 {\r\n    margin-top: -3rem !important;\r\n  }\r\n\r\n  .mr-lg-n5,\r\n  .mx-lg-n5 {\r\n    margin-right: -3rem !important;\r\n  }\r\n\r\n  .mb-lg-n5,\r\n  .my-lg-n5 {\r\n    margin-bottom: -3rem !important;\r\n  }\r\n\r\n  .ml-lg-n5,\r\n  .mx-lg-n5 {\r\n    margin-left: -3rem !important;\r\n  }\r\n\r\n  .m-lg-auto {\r\n    margin: auto !important;\r\n  }\r\n\r\n  .mt-lg-auto,\r\n  .my-lg-auto {\r\n    margin-top: auto !important;\r\n  }\r\n\r\n  .mr-lg-auto,\r\n  .mx-lg-auto {\r\n    margin-right: auto !important;\r\n  }\r\n\r\n  .mb-lg-auto,\r\n  .my-lg-auto {\r\n    margin-bottom: auto !important;\r\n  }\r\n\r\n  .ml-lg-auto,\r\n  .mx-lg-auto {\r\n    margin-left: auto !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .m-xl-0 {\r\n    margin: 0 !important;\r\n  }\r\n\r\n  .mt-xl-0,\r\n  .my-xl-0 {\r\n    margin-top: 0 !important;\r\n  }\r\n\r\n  .mr-xl-0,\r\n  .mx-xl-0 {\r\n    margin-right: 0 !important;\r\n  }\r\n\r\n  .mb-xl-0,\r\n  .my-xl-0 {\r\n    margin-bottom: 0 !important;\r\n  }\r\n\r\n  .ml-xl-0,\r\n  .mx-xl-0 {\r\n    margin-left: 0 !important;\r\n  }\r\n\r\n  .m-xl-1 {\r\n    margin: 0.25rem !important;\r\n  }\r\n\r\n  .mt-xl-1,\r\n  .my-xl-1 {\r\n    margin-top: 0.25rem !important;\r\n  }\r\n\r\n  .mr-xl-1,\r\n  .mx-xl-1 {\r\n    margin-right: 0.25rem !important;\r\n  }\r\n\r\n  .mb-xl-1,\r\n  .my-xl-1 {\r\n    margin-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .ml-xl-1,\r\n  .mx-xl-1 {\r\n    margin-left: 0.25rem !important;\r\n  }\r\n\r\n  .m-xl-2 {\r\n    margin: 0.5rem !important;\r\n  }\r\n\r\n  .mt-xl-2,\r\n  .my-xl-2 {\r\n    margin-top: 0.5rem !important;\r\n  }\r\n\r\n  .mr-xl-2,\r\n  .mx-xl-2 {\r\n    margin-right: 0.5rem !important;\r\n  }\r\n\r\n  .mb-xl-2,\r\n  .my-xl-2 {\r\n    margin-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .ml-xl-2,\r\n  .mx-xl-2 {\r\n    margin-left: 0.5rem !important;\r\n  }\r\n\r\n  .m-xl-3 {\r\n    margin: 1rem !important;\r\n  }\r\n\r\n  .mt-xl-3,\r\n  .my-xl-3 {\r\n    margin-top: 1rem !important;\r\n  }\r\n\r\n  .mr-xl-3,\r\n  .mx-xl-3 {\r\n    margin-right: 1rem !important;\r\n  }\r\n\r\n  .mb-xl-3,\r\n  .my-xl-3 {\r\n    margin-bottom: 1rem !important;\r\n  }\r\n\r\n  .ml-xl-3,\r\n  .mx-xl-3 {\r\n    margin-left: 1rem !important;\r\n  }\r\n\r\n  .m-xl-4 {\r\n    margin: 1.5rem !important;\r\n  }\r\n\r\n  .mt-xl-4,\r\n  .my-xl-4 {\r\n    margin-top: 1.5rem !important;\r\n  }\r\n\r\n  .mr-xl-4,\r\n  .mx-xl-4 {\r\n    margin-right: 1.5rem !important;\r\n  }\r\n\r\n  .mb-xl-4,\r\n  .my-xl-4 {\r\n    margin-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .ml-xl-4,\r\n  .mx-xl-4 {\r\n    margin-left: 1.5rem !important;\r\n  }\r\n\r\n  .m-xl-5 {\r\n    margin: 3rem !important;\r\n  }\r\n\r\n  .mt-xl-5,\r\n  .my-xl-5 {\r\n    margin-top: 3rem !important;\r\n  }\r\n\r\n  .mr-xl-5,\r\n  .mx-xl-5 {\r\n    margin-right: 3rem !important;\r\n  }\r\n\r\n  .mb-xl-5,\r\n  .my-xl-5 {\r\n    margin-bottom: 3rem !important;\r\n  }\r\n\r\n  .ml-xl-5,\r\n  .mx-xl-5 {\r\n    margin-left: 3rem !important;\r\n  }\r\n\r\n  .p-xl-0 {\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .pt-xl-0,\r\n  .py-xl-0 {\r\n    padding-top: 0 !important;\r\n  }\r\n\r\n  .pr-xl-0,\r\n  .px-xl-0 {\r\n    padding-right: 0 !important;\r\n  }\r\n\r\n  .pb-xl-0,\r\n  .py-xl-0 {\r\n    padding-bottom: 0 !important;\r\n  }\r\n\r\n  .pl-xl-0,\r\n  .px-xl-0 {\r\n    padding-left: 0 !important;\r\n  }\r\n\r\n  .p-xl-1 {\r\n    padding: 0.25rem !important;\r\n  }\r\n\r\n  .pt-xl-1,\r\n  .py-xl-1 {\r\n    padding-top: 0.25rem !important;\r\n  }\r\n\r\n  .pr-xl-1,\r\n  .px-xl-1 {\r\n    padding-right: 0.25rem !important;\r\n  }\r\n\r\n  .pb-xl-1,\r\n  .py-xl-1 {\r\n    padding-bottom: 0.25rem !important;\r\n  }\r\n\r\n  .pl-xl-1,\r\n  .px-xl-1 {\r\n    padding-left: 0.25rem !important;\r\n  }\r\n\r\n  .p-xl-2 {\r\n    padding: 0.5rem !important;\r\n  }\r\n\r\n  .pt-xl-2,\r\n  .py-xl-2 {\r\n    padding-top: 0.5rem !important;\r\n  }\r\n\r\n  .pr-xl-2,\r\n  .px-xl-2 {\r\n    padding-right: 0.5rem !important;\r\n  }\r\n\r\n  .pb-xl-2,\r\n  .py-xl-2 {\r\n    padding-bottom: 0.5rem !important;\r\n  }\r\n\r\n  .pl-xl-2,\r\n  .px-xl-2 {\r\n    padding-left: 0.5rem !important;\r\n  }\r\n\r\n  .p-xl-3 {\r\n    padding: 1rem !important;\r\n  }\r\n\r\n  .pt-xl-3,\r\n  .py-xl-3 {\r\n    padding-top: 1rem !important;\r\n  }\r\n\r\n  .pr-xl-3,\r\n  .px-xl-3 {\r\n    padding-right: 1rem !important;\r\n  }\r\n\r\n  .pb-xl-3,\r\n  .py-xl-3 {\r\n    padding-bottom: 1rem !important;\r\n  }\r\n\r\n  .pl-xl-3,\r\n  .px-xl-3 {\r\n    padding-left: 1rem !important;\r\n  }\r\n\r\n  .p-xl-4 {\r\n    padding: 1.5rem !important;\r\n  }\r\n\r\n  .pt-xl-4,\r\n  .py-xl-4 {\r\n    padding-top: 1.5rem !important;\r\n  }\r\n\r\n  .pr-xl-4,\r\n  .px-xl-4 {\r\n    padding-right: 1.5rem !important;\r\n  }\r\n\r\n  .pb-xl-4,\r\n  .py-xl-4 {\r\n    padding-bottom: 1.5rem !important;\r\n  }\r\n\r\n  .pl-xl-4,\r\n  .px-xl-4 {\r\n    padding-left: 1.5rem !important;\r\n  }\r\n\r\n  .p-xl-5 {\r\n    padding: 3rem !important;\r\n  }\r\n\r\n  .pt-xl-5,\r\n  .py-xl-5 {\r\n    padding-top: 3rem !important;\r\n  }\r\n\r\n  .pr-xl-5,\r\n  .px-xl-5 {\r\n    padding-right: 3rem !important;\r\n  }\r\n\r\n  .pb-xl-5,\r\n  .py-xl-5 {\r\n    padding-bottom: 3rem !important;\r\n  }\r\n\r\n  .pl-xl-5,\r\n  .px-xl-5 {\r\n    padding-left: 3rem !important;\r\n  }\r\n\r\n  .m-xl-n1 {\r\n    margin: -0.25rem !important;\r\n  }\r\n\r\n  .mt-xl-n1,\r\n  .my-xl-n1 {\r\n    margin-top: -0.25rem !important;\r\n  }\r\n\r\n  .mr-xl-n1,\r\n  .mx-xl-n1 {\r\n    margin-right: -0.25rem !important;\r\n  }\r\n\r\n  .mb-xl-n1,\r\n  .my-xl-n1 {\r\n    margin-bottom: -0.25rem !important;\r\n  }\r\n\r\n  .ml-xl-n1,\r\n  .mx-xl-n1 {\r\n    margin-left: -0.25rem !important;\r\n  }\r\n\r\n  .m-xl-n2 {\r\n    margin: -0.5rem !important;\r\n  }\r\n\r\n  .mt-xl-n2,\r\n  .my-xl-n2 {\r\n    margin-top: -0.5rem !important;\r\n  }\r\n\r\n  .mr-xl-n2,\r\n  .mx-xl-n2 {\r\n    margin-right: -0.5rem !important;\r\n  }\r\n\r\n  .mb-xl-n2,\r\n  .my-xl-n2 {\r\n    margin-bottom: -0.5rem !important;\r\n  }\r\n\r\n  .ml-xl-n2,\r\n  .mx-xl-n2 {\r\n    margin-left: -0.5rem !important;\r\n  }\r\n\r\n  .m-xl-n3 {\r\n    margin: -1rem !important;\r\n  }\r\n\r\n  .mt-xl-n3,\r\n  .my-xl-n3 {\r\n    margin-top: -1rem !important;\r\n  }\r\n\r\n  .mr-xl-n3,\r\n  .mx-xl-n3 {\r\n    margin-right: -1rem !important;\r\n  }\r\n\r\n  .mb-xl-n3,\r\n  .my-xl-n3 {\r\n    margin-bottom: -1rem !important;\r\n  }\r\n\r\n  .ml-xl-n3,\r\n  .mx-xl-n3 {\r\n    margin-left: -1rem !important;\r\n  }\r\n\r\n  .m-xl-n4 {\r\n    margin: -1.5rem !important;\r\n  }\r\n\r\n  .mt-xl-n4,\r\n  .my-xl-n4 {\r\n    margin-top: -1.5rem !important;\r\n  }\r\n\r\n  .mr-xl-n4,\r\n  .mx-xl-n4 {\r\n    margin-right: -1.5rem !important;\r\n  }\r\n\r\n  .mb-xl-n4,\r\n  .my-xl-n4 {\r\n    margin-bottom: -1.5rem !important;\r\n  }\r\n\r\n  .ml-xl-n4,\r\n  .mx-xl-n4 {\r\n    margin-left: -1.5rem !important;\r\n  }\r\n\r\n  .m-xl-n5 {\r\n    margin: -3rem !important;\r\n  }\r\n\r\n  .mt-xl-n5,\r\n  .my-xl-n5 {\r\n    margin-top: -3rem !important;\r\n  }\r\n\r\n  .mr-xl-n5,\r\n  .mx-xl-n5 {\r\n    margin-right: -3rem !important;\r\n  }\r\n\r\n  .mb-xl-n5,\r\n  .my-xl-n5 {\r\n    margin-bottom: -3rem !important;\r\n  }\r\n\r\n  .ml-xl-n5,\r\n  .mx-xl-n5 {\r\n    margin-left: -3rem !important;\r\n  }\r\n\r\n  .m-xl-auto {\r\n    margin: auto !important;\r\n  }\r\n\r\n  .mt-xl-auto,\r\n  .my-xl-auto {\r\n    margin-top: auto !important;\r\n  }\r\n\r\n  .mr-xl-auto,\r\n  .mx-xl-auto {\r\n    margin-right: auto !important;\r\n  }\r\n\r\n  .mb-xl-auto,\r\n  .my-xl-auto {\r\n    margin-bottom: auto !important;\r\n  }\r\n\r\n  .ml-xl-auto,\r\n  .mx-xl-auto {\r\n    margin-left: auto !important;\r\n  }\r\n}\r\n\r\n.text-monospace {\r\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !important;\r\n}\r\n\r\n.text-justify {\r\n  text-align: justify !important;\r\n}\r\n\r\n.text-wrap {\r\n  white-space: normal !important;\r\n}\r\n\r\n.text-nowrap {\r\n  white-space: nowrap !important;\r\n}\r\n\r\n.text-truncate {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.text-left {\r\n  text-align: left !important;\r\n}\r\n\r\n.text-right {\r\n  text-align: right !important;\r\n}\r\n\r\n.text-center {\r\n  text-align: center !important;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .text-sm-left {\r\n    text-align: left !important;\r\n  }\r\n\r\n  .text-sm-right {\r\n    text-align: right !important;\r\n  }\r\n\r\n  .text-sm-center {\r\n    text-align: center !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .text-md-left {\r\n    text-align: left !important;\r\n  }\r\n\r\n  .text-md-right {\r\n    text-align: right !important;\r\n  }\r\n\r\n  .text-md-center {\r\n    text-align: center !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .text-lg-left {\r\n    text-align: left !important;\r\n  }\r\n\r\n  .text-lg-right {\r\n    text-align: right !important;\r\n  }\r\n\r\n  .text-lg-center {\r\n    text-align: center !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .text-xl-left {\r\n    text-align: left !important;\r\n  }\r\n\r\n  .text-xl-right {\r\n    text-align: right !important;\r\n  }\r\n\r\n  .text-xl-center {\r\n    text-align: center !important;\r\n  }\r\n}\r\n\r\n.text-lowercase {\r\n  text-transform: lowercase !important;\r\n}\r\n\r\n.text-uppercase {\r\n  text-transform: uppercase !important;\r\n}\r\n\r\n.text-capitalize {\r\n  text-transform: capitalize !important;\r\n}\r\n\r\n.font-weight-light {\r\n  font-weight: 300 !important;\r\n}\r\n\r\n.font-weight-lighter {\r\n  font-weight: lighter !important;\r\n}\r\n\r\n.font-weight-normal {\r\n  font-weight: 400 !important;\r\n}\r\n\r\n.font-weight-bold {\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.font-weight-bolder {\r\n  font-weight: bolder !important;\r\n}\r\n\r\n.font-italic {\r\n  font-style: italic !important;\r\n}\r\n\r\n.text-white {\r\n  color: #fff !important;\r\n}\r\n\r\n.text-primary {\r\n  color: var(--primary) !important;\r\n}\r\n\r\na.text-primary:hover,\r\na.text-primary:focus {\r\n  color: #24376c !important;\r\n}\r\n\r\n.text-secondary {\r\n  color: var(--secondary) !important;\r\n}\r\n\r\na.text-secondary:hover,\r\na.text-secondary:focus {\r\n  color: #7492fb !important;\r\n}\r\n\r\n.text-success {\r\n  color: var(--success) !important;\r\n}\r\n\r\na.text-success:hover,\r\na.text-success:focus {\r\n  color: #10705d !important;\r\n}\r\n\r\n.text-info {\r\n  color: #5d80f9 !important;\r\n}\r\n\r\na.text-info:hover,\r\na.text-info:focus {\r\n  color: #1346f6 !important;\r\n}\r\n\r\n.text-warning {\r\n  color: #f3c363 !important;\r\n}\r\n\r\na.text-warning:hover,\r\na.text-warning:focus {\r\n  color: #eea81c !important;\r\n}\r\n\r\n.text-danger {\r\n  color: #eb3349 !important;\r\n}\r\n\r\na.text-danger:hover,\r\na.text-danger:focus {\r\n  color: #bf1327 !important;\r\n}\r\n\r\n.text-light {\r\n  color: #cccbca !important;\r\n}\r\n\r\na.text-light:hover,\r\na.text-light:focus {\r\n  color: #a6a5a3 !important;\r\n}\r\n\r\n.text-dark {\r\n  color: #343a40 !important;\r\n}\r\n\r\na.text-dark:hover,\r\na.text-dark:focus {\r\n  color: #121416 !important;\r\n}\r\n\r\n.text-inverse {\r\n  color: #4d4d4d !important;\r\n}\r\n\r\na.text-inverse:hover,\r\na.text-inverse:focus {\r\n  color: #272727 !important;\r\n}\r\n\r\n.text-gray {\r\n  color: #ccc !important;\r\n}\r\n\r\na.text-gray:hover,\r\na.text-gray:focus {\r\n  color: #a6a6a6 !important;\r\n}\r\n\r\n.text-default {\r\n  color: #f8f8f8 !important;\r\n}\r\n\r\na.text-default:hover,\r\na.text-default:focus {\r\n  color: #d2d2d2 !important;\r\n}\r\n\r\n.text-body {\r\n  color: #212529 !important;\r\n}\r\n\r\n.text-muted {\r\n  color: #cccbca !important;\r\n}\r\n\r\n.text-black-50 {\r\n  color: rgba(0, 0, 0, 0.5) !important;\r\n}\r\n\r\n.text-white-50 {\r\n  color: rgba(255, 255, 255, 0.5) !important;\r\n}\r\n\r\n.text-hide {\r\n  font: 0/0 a;\r\n  color: transparent;\r\n  text-shadow: none;\r\n  background-color: transparent;\r\n  border: 0;\r\n}\r\n\r\n.text-decoration-none {\r\n  text-decoration: none !important;\r\n}\r\n\r\n.text-break {\r\n  word-break: break-word !important;\r\n  overflow-wrap: break-word !important;\r\n}\r\n\r\n.text-reset {\r\n  color: inherit !important;\r\n}\r\n\r\n.visible {\r\n  visibility: visible !important;\r\n}\r\n\r\n.invisible {\r\n  visibility: hidden !important;\r\n}\r\n\r\n@media print {\r\n  *,\r\n  *::before,\r\n  *::after {\r\n    text-shadow: none !important;\r\n    box-shadow: none !important;\r\n  }\r\n\r\n  a:not(.btn) {\r\n    text-decoration: underline;\r\n  }\r\n\r\n  abbr[title]::after {\r\n    content: \" (\" attr(title) \")\";\r\n  }\r\n\r\n  pre {\r\n    white-space: pre-wrap !important;\r\n  }\r\n\r\n  pre,\r\n  blockquote {\r\n    border: 1px solid #666;\r\n    page-break-inside: avoid;\r\n  }\r\n\r\n  thead {\r\n    display: table-header-group;\r\n  }\r\n\r\n  tr,\r\n  img {\r\n    page-break-inside: avoid;\r\n  }\r\n\r\n  p,\r\n  h2,\r\n  h3 {\r\n    orphans: 3;\r\n    widows: 3;\r\n  }\r\n\r\n  h2,\r\n  h3 {\r\n    page-break-after: avoid;\r\n  }\r\n\r\n@page {\r\n    size: a3;\r\n}\r\n\r\n  body {\r\n    min-width: 992px !important;\r\n  }\r\n\r\n  .container {\r\n    min-width: 992px !important;\r\n  }\r\n\r\n  .navbar {\r\n    display: none;\r\n  }\r\n\r\n  .badge {\r\n    border: 1px solid #000;\r\n  }\r\n\r\n  .table {\r\n    border-collapse: collapse !important;\r\n  }\r\n\r\n  .table td,\r\n  .table th {\r\n    background-color: #fff !important;\r\n  }\r\n\r\n  .table-bordered th,\r\n  .table-bordered td {\r\n    border: 1px solid #cccbca !important;\r\n  }\r\n\r\n  .table-dark {\r\n    color: inherit;\r\n  }\r\n\r\n  .table-dark th,\r\n  .table-dark td,\r\n  .table-dark thead th,\r\n  .table-dark tbody + tbody {\r\n    border-color: #cccbca;\r\n  }\r\n\r\n  .table .thead-dark th {\r\n    color: inherit;\r\n    border-color: #cccbca;\r\n  }\r\n}\r\n\r\n/*\r\n * Glyphicons Halflings\r\n */\r\n\r\n\r\n\r\n.glyphicon {\r\n  position: relative;\r\n  top: 1px;\r\n  display: inline-block;\r\n  font-family: 'Glyphicons Halflings';\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  line-height: 1;\r\n  vertical-align: top;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.glyphicon.x05 {\r\n  font-size: 7px;\r\n}\r\n\r\n.glyphicon.x2 {\r\n  font-size: 28px;\r\n}\r\n\r\n.glyphicon.x3 {\r\n  font-size: 42px;\r\n}\r\n\r\n.glyphicon.x4 {\r\n  font-size: 56px;\r\n}\r\n\r\n.glyphicon.x5 {\r\n  font-size: 70px;\r\n}\r\n\r\n.glyphicon.x6 {\r\n  font-size: 84px;\r\n}\r\n\r\n.glyphicon.x7 {\r\n  font-size: 98px;\r\n}\r\n\r\n.glyphicon.x8 {\r\n  font-size: 112px;\r\n}\r\n\r\n.glyphicon.light:before {\r\n  color: #f2f2f2;\r\n}\r\n\r\n.glyphicon.drop:before {\r\n  text-shadow: -1px 1px 3px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.glyphicon.flip {\r\n  transform: scaleX(-1);\r\n  filter: FlipH;\r\n  -ms-filter: \"FlipH\";\r\n}\r\n\r\n.glyphicon.flipv {\r\n  transform: scaleY(-1);\r\n  filter: FlipV;\r\n  -ms-filter: \"FlipV\";\r\n}\r\n\r\n.glyphicon.rotate90 {\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.glyphicon.rotate180 {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.glyphicon.rotate270 {\r\n  transform: rotate(270deg);\r\n}\r\n\r\n.glyphicon-glass:before {\r\n  content: \"\\E001\";\r\n}\r\n\r\n.glyphicon-music:before {\r\n  content: \"\\E002\";\r\n}\r\n\r\n.glyphicon-search:before {\r\n  content: \"\\E003\";\r\n}\r\n\r\n.glyphicon-envelope:before {\r\n  content: \"\\2709\";\r\n}\r\n\r\n.glyphicon-heart:before {\r\n  content: \"\\E005\";\r\n}\r\n\r\n.glyphicon-star:before {\r\n  content: \"\\E006\";\r\n}\r\n\r\n.glyphicon-star-empty:before {\r\n  content: \"\\E007\";\r\n}\r\n\r\n.glyphicon-user:before {\r\n  content: \"\\E008\";\r\n}\r\n\r\n.glyphicon-film:before {\r\n  content: \"\\E009\";\r\n}\r\n\r\n.glyphicon-th-large:before {\r\n  content: \"\\E010\";\r\n}\r\n\r\n.glyphicon-th:before {\r\n  content: \"\\E011\";\r\n}\r\n\r\n.glyphicon-th-list:before {\r\n  content: \"\\E012\";\r\n}\r\n\r\n.glyphicon-ok:before {\r\n  content: \"\\E013\";\r\n}\r\n\r\n.glyphicon-remove:before {\r\n  content: \"\\E014\";\r\n}\r\n\r\n.glyphicon-zoom-in:before {\r\n  content: \"\\E015\";\r\n}\r\n\r\n.glyphicon-zoom-out:before {\r\n  content: \"\\E016\";\r\n}\r\n\r\n.glyphicon-off:before {\r\n  content: \"\\E017\";\r\n}\r\n\r\n.glyphicon-signal:before {\r\n  content: \"\\E018\";\r\n}\r\n\r\n.glyphicon-cog:before {\r\n  content: \"\\E019\";\r\n}\r\n\r\n.glyphicon-trash:before {\r\n  content: \"\\E020\";\r\n}\r\n\r\n.glyphicon-home:before {\r\n  content: \"\\E021\";\r\n}\r\n\r\n.glyphicon-file:before {\r\n  content: \"\\E022\";\r\n}\r\n\r\n.glyphicon-time:before {\r\n  content: \"\\E023\";\r\n}\r\n\r\n.glyphicon-road:before {\r\n  content: \"\\E024\";\r\n}\r\n\r\n.glyphicon-download-alt:before {\r\n  content: \"\\E025\";\r\n}\r\n\r\n.glyphicon-download:before {\r\n  content: \"\\E026\";\r\n}\r\n\r\n.glyphicon-upload:before {\r\n  content: \"\\E027\";\r\n}\r\n\r\n.glyphicon-inbox:before {\r\n  content: \"\\E028\";\r\n}\r\n\r\n.glyphicon-play-circle:before {\r\n  content: \"\\E029\";\r\n}\r\n\r\n.glyphicon-repeat:before {\r\n  content: \"\\E030\";\r\n}\r\n\r\n.glyphicon-refresh:before {\r\n  content: \"\\E031\";\r\n}\r\n\r\n.glyphicon-list-alt:before {\r\n  content: \"\\E032\";\r\n}\r\n\r\n.glyphicon-glyph-lock:before {\r\n  content: \"\\E033\";\r\n}\r\n\r\n.glyphicon-flag:before {\r\n  content: \"\\E034\";\r\n}\r\n\r\n.glyphicon-headphones:before {\r\n  content: \"\\E035\";\r\n}\r\n\r\n.glyphicon-volume-off:before {\r\n  content: \"\\E036\";\r\n}\r\n\r\n.glyphicon-volume-down:before {\r\n  content: \"\\E037\";\r\n}\r\n\r\n.glyphicon-volume-up:before {\r\n  content: \"\\E038\";\r\n}\r\n\r\n.glyphicon-qrcode:before {\r\n  content: \"\\E039\";\r\n}\r\n\r\n.glyphicon-barcode:before {\r\n  content: \"\\E040\";\r\n}\r\n\r\n.glyphicon-tag:before {\r\n  content: \"\\E041\";\r\n}\r\n\r\n.glyphicon-tags:before {\r\n  content: \"\\E042\";\r\n}\r\n\r\n.glyphicon-book:before {\r\n  content: \"\\E043\";\r\n}\r\n\r\n.glyphicon-glyph-bookmark:before {\r\n  content: \"\\E044\";\r\n}\r\n\r\n.glyphicon-print:before {\r\n  content: \"\\E045\";\r\n}\r\n\r\n.glyphicon-glyph-camera:before {\r\n  content: \"\\E046\";\r\n}\r\n\r\n.glyphicon-font:before {\r\n  content: \"\\E047\";\r\n}\r\n\r\n.glyphicon-bold:before {\r\n  content: \"\\E048\";\r\n}\r\n\r\n.glyphicon-italic:before {\r\n  content: \"\\E049\";\r\n}\r\n\r\n.glyphicon-text-height:before {\r\n  content: \"\\E050\";\r\n}\r\n\r\n.glyphicon-text-width:before {\r\n  content: \"\\E051\";\r\n}\r\n\r\n.glyphicon-align-left:before {\r\n  content: \"\\E052\";\r\n}\r\n\r\n.glyphicon-align-center:before {\r\n  content: \"\\E053\";\r\n}\r\n\r\n.glyphicon-align-right:before {\r\n  content: \"\\E054\";\r\n}\r\n\r\n.glyphicon-align-justify:before {\r\n  content: \"\\E055\";\r\n}\r\n\r\n.glyphicon-list:before {\r\n  content: \"\\E056\";\r\n}\r\n\r\n.glyphicon-indent-left:before {\r\n  content: \"\\E057\";\r\n}\r\n\r\n.glyphicon-indent-right:before {\r\n  content: \"\\E058\";\r\n}\r\n\r\n.glyphicon-facetime-video:before {\r\n  content: \"\\E059\";\r\n}\r\n\r\n.glyphicon-picture:before {\r\n  content: \"\\E060\";\r\n}\r\n\r\n.glyphicon-pencil:before {\r\n  content: \"\\270F\";\r\n}\r\n\r\n.glyphicon-map-marker:before {\r\n  content: \"\\E062\";\r\n}\r\n\r\n.glyphicon-adjust:before {\r\n  content: \"\\E063\";\r\n}\r\n\r\n.glyphicon-tint:before {\r\n  content: \"\\E064\";\r\n}\r\n\r\n.glyphicon-edit:before {\r\n  content: \"\\E065\";\r\n}\r\n\r\n.glyphicon-share:before {\r\n  content: \"\\E066\";\r\n}\r\n\r\n.glyphicon-check:before {\r\n  content: \"\\E067\";\r\n}\r\n\r\n.glyphicon-move:before {\r\n  content: \"\\E068\";\r\n}\r\n\r\n.glyphicon-step-backward:before {\r\n  content: \"\\E069\";\r\n}\r\n\r\n.glyphicon-fast-backward:before {\r\n  content: \"\\E070\";\r\n}\r\n\r\n.glyphicon-backward:before {\r\n  content: \"\\E071\";\r\n}\r\n\r\n.glyphicon-play:before {\r\n  content: \"\\E072\";\r\n}\r\n\r\n.glyphicon-pause:before {\r\n  content: \"\\E073\";\r\n}\r\n\r\n.glyphicon-stop:before {\r\n  content: \"\\E074\";\r\n}\r\n\r\n.glyphicon-forward:before {\r\n  content: \"\\E075\";\r\n}\r\n\r\n.glyphicon-fast-forward:before {\r\n  content: \"\\E076\";\r\n}\r\n\r\n.glyphicon-step-forward:before {\r\n  content: \"\\E077\";\r\n}\r\n\r\n.glyphicon-eject:before {\r\n  content: \"\\E078\";\r\n}\r\n\r\n.glyphicon-chevron-left:before {\r\n  content: \"\\E079\";\r\n}\r\n\r\n.glyphicon-chevron-right:before {\r\n  content: \"\\E080\";\r\n}\r\n\r\n.glyphicon-plus-sign:before {\r\n  content: \"\\E081\";\r\n}\r\n\r\n.glyphicon-minus-sign:before {\r\n  content: \"\\E082\";\r\n}\r\n\r\n.glyphicon-remove-sign:before {\r\n  content: \"\\E083\";\r\n}\r\n\r\n.glyphicon-ok-sign:before {\r\n  content: \"\\E084\";\r\n}\r\n\r\n.glyphicon-question-sign:before {\r\n  content: \"\\E085\";\r\n}\r\n\r\n.glyphicon-info-sign:before {\r\n  content: \"\\E086\";\r\n}\r\n\r\n.glyphicon-screenshot:before {\r\n  content: \"\\E087\";\r\n}\r\n\r\n.glyphicon-remove-circle:before {\r\n  content: \"\\E088\";\r\n}\r\n\r\n.glyphicon-ok-circle:before {\r\n  content: \"\\E089\";\r\n}\r\n\r\n.glyphicon-ban-circle:before {\r\n  content: \"\\E090\";\r\n}\r\n\r\n.glyphicon-arrow-left:before {\r\n  content: \"\\E091\";\r\n}\r\n\r\n.glyphicon-arrow-right:before {\r\n  content: \"\\E092\";\r\n}\r\n\r\n.glyphicon-arrow-up:before {\r\n  content: \"\\E093\";\r\n}\r\n\r\n.glyphicon-arrow-down:before {\r\n  content: \"\\E094\";\r\n}\r\n\r\n.glyphicon-share-alt:before {\r\n  content: \"\\E095\";\r\n}\r\n\r\n.glyphicon-resize-full:before {\r\n  content: \"\\E096\";\r\n}\r\n\r\n.glyphicon-resize-small:before {\r\n  content: \"\\E097\";\r\n}\r\n\r\n.glyphicon-plus:before {\r\n  content: \"\\002B\";\r\n}\r\n\r\n.glyphicon-minus:before {\r\n  content: \"\\2212\";\r\n}\r\n\r\n.glyphicon-asterisk:before {\r\n  content: \"\\002A\";\r\n}\r\n\r\n.glyphicon-exclamation-sign:before {\r\n  content: \"\\E101\";\r\n}\r\n\r\n.glyphicon-gift:before {\r\n  content: \"\\E102\";\r\n}\r\n\r\n.glyphicon-leaf:before {\r\n  content: \"\\E103\";\r\n}\r\n\r\n.glyphicon-glyph-fire:before {\r\n  content: \"\\E104\";\r\n}\r\n\r\n.glyphicon-eye-open:before {\r\n  content: \"\\E105\";\r\n}\r\n\r\n.glyphicon-eye-close:before {\r\n  content: \"\\E106\";\r\n}\r\n\r\n.glyphicon-warning-sign:before {\r\n  content: \"\\E107\";\r\n}\r\n\r\n.glyphicon-plane:before {\r\n  content: \"\\E108\";\r\n}\r\n\r\n.glyphicon-glyph-calendar:before {\r\n  content: \"\\E109\";\r\n}\r\n\r\n.glyphicon-random:before {\r\n  content: \"\\E110\";\r\n}\r\n\r\n.glyphicon-comments:before {\r\n  content: \"\\E111\";\r\n}\r\n\r\n.glyphicon-magnet:before {\r\n  content: \"\\E112\";\r\n}\r\n\r\n.glyphicon-chevron-up:before {\r\n  content: \"\\E113\";\r\n}\r\n\r\n.glyphicon-chevron-down:before {\r\n  content: \"\\E114\";\r\n}\r\n\r\n.glyphicon-retweet:before {\r\n  content: \"\\E115\";\r\n}\r\n\r\n.glyphicon-shopping-cart:before {\r\n  content: \"\\E116\";\r\n}\r\n\r\n.glyphicon-folder-close:before {\r\n  content: \"\\E117\";\r\n}\r\n\r\n.glyphicon-folder-open:before {\r\n  content: \"\\E118\";\r\n}\r\n\r\n.glyphicon-resize-vertical:before {\r\n  content: \"\\E119\";\r\n}\r\n\r\n.glyphicon-resize-horizontal:before {\r\n  content: \"\\E120\";\r\n}\r\n\r\n.glyphicon-hdd:before {\r\n  content: \"\\E121\";\r\n}\r\n\r\n.glyphicon-bullhorn:before {\r\n  content: \"\\E122\";\r\n}\r\n\r\n.glyphicon-glyph-bell:before {\r\n  content: \"\\E123\";\r\n}\r\n\r\n.glyphicon-certificate:before {\r\n  content: \"\\E124\";\r\n}\r\n\r\n.glyphicon-thumbs-up:before {\r\n  content: \"\\E125\";\r\n}\r\n\r\n.glyphicon-thumbs-down:before {\r\n  content: \"\\E126\";\r\n}\r\n\r\n.glyphicon-hand-right:before {\r\n  content: \"\\E127\";\r\n}\r\n\r\n.glyphicon-hand-left:before {\r\n  content: \"\\E128\";\r\n}\r\n\r\n.glyphicon-hand-top:before {\r\n  content: \"\\E129\";\r\n}\r\n\r\n.glyphicon-hand-down:before {\r\n  content: \"\\E130\";\r\n}\r\n\r\n.glyphicon-circle-arrow-right:before {\r\n  content: \"\\E131\";\r\n}\r\n\r\n.glyphicon-circle-arrow-left:before {\r\n  content: \"\\E132\";\r\n}\r\n\r\n.glyphicon-circle-arrow-top:before {\r\n  content: \"\\E133\";\r\n}\r\n\r\n.glyphicon-circle-arrow-down:before {\r\n  content: \"\\E134\";\r\n}\r\n\r\n.glyphicon-globe:before {\r\n  content: \"\\E135\";\r\n}\r\n\r\n.glyphicon-glyph-wrench:before {\r\n  content: \"\\E136\";\r\n}\r\n\r\n.glyphicon-tasks:before {\r\n  content: \"\\E137\";\r\n}\r\n\r\n.glyphicon-filter:before {\r\n  content: \"\\E138\";\r\n}\r\n\r\n.glyphicon-glyph-briefcase:before {\r\n  content: \"\\E139\";\r\n}\r\n\r\n.glyphicon-fullscreen:before {\r\n  content: \"\\E140\";\r\n}\r\n\r\n.glyphicon-dashboard:before {\r\n  content: \"\\E141\";\r\n}\r\n\r\n.glyphicon-glyph-paperclip:before {\r\n  content: \"\\E142\";\r\n}\r\n\r\n.glyphicon-heart-empty:before {\r\n  content: \"\\E143\";\r\n}\r\n\r\n.glyphicon-link:before {\r\n  content: \"\\E144\";\r\n}\r\n\r\n.glyphicon-phone:before {\r\n  content: \"\\E145\";\r\n}\r\n\r\n.glyphicon-glyph-pushpin:before {\r\n  content: \"\\E146\";\r\n}\r\n\r\n.glyphicon-euro:before {\r\n  content: \"\\20AC\";\r\n}\r\n\r\n.glyphicon-usd:before {\r\n  content: \"\\E148\";\r\n}\r\n\r\n.glyphicon-gbp:before {\r\n  content: \"\\E149\";\r\n}\r\n\r\n.glyphicon-sort:before {\r\n  content: \"\\E150\";\r\n}\r\n\r\n.glyphicon-sort-by-alphabet:before {\r\n  content: \"\\E151\";\r\n}\r\n\r\n.glyphicon-sort-by-alphabet-alt:before {\r\n  content: \"\\E152\";\r\n}\r\n\r\n.glyphicon-sort-by-order:before {\r\n  content: \"\\E153\";\r\n}\r\n\r\n.glyphicon-sort-by-order-alt:before {\r\n  content: \"\\E154\";\r\n}\r\n\r\n.glyphicon-sort-by-attributes:before {\r\n  content: \"\\E155\";\r\n}\r\n\r\n.glyphicon-sort-by-attributes-alt:before {\r\n  content: \"\\E156\";\r\n}\r\n\r\n.glyphicon-unchecked:before {\r\n  content: \"\\E157\";\r\n}\r\n\r\n.glyphicon-expand:before {\r\n  content: \"\\E158\";\r\n}\r\n\r\n.glyphicon-collapse:before {\r\n  content: \"\\E159\";\r\n}\r\n\r\n.glyphicon-collapse-top:before {\r\n  content: \"\\E160\";\r\n}\r\n\r\n.glyphicon-log-in:before {\r\n  content: \"\\E161\";\r\n}\r\n\r\n.glyphicon-flash:before {\r\n  content: \"\\E162\";\r\n}\r\n\r\n.glyphicon-log-out:before {\r\n  content: \"\\E163\";\r\n}\r\n\r\n.glyphicon-new-window:before {\r\n  content: \"\\E164\";\r\n}\r\n\r\n.glyphicon-record:before {\r\n  content: \"\\E165\";\r\n}\r\n\r\n.glyphicon-save:before {\r\n  content: \"\\E166\";\r\n}\r\n\r\n.glyphicon-open:before {\r\n  content: \"\\E167\";\r\n}\r\n\r\n.glyphicon-saved:before {\r\n  content: \"\\E168\";\r\n}\r\n\r\n.glyphicon-import:before {\r\n  content: \"\\E169\";\r\n}\r\n\r\n.glyphicon-export:before {\r\n  content: \"\\E170\";\r\n}\r\n\r\n.glyphicon-send:before {\r\n  content: \"\\E171\";\r\n}\r\n\r\n.glyphicon-floppy-disk:before {\r\n  content: \"\\E172\";\r\n}\r\n\r\n.glyphicon-floppy-saved:before {\r\n  content: \"\\E173\";\r\n}\r\n\r\n.glyphicon-floppy-remove:before {\r\n  content: \"\\E174\";\r\n}\r\n\r\n.glyphicon-floppy-save:before {\r\n  content: \"\\E175\";\r\n}\r\n\r\n.glyphicon-floppy-open:before {\r\n  content: \"\\E176\";\r\n}\r\n\r\n.glyphicon-credit-card:before {\r\n  content: \"\\E177\";\r\n}\r\n\r\n.glyphicon-transfer:before {\r\n  content: \"\\E178\";\r\n}\r\n\r\n.glyphicon-cutlery:before {\r\n  content: \"\\E179\";\r\n}\r\n\r\n.glyphicon-header:before {\r\n  content: \"\\E180\";\r\n}\r\n\r\n.glyphicon-compressed:before {\r\n  content: \"\\E181\";\r\n}\r\n\r\n.glyphicon-earphone:before {\r\n  content: \"\\E182\";\r\n}\r\n\r\n.glyphicon-phone-alt:before {\r\n  content: \"\\E183\";\r\n}\r\n\r\n.glyphicon-tower:before {\r\n  content: \"\\E184\";\r\n}\r\n\r\n.glyphicon-stats:before {\r\n  content: \"\\E185\";\r\n}\r\n\r\n.glyphicon-sd-video:before {\r\n  content: \"\\E186\";\r\n}\r\n\r\n.glyphicon-hd-video:before {\r\n  content: \"\\E187\";\r\n}\r\n\r\n.glyphicon-subtitles:before {\r\n  content: \"\\E188\";\r\n}\r\n\r\n.glyphicon-sound-stereo:before {\r\n  content: \"\\E189\";\r\n}\r\n\r\n.glyphicon-sound-dolby:before {\r\n  content: \"\\E190\";\r\n}\r\n\r\n.glyphicon-sound-5-1:before {\r\n  content: \"\\E191\";\r\n}\r\n\r\n.glyphicon-sound-6-1:before {\r\n  content: \"\\E192\";\r\n}\r\n\r\n.glyphicon-sound-7-1:before {\r\n  content: \"\\E193\";\r\n}\r\n\r\n.glyphicon-copyright-mark:before {\r\n  content: \"\\E194\";\r\n}\r\n\r\n.glyphicon-registration-mark:before {\r\n  content: \"\\E195\";\r\n}\r\n\r\n.glyphicon-cloud:before {\r\n  content: \"\\2601\";\r\n}\r\n\r\n.glyphicon-cloud-download:before {\r\n  content: \"\\E197\";\r\n}\r\n\r\n.glyphicon-cloud-upload:before {\r\n  content: \"\\E198\";\r\n}\r\n\r\n.glyphicon-tree-conifer:before {\r\n  content: \"\\E199\";\r\n}\r\n\r\n.glyphicon-tree-deciduous:before {\r\n  content: \"\\E200\";\r\n}\r\n\r\n.glyphicon-cd:before {\r\n  content: \"\\E201\";\r\n}\r\n\r\n.glyphicon-save-file:before {\r\n  content: \"\\E202\";\r\n}\r\n\r\n.glyphicon-open-file:before {\r\n  content: \"\\E203\";\r\n}\r\n\r\n.glyphicon-level-up:before {\r\n  content: \"\\E204\";\r\n}\r\n\r\n.glyphicon-copy:before {\r\n  content: \"\\E205\";\r\n}\r\n\r\n.glyphicon-paste:before {\r\n  content: \"\\E206\";\r\n}\r\n\r\n.glyphicon-door:before {\r\n  content: \"\\1F6AA\";\r\n}\r\n\r\n.glyphicon-key:before {\r\n  content: \"\\1F511\";\r\n}\r\n\r\n.glyphicon-alert:before {\r\n  content: \"\\E209\";\r\n}\r\n\r\n.glyphicon-equalizer:before {\r\n  content: \"\\E210\";\r\n}\r\n\r\n.glyphicon-king:before {\r\n  content: \"\\E211\";\r\n}\r\n\r\n.glyphicon-queen:before {\r\n  content: \"\\E212\";\r\n}\r\n\r\n.glyphicon-pawn:before {\r\n  content: \"\\E213\";\r\n}\r\n\r\n.glyphicon-bishop:before {\r\n  content: \"\\E214\";\r\n}\r\n\r\n.glyphicon-knight:before {\r\n  content: \"\\E215\";\r\n}\r\n\r\n.glyphicon-baby-formula:before {\r\n  content: \"\\E216\";\r\n}\r\n\r\n.glyphicon-tent:before {\r\n  content: \"\\26FA\";\r\n}\r\n\r\n.glyphicon-blackboard:before {\r\n  content: \"\\E218\";\r\n}\r\n\r\n.glyphicon-bed:before {\r\n  content: \"\\E219\";\r\n}\r\n\r\n.glyphicon-apple:before {\r\n  content: \"\\F8FF\";\r\n}\r\n\r\n.glyphicon-erase:before {\r\n  content: \"\\E221\";\r\n}\r\n\r\n.glyphicon-hourglass:before {\r\n  content: \"\\231B\";\r\n}\r\n\r\n.glyphicon-lamp:before {\r\n  content: \"\\E223\";\r\n}\r\n\r\n.glyphicon-duplicate:before {\r\n  content: \"\\E224\";\r\n}\r\n\r\n.glyphicon-piggy-bank:before {\r\n  content: \"\\E225\";\r\n}\r\n\r\n.glyphicon-scissors:before {\r\n  content: \"\\E226\";\r\n}\r\n\r\n.glyphicon-bitcoin:before {\r\n  content: \"\\E227\";\r\n}\r\n\r\n.glyphicon-yen:before {\r\n  content: \"\\00A5\";\r\n}\r\n\r\n.glyphicon-ruble:before {\r\n  content: \"\\20BD\";\r\n}\r\n\r\n.glyphicon-scale:before {\r\n  content: \"\\E230\";\r\n}\r\n\r\n.glyphicon-ice-lolly:before {\r\n  content: \"\\E231\";\r\n}\r\n\r\n.glyphicon-ice-lolly-tasted:before {\r\n  content: \"\\E232\";\r\n}\r\n\r\n.glyphicon-education:before {\r\n  content: \"\\E233\";\r\n}\r\n\r\n.glyphicon-option-horizontal:before {\r\n  content: \"\\E234\";\r\n}\r\n\r\n.glyphicon-option-vertical:before {\r\n  content: \"\\E235\";\r\n}\r\n\r\n.glyphicon-menu-hamburger:before {\r\n  content: \"\\E236\";\r\n}\r\n\r\n.glyphicon-modal-window:before {\r\n  content: \"\\E237\";\r\n}\r\n\r\n.glyphicon-oil:before {\r\n  content: \"\\E238\";\r\n}\r\n\r\n.glyphicon-grain:before {\r\n  content: \"\\E239\";\r\n}\r\n\r\n.glyphicon-sunglasses:before {\r\n  content: \"\\E240\";\r\n}\r\n\r\n.glyphicon-text-size:before {\r\n  content: \"\\E241\";\r\n}\r\n\r\n.glyphicon-text-color:before {\r\n  content: \"\\E242\";\r\n}\r\n\r\n.glyphicon-text-background:before {\r\n  content: \"\\E243\";\r\n}\r\n\r\n.glyphicon-object-align-top:before {\r\n  content: \"\\E244\";\r\n}\r\n\r\n.glyphicon-object-align-bottom:before {\r\n  content: \"\\E245\";\r\n}\r\n\r\n.glyphicon-object-align-horizontal:before {\r\n  content: \"\\E246\";\r\n}\r\n\r\n.glyphicon-object-align-left:before {\r\n  content: \"\\E247\";\r\n}\r\n\r\n.glyphicon-object-align-vertical:before {\r\n  content: \"\\E248\";\r\n}\r\n\r\n.glyphicon-object-align-right:before {\r\n  content: \"\\E249\";\r\n}\r\n\r\n.glyphicon-triangle-right:before {\r\n  content: \"\\E250\";\r\n}\r\n\r\n.glyphicon-triangle-left:before {\r\n  content: \"\\E251\";\r\n}\r\n\r\n.glyphicon-triangle-bottom:before {\r\n  content: \"\\E252\";\r\n}\r\n\r\n.glyphicon-triangle-top:before {\r\n  content: \"\\E253\";\r\n}\r\n\r\n.glyphicon-terminal:before {\r\n  content: \"\\E254\";\r\n}\r\n\r\n.glyphicon-superscript:before {\r\n  content: \"\\E255\";\r\n}\r\n\r\n.glyphicon-subscript:before {\r\n  content: \"\\E256\";\r\n}\r\n\r\n.glyphicon-menu-left:before {\r\n  content: \"\\E257\";\r\n}\r\n\r\n.glyphicon-menu-right:before {\r\n  content: \"\\E258\";\r\n}\r\n\r\n.glyphicon-menu-down:before {\r\n  content: \"\\E259\";\r\n}\r\n\r\n.glyphicon-menu-up:before {\r\n  content: \"\\E260\";\r\n}\r\n\r\n/* \r\n* \r\n* THIS IS A SMALL BONUS FOR ALL CURIOUS PEOPLE :) \r\n* Just add class .animated and .pulse, .rotateIn, .bounce, .swing or .tada to you HTML element with icons. You may find other great css animations here: http://coveloping.com/tools/css-animation-generator \r\n* \r\n*/\r\n\r\n.abc-checkbox {\r\n  cursor: default;\r\n  padding-left: 4px;\r\n}\r\n\r\n.abc-checkbox label {\r\n  cursor: pointer;\r\n  display: inline;\r\n  vertical-align: top;\r\n  position: relative;\r\n  padding-left: 5px;\r\n}\r\n\r\n.abc-checkbox label::before {\r\n  cursor: pointer;\r\n  content: \"\";\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 17px;\r\n  height: 17px;\r\n  top: 2px;\r\n  left: 0;\r\n  margin-left: -1.25rem;\r\n  border: 1px solid #ccc;\r\n  border-radius: 3px;\r\n  background-color: #fff;\r\n  transition: border 0.15s ease-in-out, color 0.15s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .abc-checkbox label::before {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.abc-checkbox label::after {\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 16px;\r\n  height: 16px;\r\n  left: 0;\r\n  top: 2px;\r\n  margin-left: -1.25rem;\r\n  padding-left: 3px;\r\n  padding-top: 1px;\r\n  font-size: 11px;\r\n  color: #4d4d4d;\r\n}\r\n\r\n.abc-checkbox input[type=\"checkbox\"],\r\n.abc-checkbox input[type=\"radio\"] {\r\n  position: static;\r\n  margin-left: 0;\r\n  cursor: pointer;\r\n  opacity: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.abc-checkbox input[type=\"checkbox\"]:focus + label::before,\r\n.abc-checkbox input[type=\"radio\"]:focus + label::before {\r\n  outline: thin dotted;\r\n  outline: 5px auto -webkit-focus-ring-color;\r\n  outline-offset: -2px;\r\n}\r\n\r\n.abc-checkbox input[type=\"checkbox\"]:checked + label::after,\r\n.abc-checkbox input[type=\"radio\"]:checked + label::after {\r\n  font-family: \"FontAwesome\";\r\n  content: \"\";\r\n}\r\n\r\n.abc-checkbox input[type=\"checkbox\"]:indeterminate + label::after,\r\n.abc-checkbox input[type=\"radio\"]:indeterminate + label::after {\r\n  display: block;\r\n  content: \"\";\r\n  width: 10px;\r\n  height: 3px;\r\n  background-color: #555555;\r\n  border-radius: 2px;\r\n  margin-left: -16.5px;\r\n  margin-top: 7px;\r\n}\r\n\r\n.abc-checkbox input[type=\"checkbox\"]:disabled + label,\r\n.abc-checkbox input[type=\"radio\"]:disabled + label {\r\n  opacity: 0.65;\r\n}\r\n\r\n.abc-checkbox input[type=\"checkbox\"]:disabled + label::before,\r\n.abc-checkbox input[type=\"radio\"]:disabled + label::before {\r\n  background-color: #efedea;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.abc-checkbox input[type=\"checkbox\"]:disabled + label::after,\r\n.abc-checkbox input[type=\"radio\"]:disabled + label::after {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.abc-checkbox.abc-checkbox-circle label::before {\r\n  border-radius: 50%;\r\n}\r\n\r\n.abc-checkbox.checkbox-inline {\r\n  margin-top: 0;\r\n}\r\n\r\n.abc-checkbox-primary input[type=\"checkbox\"]:checked + label::before,\r\n.abc-checkbox-primary input[type=\"radio\"]:checked + label::before {\r\n  background-color: var(--primary);\r\n  border-color: var(--primary);\r\n}\r\n\r\n.abc-checkbox-primary input[type=\"checkbox\"]:checked + label::after,\r\n.abc-checkbox-primary input[type=\"radio\"]:checked + label::after {\r\n  color: #fff;\r\n}\r\n\r\n.abc-checkbox-danger input[type=\"checkbox\"]:checked + label::before,\r\n.abc-checkbox-danger input[type=\"radio\"]:checked + label::before {\r\n  background-color: #eb3349;\r\n  border-color: #eb3349;\r\n}\r\n\r\n.abc-checkbox-danger input[type=\"checkbox\"]:checked + label::after,\r\n.abc-checkbox-danger input[type=\"radio\"]:checked + label::after {\r\n  color: #fff;\r\n}\r\n\r\n.abc-checkbox-info input[type=\"checkbox\"]:checked + label::before,\r\n.abc-checkbox-info input[type=\"radio\"]:checked + label::before {\r\n  background-color: #5d80f9;\r\n  border-color: #5d80f9;\r\n}\r\n\r\n.abc-checkbox-info input[type=\"checkbox\"]:checked + label::after,\r\n.abc-checkbox-info input[type=\"radio\"]:checked + label::after {\r\n  color: #fff;\r\n}\r\n\r\n.abc-checkbox-warning input[type=\"checkbox\"]:checked + label::before,\r\n.abc-checkbox-warning input[type=\"radio\"]:checked + label::before {\r\n  background-color: #f3c363;\r\n  border-color: #f3c363;\r\n}\r\n\r\n.abc-checkbox-warning input[type=\"checkbox\"]:checked + label::after,\r\n.abc-checkbox-warning input[type=\"radio\"]:checked + label::after {\r\n  color: #fff;\r\n}\r\n\r\n.abc-checkbox-success input[type=\"checkbox\"]:checked + label::before,\r\n.abc-checkbox-success input[type=\"radio\"]:checked + label::before {\r\n  background-color: var(--success);\r\n  border-color: var(--success);\r\n}\r\n\r\n.abc-checkbox-success input[type=\"checkbox\"]:checked + label::after,\r\n.abc-checkbox-success input[type=\"radio\"]:checked + label::after {\r\n  color: #fff;\r\n}\r\n\r\n.abc-checkbox-primary input[type=\"checkbox\"]:indeterminate + label::before,\r\n.abc-checkbox-primary input[type=\"radio\"]:indeterminate + label::before {\r\n  background-color: var(--primary);\r\n  border-color: var(--primary);\r\n}\r\n\r\n.abc-checkbox-primary input[type=\"checkbox\"]:indeterminate + label::after,\r\n.abc-checkbox-primary input[type=\"radio\"]:indeterminate + label::after {\r\n  background-color: #fff;\r\n}\r\n\r\n.abc-checkbox-danger input[type=\"checkbox\"]:indeterminate + label::before,\r\n.abc-checkbox-danger input[type=\"radio\"]:indeterminate + label::before {\r\n  background-color: #eb3349;\r\n  border-color: #eb3349;\r\n}\r\n\r\n.abc-checkbox-danger input[type=\"checkbox\"]:indeterminate + label::after,\r\n.abc-checkbox-danger input[type=\"radio\"]:indeterminate + label::after {\r\n  background-color: #fff;\r\n}\r\n\r\n.abc-checkbox-info input[type=\"checkbox\"]:indeterminate + label::before,\r\n.abc-checkbox-info input[type=\"radio\"]:indeterminate + label::before {\r\n  background-color: #5d80f9;\r\n  border-color: #5d80f9;\r\n}\r\n\r\n.abc-checkbox-info input[type=\"checkbox\"]:indeterminate + label::after,\r\n.abc-checkbox-info input[type=\"radio\"]:indeterminate + label::after {\r\n  background-color: #fff;\r\n}\r\n\r\n.abc-checkbox-warning input[type=\"checkbox\"]:indeterminate + label::before,\r\n.abc-checkbox-warning input[type=\"radio\"]:indeterminate + label::before {\r\n  background-color: #f3c363;\r\n  border-color: #f3c363;\r\n}\r\n\r\n.abc-checkbox-warning input[type=\"checkbox\"]:indeterminate + label::after,\r\n.abc-checkbox-warning input[type=\"radio\"]:indeterminate + label::after {\r\n  background-color: #fff;\r\n}\r\n\r\n.abc-checkbox-success input[type=\"checkbox\"]:indeterminate + label::before,\r\n.abc-checkbox-success input[type=\"radio\"]:indeterminate + label::before {\r\n  background-color: var(--success);\r\n  border-color: var(--success);\r\n}\r\n\r\n.abc-checkbox-success input[type=\"checkbox\"]:indeterminate + label::after,\r\n.abc-checkbox-success input[type=\"radio\"]:indeterminate + label::after {\r\n  background-color: #fff;\r\n}\r\n\r\n.abc-radio {\r\n  cursor: default;\r\n  padding-left: 4px;\r\n}\r\n\r\n.abc-radio label {\r\n  cursor: pointer;\r\n  display: inline;\r\n  vertical-align: top;\r\n  position: relative;\r\n  padding-left: 5px;\r\n}\r\n\r\n.abc-radio label::before {\r\n  cursor: pointer;\r\n  content: \"\";\r\n  display: inline-block;\r\n  position: absolute;\r\n  width: 17px;\r\n  height: 17px;\r\n  top: 2px;\r\n  left: 0;\r\n  margin-left: -20px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 50%;\r\n  background-color: #fff;\r\n  transition: border 0.15s ease-in-out;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .abc-radio label::before {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.abc-radio label::after {\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  position: absolute;\r\n  content: \" \";\r\n  width: 11px;\r\n  height: 11px;\r\n  left: 3px;\r\n  top: 5px;\r\n  margin-left: -20px;\r\n  border-radius: 50%;\r\n  background-color: #4d4d4d;\r\n  transform: scale(0, 0);\r\n  transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\r\n}\r\n\r\n.abc-radio input[type=\"radio\"] {\r\n  position: static;\r\n  margin-left: 0;\r\n  cursor: pointer;\r\n  opacity: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.abc-radio input[type=\"radio\"]:focus + label::before {\r\n  outline: thin dotted;\r\n  outline: 5px auto -webkit-focus-ring-color;\r\n  outline-offset: -2px;\r\n}\r\n\r\n.abc-radio input[type=\"radio\"]:checked + label::after {\r\n  transform: scale(1, 1);\r\n}\r\n\r\n.abc-radio input[type=\"radio\"]:disabled + label {\r\n  opacity: 0.65;\r\n}\r\n\r\n.abc-radio input[type=\"radio\"]:disabled + label::before {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.abc-radio input[type=\"radio\"]:disabled + label::after {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.abc-radio.radio-inline {\r\n  margin-top: 0;\r\n}\r\n\r\n.abc-radio-primary input[type=\"radio\"] + label::after {\r\n  background-color: var(--primary);\r\n}\r\n\r\n.abc-radio-primary input[type=\"radio\"]:checked + label::before {\r\n  border-color: var(--primary);\r\n}\r\n\r\n.abc-radio-primary input[type=\"radio\"]:checked + label::after {\r\n  background-color: var(--primary);\r\n}\r\n\r\n.abc-radio-danger input[type=\"radio\"] + label::after {\r\n  background-color: #eb3349;\r\n}\r\n\r\n.abc-radio-danger input[type=\"radio\"]:checked + label::before {\r\n  border-color: #eb3349;\r\n}\r\n\r\n.abc-radio-danger input[type=\"radio\"]:checked + label::after {\r\n  background-color: #eb3349;\r\n}\r\n\r\n.abc-radio-info input[type=\"radio\"] + label::after {\r\n  background-color: #5d80f9;\r\n}\r\n\r\n.abc-radio-info input[type=\"radio\"]:checked + label::before {\r\n  border-color: #5d80f9;\r\n}\r\n\r\n.abc-radio-info input[type=\"radio\"]:checked + label::after {\r\n  background-color: #5d80f9;\r\n}\r\n\r\n.abc-radio-warning input[type=\"radio\"] + label::after {\r\n  background-color: #f3c363;\r\n}\r\n\r\n.abc-radio-warning input[type=\"radio\"]:checked + label::before {\r\n  border-color: #f3c363;\r\n}\r\n\r\n.abc-radio-warning input[type=\"radio\"]:checked + label::after {\r\n  background-color: #f3c363;\r\n}\r\n\r\n.abc-radio-success input[type=\"radio\"] + label::after {\r\n  background-color: var(--success);\r\n}\r\n\r\n.abc-radio-success input[type=\"radio\"]:checked + label::before {\r\n  border-color: var(--success);\r\n}\r\n\r\n.abc-radio-success input[type=\"radio\"]:checked + label::after {\r\n  background-color: var(--success);\r\n}\r\n\r\nlabel .was-validated .form-check-input:invalid .abc-checkbox:before,\r\nlabel\r\n.was-validated .form-check-input:invalid .abc-radio:before,\r\nlabel .form-check-input.is-invalid .abc-checkbox:before,\r\nlabel\r\n.form-check-input.is-invalid .abc-radio:before {\r\n  border-color: #eb3349;\r\n}\r\n\r\n/**\r\n * Custom application mixins available through out the app\r\n */\r\n\r\n.container-fluid {\r\n  padding-left: 30px;\r\n  padding-right: 30px;\r\n}\r\n\r\n.navbar {\r\n  border: none;\r\n  height: 75px;\r\n  border-radius: 0;\r\n  margin-bottom: -75px;\r\n  padding: 0.5rem 2.25rem;\r\n}\r\n\r\n@media (min-width: 0) {\r\n  .navbar-right .dropdown-menu {\r\n    left: 0;\r\n  }\r\n}\r\n\r\n.nav.nav-tabs .nav-item a {\r\n  color: #4d4d4d;\r\n}\r\n\r\n.nav.nav-tabs .nav-item a.active {\r\n  background-color: #eb3349;\r\n  border-color: #eb3349;\r\n  color: white;\r\n}\r\n\r\n.progress-sm {\r\n  height: 1rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.progress-xs {\r\n  height: 5px;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.breadcrumb {\r\n  margin-top: -15px;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.breadcrumb > .active {\r\n  font-weight: 600;\r\n}\r\n\r\n.breadcrumb > li + li::before {\r\n  color: #f9f6f2;\r\n}\r\n\r\n.form-control {\r\n  font-size: 1rem;\r\n  transition: border-color ease-in-out 0.15s, background-color ease-in-out 0.15s;\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .form-control {\r\n    transition: none;\r\n  }\r\n}\r\n\r\n.form-control.no-border {\r\n  border: none;\r\n  background-color: #f2f2f2;\r\n}\r\n\r\n.form-control.no-border:focus {\r\n  background-color: #ededed;\r\n}\r\n\r\n.input-sm {\r\n  font-size: 13px;\r\n}\r\n\r\n.btn-inverse {\r\n  color: #212529;\r\n  background-color: #fff;\r\n  border-color: #4d4d4d;\r\n}\r\n\r\n.btn-inverse:hover {\r\n  color: #fff;\r\n  background-color: #414749;\r\n  border-color: #343434;\r\n}\r\n\r\n.btn-inverse:focus,\r\n.btn-inverse.focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(70, 71, 72, 0.5);\r\n}\r\n\r\n.btn-inverse.disabled,\r\n.btn-inverse:disabled {\r\n  color: #212529;\r\n  background-color: #fff;\r\n  border-color: #4d4d4d;\r\n}\r\n\r\n.btn-inverse:not(:disabled):not(.disabled):active,\r\n.btn-inverse:not(:disabled):not(.disabled).active,\r\n.show > .btn-inverse.dropdown-toggle {\r\n  color: #212529;\r\n  background-color: #e6e6e6;\r\n  border-color: #2d2d2d;\r\n}\r\n\r\n.btn-inverse:not(:disabled):not(.disabled):active:focus,\r\n.btn-inverse:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-inverse.dropdown-toggle:focus {\r\n  box-shadow: 0 0 0 0.2rem rgba(70, 71, 72, 0.5);\r\n}\r\n\r\n.alert {\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.alert .close {\r\n  color: rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n.alert-sm {\r\n  padding: 10px 15px;\r\n}\r\n\r\n.alert-sm .close {\r\n  font-size: 20px;\r\n  top: 0;\r\n  right: -8px;\r\n}\r\n\r\n.badge {\r\n  font-size: 12px;\r\n}\r\n\r\n.list-group-item > .badge {\r\n  margin-top: 2px;\r\n}\r\n\r\n.table-no-border {\r\n  margin-left: -0.75rem;\r\n  margin-right: -0.75rem;\r\n}\r\n\r\n.table-no-border > thead > tr > th,\r\n.table-no-border > thead > tr > td,\r\n.table-no-border > tbody > tr > th,\r\n.table-no-border > tbody > tr > td,\r\n.table-no-border > tfoot > tr > th,\r\n.table-no-border > tfoot > tr > td {\r\n  border-top: 0;\r\n}\r\n\r\n.table-sm {\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.table-sm > thead > tr > th,\r\n.table-sm > thead > tr > td,\r\n.table-sm > tbody > tr > th,\r\n.table-sm > tbody > tr > td,\r\n.table-sm > tfoot > tr > th,\r\n.table-sm > tfoot > tr > td {\r\n  padding: 4px;\r\n}\r\n\r\n.table-sm.table-no-border {\r\n  margin-left: -4px;\r\n  margin-right: -4px;\r\n}\r\n\r\npre {\r\n  display: block;\r\n  padding: 6.5px;\r\n  margin: 0 0 0.5rem;\r\n  font-size: 13px;\r\n  line-height: 1rem;\r\n  word-break: break-all;\r\n  word-wrap: break-word;\r\n  color: #212529;\r\n  background-color: #f9f6f2;\r\n  border: 1px solid #ccc;\r\n  border-radius: 0.25rem;\r\n}\r\n\r\npre code {\r\n  padding: 0;\r\n  font-size: inherit;\r\n  color: inherit;\r\n  white-space: pre-wrap;\r\n  background-color: transparent;\r\n  border-radius: 0;\r\n}\r\n\r\n.list-group {\r\n  padding: 0 1.25rem;\r\n  background: #fff;\r\n}\r\n\r\n.list-group .list-group-item {\r\n  border: none;\r\n  padding: 1.25rem 0;\r\n  color: #5d80f9;\r\n  border-top: 1px solid #efedea;\r\n}\r\n\r\n.list-group .list-group-item:hover {\r\n  z-index: 0;\r\n}\r\n\r\n.list-group .list-group-item:first-child {\r\n  border-top: none;\r\n}\r\n\r\nhtml {\r\n  font-weight: 100;\r\n  font-size: 14px;\r\n}\r\n\r\nbody {\r\n  overflow-x: hidden;\r\n}\r\n\r\nhtml,\r\nbody,\r\n.app {\r\n  height: 100%;\r\n}\r\n\r\na {\r\n  cursor: pointer;\r\n  transition: color 0.1s ease-in-out, background-color 0.1s ease-in-out;\r\n}\r\n\r\nth {\r\n  font-weight: 600;\r\n}\r\n\r\nlabel {\r\n  font-weight: 600;\r\n}\r\n\r\n.mt-xlg {\r\n  margin-top: 40px;\r\n}\r\n\r\n.mt-n-xlg {\r\n  margin-top: -40px;\r\n}\r\n\r\n.mt-lg {\r\n  margin-top: 2.25rem;\r\n}\r\n\r\n.mt-n-lg {\r\n  margin-top: -2.25rem;\r\n}\r\n\r\n.mt {\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.mt-n {\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.mt-md {\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.mt-n-md {\r\n  margin-top: -1.5rem;\r\n}\r\n\r\n.mt-sm {\r\n  margin-top: 0.75rem;\r\n}\r\n\r\n.mt-n-sm {\r\n  margin-top: -0.75rem;\r\n}\r\n\r\n.mt-xs {\r\n  margin-top: 0.375rem;\r\n}\r\n\r\n.mt-n-xs {\r\n  margin-top: -0.375rem;\r\n}\r\n\r\n.mt-0 {\r\n  margin-top: 0;\r\n}\r\n\r\n.mt-n-0 {\r\n  margin-top: 0;\r\n}\r\n\r\n.mb-xlg {\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.mb-n-xlg {\r\n  margin-bottom: -40px;\r\n}\r\n\r\n.mb-lg {\r\n  margin-bottom: 2.25rem;\r\n}\r\n\r\n.mb-n-lg {\r\n  margin-bottom: -2.25rem;\r\n}\r\n\r\n.mb {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.mb-n {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.mb-md {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.mb-n-md {\r\n  margin-bottom: -1.5rem;\r\n}\r\n\r\n.mb-sm {\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.mb-n-sm {\r\n  margin-bottom: -0.75rem;\r\n}\r\n\r\n.mb-xs {\r\n  margin-bottom: 0.375rem;\r\n}\r\n\r\n.mb-n-xs {\r\n  margin-bottom: -0.375rem;\r\n}\r\n\r\n.mb-0 {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.mb-n-0 {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.ml-lg {\r\n  margin-left: 20px;\r\n}\r\n\r\n.ml-n-lg {\r\n  margin-left: -20px;\r\n}\r\n\r\n.ml {\r\n  margin-left: 15px;\r\n}\r\n\r\n.ml-n {\r\n  margin-left: 15px;\r\n}\r\n\r\n.ml-md {\r\n  margin-left: 15px;\r\n}\r\n\r\n.ml-n-md {\r\n  margin-left: -15px;\r\n}\r\n\r\n.ml-sm {\r\n  margin-left: 10px;\r\n}\r\n\r\n.ml-n-sm {\r\n  margin-left: -10px;\r\n}\r\n\r\n.ml-xs {\r\n  margin-left: 5px;\r\n}\r\n\r\n.ml-n-xs {\r\n  margin-left: -5px;\r\n}\r\n\r\n.ml-0 {\r\n  margin-left: 0;\r\n}\r\n\r\n.ml-n-0 {\r\n  margin-left: 0;\r\n}\r\n\r\n.mr-lg {\r\n  margin-right: 20px;\r\n}\r\n\r\n.mr-n-lg {\r\n  margin-right: -20px;\r\n}\r\n\r\n.mr {\r\n  margin-right: 15px;\r\n}\r\n\r\n.mr-n {\r\n  margin-right: 15px;\r\n}\r\n\r\n.mr-md {\r\n  margin-right: 15px;\r\n}\r\n\r\n.mr-n-md {\r\n  margin-right: -15px;\r\n}\r\n\r\n.mr-sm {\r\n  margin-right: 10px;\r\n}\r\n\r\n.mr-n-sm {\r\n  margin-right: -10px;\r\n}\r\n\r\n.mr-xs {\r\n  margin-right: 5px;\r\n}\r\n\r\n.mr-n-xs {\r\n  margin-right: -5px;\r\n}\r\n\r\n.mr-0 {\r\n  margin-right: 0;\r\n}\r\n\r\n.mr-n-0 {\r\n  margin-right: 0;\r\n}\r\n\r\n.opacity-10 {\r\n  opacity: 0.1;\r\n}\r\n\r\n.opacity-n-10 {\r\n  opacity: -0.1;\r\n}\r\n\r\n.opacity-20 {\r\n  opacity: 0.2;\r\n}\r\n\r\n.opacity-n-20 {\r\n  opacity: -0.2;\r\n}\r\n\r\n.opacity-30 {\r\n  opacity: 0.3;\r\n}\r\n\r\n.opacity-n-30 {\r\n  opacity: -0.3;\r\n}\r\n\r\n.opacity-40 {\r\n  opacity: 0.4;\r\n}\r\n\r\n.opacity-n-40 {\r\n  opacity: -0.4;\r\n}\r\n\r\n.opacity-50 {\r\n  opacity: 0.5;\r\n}\r\n\r\n.opacity-n-50 {\r\n  opacity: -0.5;\r\n}\r\n\r\n.opacity-60 {\r\n  opacity: 0.6;\r\n}\r\n\r\n.opacity-n-60 {\r\n  opacity: -0.6;\r\n}\r\n\r\n.opacity-70 {\r\n  opacity: 0.7;\r\n}\r\n\r\n.opacity-n-70 {\r\n  opacity: -0.7;\r\n}\r\n\r\n.opacity-80 {\r\n  opacity: 0.8;\r\n}\r\n\r\n.opacity-n-80 {\r\n  opacity: -0.8;\r\n}\r\n\r\n.opacity-90 {\r\n  opacity: 0.9;\r\n}\r\n\r\n.opacity-n-90 {\r\n  opacity: -0.9;\r\n}\r\n\r\n.fw-thin {\r\n  font-weight: 300;\r\n}\r\n\r\n.fw-normal {\r\n  font-weight: 400;\r\n}\r\n\r\n.fw-semi-bold {\r\n  font-weight: 600;\r\n}\r\n\r\n.fw-bold {\r\n  font-weight: 700;\r\n}\r\n\r\n.fs-sm {\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.text-default {\r\n  color: #4d4d4d;\r\n}\r\n\r\n.bg-dark {\r\n  background-color: #4d4d4d !important;\r\n}\r\n\r\na.bg-dark:hover,\r\na.bg-dark:focus {\r\n  background-color: #343434 !important;\r\n}\r\n\r\n.td-underline {\r\n  text-decoration: underline;\r\n}\r\n\r\n.widget-table-overflow {\r\n  margin: 0 -20px -15px;\r\n}\r\n\r\n.text-orange{\r\n    color: #fd7e14 !important;\r\n}\r\n\r\n.text-dark{\r\n    color: #4d4d4d !important;\r\n}\r\n\r\n.a_login {\r\n    text-decoration: none;\r\n    color:#14b1d7 !important;\r\n    \r\n}\r\n\r\n.a_login:hover {\r\n    color:#1479d7;\r\n    text-shadow: 0 0 10px #1479d7;\r\n}\r\n\r\n.text-gray-600{\r\n    color: #959798 !important\r\n}\r\n.btn-cancle{\r\n  padding: 10px 20px;\r\n    size: 16px;\r\n  border-radius: 5px;\r\n  border: none;\r\n  cursor: pointer;\r\n  background-color: #b9bbbe;\r\n}\r\n.btn-cancle:hover{\r\n\r\n  background-color:#acacac;\r\n}\r\n\r\n\r\n\r\n.bg-purple-500 {\r\n    background-color: #8A5BD7\r\n}\r\n\r\n.text-purple-500 {\r\n    color: #8A5BD7\r\n}\r\n.border-purple-500 {\r\n    border-color: #8A5BD7;\r\n}\r\n\r\n\r\n  \r\n \r\n  \r\n   .main-title {\r\n    font-size: 24px;\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n    color: #333;\r\n  } \r\n \r\n\r\n\r\n\r\n  html[dir=\"rtl\"] {\r\n    direction: rtl;\r\n    text-align: right;\r\n  }\r\n  \r\n  html[dir=\"ltr\"] {\r\n    direction: ltr;\r\n    text-align: left;\r\n  }\r\n\r\n\r\n\r\n  \r\n  .btnSubmit {\r\n    padding: 10px 20px;\r\n    size: 16px;\r\n    border-radius: 5px;\r\n    border: none;\r\n    cursor: pointer;\r\n    background-color: #1f7c50;\r\n    color: white;\r\n    opacity: 0.9;\r\n  }\r\n\r\n  .btnSubmit:hover {\r\n    background-color: #196b43;\r\n    color: white;\r\n    opacity: 1;\r\n  }\r\n\r\n  .styled-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-bottom: 20px;\r\n    background-color: white;\r\n  }\r\n  \r\n  .styled-table th,\r\n  .styled-table td {\r\n    padding: 12px;\r\n   \r\n    border-bottom: 1px solid #ddd;\r\n  }\r\n  \r\n  .styled-table th {\r\n    background-color: #f2f2f2;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .styled-table th.sortable-header:hover {\r\n    background-color: #eaeef2;\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
